
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("abz2K", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorSPA", () => $95ca2b279cc03087$export$7f97e22e1179da90);
$parcel$export(module.exports, "ServiceDeskProjectIssueNavigatorSPA", () => $95ca2b279cc03087$export$8d32398195782ca1);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQX23");

var $hTLlD = parcelRequire("hTLlD");

var $3LiTJ = parcelRequire("3LiTJ");

var $53ciZ = parcelRequire("53ciZ");

var $cFpT4 = parcelRequire("cFpT4");

var $5as0a = parcelRequire("5as0a");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $eI64M = parcelRequire("eI64M");

var $6vrw7 = parcelRequire("6vrw7");

var $2wMrb = parcelRequire("2wMrb");

var $f6ie2 = parcelRequire("f6ie2");

var $6M8Uw = parcelRequire("6M8Uw");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $81C0N = parcelRequire("81C0N");
const $95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY = 'jira.project-issue-navigator';
const $95ca2b279cc03087$var$initInteractions = ()=>({
        pagination: {
            metrics: (0, $cFpT4.metrics).interaction({
                key: `${$95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY}.pagination.start-end.diff`
            }),
            properties: {}
        },
        refinement: {
            metrics: (0, $cFpT4.metrics).interaction({
                key: `${$95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY}.refinement.start-end.diff`
            }),
            properties: {}
        },
        filter: {
            metrics: (0, $cFpT4.metrics).interaction({
                key: `${$95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY}.filter.start-end.diff`
            }),
            properties: {}
        },
        'list-view': {
            metrics: (0, $cFpT4.metrics).interaction({
                key: `${$95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY}.list-view.start-end.diff`
            }),
            properties: {}
        },
        'split-view': {
            metrics: (0, $cFpT4.metrics).interaction({
                key: `${$95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY}.split-view.start-end.diff`
            }),
            properties: {}
        },
        'column-configuration': {
            metrics: (0, $cFpT4.metrics).interaction({
                key: `${$95ca2b279cc03087$var$BROWSER_METRICS_INTERACTION_APP_KEY}.column-configuration.start-end.diff`
            }),
            properties: {}
        }
    });
// eslint-disable-next-line jira/react/no-class-components
class $95ca2b279cc03087$var$ProjectIssueNavigatorSPAWrapper extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {
            initialised: false,
            issueKey: this.props.match?.params.issueKey ?? ''
        };
        /**
   * Update the currently selected issue in the URL.
   *
   * @param issueKey Issue key to update in the URL
   * @param isSelectedByUserInteraction True if this issue was selected by a user interaction, e.g. clicking an issue
   * in the list. This will be false if an issue was automatically selected by the app, e.g. automatically selecting
   * the first issue once the issue list has loaded.
   */ this.onChangeIssue = (issueKey, isSelectedByUserInteraction)=>{
            // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
            // the history stack
            this.push({
                issueKey: issueKey
            }, !isSelectedByUserInteraction);
        };
        this.onChangePage = ()=>{
            this.startInteraction('pagination', {
                view: this.view
            });
        };
        /**
   * Set the currently selected view and update the selected issue in the URL if provided.
   *
   * @param newView View to update
   * @param issueKey Issue key to update in the URL
   */ this.onSetView = (newView, issueKey)=>{
            this.startInteraction((0, $3wKQY.convertToView)(newView));
            this.view = newView;
            if (issueKey !== undefined) this.push({
                issueKey: issueKey
            }, true);
        };
        this.onRefinement = ()=>{
            this.startInteraction('refinement');
        };
        /**
   * Callback function called when internal changes are made to PIN's state which generates new JQL.
   *
   * @param jql string The new JQL string
   * @param clearFilter boolean When true we clear the filter from url params
   */ this.onChangeJql = (jql, clearFilter = false)=>{
            this.push({
                ...clearFilter ? {
                    filter: undefined
                } : {},
                jql: jql,
                // Clear issue key from URL whenever JQL changes
                issueKey: (0, $6vrw7.toIssueKey)('')
            });
        };
        this.onPageDataLoad = (selectedView)=>{
            if (selectedView !== undefined) this.view = selectedView;
            if (!this.state.initialised) this.setState({
                initialised: true
            });
            this.endInteractions();
        };
        this.onStartFilterChangeInteractionIfAny = (filter)=>{
            if (this.lastFilter !== filter) {
                this.lastFilter = filter;
                if (filter != null && ((0, $5as0a.isFilterId)(filter) || (0, $f6ie2.isFilterKey)(filter))) this.startInteraction('filter', {
                    filterId: filter
                });
            }
        };
        this.onChangeFilter = (filter)=>{
            this.push({
                ...filter ? {
                    filter: filter,
                    jql: undefined
                } : {
                    jql: undefined
                }
            }, true);
        };
        this.onChangeColumnConfiguration = ()=>{
            this.startInteraction('column-configuration');
        };
        this.startInteraction = (key, properties)=>{
            if (!this.activeInteractions.includes(key)) this.activeInteractions.push(key);
            const interaction = this.interactions[key];
            if (interaction) {
                interaction.properties = properties || {};
                interaction.metrics.start();
            }
        };
        this.endInteractions = ()=>{
            this.activeInteractions.forEach((key)=>{
                this.interactions[key]?.metrics.stop({
                    customData: this.interactions[key]?.properties
                });
            });
            this.activeInteractions = [];
        };
        const { location: location } = props;
        this.locationSearchStr = location.search;
        this.activeInteractions = [];
        this.view = (0, $jccNB.DEFAULT_VIEW_ID);
        this.interactions = $95ca2b279cc03087$var$initInteractions();
    }
    componentDidUpdate(prevProps) {
        const prevIssueKey = prevProps.match?.params.issueKey ?? '';
        const issueKey = this.props.match?.params.issueKey ?? '';
        // If issue key has changed from the router and does not match our internal key then update our state
        if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
            issueKey: issueKey
        });
    }
    push(newParams, shouldReplace = false) {
        const { match: match, push: push, location: location, replace: replace } = this.props;
        const historyAction = shouldReplace ? replace : push;
        const oldIssueKey = this.state.issueKey;
        const { projectKey: projectKey = match?.params.projectKey ?? '', issueKey: issueKey = oldIssueKey ?? '', ...params } = newParams;
        const newProjectKey = newParams.projectKey;
        const oldProjectKey = match?.params.projectKey;
        const projectKeyChanged = typeof newProjectKey !== 'undefined' && newProjectKey !== oldProjectKey;
        const newIssueKey = newParams.issueKey;
        const issueKeyParamsAreDefined = !!(newIssueKey || oldIssueKey);
        const issueKeyChanged = issueKeyParamsAreDefined && newIssueKey !== oldIssueKey;
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const query = (0, $53ciZ.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const queryParamsChanged = Object.keys(params).length !== 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))((0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(params, (param)=>param != null), query);
        if (projectKeyChanged || issueKeyChanged || queryParamsChanged) // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
        historyAction({
            pathname: `${(match && (0, $f6ie2.getUrlPrefix)(match.url)) ?? ''}/projects/${projectKey}/issues/${issueKey ?? ''}`,
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            search: (0, $53ciZ.stringify)({
                ...query,
                ...params
            }, {
                arrayFormat: 'comma'
            })
        });
        if (issueKeyChanged) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
        // re-rendered synchronously. Setting into state makes our render order more reliable.
        this.setState({
            issueKey: issueKey ?? ''
        });
        return true;
    }
    render() {
        const { match: match, location: location } = this.props;
        const { projectKey: projectKey } = match?.params ?? {};
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const params = (0, $53ciZ.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const { filter: filter, jql: jql } = params;
        this.onStartFilterChangeInteractionIfAny(filter);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wMrb.ProjectSubProductUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
            projectKey: projectKey ?? null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $81C0N.default), {
            showNav3Header: this.props.showNav3Header,
            projectKey: (0, $6vrw7.toProjectKey)(projectKey ?? ''),
            issueKey: (0, $6vrw7.toIssueKey)(this.state.issueKey),
            jql: jql,
            onChangeIssue: this.onChangeIssue,
            onChangePage: this.onChangePage,
            onPageDataLoad: this.onPageDataLoad,
            onChangeColumnConfiguration: this.onChangeColumnConfiguration,
            onChangeJql: this.onChangeJql,
            initialised: this.state.initialised,
            onRefinement: this.onRefinement,
            onSetView: this.onSetView,
            view: (0, $3wKQY.convertToView)(this.view),
            filter: filter,
            onChangeFilter: this.onChangeFilter
        }));
    }
}
const $95ca2b279cc03087$var$ProjectIssueNavigatorSPAWrapperRouterConsumer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "project-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95ca2b279cc03087$var$ProjectIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace
            }))));
const $95ca2b279cc03087$export$7f97e22e1179da90 = /*#__PURE__*/ (0, $eUqFw.memo)($95ca2b279cc03087$var$ProjectIssueNavigatorSPAWrapperRouterConsumer);
const $95ca2b279cc03087$var$ServiceDeskProjectIssueNavigatorSPAWrapperRouterConsumer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "project-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95ca2b279cc03087$var$ProjectIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace,
                showNav3Header: true
            }))));
const $95ca2b279cc03087$export$8d32398195782ca1 = /*#__PURE__*/ (0, $eUqFw.memo)($95ca2b279cc03087$var$ServiceDeskProjectIssueNavigatorSPAWrapperRouterConsumer);

});
parcelRegister("3wKQY", function(module, exports) {

$parcel$export(module.exports, "createRememoizeSelector", () => $5765d28cb6e68fa6$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $5765d28cb6e68fa6$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $5765d28cb6e68fa6$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $5765d28cb6e68fa6$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $5765d28cb6e68fa6$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $5765d28cb6e68fa6$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $5765d28cb6e68fa6$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $5765d28cb6e68fa6$export$ec4f6e9ea23bb55d);

var $df4Sl = parcelRequire("df4Sl");

var $jccNB = parcelRequire("jccNB");
const $5765d28cb6e68fa6$export$982d75deeca693ef = (0, $df4Sl.createSelectorCreator)((0, $df4Sl.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $5765d28cb6e68fa6$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $5765d28cb6e68fa6$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $5765d28cb6e68fa6$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($5765d28cb6e68fa6$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $5765d28cb6e68fa6$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $5765d28cb6e68fa6$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $jccNB.views).detail : (0, $jccNB.views).list;
const $5765d28cb6e68fa6$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $jccNB.views).detail ? 'detail' : 'list_default';
const $5765d28cb6e68fa6$export$5786a571e562003d = (viewMode)=>viewMode === (0, $jccNB.views).detail ? 'DETAIL' : 'LIST';
function $5765d28cb6e68fa6$export$70573498ee17fe1d(value) {
    return value != null;
}
const $5765d28cb6e68fa6$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($5765d28cb6e68fa6$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $5765d28cb6e68fa6$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $5765d28cb6e68fa6$export$6ce707b3eccb341d = (view)=>view === (0, $jccNB.views).detail ? 'detail' : 'list_default';
const $5765d28cb6e68fa6$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $jccNB.views).detail : (0, $jccNB.views).list;
const $5765d28cb6e68fa6$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};

});

parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("2wMrb", function(module, exports) {

$parcel$export(module.exports, "ProjectSubProductUpdater", () => $967eaa8dc0617775$export$bfbf80c212b0dcb9);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $i889l = parcelRequire("i889l");

var $fO5rB = parcelRequire("fO5rB");

var $6QL9v = parcelRequire("6QL9v");
const $967eaa8dc0617775$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SEaoU.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, data && (0, $i889l.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
            subProduct: (0, $6QL9v.getSubProductFromProjectType)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("i889l", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $bedad64595855821$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $bedad64595855821$export$8d1083037a4a6250);
const $bedad64595855821$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $bedad64595855821$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});



parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("81C0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d577cdf638fbbc4b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $1lXFP = parcelRequire("1lXFP");

var $aR8n6 = parcelRequire("aR8n6");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5as0a = parcelRequire("5as0a");

var $1h6H8 = parcelRequire("1h6H8");

var $jBY8A = parcelRequire("jBY8A");

var $cWCvn = parcelRequire("cWCvn");

var $eMGKM = parcelRequire("eMGKM");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

var $eAg61 = parcelRequire("eAg61");

var $5yh8X = parcelRequire("5yh8X");

var $7vf5z = parcelRequire("7vf5z");

var $buJlM = parcelRequire("buJlM");

var $cINNO = parcelRequire("cINNO");

var $cWgoa = parcelRequire("cWgoa");

var $ixwgj = parcelRequire("ixwgj");

var $iPtkN = parcelRequire("iPtkN");

var $f6ie2 = parcelRequire("f6ie2");

var $iJHZm = parcelRequire("iJHZm");

var $lB25E = parcelRequire("lB25E");
const $d577cdf638fbbc4b$var$getSearchInput = (projectKey, jql, filter)=>{
    const filterInput = (0, $5as0a.isFilterId)(filter) ? filter : (0, $f6ie2.mapFilterToJql)(projectKey, filter);
    return (0, $eMGKM.getSearchInput)(jql, filterInput);
};
const $d577cdf638fbbc4b$var$AsyncProjectIssueNavigatorWrapper = ({ filter: filter, jql: jqlParam, initialised: initialised, view: view, projectKey: projectKey, showNav3Header: showNav3Header = false, ...props })=>{
    const onMutateJqlParam = (0, $eMGKM.useUpdateUrlQueryParamCallback)('jql');
    const defaultJql = projectKey !== null && projectKey !== undefined ? (0, $f6ie2.getDefaultJql)(projectKey) : '';
    const jql = (0, $eMGKM.getJqlFromParamValues)(defaultJql, jqlParam, filter, (0, $f6ie2.mapFilterToJql).bind(undefined, projectKey), onMutateJqlParam);
    const issueTableProps = (0, $eUqFw.useMemo)(()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInlineIssueCreateEnabled', false) ? {
            projectContext: projectKey
        } : undefined, [
        projectKey
    ]);
    const searchInput = (0, $eUqFw.useMemo)(()=>$d577cdf638fbbc4b$var$getSearchInput(projectKey, jql, filter), [
        projectKey,
        jql,
        filter
    ]);
    const { data: projectContext } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResource));
    if ((0, $1ybV0.ff)('nin.global-scope_aqec8')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: globalEnrolmentData } = (0, $lB25E.useResource)((0, $cINNO.isNinGlobalScopeEnrolmentEnabledResource));
        if (globalEnrolmentData !== null && globalEnrolmentData !== undefined) (0, $1h6H8.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(globalEnrolmentData);
    }
    const response = (0, $buJlM.useRelayResource)((0, $cWgoa.issueNavigatorRelayResource));
    const { queryReference: queryReference } = response;
    const filterResponse = (0, $buJlM.useRelayResource)((0, $cWgoa.issueNavigatorFilterRelayResource));
    const filterQueryReference = filterResponse.queryReference;
    const hydrationResponse = (0, $buJlM.useRelayResource)((0, $cWgoa.issueNavigatorHydrationRelayResource));
    const hydrationQueryReference = hydrationResponse.queryReference;
    // During SSR our issueNavigatorRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPtkN.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorFilterRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPtkN.ProjectIssueNavigatorSkeleton), null);
    let resolvedProjectConfig;
    switch(projectContext?.simplified){
        case true:
            resolvedProjectConfig = (0, $7ZZxN.ProjectStyle).NEXT_GEN;
            break;
        case false:
            resolvedProjectConfig = (0, $7ZZxN.ProjectStyle).CLASSIC;
            break;
        default:
            resolvedProjectConfig = '';
    }
    const resolvedProjectType = projectContext?.projectType || '';
    const filterForAnalytics = filter && ((0, $5as0a.isFilterId)(filter) || (0, $f6ie2.isFilterKey)(filter)) ? filter : 'default';
    const attributes = {
        navigatorScope: 'project',
        projectConfig: resolvedProjectConfig,
        projectType: resolvedProjectType,
        viewLayout: view || '',
        jql: !!jqlParam,
        filter: filterForAnalytics,
        ...(0, $jBY8A.getIssueNavigatorFFAndFG)()
    };
    const extraInfo = {
        scope: 'project',
        filterId: filterForAnalytics,
        isJqlParamPresent: !!jqlParam,
        ...attributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && ((0, $5as0a.isFilterId)(filter) || (0, $f6ie2.isFilterKey)(filter)) && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iPtkN.ProjectIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eAg61.default), {
        ...props,
        showNav3Header: showNav3Header,
        projectKey: projectKey,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference,
        searchInput: searchInput,
        issueTableProps: issueTableProps,
        jqlBuilderProps: {
            hydrationQueryReference: hydrationQueryReference || undefined
        }
    }))), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "project-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $5yh8X.appBundleReadyMark),
            (0, $5yh8X.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $cWCvn.NINPageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)));
};
var $d577cdf638fbbc4b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($d577cdf638fbbc4b$var$AsyncProjectIssueNavigatorWrapper);

});
parcelRegister("1lXFP", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $1c31f74fac112a78$export$c7209ce2e0d060ea);

var $c7lez = parcelRequire("c7lez");
const $1c31f74fac112a78$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $c7lez.isLoaderError)(error)
    });

});

parcelRegister("jBY8A", function(module, exports) {

$parcel$export(module.exports, "getIssueNavigatorFFAndFG", () => $46fac0cd0242a9cb$export$f94cc81069819a21);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");
const $46fac0cd0242a9cb$export$f94cc81069819a21 = ()=>({
        isCohorted: (0, $1ybV0.ff)('nin.global-scope_aqec8'),
        isNinExposeTextOption: (0, $1ybV0.ff)('nin_expose_text_option_jql_builder_4kwzo'),
        isNinIssueLinksFieldNativeCellEnabled: (0, $1ybV0.ff)('extend-popup-cell-with-custom-override-content-and-parameters_obikd'),
        isNinShowFieldOptionsAsOnlyUnselectableEnabled: (0, $1ybV0.ff)('nin-show-field-options-as-only-unselectable_0s1y2'),
        isNinShowOutOfContextFieldsAsOnlyUnselectableEnabled: (0, $1ybV0.ff)('nin-enable-show-out-of-context-fields-as-only-unselectable_lmsy7'),
        isJscM1ApiUpdatesEnabled: (0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates')
    });

});

parcelRegister("cWCvn", function(module, exports) {

$parcel$export(module.exports, "marks", () => $eeca211cf721329d$export$3a8025f2f3e0c64);
$parcel$export(module.exports, "NINJqlBuilderAsyncLoad", () => $eeca211cf721329d$export$8ba5b9245ec3f6f9);
$parcel$export(module.exports, "NINPageLoad", () => $eeca211cf721329d$export$248c6c208e271182);
$parcel$export(module.exports, "markOnce", () => $eeca211cf721329d$export$243d158112bae094);

var $cFpT4 = parcelRequire("cFpT4");

var $6oH5O = parcelRequire("6oH5O");
const $eeca211cf721329d$export$3a8025f2f3e0c64 = {
    ISSUE_NAVIGATOR_START: 'ISSUE_NAVIGATOR_START',
    ISSUE_NAVIGATOR_END: 'ISSUE_NAVIGATOR_END',
    ISSUE_NAVIGATOR_UI_START: 'ISSUE_NAVIGATOR_UI_START',
    ISSUE_NAVIGATOR_UI_END: 'ISSUE_NAVIGATOR_UI_END',
    PAGE_ACTIONS_START: 'PAGE_ACTIONS_START',
    PAGE_ACTIONS_END: 'PAGE_ACTIONS_END',
    PAGE_ACTIONS_VIEW_SWITCHER_START: 'PAGE_ACTIONS_VIEW_SWITCHER_START',
    PAGE_ACTIONS_VIEW_SWITCHER_END: 'PAGE_ACTIONS_VIEW_SWITCHER_END',
    REFINEMENT_START: 'REFINEMENT_START',
    REFINEMENT_END: 'REFINEMENT_END',
    ISSUE_RESULTS_START: 'ISSUE_RESULTS_START',
    ISSUE_RESULTS_END: 'ISSUE_RESULTS_END',
    ISSUE_RESULTS_DETAIL_VIEW_START: 'ISSUE_RESULTS_DETAIL_VIEW_START',
    ISSUE_RESULTS_DETAIL_VIEW_END: 'ISSUE_RESULTS_DETAIL_VIEW_END',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END',
    ISSUE_RESULTS_LIST_VIEW_START: 'ISSUE_RESULTS_LIST_VIEW_START',
    ISSUE_RESULTS_LIST_VIEW_END: 'ISSUE_RESULTS_LIST_VIEW_END',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_START: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_START',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_END: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_END',
    ISSUE_APP_START: 'ISSUE_APP_START',
    ISSUE_APP_END: 'ISSUE_APP_END',
    ...(0, $6oH5O.JQL_BUILDER_PERFORMANCE_MARKS)
};
const $eeca211cf721329d$var$featureFlags = [
    'nin_expose_text_option_jql_builder_4kwzo',
    'nin-show-field-options-as-only-unselectable_0s1y2',
    'nin-enable-show-out-of-context-fields-as-only-unselectable_lmsy7'
];
const $eeca211cf721329d$export$8ba5b9245ec3f6f9 = (0, $cFpT4.metrics).pageSegmentLoad({
    key: 'new-issue-navigator-jql-builder',
    timings: [
        {
            key: 'product/issue-navigator/ui/jql-builder',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/hydrate',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic/js',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced/js',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_END
        }
    ],
    histogram: {
        initial: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        },
        transition: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        }
    },
    featureFlags: $eeca211cf721329d$var$featureFlags
});
const $eeca211cf721329d$export$248c6c208e271182 = (0, $cFpT4.metrics).pageLoad({
    key: 'new-issue-navigator',
    slo: {
        fmp: {
            initial: {
                threshold: 3000
            },
            transition: {
                threshold: 3000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    },
    ssr: {
        doneAsFmp: true
    },
    timings: [
        {
            key: 'product/issue-navigator',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_END
        },
        {
            key: 'product/issue-navigator/ui',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_END
        },
        {
            key: 'product/issue-navigator/ui/page-actions',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_END
        },
        {
            key: 'product/issue-navigator/ui/page-actions/view-switcher',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_END
        },
        {
            key: 'product/issue-navigator/ui/refinement',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.REFINEMENT_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.REFINEMENT_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/detail-view',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/detail-view/card-list',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/list-view',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/list-view/footer',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_END
        },
        {
            key: 'product/issue-navigator/ui/issue-app',
            startMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_APP_START,
            endMark: $eeca211cf721329d$export$3a8025f2f3e0c64.ISSUE_APP_END
        }
    ],
    featureFlags: $eeca211cf721329d$var$featureFlags
});
const $eeca211cf721329d$var$consumedMarks = [];
const $eeca211cf721329d$export$243d158112bae094 = (mark)=>{
    if (!$eeca211cf721329d$var$consumedMarks.includes(mark)) {
        $eeca211cf721329d$var$consumedMarks.push(mark);
        $eeca211cf721329d$export$248c6c208e271182.mark(mark);
        $eeca211cf721329d$export$8ba5b9245ec3f6f9.mark(mark);
    }
};

});
parcelRegister("6oH5O", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $40075442b615ad27$export$5fd6d8ece357700d);
// Performance marks
const $40075442b615ad27$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $40075442b615ad27$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $40075442b615ad27$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $40075442b615ad27$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $40075442b615ad27$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $40075442b615ad27$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $40075442b615ad27$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $40075442b615ad27$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $40075442b615ad27$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $40075442b615ad27$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $40075442b615ad27$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $40075442b615ad27$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("eMGKM", function(module, exports) {

$parcel$export(module.exports, "getJqlFromParamValues", () => $58d137b95f298e69$export$52de656da34011c3);
$parcel$export(module.exports, "getSearchInput", () => $58d137b95f298e69$export$2fa22ca814667ff4);
$parcel$export(module.exports, "useUpdateUrlQueryParamCallback", () => $58d137b95f298e69$export$f6b4f46bd8314b51);

var $eUqFw = parcelRequire("eUqFw");

var $5as0a = parcelRequire("5as0a");

var $lB25E = parcelRequire("lB25E");

var $jccNB = parcelRequire("jccNB");
const $58d137b95f298e69$export$52de656da34011c3 = (defaultJql, jqlParam, filter, /**
	 * when `filter` has a value that is not a standard numeric filter ID, consumers can provide a
	 * customMapper function to transform the filter value to a jql string. For example this is used
	 * by Project Issue Navigator to map filter query params such as '?filter=myopenissues into jql
	 * strings without calling the backend API
	 */ customMapper, /**
	 * callback in the event of jql being returned is different to the jqlParam value, such as when
	 * it is undefined and the default jql is being returned. This allows the caller to sync the new
	 * jql value with the `?jql=...` url query param
	 */ onMutateJqlParam)=>{
    let jql = jqlParam;
    if (typeof jql === 'string') return jql;
    if ((0, $5as0a.isFilterId)(filter)) return undefined;
    if (typeof filter === 'string' && customMapper) jql = customMapper(filter);
    if (jql === undefined) jql = defaultJql;
    if (jql !== jqlParam) onMutateJqlParam?.(jql);
    return jql;
};
const $58d137b95f298e69$var$getFilter = (filterInput)=>(0, $5as0a.isFilterId)(filterInput) ? {
        value: filterInput,
        type: (0, $jccNB.FilterTypes).ID
    } : {
        value: filterInput,
        type: (0, $jccNB.FilterTypes).JQL
    };
const $58d137b95f298e69$export$2fa22ca814667ff4 = (jqlInput, filterInput)=>{
    const filter = filterInput !== undefined ? $58d137b95f298e69$var$getFilter(filterInput) : undefined;
    if (jqlInput === undefined) {
        if (filter === undefined) throw new Error('filter is missing for search input');
        return filter;
    }
    if (filter === undefined) return {
        jql: jqlInput,
        type: (0, $jccNB.SearchInputTypes).JQL
    };
    return {
        jql: jqlInput,
        filter: filter,
        type: (0, $jccNB.SearchInputTypes).FILTER_AND_JQL
    };
};
const $58d137b95f298e69$export$f6b4f46bd8314b51 = (queryParamKey)=>{
    const [_, setQueryParam] = (0, $lB25E.useQueryParam)(queryParamKey);
    const setJqlQueryParamCallback = (0, $eUqFw.useCallback)((value)=>setQueryParam(value, 'replace'), [
        setQueryParam
    ]);
    return setJqlQueryParamCallback;
};

});

parcelRegister("eAg61", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e80ddbacac14f90$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1WU96 = parcelRequire("1WU96");

var $8GfI5 = parcelRequire("8GfI5");

var $6FP8W = parcelRequire("6FP8W");

var $kKzsy = parcelRequire("kKzsy");

var $1j7Qw = parcelRequire("1j7Qw");

var $2smFL = parcelRequire("2smFL");

var $bnHey = parcelRequire("bnHey");
const $3e80ddbacac14f90$var$ActionMenu = (customHeaderProps)=>{
    const { jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData } = customHeaderProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnHey.default), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: filterDetails?.jql !== jql,
        searchResultPageData: searchResultPageData
    });
};
const $3e80ddbacac14f90$var$ProjectIssueNavigator = ({ projectKey: projectKey, showNav3Header: showNav3Header = false, ...rest })=>{
    const CustomHeader = (0, $eUqFw.useCallback)((customHeaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2smFL.default), {
            projectKey: projectKey,
            ...customHeaderProps,
            isQuickFiltersDisabled: showNav3Header
        }), [
        projectKey,
        showNav3Header
    ]);
    const showNewNav = (0, $6FP8W.getWillShowNav4)() && !showNav3Header;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GfI5.default), {
        ...!showNewNav && {
            CustomHeader: CustomHeader
        },
        ...showNewNav && {
            ActionMenu: $3e80ddbacac14f90$var$ActionMenu
        },
        HeaderSkeletonImage: (0, $1j7Qw.ProjectIssueNavigatorHeaderSkeleton),
        isFeedbackButtonDisabled: true,
        ...rest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WU96.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null)));
};
var $3e80ddbacac14f90$export$2e2bcd8739ae039 = $3e80ddbacac14f90$var$ProjectIssueNavigator;

});
parcelRegister("8GfI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8432ffc32f4cd4cc$export$2e2bcd8739ae039);

var $2ktFK = parcelRequire("2ktFK");

var $fI66u = parcelRequire("fI66u");

var $bzxxY = parcelRequire("bzxxY");

var $l2JXs = parcelRequire("l2JXs");

var $9dV0n = parcelRequire("9dV0n");

var $cADg3 = parcelRequire("cADg3");

var $lk02k = parcelRequire("lk02k");

var $1zgpM = parcelRequire("1zgpM");

var $k7wca = parcelRequire("k7wca");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $79xbN = parcelRequire("79xbN");

var $9zysr = parcelRequire("9zysr");

var $b2n8w = parcelRequire("b2n8w");

var $jccNB = parcelRequire("jccNB");

var $cWCvn = parcelRequire("cWCvn");

var $651im = parcelRequire("651im");

var $4w4xT = parcelRequire("4w4xT");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");

var $cQBUE = parcelRequire("cQBUE");

var $ejYx7 = parcelRequire("ejYx7");

var $8CJEL = parcelRequire("8CJEL");

var $jSaIj = parcelRequire("jSaIj");

var $jtc88 = parcelRequire("jtc88");
const $8432ffc32f4cd4cc$export$e111e6466962b82b = (0, $k7wca.default);
// We memo as an optimisation to reduce forced re-renders when the immediate parent renders. In this case it's
// AppContextualAnalytics which will re-render when interacting with the JQL builder, e.g. opening picker.
const $8432ffc32f4cd4cc$var$FilterAndJqlProvider = /*#__PURE__*/ (0, $eUqFw.memo)(({ children: children, jql: jql, refetch: refetch, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dCaOY.FilterQueryProvider), {
        query: $8432ffc32f4cd4cc$export$e111e6466962b82b,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mEVr.ActiveJqlProvider), {
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable
    }, children)));
const $8432ffc32f4cd4cc$var$getFilter = (searchParam)=>{
    if (searchParam?.type === (0, $jccNB.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $jccNB.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $8432ffc32f4cd4cc$var$MaybeIssueSearch = (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), (0, $ejYx7.IssueSearch), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
const $8432ffc32f4cd4cc$var$MaybeIssueSearchQueryProvider = (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children), (0, $cQBUE.IssueSearchQueryProvider));
const $8432ffc32f4cd4cc$var$SelectedIssue = (0, $9zysr.componentWithCondition)(()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), ({ children: children, issues: issues, onChange: onChange, selectedIssueKey: selectedIssueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSaIj.SelectedIssue), {
        issues: issues,
        onChange: onChange,
        selectedIssueKey: selectedIssueKey
    }, children), ({ children: children, issuesOld: issuesOld, onChange: onChange, selectedIssueKey: selectedIssueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4w4xT.SelectedIssueContainer), {
        issueResults: issuesOld,
        onChange: onChange,
        selectedIssueKey: selectedIssueKey
    }, children));
const $8432ffc32f4cd4cc$var$IssueNavigator = ({ issueKey: issueKey, queryReference: queryReference, filterQueryReference: filterQueryReference, CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, onRefinement: onRefinement, onChangePage: onChangePage, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onSetView: onSetView, defaultJql: defaultJql, searchInput: searchInput, jqlBuilderProps: jqlBuilderProps, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_END);
    }, []);
    const filterInput = searchInput ? $8432ffc32f4cd4cc$var$getFilter(searchInput) : undefined;
    const issueQuery = (0, $iWLL0.usePreloadedQuery)((0, $1zgpM.default), queryReference);
    const issueDataCondition = (0, $iWLL0.useFragment)((0, $lk02k.default), issueQuery);
    const refetchQueryOld = (0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? null : issueDataCondition;
    const refetchQueryNew = (0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? issueDataCondition : null;
    /* eslint-disable @atlassian/relay/unused-fields */ const [issueNavigatorRefetchDataOld, issueNavigatorRefetchOld] = (0, $iWLL0.useRefetchableFragment)((0, $cADg3.default), refetchQueryOld);
    /* eslint-enable @atlassian/relay/unused-fields */ const [issueNavigatorRefetchDataNew, issueNavigatorRefetchNew] = (0, $iWLL0.useRefetchableFragment)((0, $9dV0n.default), refetchQueryNew);
    /* eslint-disable @atlassian/relay/unused-fields */ const { data: issueConnectionData, loadNext: loadNext, loadPrevious: loadPrevious, hasNext: hasNext, hasPrevious: hasPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious } = (0, $iWLL0.usePaginationFragment)((0, $l2JXs.default), issueNavigatorRefetchDataNew ?? null);
    /* eslint-enable @atlassian/relay/unused-fields */ const userPreferencesData = (0, $iWLL0.useFragment)((0, $bzxxY.default), issueQuery.jira?.userPreferences ?? null);
    const jqlBuilderWithAiData = (0, $iWLL0.useFragment)((0, $fI66u.default), // @ts-expect-error - No overload matches this call.
    issueQuery.jira);
    const issueResultsDataOld = issueNavigatorRefetchDataOld?.jira?.issueSearchStable ?? null;
    const viewResultDataOld = issueNavigatorRefetchDataOld?.jira?.issueSearchViewResult ?? null;
    const issueSearchViewDataOld = viewResultDataOld?.__typename === 'JiraIssueSearchView' ? viewResultDataOld : null;
    const issueResultsDataNew = issueConnectionData?.jira?.issueSearch ?? null;
    const viewResultDataNew = issueNavigatorRefetchDataNew?.jira?.issueSearchViewResult ?? null;
    const issueSearchViewDataNew = viewResultDataNew?.__typename === 'JiraIssueSearchView' ? viewResultDataNew : null;
    let issueResultsData;
    let viewResultData;
    let issueSearchViewData;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        issueResultsData = issueResultsDataNew;
        viewResultData = viewResultDataNew;
        issueSearchViewData = issueSearchViewDataNew;
    } else {
        issueResultsData = issueResultsDataOld;
        viewResultData = viewResultDataOld;
        issueSearchViewData = issueSearchViewDataOld;
    }
    const filterQuery = (0, $iWLL0.usePreloadedQuery)($8432ffc32f4cd4cc$export$e111e6466962b82b, filterQueryReference);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [filterData, refetchFilter] = (0, $iWLL0.useRefetchableFragment)((0, $2ktFK.default), filterQuery);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $651im.AppContextualAnalytics), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8432ffc32f4cd4cc$var$FilterAndJqlProvider, {
        refetch: refetchFilter,
        filterId: filterInput?.type === (0, $jccNB.FilterTypes).ID ? filterInput?.value : undefined,
        filterJql: filterInput?.type === (0, $jccNB.FilterTypes).JQL ? filterInput?.value : filterData?.jira?.filter?.jql,
        isFilterEditable: filterData.jira?.filter?.isEditable !== null ? filterData.jira?.filter?.isEditable : undefined,
        jql: searchInput?.type === (0, $jccNB.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $jccNB.SearchInputTypes).JQL ? searchInput?.jql : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8432ffc32f4cd4cc$var$MaybeIssueSearchQueryProvider, {
        refetch: issueNavigatorRefetchOld,
        issueResults: issueResultsDataOld,
        view: issueSearchViewDataOld,
        query: (0, $b2n8w.default),
        onPageDataLoad: onPageDataLoad,
        onChangePage: onChangePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8432ffc32f4cd4cc$var$MaybeIssueSearch, {
        onPageDataLoad: onPageDataLoad,
        view: issueSearchViewDataNew,
        refetch: issueNavigatorRefetchNew,
        onLoadNext: loadNext,
        onLoadPrevious: loadPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtc88.SelectedViewContainer), {
        onSetView: onSetView,
        fragment: issueSearchViewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8432ffc32f4cd4cc$var$SelectedIssue, {
        selectedIssueKey: issueKey,
        onChange: onChangeIssue,
        issuesOld: issueResultsDataOld,
        issues: issueResultsDataNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CJEL.default), {
        CustomHeader: CustomHeader,
        ActionMenu: ActionMenu,
        HeaderSkeletonImage: HeaderSkeletonImage,
        filter: filterData?.jira?.filter ?? null,
        onChangeIssue: onChangeIssue,
        onChangeFilter: onChangeFilter,
        onPageDataLoad: onPageDataLoad,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        onChangeJql: onChangeJql,
        onRefinement: onRefinement,
        defaultJql: defaultJql,
        issueResults: issueResultsData,
        viewResult: viewResultData,
        userPreferences: userPreferencesData,
        jqlBuilderProps: jqlBuilderProps,
        jqlBuilderWithAiKey: jqlBuilderWithAiData,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled,
        issueTableProps: issueTableProps
    })))))));
};
var $8432ffc32f4cd4cc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8432ffc32f4cd4cc$var$IssueNavigator);

});
parcelRegister("2ktFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7169b3b90081b930$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50c8e9868b3e511de3ea4f420144c717>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9dp8J = parcelRequire("9dp8J");
const $7169b3b90081b930$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filterAri"
        },
        {
            "kind": "RootArgument",
            "name": "includeFilter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $9dp8J.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_filterQuery",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "includeFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "filterAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Header_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "topBar_issueNavigator_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_ListView_filter"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$7169b3b90081b930$var$node.hash = "26da718314f181d4824f62928229af2b";
var $7169b3b90081b930$export$2e2bcd8739ae039 = $7169b3b90081b930$var$node;

});
parcelRegister("9dp8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f2570326db46ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0913b38543a4ac835cf7eeb194420fa3>>
 * @relayHash d4259e050915cf8816f8c8a4884d4afb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e
const $e1f2570326db46ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e",
            "metadata": {},
            "name": "FilterRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e1f2570326db46ca$var$node.hash = "26da718314f181d4824f62928229af2b";
var $e1f2570326db46ca$export$2e2bcd8739ae039 = $e1f2570326db46ca$var$node;

});


parcelRegister("fI66u", function(module, exports) {

$parcel$export(module.exports, "default", () => $011baa0df1c255ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b849f64e4a61be907eaec3accbf05bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $011baa0df1c255ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_jira",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$011baa0df1c255ea$var$node.hash = "e871bd0eb341a6573bd1df76ea8e5df1";
var $011baa0df1c255ea$export$2e2bcd8739ae039 = $011baa0df1c255ea$var$node;

});

parcelRegister("bzxxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1adef7b0668deb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ecec124bc87c6002f2c45127804b4c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c1adef7b0668deb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_userPreferences"
        }
    ],
    "type": "JiraUserPreferences"
};
$6c1adef7b0668deb$var$node.hash = "1143e00ad7112d3bc319370b0e0a4b27";
var $6c1adef7b0668deb$export$2e2bcd8739ae039 = $6c1adef7b0668deb$var$node;

});

parcelRegister("l2JXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b6c87f151c25a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<106cdbf5ca3c146af8085a03cdbeac30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $dNX5c = parcelRequire("dNX5c");
const $84b6c87f151c25a5$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "kind": "RootArgument",
                "name": "queryStatusForIssuekeyStrikethrough"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $dNX5c.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_issueSearchData",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "alias": "issueSearch",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "options",
                                "variableName": "options"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "__IssueNavigatorIssueSearchPagination__issueSearch_connection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "cursor"
                                    },
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedIssue_issueNavigator"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "endCursor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasPreviousPage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "startCursor"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$84b6c87f151c25a5$var$node.hash = "d2ac9ad04959fd7c243cb7854cfda4a3";
var $84b6c87f151c25a5$export$2e2bcd8739ae039 = $84b6c87f151c25a5$var$node;

});
parcelRegister("dNX5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $818c0b1d1f83e3f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7586d86afd444cd9439cdfb505ca19e8>>
 * @relayHash 7585bf3cc7fcae007d03d2e02a443b07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d09a4147902e4674ae786ac3a317a487c57ee09691432f5e44532edd0fda0906

var $dbXJb = parcelRequire("dbXJb");

var $6aQ5B = parcelRequire("6aQ5B");

var $57iDA = parcelRequire("57iDA");

var $91oFA = parcelRequire("91oFA");

var $9u07e = parcelRequire("9u07e");
const $818c0b1d1f83e3f1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryStatusForIssuekeyStrikethrough"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v16 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        },
        v19 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "text"
    }, v24 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v25 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "type"
    }, v29 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v30 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v22 /*: any*/ ,
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v32 = {
        "kind": "ScalarField",
        "name": "message"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v32 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v34 = [
        v22 /*: any*/ ,
        v17 /*: any*/ 
    ], v35 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v34 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v36 = {
        "kind": "ScalarField",
        "name": "date"
    }, v37 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v39 = {
        "kind": "ClientExtension",
        "selections": [
            v38 /*: any*/ 
        ]
    }, v40 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ ,
            v22 /*: any*/ ,
            v37 /*: any*/ ,
            v39 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v18 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v26 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v27 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v46 = [
        v22 /*: any*/ 
    ], v47 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v48 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000
            }
        ],
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v46 /*: any*/ 
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "storageKey": "selectedLabelsConnection(first:1000)"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            v48 /*: any*/ ,
            v22 /*: any*/ ,
            v39 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v22 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v51 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v18 /*: any*/ ,
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v17 /*: any*/ 
                        ]
                    },
                    v17 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    },
                                    v17 /*: any*/ 
                                ]
                            },
                            v17 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v51 /*: any*/ ,
                                    v22 /*: any*/ ,
                                    v17 /*: any*/ 
                                ]
                            },
                            v17 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v53 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v17 /*: any*/ 
        ]
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ ,
            v22 /*: any*/ ,
            v39 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v18 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v34 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v57 = {
        "concreteType": "JiraSprintConnection",
        "kind": "LinkedField",
        "name": "selectedSprintsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSprintEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v17 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "sprintId"
                            },
                            v22 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "state"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            v22 /*: any*/ ,
            v39 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v59 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v60 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v61 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v59 /*: any*/ ,
            v24 /*: any*/ ,
            v22 /*: any*/ ,
            v17 /*: any*/ ,
            v60 /*: any*/ 
        ]
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            v22 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v34 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v51 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v65 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v66 = [
        v47 /*: any*/ 
    ], v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    v65 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v66 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v18 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v16 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v27 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v17 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v17 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v17 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueLinkField"
    }, v68 = {
        "kind": "ScalarField",
        "name": "isStoryPointField"
    }, v69 = {
        "kind": "ScalarField",
        "name": "number"
    }, v70 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    v69 /*: any*/ ,
                    v22 /*: any*/ ,
                    v39 /*: any*/ 
                ],
                "type": "JiraNumberField"
            }
        ]
    }, v71 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                    },
                    v19 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v28 /*: any*/ ,
                                    v29 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v16 /*: any*/ ,
                                                            v21 /*: any*/ ,
                                                            v28 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            v17 /*: any*/ ,
                                                            v31 /*: any*/ ,
                                                            v33 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            v40 /*: any*/ ,
                                                            v41 /*: any*/ ,
                                                            v42 /*: any*/ ,
                                                            v43 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v23 /*: any*/ ,
                                                                    v22 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            v44 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            v49 /*: any*/ ,
                                                            v50 /*: any*/ ,
                                                            v52 /*: any*/ ,
                                                            v54 /*: any*/ ,
                                                            v55 /*: any*/ ,
                                                            v56 /*: any*/ ,
                                                            v58 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v61 /*: any*/ ,
                                                                    v22 /*: any*/ ,
                                                                    v37 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v62 /*: any*/ ,
                                                            v63 /*: any*/ ,
                                                            v64 /*: any*/ ,
                                                            v67 /*: any*/ ,
                                                            v70 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v72 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": v20 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v28 /*: any*/ ,
                                    v29 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v21 /*: any*/ ,
                                                            v28 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            v31 /*: any*/ ,
                                                            v33 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            v40 /*: any*/ ,
                                                            v41 /*: any*/ ,
                                                            v42 /*: any*/ ,
                                                            v43 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v28 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": v46 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraStatusCategoryField"
                                                            },
                                                            v45 /*: any*/ ,
                                                            v49 /*: any*/ ,
                                                            v52 /*: any*/ ,
                                                            v54 /*: any*/ ,
                                                            v55 /*: any*/ ,
                                                            v56 /*: any*/ ,
                                                            v58 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v28 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v59 /*: any*/ ,
                                                                            v60 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v37 /*: any*/ ,
                                                                    v39 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v62 /*: any*/ ,
                                                            v63 /*: any*/ ,
                                                            v64 /*: any*/ ,
                                                            v67 /*: any*/ ,
                                                            v70 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v74 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v75 = [
        v73 /*: any*/ ,
        v15 /*: any*/ ,
        v74 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchPaginationQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueSearchData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "args": v20 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsForIssueSearchView",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v16 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v22 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v17 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v21 /*: any*/ ,
                                                                                                        v27 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "queryStatusForIssuekeyStrikethrough",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v27 /*: any*/ ,
                                                                                                v17 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        v71 /*: any*/ ,
                                                        v72 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v71 /*: any*/ ,
                                                        v72 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueRowFieldSets",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v16 /*: any*/ ,
                                                                                                                v21 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v17 /*: any*/ ,
                                                                                                                v31 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraDatePickerField"
                                                                                                                },
                                                                                                                v41 /*: any*/ ,
                                                                                                                v42 /*: any*/ ,
                                                                                                                v43 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v44 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v48 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraLabelsField"
                                                                                                                },
                                                                                                                v50 /*: any*/ ,
                                                                                                                v52 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v53 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraPriorityField"
                                                                                                                },
                                                                                                                v55 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v57 /*: any*/ ,
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSprintField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                v62 /*: any*/ ,
                                                                                                                v63 /*: any*/ ,
                                                                                                                v64 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v68 /*: any*/ ,
                                                                                                                                v69 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v22 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": v66 /*: any*/ ,
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v75 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v75 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v74 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messages"
                                                }
                                            ],
                                            "type": "JiraInvalidJqlError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ],
                                            "type": "JiraInvalidSyntaxError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        v65 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options"
                            ],
                            "handle": "connection",
                            "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d09a4147902e4674ae786ac3a317a487c57ee09691432f5e44532edd0fda0906",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, $91oFA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, $9u07e.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, $57iDA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, $6aQ5B.default)
            }
        }
    };
}();
$818c0b1d1f83e3f1$var$node.hash = "d2ac9ad04959fd7c243cb7854cfda4a3";
var $818c0b1d1f83e3f1$export$2e2bcd8739ae039 = $818c0b1d1f83e3f1$var$node;

});


parcelRegister("9dV0n", function(module, exports) {

$parcel$export(module.exports, "default", () => $c910d15ed5269cee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<68353f83f54d1e8b8acf18c208378932>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $bQuAU = parcelRequire("bQuAU");
const $c910d15ed5269cee$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "after"
        },
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "before"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetIds"
        },
        {
            "kind": "RootArgument",
            "name": "filterId"
        },
        {
            "kind": "RootArgument",
            "name": "first"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "last"
        },
        {
            "kind": "RootArgument",
            "name": "namespace"
        },
        {
            "kind": "RootArgument",
            "name": "options"
        },
        {
            "kind": "RootArgument",
            "name": "queryStatusForIssuekeyStrikethrough"
        },
        {
            "kind": "RootArgument",
            "name": "shouldQueryFieldSetsById"
        },
        {
            "kind": "RootArgument",
            "name": "viewId"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $bQuAU.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_refetchQueryNew",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_issueSearchData"
        },
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "filterId",
                            "variableName": "filterId"
                        },
                        {
                            "kind": "Variable",
                            "name": "namespace",
                            "variableName": "namespace"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "issueSearchViewResult",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "issueSearch_issueNavigator"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "selectedView_issueNavigator_SelectedViewContainer"
                                }
                            ],
                            "type": "JiraIssueSearchView"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigatorUI_viewResult"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$c910d15ed5269cee$var$node.hash = "611c62c80fa368ece022de74701e875a";
var $c910d15ed5269cee$export$2e2bcd8739ae039 = $c910d15ed5269cee$var$node;

});
parcelRegister("bQuAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0420d658e796f98b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d2e63667ea4d3683a5001a7decc88b1>>
 * @relayHash 784013c205207295bb89a43e7e434ae9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e562c1dd9fe8b7b9270147e0bae9e70ca6d7a3fc414b5747441da3b1bfca3e9a

var $dbXJb = parcelRequire("dbXJb");

var $6aQ5B = parcelRequire("6aQ5B");

var $57iDA = parcelRequire("57iDA");

var $91oFA = parcelRequire("91oFA");

var $9u07e = parcelRequire("9u07e");
const $0420d658e796f98b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryStatusForIssuekeyStrikethrough"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v21 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v22 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v23 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v24 = [
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "kind": "ScalarField",
        "name": "text"
    }, v28 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v29 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v31 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "type"
    }, v33 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v34 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v26 /*: any*/ ,
                                    v18 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v36 = {
        "kind": "ScalarField",
        "name": "message"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v36 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v38 = [
        v26 /*: any*/ ,
        v18 /*: any*/ 
    ], v39 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v38 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v40 = {
        "kind": "ScalarField",
        "name": "date"
    }, v41 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v43 = {
        "kind": "ClientExtension",
        "selections": [
            v42 /*: any*/ 
        ]
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v26 /*: any*/ ,
            v41 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v30 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v31 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v50 = [
        v26 /*: any*/ 
    ], v51 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v52 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000
            }
        ],
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v50 /*: any*/ 
                    }
                ]
            },
            v51 /*: any*/ 
        ],
        "storageKey": "selectedLabelsConnection(first:1000)"
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            v52 /*: any*/ ,
            v26 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    v26 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v55 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v27 /*: any*/ ,
                            v18 /*: any*/ 
                        ]
                    },
                    v18 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    },
                                    v18 /*: any*/ 
                                ]
                            },
                            v18 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v55 /*: any*/ ,
                                    v26 /*: any*/ ,
                                    v18 /*: any*/ 
                                ]
                            },
                            v18 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v57 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v18 /*: any*/ 
        ]
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            v26 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v19 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v38 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v61 = {
        "concreteType": "JiraSprintConnection",
        "kind": "LinkedField",
        "name": "selectedSprintsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSprintEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "sprintId"
                            },
                            v26 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "state"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            v61 /*: any*/ ,
            v26 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v63 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v65 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v63 /*: any*/ ,
            v28 /*: any*/ ,
            v26 /*: any*/ ,
            v18 /*: any*/ ,
            v64 /*: any*/ 
        ]
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            v26 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v38 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v55 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v69 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v70 = [
        v51 /*: any*/ 
    ], v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    v69 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v70 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v19 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v17 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v31 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v18 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v18 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v18 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueLinkField"
    }, v72 = {
        "kind": "ScalarField",
        "name": "isStoryPointField"
    }, v73 = {
        "kind": "ScalarField",
        "name": "number"
    }, v74 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v72 /*: any*/ ,
                    v73 /*: any*/ ,
                    v26 /*: any*/ ,
                    v43 /*: any*/ 
                ],
                "type": "JiraNumberField"
            }
        ]
    }, v75 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                    },
                    v21 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v32 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v17 /*: any*/ ,
                                                            v25 /*: any*/ ,
                                                            v32 /*: any*/ ,
                                                            v34 /*: any*/ ,
                                                            v18 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            v37 /*: any*/ ,
                                                            v39 /*: any*/ ,
                                                            v44 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            v46 /*: any*/ ,
                                                            v47 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v27 /*: any*/ ,
                                                                    v26 /*: any*/ ,
                                                                    v43 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            v48 /*: any*/ ,
                                                            v49 /*: any*/ ,
                                                            v53 /*: any*/ ,
                                                            v54 /*: any*/ ,
                                                            v56 /*: any*/ ,
                                                            v58 /*: any*/ ,
                                                            v59 /*: any*/ ,
                                                            v60 /*: any*/ ,
                                                            v62 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v65 /*: any*/ ,
                                                                    v26 /*: any*/ ,
                                                                    v41 /*: any*/ ,
                                                                    v43 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v66 /*: any*/ ,
                                                            v67 /*: any*/ ,
                                                            v68 /*: any*/ ,
                                                            v71 /*: any*/ ,
                                                            v74 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v76 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": v24 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v32 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v25 /*: any*/ ,
                                                            v32 /*: any*/ ,
                                                            v34 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            v37 /*: any*/ ,
                                                            v39 /*: any*/ ,
                                                            v44 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            v46 /*: any*/ ,
                                                            v47 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v32 /*: any*/ ,
                                                                    v43 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": v50 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraStatusCategoryField"
                                                            },
                                                            v49 /*: any*/ ,
                                                            v53 /*: any*/ ,
                                                            v56 /*: any*/ ,
                                                            v58 /*: any*/ ,
                                                            v59 /*: any*/ ,
                                                            v60 /*: any*/ ,
                                                            v62 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v32 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v63 /*: any*/ ,
                                                                            v64 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v41 /*: any*/ ,
                                                                    v43 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v66 /*: any*/ ,
                                                            v67 /*: any*/ ,
                                                            v68 /*: any*/ ,
                                                            v71 /*: any*/ ,
                                                            v74 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v78 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v79 = [
        v77 /*: any*/ ,
        v16 /*: any*/ ,
        v78 /*: any*/ 
    ], v80 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v81 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryNew"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "args": v24 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsForIssueSearchView",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v27 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v17 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v26 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                v18 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "queryStatusForIssuekeyStrikethrough",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v25 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueRowFieldSets",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v32 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v17 /*: any*/ ,
                                                                                                                v25 /*: any*/ ,
                                                                                                                v32 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                v39 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v41 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraDatePickerField"
                                                                                                                },
                                                                                                                v45 /*: any*/ ,
                                                                                                                v46 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v27 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v48 /*: any*/ ,
                                                                                                                v49 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraLabelsField"
                                                                                                                },
                                                                                                                v54 /*: any*/ ,
                                                                                                                v56 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v57 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraPriorityField"
                                                                                                                },
                                                                                                                v59 /*: any*/ ,
                                                                                                                v60 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSprintField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v65 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v26 /*: any*/ ,
                                                                                                                        v41 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                v66 /*: any*/ ,
                                                                                                                v67 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                v71 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v72 /*: any*/ ,
                                                                                                                                v73 /*: any*/ ,
                                                                                                                                v42 /*: any*/ ,
                                                                                                                                v26 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": v70 /*: any*/ ,
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": v79 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": v79 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v77 /*: any*/ ,
                                                v78 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messages"
                                                }
                                            ],
                                            "type": "JiraInvalidJqlError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v36 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ],
                                            "type": "JiraInvalidSyntaxError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        v69 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasPreviousPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "startCursor"
                                        }
                                    ]
                                },
                                v80 /*: any*/ 
                            ]
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "issueSearchInput",
                                "options"
                            ],
                            "handle": "connection",
                            "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                            "kind": "LinkedHandle",
                            "name": "issueSearch"
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v20 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "issueSearchViewResult",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueSearchViewResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        v18 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasDefaultFieldSets"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "fieldSetSelectedState": "SELECTED"
                                                    }
                                                },
                                                v21 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v51 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v81 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSortable"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "width"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldType",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v81 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v80 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v36 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v18 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e562c1dd9fe8b7b9270147e0bae9e70ca6d7a3fc414b5747441da3b1bfca3e9a",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, $91oFA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, $9u07e.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, $57iDA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, $6aQ5B.default)
            }
        }
    };
}();
$0420d658e796f98b$var$node.hash = "611c62c80fa368ece022de74701e875a";
var $0420d658e796f98b$export$2e2bcd8739ae039 = $0420d658e796f98b$var$node;

});


parcelRegister("cADg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $08077de4b07f346c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f096784f35eab110daa1ba278efcd08>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $b2n8w = parcelRequire("b2n8w");
const $08077de4b07f346c$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "kind": "RootArgument",
                "name": "queryStatusForIssuekeyStrikethrough"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $b2n8w.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_refetchQueryOld",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "after",
                                "variableName": "after"
                            },
                            {
                                "kind": "Variable",
                                "name": "before",
                                "variableName": "before"
                            },
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "last",
                                "variableName": "last"
                            },
                            {
                                "kind": "Variable",
                                "name": "options",
                                "variableName": "options"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issueSearchStable",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_issueResults"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedIssueStateOld_issueNavigator_SelectedIssueContainer"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                            }
                        ]
                    },
                    {
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "filterId",
                                "variableName": "filterId"
                            },
                            {
                                "kind": "Variable",
                                "name": "namespace",
                                "variableName": "namespace"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewId",
                                "variableName": "viewId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "issueSearchViewResult",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_view"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "selectedView_issueNavigator_SelectedViewContainer"
                                    }
                                ],
                                "type": "JiraIssueSearchView"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_viewResult"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$08077de4b07f346c$var$node.hash = "5cbeda9e7274a0591cd064f7cbe9d9f5";
var $08077de4b07f346c$export$2e2bcd8739ae039 = $08077de4b07f346c$var$node;

});
parcelRegister("b2n8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dc6948a5a3de181$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ceb6f300739560850ba7ad40f29d2a72>>
 * @relayHash 10077dbd35d28b7b6dcc8c5023ab91ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bae268cd7cef19b3235480bb6f26e97aa6cda1aa61f845d7b0fb93a18ac91d2a

var $dbXJb = parcelRequire("dbXJb");

var $6aQ5B = parcelRequire("6aQ5B");

var $57iDA = parcelRequire("57iDA");

var $91oFA = parcelRequire("91oFA");

var $9u07e = parcelRequire("9u07e");
const $5dc6948a5a3de181$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryStatusForIssuekeyStrikethrough"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "kind": "ScalarField",
        "name": "key"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v18 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v19 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v20 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v21 = [
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "text"
    }, v26 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v27 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v29 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "type"
    }, v31 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v32 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v24 /*: any*/ ,
                                    v16 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v34 = {
        "kind": "ScalarField",
        "name": "message"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v34 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v36 = [
        v24 /*: any*/ ,
        v16 /*: any*/ 
    ], v37 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v36 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v38 = {
        "kind": "ScalarField",
        "name": "date"
    }, v39 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v41 = {
        "kind": "ClientExtension",
        "selections": [
            v40 /*: any*/ 
        ]
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            v38 /*: any*/ ,
            v24 /*: any*/ ,
            v39 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "dateTime"
            }
        ],
        "type": "JiraDateTimePickerField"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "summary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v28 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v29 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v48 = [
        v24 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v50 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000
            }
        ],
        "concreteType": "JiraLabelConnection",
        "kind": "LinkedField",
        "name": "selectedLabelsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraLabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v48 /*: any*/ 
                    }
                ]
            },
            v49 /*: any*/ 
        ],
        "storageKey": "selectedLabelsConnection(first:1000)"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            v50 /*: any*/ ,
            v24 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v27 /*: any*/ ,
                    v24 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v53 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                            v25 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    v16 /*: any*/ ,
                    {
                        "concreteType": "JiraColorField",
                        "kind": "LinkedField",
                        "name": "issueColorField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "colorKey"
                                    },
                                    v16 /*: any*/ 
                                ]
                            },
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v53 /*: any*/ ,
                                    v24 /*: any*/ ,
                                    v16 /*: any*/ 
                                ]
                            },
                            v16 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v55 = {
        "concreteType": "JiraPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            v16 /*: any*/ 
        ]
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            v55 /*: any*/ ,
            v24 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v15 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v36 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v59 = {
        "concreteType": "JiraSprintConnection",
        "kind": "LinkedField",
        "name": "selectedSprintsConnection",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraSprintEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v16 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "sprintId"
                            },
                            v24 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "state"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endDate"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            v59 /*: any*/ ,
            v24 /*: any*/ ,
            v41 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v61 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v62 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v63 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v61 /*: any*/ ,
            v26 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v62 /*: any*/ 
        ]
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            v24 /*: any*/ ,
            {
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v36 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v53 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v67 = [
        v49 /*: any*/ 
    ], v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v67 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "webUrl"
                                            },
                                            v15 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v22 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v29 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v16 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v16 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v16 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueLinkField"
    }, v69 = {
        "kind": "ScalarField",
        "name": "isStoryPointField"
    }, v70 = {
        "kind": "ScalarField",
        "name": "number"
    }, v71 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v69 /*: any*/ ,
                    v70 /*: any*/ ,
                    v24 /*: any*/ ,
                    v41 /*: any*/ 
                ],
                "type": "JiraNumberField"
            }
        ]
    }, v72 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                    },
                    v18 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v31 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v22 /*: any*/ ,
                                                            v23 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            v32 /*: any*/ ,
                                                            v16 /*: any*/ ,
                                                            v33 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            v37 /*: any*/ ,
                                                            v42 /*: any*/ ,
                                                            v43 /*: any*/ ,
                                                            v44 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v25 /*: any*/ ,
                                                                    v24 /*: any*/ ,
                                                                    v41 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            v46 /*: any*/ ,
                                                            v47 /*: any*/ ,
                                                            v51 /*: any*/ ,
                                                            v52 /*: any*/ ,
                                                            v54 /*: any*/ ,
                                                            v56 /*: any*/ ,
                                                            v57 /*: any*/ ,
                                                            v58 /*: any*/ ,
                                                            v60 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v63 /*: any*/ ,
                                                                    v24 /*: any*/ ,
                                                                    v39 /*: any*/ ,
                                                                    v41 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v64 /*: any*/ ,
                                                            v65 /*: any*/ ,
                                                            v66 /*: any*/ ,
                                                            v68 /*: any*/ ,
                                                            v71 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v73 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": v21 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v31 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v23 /*: any*/ ,
                                                            v30 /*: any*/ ,
                                                            v32 /*: any*/ ,
                                                            v33 /*: any*/ ,
                                                            v35 /*: any*/ ,
                                                            v37 /*: any*/ ,
                                                            v42 /*: any*/ ,
                                                            v43 /*: any*/ ,
                                                            v44 /*: any*/ ,
                                                            v45 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v30 /*: any*/ ,
                                                                    v41 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraStatusCategory",
                                                                        "kind": "LinkedField",
                                                                        "name": "statusCategory",
                                                                        "plural": false,
                                                                        "selections": v48 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "JiraStatusCategoryField"
                                                            },
                                                            v47 /*: any*/ ,
                                                            v51 /*: any*/ ,
                                                            v54 /*: any*/ ,
                                                            v56 /*: any*/ ,
                                                            v57 /*: any*/ ,
                                                            v58 /*: any*/ ,
                                                            v60 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v61 /*: any*/ ,
                                                                            v62 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    v39 /*: any*/ ,
                                                                    v41 /*: any*/ 
                                                                ],
                                                                "type": "JiraSingleSelectUserPickerField"
                                                            },
                                                            v64 /*: any*/ ,
                                                            v65 /*: any*/ ,
                                                            v66 /*: any*/ ,
                                                            v68 /*: any*/ ,
                                                            v71 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v74 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v75 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v76 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v77 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v78 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorResultsRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryOld"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorResultsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "before",
                                    "variableName": "before"
                                },
                                v14 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "options",
                                    "variableName": "options"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                },
                                                {
                                                    "args": v21 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsForIssueSearchView",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v24 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v16 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v23 /*: any*/ ,
                                                                                                        v29 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "queryStatusForIssuekeyStrikethrough",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v29 /*: any*/ ,
                                                                                                v16 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        v72 /*: any*/ ,
                                                        v73 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v72 /*: any*/ ,
                                                        v73 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueRowFieldSets",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v30 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                v32 /*: any*/ ,
                                                                                                                v16 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v39 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraDatePickerField"
                                                                                                                },
                                                                                                                v43 /*: any*/ ,
                                                                                                                v44 /*: any*/ ,
                                                                                                                v45 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                v46 /*: any*/ ,
                                                                                                                v47 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraLabelsField"
                                                                                                                },
                                                                                                                v52 /*: any*/ ,
                                                                                                                v54 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v55 /*: any*/ ,
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraPriorityField"
                                                                                                                },
                                                                                                                v57 /*: any*/ ,
                                                                                                                v58 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v59 /*: any*/ ,
                                                                                                                        v24 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSprintField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v39 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                v64 /*: any*/ ,
                                                                                                                v65 /*: any*/ ,
                                                                                                                v66 /*: any*/ ,
                                                                                                                v68 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v69 /*: any*/ ,
                                                                                                                                v70 /*: any*/ ,
                                                                                                                                v40 /*: any*/ ,
                                                                                                                                v24 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraNumberField"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "childIssues",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "activeProjectsOnly",
                                                                                    "value": true
                                                                                },
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 10
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": v67 /*: any*/ ,
                                                                            "storageKey": "issues(activeProjectsOnly:true,first:10)"
                                                                        }
                                                                    ],
                                                                    "type": "JiraChildIssuesWithinLimit"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v74 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": [
                                                v75 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                v77 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": [
                                                v77 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v76 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": [
                                                v75 /*: any*/ ,
                                                v77 /*: any*/ ,
                                                v76 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssueKeyFromNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssueKeyFromPreviousPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messages"
                                                }
                                            ],
                                            "type": "JiraInvalidJqlError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v34 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ],
                                            "type": "JiraInvalidSyntaxError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v74 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v14 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "issueSearchViewResult",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueSearchViewResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "fieldSetSelectedState": "SELECTED"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v31 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v78 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSortable"
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldSetPreferences",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetPreferences",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "width"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraFieldType",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v78 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v49 /*: any*/ ,
                                                v74 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasDefaultFieldSets"
                                        }
                                    ],
                                    "type": "JiraIssueSearchView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v34 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v16 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bae268cd7cef19b3235480bb6f26e97aa6cda1aa61f845d7b0fb93a18ac91d2a",
            "metadata": {},
            "name": "IssueNavigatorResultsRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, $dbXJb.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, $91oFA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, $9u07e.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, $57iDA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, $6aQ5B.default)
            }
        }
    };
}();
$5dc6948a5a3de181$var$node.hash = "5cbeda9e7274a0591cd064f7cbe9d9f5";
var $5dc6948a5a3de181$export$2e2bcd8739ae039 = $5dc6948a5a3de181$var$node;

});


parcelRegister("lk02k", function(module, exports) {

$parcel$export(module.exports, "default", () => $efaadc155685505c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58e29922a2265a3c4b6bbfefb99cf906>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $efaadc155685505c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_issueQuery",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryOld"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryNew"
                }
            ]
        }
    ],
    "type": "Query"
};
$efaadc155685505c$var$node.hash = "0296d13020f68034a057103bb2c3501c";
var $efaadc155685505c$export$2e2bcd8739ae039 = $efaadc155685505c$var$node;

});

parcelRegister("651im", function(module, exports) {

$parcel$export(module.exports, "useAppContextualAnalyticsActions", () => $da8f29e5e5066bf4$export$8aad1a4e4d637906);
$parcel$export(module.exports, "AppContextualAnalytics", () => $da8f29e5e5066bf4$export$2942dddca20a92ac);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $8WuJm = parcelRequire("8WuJm");

var $WBLbN = parcelRequire("WBLbN");
const $da8f29e5e5066bf4$var$Container = (0, $WBLbN.createContainer)();
const $da8f29e5e5066bf4$var$Store = (0, $WBLbN.createStore)({
    containedBy: $da8f29e5e5066bf4$var$Container,
    initialState: {
        issueNavigatorSearchSessionId: undefined
    },
    actions: {
        onJourneyStart: ()=>({ setState: setState })=>{
                const issueNavigatorSearchSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
                setState({
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                });
                return {
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                };
            }
    }
});
const $da8f29e5e5066bf4$export$e1e7a4797df1a656 = (0, $WBLbN.createHook)($da8f29e5e5066bf4$var$Store, {
    selector: (state)=>state.issueNavigatorSearchSessionId
});
const $da8f29e5e5066bf4$export$8aad1a4e4d637906 = (0, $WBLbN.createActionsHook)($da8f29e5e5066bf4$var$Store);
const $da8f29e5e5066bf4$var$AppContextualAnalyticsData = ({ children: children })=>{
    const [issueNavigatorSearchSessionId] = $da8f29e5e5066bf4$export$e1e7a4797df1a656();
    const attributes = (0, $eUqFw.useMemo)(()=>({
            issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
        }), [
        issueNavigatorSearchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueNavigator",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
const $da8f29e5e5066bf4$export$2942dddca20a92ac = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f29e5e5066bf4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da8f29e5e5066bf4$var$AppContextualAnalyticsData, null, children));

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("4w4xT", function(module, exports) {

$parcel$export(module.exports, "selectionState", () => $2f91fa7d6870d31d$export$a01d720722806cd3);
$parcel$export(module.exports, "SelectedIssueContainer", () => $2f91fa7d6870d31d$export$8b7bb55917259a5d);
$parcel$export(module.exports, "useSelectedIssueKey", () => $2f91fa7d6870d31d$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useSelectedIssueIndex", () => $2f91fa7d6870d31d$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useFocusedIssueIndex", () => $2f91fa7d6870d31d$export$4399fa4a8958cb76);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $2f91fa7d6870d31d$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useSelectedIssueStateOldActions", () => $2f91fa7d6870d31d$export$6f74178a4465fc7e);
$parcel$export(module.exports, "useIssueSelectionState", () => $2f91fa7d6870d31d$export$d703c03c23d04b26);
$parcel$export(module.exports, "useIsForcedSelectionOnReset", () => $2f91fa7d6870d31d$export$800a67a9f72a46a2);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $2f91fa7d6870d31d$export$988cbddd89e853c0);

var $jf5Jh = parcelRequire("jf5Jh");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cQBUE = parcelRequire("cQBUE");

var $4RwIp = parcelRequire("4RwIp");

var $gJkBi = parcelRequire("gJkBi");

const $2f91fa7d6870d31d$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        _rememoize: Date.now(),
        searchKey: '',
        selectedIssue: [
            null,
            (0, $6vrw7.toIssueKey)('')
        ],
        focusedIssue: null,
        nextResetStrategy: (0, $e99b4649deabf3b0$export$6953d2fd44491a2f),
        isFullPageIssueAppMode: false
    },
    actions: $gJkBi.default,
    name: 'IssueNavigatorSelectedIssueState'
});
const $2f91fa7d6870d31d$export$a01d720722806cd3 = {
    ISSUE_SELECTED: 'ISSUE_SELECTED',
    BLANK_ISSUE_SELECTED: 'BLANK_ISSUE_SELECTED',
    NO_SELECTION: 'NO_SELECTION'
};
const $2f91fa7d6870d31d$var$getSelectedIndex = (issueKeys, selectedIssueKey)=>{
    const index = selectedIssueKey && issueKeys ? issueKeys.indexOf(selectedIssueKey) : null;
    if (index !== null && index >= 0) // If key exists in result set, set selected index to the corresponding position
    return index;
    // Otherwise, set selected index to null (i.e. no visual selection)
    return null;
};
const $2f91fa7d6870d31d$var$Container = (0, $WBLbN.createContainer)($2f91fa7d6870d31d$var$Store, {
    onInit: ()=>({ dispatch: dispatch, setState: setState }, { selectedIssueKey: selectedIssueKey, issueKeys: issueKeys, searchKey: searchKey, view: view })=>{
            const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $jccNB.views).list;
            const initialIssueKey = selectedIssueKey || dispatch((0, $gJkBi.privateActions).getDefaultIssueKey()) || (0, $6vrw7.toIssueKey)('');
            const initialIndex = $2f91fa7d6870d31d$var$getSelectedIndex(issueKeys, initialIssueKey);
            setState({
                _rememoize: Date.now(),
                selectedIssue: [
                    initialIndex,
                    initialIssueKey
                ],
                searchKey: searchKey,
                isFullPageIssueAppMode: isFullPageIssueAppMode
            });
        },
    onUpdate: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { selectedIssueKey: nextIssueKey, isFetching: isFetching, searchKey: searchKey, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage })=>{
            if (isFetching) return;
            const state = getState();
            // Reset the selected issue whenever our search key has changed
            if (searchKey !== state.searchKey) {
                dispatch((0, $gJkBi.privateActions).resetSelectedIssue(!!nextIssueKey));
                setState({
                    searchKey: searchKey
                });
            } else if (nextIssueKey) {
                // Call our set action to ensure the selected issue index is up to date.
                dispatch($2f91fa7d6870d31d$var$Store.actions.setSelectedIssueByKey(nextIssueKey, false, false, false));
                // If an issue key has been specified while in list view then enter full page issue app mode.
                if (dispatch((0, $gJkBi.privateActions).isListViewWithoutIssueApp())) dispatch($2f91fa7d6870d31d$var$Store.actions.enterFullPageIssueAppMode());
                // If the issue key to select matches the first issue key from the next page then emit an event to go to
                // the next page.
                if (nextIssueKey === firstIssueKeyFromNextPage) dispatch($2f91fa7d6870d31d$var$Store.actions.selectFirstIssueOnNextPage());
                else if (nextIssueKey === lastIssueKeyFromPreviousPage) dispatch($2f91fa7d6870d31d$var$Store.actions.selectLastIssueOnPreviousPage());
            } else if (dispatch((0, $gJkBi.privateActions).isListViewWithIssueAppAndKey())) dispatch($2f91fa7d6870d31d$var$Store.actions.exitFullPageIssueAppMode());
        }
});
const $2f91fa7d6870d31d$export$8b7bb55917259a5d = ({ selectedIssueKey: selectedIssueKey, issueResults: issueResults, ...props })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { isFetching: isFetching, searchKey: searchKey, onIssueSearchForPage: onIssueSearchForPage, onIssueSearchForNextPage: onIssueSearchForNextPage, onIssueSearchForPreviousPage: onIssueSearchForPreviousPage } = (0, $cQBUE.useIssueSearchQuery)();
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const issueData = (0, $iWLL0.useFragment)((0, $jf5Jh.default), issueResults);
    const { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage } = issueData?.issueNavigatorPageInfo ?? {};
    const issueKeys = (0, $eUqFw.useMemo)(()=>issueData?.edges?.map((edge)=>(0, $6vrw7.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issueData?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f91fa7d6870d31d$var$Container, {
        isFetching: isFetching,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        issueKeys: issueKeys,
        view: (0, $3wKQY.convertToView)(view),
        onPageChange: onIssueSearchForPage,
        onNextPage: onIssueSearchForNextPage,
        onPreviousPage: onIssueSearchForPreviousPage,
        firstIssuePosition: firstIssuePosition ?? null,
        lastIssuePosition: lastIssuePosition ?? null,
        firstIssueKeyFromNextPage: firstIssueKeyFromNextPage ?? null,
        lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage ?? null,
        ...props
    });
};
const $2f91fa7d6870d31d$export$7cedcbfb2da7e49d = (0, $WBLbN.createStateHook)($2f91fa7d6870d31d$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>selectedIssue[1]
});
const $2f91fa7d6870d31d$export$a4b375f8f9b094ad = (0, $WBLbN.createStateHook)($2f91fa7d6870d31d$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>selectedIssue[0]
});
const $2f91fa7d6870d31d$export$4399fa4a8958cb76 = (0, $WBLbN.createHook)($2f91fa7d6870d31d$var$Store, {
    selector: ({ focusedIssue: focusedIssue })=>focusedIssue
});
const $2f91fa7d6870d31d$export$ed5cb04ac9d88e95 = (0, $WBLbN.createStateHook)($2f91fa7d6870d31d$var$Store, {
    selector: (0, $3wKQY.createRememoizeSelector)((state)=>state, ({ selectedIssue: selectedIssue })=>selectedIssue[1])
});
const $2f91fa7d6870d31d$export$6f74178a4465fc7e = (0, $WBLbN.createActionsHook)($2f91fa7d6870d31d$var$Store);
const $2f91fa7d6870d31d$export$d703c03c23d04b26 = (0, $WBLbN.createHook)($2f91fa7d6870d31d$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>{
        if (selectedIssue[0] !== null && selectedIssue[1].length > 0) return $2f91fa7d6870d31d$export$a01d720722806cd3.ISSUE_SELECTED;
        if (selectedIssue[0] !== null && selectedIssue[1].length === 0) return $2f91fa7d6870d31d$export$a01d720722806cd3.BLANK_ISSUE_SELECTED;
        return $2f91fa7d6870d31d$export$a01d720722806cd3.NO_SELECTION;
    }
});
const $2f91fa7d6870d31d$export$800a67a9f72a46a2 = (0, $WBLbN.createStateHook)($2f91fa7d6870d31d$var$Store, {
    selector: ({ nextResetStrategy: nextResetStrategy })=>nextResetStrategy === (0, $e99b4649deabf3b0$export$7438b768c88f1c5b) || nextResetStrategy === (0, $e99b4649deabf3b0$export$9d24b8100c251252)
});
const $2f91fa7d6870d31d$export$988cbddd89e853c0 = (0, $WBLbN.createStateHook)($2f91fa7d6870d31d$var$Store, {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});

});
parcelRegister("jf5Jh", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c40025ba39d82f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<705c41b65f0364f33cc5d8ace96b3876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51c40025ba39d82f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssueStateOld_issueNavigator_SelectedIssueContainer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "firstIssueKeyFromNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssueKeyFromPreviousPage"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$51c40025ba39d82f$var$node.hash = "337a019a583c3a28f545e54926fd4e34";
var $51c40025ba39d82f$export$2e2bcd8739ae039 = $51c40025ba39d82f$var$node;

});

parcelRegister("cQBUE", function(module, exports) {

$parcel$export(module.exports, "useIssueSearchQuery", () => $1a73b4f227531979$export$11659072884978f5);
$parcel$export(module.exports, "IssueSearchQueryProvider", () => $1a73b4f227531979$export$3f36a9df094c3109);

var $025Ej = parcelRequire("025Ej");

var $idw3X = parcelRequire("idw3X");

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $hzcvF = parcelRequire("hzcvF");

var $5iZBp = parcelRequire("5iZBp");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $6yplV = parcelRequire("6yplV");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $3mEVr = parcelRequire("3mEVr");

var $fsuyl = parcelRequire("fsuyl");

var $KuaNm = parcelRequire("KuaNm");

var $jAg40 = parcelRequire("jAg40");

var $edbn4 = parcelRequire("edbn4");

var $9rcnc = parcelRequire("9rcnc");
// Maximum number of times we will attempt to backfill our page of issues, e.g. if the user refreshes on page 3 but
// there are only 100 issues then we refresh page 2.
const $1a73b4f227531979$var$MAX_BACKFILL_RETRIES = 1;
const $1a73b4f227531979$var$IssueSearchQueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isFetching: false,
    isRefreshing: false,
    hasViewIdChanged: false,
    isNetworkError: false,
    isStalePage: false,
    onDeleteIssue: ()=>'',
    onFetchUncappedTotalIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearch: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchForPage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchForCurrentPage: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchForNextPage: ()=>false,
    onIssueSearchForPreviousPage: ()=>false,
    onIssueSearchForView: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueSearchRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onIssueByFieldsRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    searchKey: '',
    uncappedTotalIssueCount: {
        ...(0, $jAg40.uncappedTotalInitialState)
    }
});
$1a73b4f227531979$var$IssueSearchQueryContext.displayName = 'IssueSearchQueryContext';
const $1a73b4f227531979$export$11659072884978f5 = ()=>(0, $eUqFw.useContext)($1a73b4f227531979$var$IssueSearchQueryContext);
const $1a73b4f227531979$export$3f36a9df094c3109 = ({ refetch: refetch, issueResults: issueResults, view: view, query: query, onPageDataLoad: onPageDataLoad, onChangePage: onChangePage, children: children })=>{
    /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ const issueResultsData = (0, $iWLL0.useFragment)((0, $idw3X.default), issueResults);
    const viewData = (0, $iWLL0.useFragment)((0, $025Ej.default), view);
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ const [isRefreshing, setIsRefreshing] = (0, $eUqFw.useState)(false);
    const { jql: jql, filterId: filterId } = (0, $3mEVr.useActiveJql)();
    // Track if a refetch action is about to be called due to changing issueSearchInput
    const willFetch = (0, $eUqFw.useRef)(false);
    // Track currently selected view as a ref which will be used as an argument for any issue search queries
    const selectedViewId = (0, $eUqFw.useRef)((0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(viewData?.viewId, (0, $jccNB.DEFAULT_VIEW_ID)));
    // Only a fixed set of input variables are recomputed for our refetch query.
    const issueSearchInput = (0, $eUqFw.useMemo)(()=>jql === undefined && (0, $5as0a.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    const prevIssueSearchInput = (0, $hzcvF.usePreviousWithInitial)(issueSearchInput);
    const fieldSetIds = (0, $eUqFw.useMemo)(()=>viewData?.fieldSets?.edges.filter((0, $3wKQY.isNonNullish)).map(({ node: { fieldSetId: fieldSetId } })=>fieldSetId) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { onIssueSearchFail: onIssueSearchFail } = (0, $fsuyl.useExperienceAnalytics)(onPageDataLoad, selectedViewId.current);
    const { isFetching: isFetching, hasViewIdChanged: hasViewIdChanged, isNetworkError: isNetworkError, onIssueSearchRefetch: onIssueSearchRefetch, onIssueByFieldsRefetch: onIssueByFieldsRefetch, searchKey: searchKey, uncappedTotalIssueCount: uncappedTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $KuaNm.useIssueSearchRefetch)(refetch, query, issueSearchInput, selectedViewId.current, issueResultsData?.__id, fieldSetIds, onIssueSearchFail);
    const onIssueSearch = (0, $eUqFw.useCallback)(()=>{
        // Execute a new search against the network with current JQL input arguments
        onIssueSearchRefetch({}, {
            fetchPolicy: 'network-only'
        });
    }, [
        onIssueSearchRefetch
    ]);
    const hasIssueSearchInputChanged = !(0, $5iZBp.isShallowEqual)(issueSearchInput, prevIssueSearchInput);
    if (hasIssueSearchInputChanged) // We track this during render instead of waiting for useEffect to fire so there is no intermediary render for
    // downstream components where `jql` has changed but `isFetching` is still false.
    willFetch.current = true;
    (0, $eUqFw.useEffect)(()=>{
        if (hasIssueSearchInputChanged) {
            willFetch.current = false;
            const shouldLoadWithFilterViewId = selectedViewId.current !== 'detail' && issueSearchInput.filterId && (0, $5as0a.isCustomFilter)(issueSearchInput.filterId);
            const isCurrentViewIdInvalid = (0, $3wKQY.isFilterViewId)(selectedViewId.current) && selectedViewId.current !== `list_filter_${filterId}`;
            if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
                selectedViewId.current = (0, $3wKQY.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
                onIssueSearchRefetch({
                    viewId: selectedViewId.current
                }, {
                    fetchPolicy: 'network-only'
                });
            } else if (isCurrentViewIdInvalid) {
                selectedViewId.current = (0, $jccNB.DEFAULT_VIEW_ID);
                onIssueSearchRefetch({
                    viewId: selectedViewId.current
                }, {
                    fetchPolicy: 'network-only'
                });
            } else onIssueSearch();
        }
    }, [
        filterId,
        hasIssueSearchInputChanged,
        issueSearchInput,
        onIssueSearch,
        onIssueSearchRefetch,
        prevIssueSearchInput
    ]);
    const cursors = issueResultsData?.pageCursors?.around;
    const currentPageIndex = (0, $eUqFw.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const currentPage = currentPageIndex > -1 ? cursors?.[currentPageIndex] : undefined;
    const currentPageCursor = currentPage?.cursor ?? null;
    const currentPageNumber = currentPage?.pageNumber ?? 1;
    // Ignoring linting errors for the conditional call as the FF does not change during runtime
    const onSelectedViewMutation = (0, $edbn4.useSelectedViewMutation)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    /**
   * This will refetch issue and field configuration data for the provided view.
   */ const onIssueSearchForView = (0, $eUqFw.useCallback)((newViewId)=>{
        // Only allow non-anonymous users to invoke the mutation to update the user preference
        if (!isAnonymous && (0, $3wKQY.convertToView)(newViewId) !== (0, $3wKQY.convertToView)(selectedViewId.current)) onSelectedViewMutation(newViewId);
        // Update our viewId according to the selected view and refetch our issue data
        selectedViewId.current = newViewId;
        // If we have no currentPageCursor then we can assume our search has failed. In this case we need to force a
        // network call as otherwise Relay will serve null data from cache.
        const options = {
            isNewSearchKey: false,
            fetchPolicy: 'network-only'
        };
        onIssueSearchRefetch({
            after: currentPageCursor,
            viewId: selectedViewId.current
        }, options);
    }, [
        currentPageCursor,
        isAnonymous,
        onIssueSearchRefetch,
        onSelectedViewMutation
    ]);
    /**
   * Event emitted when an issue is deleted.
   */ const onDeleteIssue = (0, $9rcnc.useOnDeleteIssue)(issueResultsData);
    /**
   * This will refetch issue and field configuration data for the provided page cursor.
   */ const onIssueSearchForPage = (0, $eUqFw.useCallback)((after, options)=>{
        onIssueSearchRefetch({
            after: after
        }, options);
        onChangePage && onChangePage();
    }, [
        onChangePage,
        onIssueSearchRefetch
    ]);
    const onIssueSearchForNextPage = (0, $eUqFw.useCallback)((options)=>{
        if (currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) {
                onIssueSearchForPage(nextPage.cursor, options);
                return true;
            }
        }
        return false;
    }, [
        currentPageIndex,
        cursors,
        onIssueSearchForPage
    ]);
    const onIssueSearchForPreviousPage = (0, $eUqFw.useCallback)((options)=>{
        if (currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) {
                onIssueSearchForPage(previousPage.cursor, options);
                return true;
            }
        }
        return false;
    }, [
        currentPageIndex,
        cursors,
        onIssueSearchForPage
    ]);
    /**
   * This will refetch issue and field configuration data for the current page.
   */ const onIssueSearchForCurrentPage = (0, $eUqFw.useCallback)(()=>{
        onIssueSearchRefetch({
            after: currentPageCursor
        }, {
            fetchPolicy: 'network-only',
            isNewSearchKey: false
        });
    }, [
        currentPageCursor,
        onIssueSearchRefetch
    ]);
    /**
   * This will refresh issue and field configuration data for the provided page number (or current page if no page
   * number is given), triggering a new search using offset based pagination.
   */ const onIssueSearchRefresh = (0, $eUqFw.useCallback)((pageNumber = currentPageNumber)=>{
        setIsRefreshing(true);
        // Offset based request - API will run a new (i.e. non-stable) search for the given range
        onIssueSearchRefetch({
            first: pageNumber * (0, $jccNB.MAX_ISSUES_PER_PAGE),
            last: (0, $jccNB.MAX_ISSUES_PER_PAGE)
        }, {
            fetchPolicy: 'network-only',
            onComplete: ()=>{
                setIsRefreshing(false);
            },
            onError: ()=>{
                setIsRefreshing(false);
            },
            onUnsubscribe: ()=>{
                setIsRefreshing(false);
            }
        });
    }, [
        currentPageNumber,
        onIssueSearchRefetch
    ]);
    const backfillRetryCount = (0, $eUqFw.useRef)(0);
    const edges = issueResultsData?.edges ?? [];
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const isStalePage = total > 0 && edges.length === 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const prevIssueResultsData = (0, $hzcvF.usePrevious)(issueResultsData);
    /**
   * Handle the edge case where the user refreshes a page (e.g. page 3) and there are no issues present on the page.
   * In this scenario we automatically trigger a refresh request for the last available page with issues.
   */ (0, $eUqFw.useLayoutEffect)(()=>{
        if (issueResultsData !== prevIssueResultsData) {
            if (isStalePage && backfillRetryCount.current <= $1a73b4f227531979$var$MAX_BACKFILL_RETRIES) {
                const pageNumber = // If we've reached our limit then fallback to page 1
                backfillRetryCount.current === $1a73b4f227531979$var$MAX_BACKFILL_RETRIES ? 1 : Math.ceil(total / (0, $jccNB.MAX_ISSUES_PER_PAGE));
                onIssueSearchRefresh(pageNumber);
                backfillRetryCount.current += 1;
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueSearchResults backfill');
                return;
            }
            backfillRetryCount.current = 0;
        }
    }, [
        createAnalyticsEvent,
        issueResultsData,
        prevIssueResultsData,
        isStalePage,
        onIssueSearchRefresh,
        total
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isFetching: isFetching || willFetch.current,
            isRefreshing: isRefreshing,
            hasViewIdChanged: hasViewIdChanged,
            isNetworkError: isNetworkError,
            isStalePage: isStalePage,
            searchKey: searchKey,
            onDeleteIssue: onDeleteIssue,
            onIssueSearch: onIssueSearch,
            onIssueSearchForPage: onIssueSearchForPage,
            onIssueSearchForCurrentPage: onIssueSearchForCurrentPage,
            onIssueSearchForNextPage: onIssueSearchForNextPage,
            onIssueSearchForPreviousPage: onIssueSearchForPreviousPage,
            onIssueSearchForView: onIssueSearchForView,
            onIssueSearchRefresh: onIssueSearchRefresh,
            onIssueByFieldsRefetch: onIssueByFieldsRefetch,
            onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount,
            uncappedTotalIssueCount: uncappedTotalIssueCount
        }), [
        isFetching,
        isRefreshing,
        hasViewIdChanged,
        isNetworkError,
        isStalePage,
        searchKey,
        onDeleteIssue,
        onIssueSearch,
        onIssueSearchForPage,
        onIssueSearchForCurrentPage,
        onIssueSearchForNextPage,
        onIssueSearchForPreviousPage,
        onIssueSearchForView,
        onIssueSearchRefresh,
        onIssueByFieldsRefetch,
        onFetchUncappedTotalIssueCount,
        uncappedTotalIssueCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            issuesLoaded: total
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1a73b4f227531979$var$IssueSearchQueryContext.Provider, {
        value: contextValue
    }, children));
};

});
parcelRegister("025Ej", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e3345995e17f7d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc976390fd8b29859278e8cbe5af37b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1e3345995e17f7d6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueSearchFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldSets.edges.node.fieldSetId"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "fieldSets.edges.node"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldSets.edges"
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSets"
        }
    ],
    "type": "JiraIssueSearchView"
};
$1e3345995e17f7d6$var$node.hash = "73c821f489985ab33d96817dee8a6600";
var $1e3345995e17f7d6$export$2e2bcd8739ae039 = $1e3345995e17f7d6$var$node;

});

parcelRegister("idw3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0810963df552b4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5558bea4509b675d4b93f377171ac71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0810963df552b4b$var$node = function() {
    var v0 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isCurrent"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "pageNumber"
                            }
                        ]
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            v0 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$b0810963df552b4b$var$node.hash = "be5101b94f9ee67c52f693de30818ccb";
var $b0810963df552b4b$export$2e2bcd8739ae039 = $b0810963df552b4b$var$node;

});

parcelRegister("3mEVr", function(module, exports) {

$parcel$export(module.exports, "useActiveJql", () => $54d21fadf94bae18$export$caeaf867313163e4);
$parcel$export(module.exports, "ActiveJqlProvider", () => $54d21fadf94bae18$export$c69a9a3114157ae7);
$parcel$export(module.exports, "useResolvedJql", () => $54d21fadf94bae18$export$23e17984875d36b4);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $5as0a = parcelRequire("5as0a");
const $54d21fadf94bae18$var$ActiveJqlContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    jql: ''
});
$54d21fadf94bae18$var$ActiveJqlContext.displayName = 'ActiveJqlContext';
const $54d21fadf94bae18$export$caeaf867313163e4 = ()=>(0, $eUqFw.useContext)($54d21fadf94bae18$var$ActiveJqlContext);
const $54d21fadf94bae18$export$c69a9a3114157ae7 = ({ jql: jql, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql, children: children })=>{
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            isFilterEditable: isFilterEditable,
            filterJql: filterJql
        }), [
        jql,
        filterId,
        isFilterEditable,
        filterJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($54d21fadf94bae18$var$ActiveJqlContext.Provider, {
        value: contextValue
    }, children);
};
const $54d21fadf94bae18$export$23e17984875d36b4 = ()=>{
    const { jql: jql, filterJql: filterJql } = $54d21fadf94bae18$export$caeaf867313163e4();
    const filter = filterJql !== undefined ? filterJql : '';
    return jql !== undefined ? jql : filter;
};
const $54d21fadf94bae18$export$5d3c8489d1ae8bee = ()=>{
    const { filterId: filterId, jql: jql } = $54d21fadf94bae18$export$caeaf867313163e4();
    return `/issues/?${(0, $53ciZ.stringify)({
        jql: jql,
        ...(0, $5as0a.isFilterId)(filterId) ? {
            filter: filterId
        } : {}
    })}`;
};

});

parcelRegister("fsuyl", function(module, exports) {

$parcel$export(module.exports, "useExperienceAnalytics", () => $15469ae391633960$export$523b242362f30838);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $jccNB = parcelRequire("jccNB");
/**
 * This debouncer is shared between both the success and fail calls so that the last one called in the current event
 * loop tick is the one that gets logged. This helps us overcome weaknesses in the Relay-based rendering where an error
 * being thrown taks an additional render cycle to reach the component managing the analytics.
 */ const $15469ae391633960$var$sharedDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((action)=>action(), 0);
const $15469ae391633960$export$523b242362f30838 = (/**
	 * Event emitted when page data has loaded and the key experience is interactive.
	 */ onPageDataLoad, /**
	 * Currently selected view mode.
	 */ view, /**
	 * Analytics attributes to be emitted as part of success/fail experience events.
	 */ attributes)=>{
    const onExperienceStart = (0, $bDhRl.useExperienceStart)({
        experience: (0, $jccNB.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: (0, $jccNB.ANALYTICS_SOURCE)
    });
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: (0, $jccNB.EXPERIENCE_NAME),
        attributes: attributes
    });
    const onExperienceFail = (0, $4qhD6.useExperienceFail)({
        experience: (0, $jccNB.EXPERIENCE_NAME),
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const onFireUIAnalyticsEvent = (0, $eUqFw.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        (0, $jMP2a.fireUIAnalytics)(event, 'issueSearchResults', attributes ?? {});
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onIssueSearchSuccess = (0, $eUqFw.useCallback)(()=>{
        $15469ae391633960$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceSuccess();
            onFireUIAnalyticsEvent();
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceStart,
        onExperienceSuccess,
        onFireUIAnalyticsEvent,
        onPageDataLoad,
        view
    ]);
    const onIssueSearchFail = (0, $eUqFw.useCallback)((location, error)=>{
        $15469ae391633960$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceFail(location, error);
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceFail,
        onExperienceStart,
        onPageDataLoad,
        view
    ]);
    return {
        onIssueSearchSuccess: onIssueSearchSuccess,
        onIssueSearchFail: onIssueSearchFail
    };
};

});

parcelRegister("KuaNm", function(module, exports) {

$parcel$export(module.exports, "useIssueSearchRefetch", () => $3d0f02e3cc973d83$export$b550b6912621dc5d);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $hTLlD = parcelRequire("hTLlD");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $hompL = parcelRequire("hompL");

var $eI5EY = parcelRequire("eI5EY");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $hzcvF = parcelRequire("hzcvF");

var $gd0Sp = parcelRequire("gd0Sp");

var $jccNB = parcelRequire("jccNB");

var $jAg40 = parcelRequire("jAg40");

var $7YJjT = parcelRequire("7YJjT");

var $1toLw = parcelRequire("1toLw");
const $3d0f02e3cc973d83$var$searchErrorFlagId = (0, $eo17r.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $3d0f02e3cc973d83$var$searchErrorFlag = {
    id: $3d0f02e3cc973d83$var$searchErrorFlagId,
    type: 'error',
    title: (0, $1toLw.default).searchFailedTitle,
    description: (0, $1toLw.default).searchFailedDescription
};
const $3d0f02e3cc973d83$export$b550b6912621dc5d = (refetch, query, issueSearchInput, viewId, connectionId, fieldSetIds, onIssueSearchFail)=>{
    // Used to track and force a network-only request when a failed search has been cached
    const lastVariables = (0, $eUqFw.useRef)();
    const networkOnlyVariables = (0, $eUqFw.useRef)(new Set());
    const connectionIds = (0, $eUqFw.useRef)(new Set());
    const disposableOperations = (0, $eUqFw.useRef)(new Set());
    const [searchKey, setSearchKey] = (0, $eUqFw.useState)((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    const [isFetching, setIsFetching] = (0, $eUqFw.useState)(false);
    const [isNetworkError, setNetworkError] = (0, $eUqFw.useState)(false);
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { uncappedTotalIssueCount: uncappedTotalIssueCount, resetTotalIssueCount: resetTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $jAg40.useIssueSearchTotalCount)({
        cloudId: cloudId,
        issueSearchInput: issueSearchInput
    });
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const prevViewId = (0, $hzcvF.usePreviousWithInitial)(viewId);
    const prevFieldSetIds = (0, $hzcvF.usePreviousWithInitial)(fieldSetIds);
    const inFlightRequest = (0, $eUqFw.useRef)();
    // Release data for each fetchQuery operation allowing them to be garbage collected by Relay
    const onDisposeOperations = (0, $eUqFw.useCallback)(()=>{
        disposableOperations.current.forEach((disposable)=>disposable.dispose());
        disposableOperations.current.clear();
    }, []);
    // Dispose operations on unmount. This happens automatically for Relay query hooks, but we need to do it ourselves
    // when using fetchQuery.
    (0, $eUqFw.useEffect)(()=>onDisposeOperations, [
        onDisposeOperations
    ]);
    const onIssueByFieldsRefetch = (0, $7YJjT.useIssueByFieldsRefetch)(fieldSetIds);
    /**
	 * Invalidate all tracked issue connections so any subsequent queries with a matching identifier will hit the
	 * network.
	 */ const onInvalidateIssueConnection = (0, $eUqFw.useCallback)(()=>{
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            connectionIds.current.forEach((id)=>{
                const connection = store.get(id);
                connection && connection.invalidateRecord();
            });
            connectionIds.current.clear();
        });
    }, [
        environment
    ]);
    const onInvalidateAndDisposeIssueConnection = (0, $eUqFw.useCallback)(()=>{
        onInvalidateIssueConnection();
        onDisposeOperations();
    }, [
        onDisposeOperations,
        onInvalidateIssueConnection
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // If our fieldSetIds have changed then we must invalidate our connections so we don't serve stale issue data
        // with mismatched field sets.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fieldSetIds, prevFieldSetIds) && viewId === prevViewId) onInvalidateIssueConnection();
        if (connectionId !== undefined) // Track ids of our issue connections so they can be invalidated
        connectionIds.current.add(connectionId);
        else if (lastVariables.current) // If we do not receive a connection id then add the last used variables to our set of network-only
        // variables. This prevents us serving null responses from cache when there is no connection id to invalidate.
        networkOnlyVariables.current.add(lastVariables.current);
    });
    const onIssueSearchRefetch = (0, $eUqFw.useCallback)((variables, options)=>{
        // Some consumers may fire refetch queries before in-flight query
        // has been completed (e.g. while user is toggling columns on and off in
        // the column picker). In these situations, we always want to fetch latest
        // data from the API as column configuration may have changed for the user.
        // To do that, we disable Relay's automatic de-deduping of requests.
        inFlightRequest.current?.unsubscribe();
        const finalVariables = {
            cloudId: cloudId,
            issueSearchInput: issueSearchInput,
            first: (0, $jccNB.MAX_ISSUES_PER_PAGE),
            after: null,
            namespace: 'ISSUE_NAVIGATOR',
            viewId: viewId,
            options: null,
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
            filterId: null,
            queryStatusForIssuekeyStrikethrough: (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough'),
            ...variables
        };
        setIsFetching(true);
        setNetworkError(false);
        // Hide any search error flags currently visible
        dismissFlag($3d0f02e3cc973d83$var$searchErrorFlagId);
        let fetchPolicy = options?.fetchPolicy ?? 'store-or-network';
        // Check if our final variables match any of our network-only variables, and if so update the fetch policy.
        networkOnlyVariables.current.forEach((value)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(finalVariables, value)) {
                fetchPolicy = 'network-only';
                networkOnlyVariables.current.delete(value);
            }
        });
        if (fetchPolicy === 'network-only') onInvalidateAndDisposeIssueConnection();
        inFlightRequest.current = (0, $cNy9K.fetchQuery)(environment, query, finalVariables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        }).subscribe({
            complete: ()=>{
                /*
					 * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
					 * data will remain saved in the Relay store at any point after the request completes.
					 * We need to explicitly retain the operation to ensure it doesn't get deleted.
					 * See https://relay.dev/docs/api-reference/fetch-query/#behavior
					 */ const operation = (0, $cNy9K.createOperationDescriptor)((0, $cNy9K.getRequest)(query), finalVariables);
                disposableOperations.current.add(environment.retain(operation));
                lastVariables.current = finalVariables;
                let hasStoreRefetchCompleted = false;
                // We need to batch these updates as without it, Relay will cause multiple renders and invoke the
                // onComplete callback multiple times. This causes our success/fail analytics events to become
                // unreliable.
                // We introduced a similar fix for fetchQuery (see src/packages/platform/graphql/relay-scheduler/src/index.js)
                // and in React 18 will be able to remove this in favour of the startTransition/useTransition APIs.
                (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
                    refetch(finalVariables, {
                        fetchPolicy: 'store-only',
                        onComplete: ()=>{
                            // Relay will dispose the cached operation after a 5m timeout, in which case it will
                            // refetch the query from the store and retrigger the onComplete callback. We need to
                            // ensure this callback is invoked strictly once to prevent unexpected side effects,
                            // e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
                            if (hasStoreRefetchCompleted) return;
                            hasStoreRefetchCompleted = true;
                            setIsFetching(false);
                            options?.onComplete && options.onComplete();
                            if (options?.isNewSearchKey ?? true) {
                                setSearchKey((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
                                if (/*
										 * Once a refetch has completed, go back and inspect
										 * the request variables for the existence of an `after` cursor.
										 * If an `after` cursor was provided to the query, this means that
										 * the query was triggered via user navigating to a different page of
										 * results for the current search (I.e. by clicking pagination controls).
										 * For such events, do not reset the total issue count. We want it to
										 * be preserved across pagination.
										 */ !finalVariables.after) resetTotalIssueCount();
                            }
                        }
                    });
                });
            },
            error: (error)=>{
                setIsFetching(false);
                setNetworkError(true);
                onIssueSearchFail(`${(0, $jccNB.PACKAGE_NAME)}.issue-search-refetch`, error);
                showFlag($3d0f02e3cc973d83$var$searchErrorFlag);
                options?.onError && options.onError();
            },
            unsubscribe: ()=>{
                options?.onUnsubscribe && options.onUnsubscribe();
            }
        });
    }, [
        cloudId,
        issueSearchInput,
        viewId,
        dismissFlag,
        environment,
        query,
        onInvalidateAndDisposeIssueConnection,
        refetch,
        resetTotalIssueCount,
        onIssueSearchFail,
        showFlag
    ]);
    return {
        isFetching: isFetching,
        hasViewIdChanged: viewId !== prevViewId,
        isNetworkError: isNetworkError,
        onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount,
        onIssueSearchRefetch: onIssueSearchRefetch,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch,
        searchKey: searchKey,
        uncappedTotalIssueCount: uncappedTotalIssueCount
    };
};

});
parcelRegister("jAg40", function(module, exports) {

$parcel$export(module.exports, "uncappedTotalInitialState", () => $74264aab25afb4c1$export$31250fb09166d65c);
$parcel$export(module.exports, "useIssueSearchTotalCount", () => $74264aab25afb4c1$export$409cb8d89f7323a6);

var $7HT6h = parcelRequire("7HT6h");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");
const $74264aab25afb4c1$export$31250fb09166d65c = {
    count: undefined,
    isFetching: false,
    isError: false
};
const $74264aab25afb4c1$export$409cb8d89f7323a6 = ({ cloudId: cloudId, issueSearchInput: issueSearchInput })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [uncappedTotalIssueCount, setUncappedTotalIssueCount] = (0, $eUqFw.useState)({
        ...$74264aab25afb4c1$export$31250fb09166d65c
    });
    const resetTotalIssueCount = (0, $eUqFw.useCallback)(()=>{
        setUncappedTotalIssueCount({
            ...$74264aab25afb4c1$export$31250fb09166d65c
        });
    }, []);
    const onFetchUncappedTotalIssueCount = (0, $eUqFw.useCallback)(()=>{
        setUncappedTotalIssueCount({
            count: undefined,
            isFetching: true,
            isError: false
        });
        (0, $iWLL0.fetchQuery)(environment, (0, $7HT6h.default), {
            cloudId: cloudId,
            issueSearchInput: issueSearchInput
        }, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        }).toPromise().then((data)=>{
            const count = data ? data.jira?.issueSearchTotalCount : null;
            let isError = false;
            if (count === null || count === undefined) isError = true;
            setUncappedTotalIssueCount({
                count: count,
                isFetching: false,
                isError: isError
            });
        }).catch(()=>{
            setUncappedTotalIssueCount({
                count: null,
                isFetching: false,
                isError: true
            });
        });
    }, [
        cloudId,
        environment,
        issueSearchInput
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            uncappedTotalIssueCount: uncappedTotalIssueCount,
            resetTotalIssueCount: resetTotalIssueCount,
            onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount
        }), [
        uncappedTotalIssueCount,
        resetTotalIssueCount,
        onFetchUncappedTotalIssueCount
    ]);
};

});
parcelRegister("7HT6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c79110aa5f61d153$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a236f27c28dfc2d243f3bcac9e0ef56>>
 * @relayHash 929c7cfdabf85276ab021ca0aaf710c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3810891dc29174a6ad47903cc92470a66dff964fe69f524a8d29c29992b37a1
const $c79110aa5f61d153$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a3810891dc29174a6ad47903cc92470a66dff964fe69f524a8d29c29992b37a1",
            "metadata": {},
            "name": "issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c79110aa5f61d153$var$node.hash = "37773194a6f16231c4993e21b36ed872";
var $c79110aa5f61d153$export$2e2bcd8739ae039 = $c79110aa5f61d153$var$node;

});


parcelRegister("7YJjT", function(module, exports) {

$parcel$export(module.exports, "useIssueByFieldsRefetch", () => $9b70cc47533bb463$export$a3f7fddb3e08cea5);

var $a9FDt = parcelRequire("a9FDt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");

var $gd0Sp = parcelRequire("gd0Sp");

var $jccNB = parcelRequire("jccNB");
const $9b70cc47533bb463$export$a3f7fddb3e08cea5 = (fieldSets)=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((issuekey)=>(0, $cNy9K.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ (0, $a9FDt.default), /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ {
            cloudId: cloudId,
            issueSearchInput: {
                jql: `issueKey=${issuekey}`
            },
            fieldSetIds: fieldSets,
            amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS)
        }, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        cloudId,
        environment,
        fieldSets
    ]);
};

});
parcelRegister("a9FDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4272320f3aceb63a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a14886d0822bad85885f5342a0723096>>
 * @relayHash 2ea14df2a5aa395721961ee14b971373
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a47c21005ddddb0c8bea3d9b91ef24b1dcbc85ef263ad624ef0c36aa216dd86d

var $6aQ5B = parcelRequire("6aQ5B");

var $57iDA = parcelRequire("57iDA");

var $9u07e = parcelRequire("9u07e");
const $4272320f3aceb63a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = [
        v9 /*: any*/ ,
        v8 /*: any*/ 
    ], v11 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v12 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lazyIsEditableInIssueView"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "text"
    }, v15 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v16 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            v8 /*: any*/ 
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v18 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isDensityFull",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isInlineEditingEnabled",
                                                                    "value": true
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSetsForIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v5 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v7 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fieldId"
                                                                                                },
                                                                                                v6 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v8 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                v8 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "message"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraComponentConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedComponentsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraComponentEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponent",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v10 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraComponentsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "date"
                                                                                                        },
                                                                                                        v9 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "dateTime"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "summary"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v14 /*: any*/ ,
                                                                                                        v9 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v15 /*: any*/ ,
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v16 /*: any*/ ,
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Literal",
                                                                                                                    "name": "first",
                                                                                                                    "value": 1000
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v9 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v17 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v9 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v9 /*: any*/ ,
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraSingleLineTextField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "summaryField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v14 /*: any*/ ,
                                                                                                                        v8 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v8 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraColorField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueColorField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraColor",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "color",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "colorKey"
                                                                                                                                },
                                                                                                                                v8 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v8 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueTypeField",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v18 /*: any*/ ,
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                v8 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v8 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v9 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v13 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v10 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v8 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v9 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v7 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "accountId"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "picture"
                                                                                                                },
                                                                                                                v9 /*: any*/ ,
                                                                                                                v8 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "accountStatus"
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v9 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v10 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v9 /*: any*/ ,
                                                                                                                v18 /*: any*/ ,
                                                                                                                v8 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                {
                                                                                                                    "kind": "Variable",
                                                                                                                    "name": "first",
                                                                                                                    "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                                                                                                                }
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "PageInfo",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "pageInfo",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "hasNextPage"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "webUrl"
                                                                                                                                        },
                                                                                                                                        v13 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v7 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v16 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v8 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v8 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v8 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "isStoryPointField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "number"
                                                                                                                },
                                                                                                                v9 /*: any*/ ,
                                                                                                                v12 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraNumberField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a47c21005ddddb0c8bea3d9b91ef24b1dcbc85ef263ad624ef0c36aa216dd86d",
            "metadata": {},
            "name": "refetchIssue_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, $9u07e.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, $57iDA.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, $6aQ5B.default)
            }
        }
    };
}();
$4272320f3aceb63a$var$node.hash = "a1923415f412cb59e7b5d21b9573d30f";
var $4272320f3aceb63a$export$2e2bcd8739ae039 = $4272320f3aceb63a$var$node;

});


parcelRegister("1toLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdab0c2bb92238a0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cdab0c2bb92238a0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.services.issue-search-refetch.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.services.issue-search-refetch.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("edbn4", function(module, exports) {

$parcel$export(module.exports, "useSelectedViewMutation", () => $b7766e5802077f74$export$765f658bb8bac50f);

var $iQw8K = parcelRequire("iQw8K");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $dWLk9 = parcelRequire("dWLk9");

var $jccNB = parcelRequire("jccNB");
const $b7766e5802077f74$export$5786a571e562003d = (view)=>view.startsWith('list_') ? 'LIST' : 'DETAIL';
const $b7766e5802077f74$export$765f658bb8bac50f = ()=>{
    const userCloudId = (0, $dWLk9.useCloudId)();
    const [commitMutation] = (0, $iWLL0.useMutation)((0, $iQw8K.default));
    return (0, $eUqFw.useCallback)((view)=>{
        commitMutation({
            variables: {
                cloudId: userCloudId,
                searchLayout: $b7766e5802077f74$export$5786a571e562003d(view)
            },
            onError: (error)=>{
                (0, $guiFP.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira: {
                    userPreferences: {
                        setIssueNavigatorSearchLayout: {
                            success: true,
                            errors: [],
                            issueNavigatorSearchLayout: $b7766e5802077f74$export$5786a571e562003d(view)
                        }
                    }
                }
            }
        });
    }, [
        commitMutation,
        userCloudId
    ]);
};

});
parcelRegister("iQw8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a2486ffe7c40fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03678eaaa27509a9eaff05b3536ed7a3>>
 * @relayHash 411c1701f9d22f072c495ac536a98400
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f11f424abd082a8324c0f881b823fe5b84699dcb133b3f8c6933ee47e9907505
const $e1a2486ffe7c40fe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchLayout"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchLayout",
                                    "variableName": "searchLayout"
                                }
                            ],
                            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
                            "kind": "LinkedField",
                            "name": "setIssueNavigatorSearchLayout",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueNavigatorSearchLayout"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "selectedView_updateUserViewModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "selectedView_updateUserViewModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f11f424abd082a8324c0f881b823fe5b84699dcb133b3f8c6933ee47e9907505",
            "metadata": {},
            "name": "selectedView_updateUserViewModeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e1a2486ffe7c40fe$var$node.hash = "57781762cebd4351d1b1402acc6af4c4";
var $e1a2486ffe7c40fe$export$2e2bcd8739ae039 = $e1a2486ffe7c40fe$var$node;

});


parcelRegister("9rcnc", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $ae50790b46487e81$export$45e2b3c3de4980ed);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");
const $ae50790b46487e81$export$45e2b3c3de4980ed = (data)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((issueKeyToDelete)=>{
        const issueResultEdges = data?.edges ?? [];
        let previousIssueKey;
        let nextIssueKey;
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            let record;
            for(let i = 0; i < issueResultEdges.length; i++){
                const edge = issueResultEdges[i];
                const key = edge?.node?.key;
                // If we have not found the record holding the deleted issue
                if (!record) {
                    // Check if we've found the deleted issue
                    if (edge && key === issueKeyToDelete) record = store.get(edge.__id);
                    else if (key != null) previousIssueKey = key;
                } else if (key != null) {
                    nextIssueKey = key;
                    break;
                }
            }
            // Nullify the issue node which we'll handle in our UI as a deleted issue
            record?.setValue(null, 'node');
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        data?.edges
    ]);
};

});


parcelRegister("4RwIp", function(module, exports) {

$parcel$export(module.exports, "Container", () => $62f8b6bd8485eb34$export$42a852a2b6b56249);
$parcel$export(module.exports, "useSelectedViewState", () => $62f8b6bd8485eb34$export$b94206faaa871f9e);

var $WBLbN = parcelRequire("WBLbN");

var $jccNB = parcelRequire("jccNB");
const $62f8b6bd8485eb34$export$42a852a2b6b56249 = (0, $WBLbN.createContainer)();
const $62f8b6bd8485eb34$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        view: (0, $jccNB.DEFAULT_VIEW_ID)
    },
    containedBy: $62f8b6bd8485eb34$export$42a852a2b6b56249,
    actions: {
        setView: (view, issueKey)=>({ setState: setState }, { onSetView: onSetView, onIssueSearchForView: onIssueSearchForView })=>{
                setState({
                    view: view
                });
                onSetView(view, issueKey);
                onIssueSearchForView && onIssueSearchForView(view);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { view: view })=>{
                setState({
                    view: view
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.view !== prevProps.view) setState({
                    view: nextProps.view
                });
            }
    },
    name: 'IssueNavigatorSelectedViewStateNew'
});
const $62f8b6bd8485eb34$export$b94206faaa871f9e = (0, $WBLbN.createHook)($62f8b6bd8485eb34$var$Store);

});

parcelRegister("gJkBi", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $3ec0203584f6247d$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $3ec0203584f6247d$export$2e2bcd8739ae039);

var $dxIU5 = parcelRequire("dxIU5");

var $6vrw7 = parcelRequire("6vrw7");

var $jccNB = parcelRequire("jccNB");

const $3ec0203584f6247d$var$doSideEffectUpdate = ({ setState: setState, getState: getState, onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange, isSelectedByUserInteraction: isSelectedByUserInteraction })=>{
    const { selectedIssue: selectedIssue } = getState();
    setState({
        _rememoize: Date.now()
    });
    const key = selectedIssue[1];
    shouldNotifyOnChange && onChange && onChange(key, isSelectedByUserInteraction);
};
const $3ec0203584f6247d$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($3ec0203584f6247d$var$doSideEffectUpdate, 600);
const $3ec0203584f6247d$var$doSideEffectUpdates = (shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction)=>{
    if (shouldDebounce) $3ec0203584f6247d$var$doDebouncedSideEffectUpdate({
        setState: setState,
        getState: getState,
        onChange: onChange,
        shouldNotifyOnChange: shouldNotifyOnChange,
        isSelectedByUserInteraction: isSelectedByUserInteraction
    });
    else $3ec0203584f6247d$var$doSideEffectUpdate({
        setState: setState,
        getState: getState,
        onChange: onChange,
        shouldNotifyOnChange: shouldNotifyOnChange,
        isSelectedByUserInteraction: isSelectedByUserInteraction
    });
};
const $3ec0203584f6247d$var$setSelectedIssueByKey = (issueKey, shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange, issueKeys: issueKeys })=>{
        if (!issueKey.length) return;
        const index = issueKey.length ? issueKeys?.findIndex((key)=>key === issueKey) : -1;
        if (index !== -1) setState({
            selectedIssue: [
                index,
                issueKey
            ]
        });
        else setState({
            selectedIssue: [
                null,
                issueKey
            ]
        });
        $3ec0203584f6247d$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
const $3ec0203584f6247d$var$setSelectedIssueByIndex = (issueIndex, shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange, issueKeys: issueKeys })=>{
        if (issueIndex >= issueKeys.length) return;
        const key = issueKeys[issueIndex];
        setState({
            selectedIssue: [
                issueIndex,
                key
            ]
        });
        $3ec0203584f6247d$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
/**
 * Return the position of the currently selected issue in the search results or `null` if the selected issue could not
 * be found.
 */ const $3ec0203584f6247d$var$getSelectedIssuePosition = ()=>({ getState: getState }, { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage })=>{
        // Incomplete page info from our search results so don't compute the position
        if (firstIssuePosition === null || lastIssuePosition === null) return null;
        const { selectedIssue: selectedIssue, nextResetStrategy: nextResetStrategy } = getState();
        const [selectedIssueIndex, selectedIssueKey] = selectedIssue;
        // If the first issue key from next page is selected or if we are forcing selection of the first issue on
        // pagination then we optimistically compute the issue position.
        if (selectedIssueKey === firstIssueKeyFromNextPage || nextResetStrategy === (0, $e99b4649deabf3b0$export$7438b768c88f1c5b)) return lastIssuePosition + 1;
        // If the last issue key from previous page is selected or if we are forcing selection of the last issue on
        // pagination then we optimistically compute the issue position.
        if (selectedIssueKey === lastIssueKeyFromPreviousPage || nextResetStrategy === (0, $e99b4649deabf3b0$export$9d24b8100c251252)) return firstIssuePosition - 1;
        if (selectedIssueIndex !== null) return selectedIssueIndex + firstIssuePosition;
        return null;
    };
/**
 * Returns true if the currently selected issue is within the page of issues.
 */ const $3ec0203584f6247d$var$isSelectedIssueOnPage = ()=>({ dispatch: dispatch }, { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition })=>{
        const selectedIssuePosition = dispatch($3ec0203584f6247d$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && firstIssuePosition !== null && lastIssuePosition !== null && selectedIssuePosition >= firstIssuePosition && selectedIssuePosition <= lastIssuePosition;
    };
/**
 * Returns true if the currently selected issue is the first issue on the page.
 */ const $3ec0203584f6247d$var$isFirstIssueOnPage = ()=>({ dispatch: dispatch }, { firstIssuePosition: firstIssuePosition })=>{
        const selectedIssuePosition = dispatch($3ec0203584f6247d$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && selectedIssuePosition === firstIssuePosition;
    };
/**
 * Returns true if the currently selected issue is the last issue on the page.
 */ const $3ec0203584f6247d$var$isLastIssueOnPage = ()=>({ dispatch: dispatch }, { lastIssuePosition: lastIssuePosition })=>{
        const selectedIssuePosition = dispatch($3ec0203584f6247d$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && selectedIssuePosition === lastIssuePosition;
    };
/**
 * Return the next issue in the search results from the currently selected issue. If the selected issue is the last item
 * in the page of search results then the first key from the next page is returned with a boolean indicating the issue
 * belongs to the next page.
 */ const $3ec0203584f6247d$var$getNextIssue = ()=>({ getState: getState, dispatch: dispatch }, { firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, issueKeys: issueKeys })=>{
        const { selectedIssue: selectedIssue } = getState();
        const [selectedIssueIndex] = selectedIssue;
        let nextIssueKey = '';
        let nextIssueIndex = null;
        let isOnNextPage = false;
        if (dispatch($3ec0203584f6247d$var$isLastIssueOnPage())) {
            nextIssueKey = firstIssueKeyFromNextPage ?? '';
            isOnNextPage = true;
        } else if (selectedIssueIndex !== null && dispatch($3ec0203584f6247d$var$isSelectedIssueOnPage())) {
            nextIssueIndex = selectedIssueIndex + 1;
            nextIssueKey = issueKeys[nextIssueIndex];
        }
        return {
            issueKey: nextIssueKey,
            issueIndex: nextIssueIndex,
            isOnNextPage: isOnNextPage
        };
    };
/**
 * Return the previous issue in the search results from the currently selected issue. If the selected issue is the first
 * item in the page of search results then the last key from the previous page is returned with a boolean indicating the
 * issue belongs to the previous page.
 */ const $3ec0203584f6247d$var$getPreviousIssue = ()=>({ getState: getState, dispatch: dispatch }, { lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage, issueKeys: issueKeys })=>{
        const { selectedIssue: selectedIssue } = getState();
        const [selectedIssueIndex] = selectedIssue;
        let previousIssueKey = '';
        let previousIssueIndex = null;
        let isOnPreviousPage = false;
        const selectedIssuePosition = dispatch($3ec0203584f6247d$var$getSelectedIssuePosition());
        // Ignore the first issue on the first page, which always has position '1'
        if (selectedIssuePosition === 1) return {
            issueKey: previousIssueKey,
            issueIndex: previousIssueIndex,
            isOnPreviousPage: isOnPreviousPage
        };
        if (dispatch($3ec0203584f6247d$var$isFirstIssueOnPage())) {
            previousIssueKey = lastIssueKeyFromPreviousPage ?? '';
            isOnPreviousPage = true;
        } else if (selectedIssueIndex !== null && dispatch($3ec0203584f6247d$var$isSelectedIssueOnPage())) {
            previousIssueIndex = selectedIssueIndex - 1;
            previousIssueKey = issueKeys[previousIssueIndex];
        }
        return {
            issueKey: previousIssueKey,
            issueIndex: previousIssueIndex,
            isOnPreviousPage: isOnPreviousPage
        };
    };
/**
 * Emit an event to fetch the next page of issues and force the first issue on the page (including null issues) to
 * be selected when the new connection of search results is loaded.
 */ const $3ec0203584f6247d$var$selectFirstIssueOnNextPage = ()=>({ setState: setState }, { onNextPage: onNextPage })=>{
        setState({
            nextResetStrategy: (0, $e99b4649deabf3b0$export$7438b768c88f1c5b)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $e99b4649deabf3b0$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        const handled = onNextPage({
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
        // Revert the reset strategy if the page was unchanged
        if (!handled) revertStrategy();
    };
/**
 * Emit an event to fetch the previous page of issues and force the last issue on the page (including null issues)
 * to be selected when the new connection of search results is loaded.
 */ const $3ec0203584f6247d$var$selectLastIssueOnPreviousPage = ()=>({ setState: setState }, { onPreviousPage: onPreviousPage })=>{
        setState({
            nextResetStrategy: (0, $e99b4649deabf3b0$export$9d24b8100c251252)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $e99b4649deabf3b0$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        const handled = onPreviousPage({
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
        // Revert the reset strategy if the page was unchanged
        if (!handled) revertStrategy();
    };
const $3ec0203584f6247d$var$selectIssueOnPage = (after, shouldSelectLastIssue)=>({ setState: setState }, { onPageChange: onPageChange })=>{
        setState({
            nextResetStrategy: shouldSelectLastIssue ? (0, $e99b4649deabf3b0$export$9d24b8100c251252) : (0, $e99b4649deabf3b0$export$7438b768c88f1c5b)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $e99b4649deabf3b0$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        onPageChange(after, {
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $3ec0203584f6247d$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch })=>{
        const { issueKey: issueKey, issueIndex: issueIndex, isOnNextPage: isOnNextPage } = dispatch($3ec0203584f6247d$var$getNextIssue());
        if (issueIndex !== null) {
            dispatch($3ec0203584f6247d$var$setSelectedIssueByIndex(issueIndex, shouldDebounce));
            return true;
        }
        if (issueKey !== '') {
            dispatch($3ec0203584f6247d$var$setSelectedIssueByKey(issueKey, shouldDebounce));
            return true;
        }
        // If we do not have an issue key but our issue to select is on the next page (i.e. deleted issue) then we
        // dispatch an action to fetch the next page (rather than relying on the container update action).
        if (isOnNextPage) {
            dispatch($3ec0203584f6247d$var$selectFirstIssueOnNextPage());
            return true;
        }
        return false;
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $3ec0203584f6247d$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch })=>{
        const { issueKey: issueKey, issueIndex: issueIndex, isOnPreviousPage: isOnPreviousPage } = dispatch($3ec0203584f6247d$var$getPreviousIssue());
        if (issueIndex !== null) {
            dispatch($3ec0203584f6247d$var$setSelectedIssueByIndex(issueIndex, shouldDebounce));
            return true;
        }
        if (issueKey !== '') {
            dispatch($3ec0203584f6247d$var$setSelectedIssueByKey(issueKey, shouldDebounce));
            return true;
        }
        // If we do not have an issue key but our issue to select is on the previous page (i.e. deleted issue) then we
        // dispatch an action to fetch the previous page (rather than relying on the container update action).
        if (isOnPreviousPage) {
            dispatch($3ec0203584f6247d$var$selectLastIssueOnPreviousPage());
            return true;
        }
        return false;
    };
const $3ec0203584f6247d$var$setFocusedIssueByIndex = (issueIndex)=>({ setState: setState })=>{
        setState({
            focusedIssue: issueIndex
        });
    };
const $3ec0203584f6247d$var$resetFocusedIssue = ()=>({ setState: setState })=>{
        setState({
            focusedIssue: null
        });
    };
const $3ec0203584f6247d$var$deselectIssue = (shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange })=>{
        setState({
            selectedIssue: [
                null,
                (0, $6vrw7.toIssueKey)('')
            ]
        });
        $3ec0203584f6247d$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
const $3ec0203584f6247d$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $3ec0203584f6247d$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
const $3ec0203584f6247d$var$getDefaultIssueKey = ()=>(_, { issueKeys: issueKeys })=>issueKeys.find((nonEmptyKey)=>Boolean(nonEmptyKey));
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $3ec0203584f6247d$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $jccNB.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $3ec0203584f6247d$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssue: selectedIssue } = getState();
        return view === (0, $jccNB.views).list && isFullPageIssueAppMode && !!selectedIssue[1];
    };
/**
 * Reset the selected issue based on the current reset strategy.
 *
 * @param hasNextIssueKey `true` if a selected issue key is specified in the URL
 */ const $3ec0203584f6247d$var$resetSelectedIssue = (hasNextIssueKey)=>({ dispatch: dispatch, getState: getState, setState: setState }, { issueKeys: issueKeys })=>{
        const { nextResetStrategy: nextResetStrategy } = getState();
        // Update to default reset strategy
        setState({
            nextResetStrategy: (0, $e99b4649deabf3b0$export$6953d2fd44491a2f)
        });
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($3ec0203584f6247d$var$isListViewWithoutIssueApp());
        // If there is a selected issue specified in the URL, e.g. pagination, then `isSelectedByUserInteraction` should
        // be `true` to push a new entry in the browser history stack. Otherwise, if there is no selected issue in the
        // URL, e.g. new search, then `isSelectedByUserInteraction` should be false to replace the existing entry.
        const isSelectedByUserInteraction = hasNextIssueKey;
        // Index of the last issue on the issue list
        const lastIssueIndex = issueKeys.length - 1;
        switch(nextResetStrategy){
            case 0, $e99b4649deabf3b0$export$9d24b8100c251252:
                dispatch($3ec0203584f6247d$var$setSelectedIssueByIndex(lastIssueIndex, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                dispatch($3ec0203584f6247d$var$setFocusedIssueByIndex(lastIssueIndex));
                break;
            case 0, $e99b4649deabf3b0$export$7438b768c88f1c5b:
                dispatch($3ec0203584f6247d$var$setSelectedIssueByIndex(0, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                dispatch($3ec0203584f6247d$var$setFocusedIssueByIndex(0));
                break;
            case 0, $e99b4649deabf3b0$export$6953d2fd44491a2f:
            default:
                dispatch($3ec0203584f6247d$var$setSelectedIssueByIndex(0, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                break;
        }
    };
const $3ec0203584f6247d$export$e324594224ef24da = {
    setSelectedIssueByKey: $3ec0203584f6247d$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $3ec0203584f6247d$var$setSelectedIssueByIndex,
    getSelectedIssuePosition: $3ec0203584f6247d$var$getSelectedIssuePosition,
    getNextIssue: $3ec0203584f6247d$var$getNextIssue,
    getPreviousIssue: $3ec0203584f6247d$var$getPreviousIssue,
    selectNextIssue: $3ec0203584f6247d$var$selectNextIssue,
    selectPreviousIssue: $3ec0203584f6247d$var$selectPreviousIssue,
    setFocusedIssueByIndex: $3ec0203584f6247d$var$setFocusedIssueByIndex,
    deselectIssue: $3ec0203584f6247d$var$deselectIssue,
    selectFirstIssueOnNextPage: $3ec0203584f6247d$var$selectFirstIssueOnNextPage,
    selectLastIssueOnPreviousPage: $3ec0203584f6247d$var$selectLastIssueOnPreviousPage,
    selectIssueOnPage: $3ec0203584f6247d$var$selectIssueOnPage,
    enterFullPageIssueAppMode: $3ec0203584f6247d$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $3ec0203584f6247d$var$exitFullPageIssueAppMode,
    resetFocusedIssue: $3ec0203584f6247d$var$resetFocusedIssue
};
const $3ec0203584f6247d$export$3f1be494d407b77a = {
    getDefaultIssueKey: $3ec0203584f6247d$var$getDefaultIssueKey,
    isListViewWithoutIssueApp: $3ec0203584f6247d$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $3ec0203584f6247d$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $3ec0203584f6247d$var$resetSelectedIssue
};
var $3ec0203584f6247d$export$2e2bcd8739ae039 = $3ec0203584f6247d$export$e324594224ef24da;

});
const $e99b4649deabf3b0$export$6953d2fd44491a2f = 'DEFAULT_FIRST';
const $e99b4649deabf3b0$export$7438b768c88f1c5b = 'FORCE_FIRST';
const $e99b4649deabf3b0$export$9d24b8100c251252 = 'FORCE_LAST';



parcelRegister("dCaOY", function(module, exports) {

$parcel$export(module.exports, "useFilterQuery", () => $99e32d8ca2cce6d8$export$5576614cd48b552);
$parcel$export(module.exports, "FilterQueryProvider", () => $99e32d8ca2cce6d8$export$78b7af8c530bd7a4);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $jpJd3 = parcelRequire("jpJd3");

var $huI7r = parcelRequire("huI7r");

var $6Fbwh = parcelRequire("6Fbwh");

var $4rWQe = parcelRequire("4rWQe");

var $dWLk9 = parcelRequire("dWLk9");
const $99e32d8ca2cce6d8$var$FilterQueryContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    filterQueryIsFetching: false,
    filterQueryIsNetworkError: false
});
$99e32d8ca2cce6d8$var$FilterQueryContext.displayName = 'FilterQueryContext';
const $99e32d8ca2cce6d8$export$5576614cd48b552 = ()=>(0, $eUqFw.useContext)($99e32d8ca2cce6d8$var$FilterQueryContext);
const $99e32d8ca2cce6d8$export$78b7af8c530bd7a4 = ({ refetch: refetch, query: query, children: children, filterId: filterId })=>{
    const [filterQueryIsFetching, setFilterQueryIsFetching] = (0, $eUqFw.useState)(false);
    const [filterQueryIsNetworkError, setFilterQueryNetworkError] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const activationId = (0, $4rWQe.useActivationId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const inFlightRequest = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        if (filterId !== undefined && (0, $5as0a.isFilterId)(filterId)) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            const variables = {
                filterAri: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                includeFilter: true
            };
            setFilterQueryIsFetching(true);
            setFilterQueryNetworkError(false);
            inFlightRequest.current = (0, $iWLL0.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only'
                    });
                    setFilterQueryIsFetching(false);
                },
                error: ()=>{
                    setFilterQueryIsFetching(false);
                    setFilterQueryNetworkError(true);
                }
            });
        } else // Need to refetch when filter is undefined so it reset filterData to empty
        refetch({
            includeFilter: false,
            filterAri: ''
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        activationId,
        cloudId,
        environment,
        filterId,
        query,
        refetch,
        setFilterQueryIsFetching,
        setFilterQueryNetworkError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (filterId !== undefined && (0, $5as0a.isFilterId)(filterId)) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jpJd3.addFilterToRecent)(filterId, analyticsEvent);
        }
    }, [
        filterId,
        createAnalyticsEvent
    ]);
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            filterQueryIsFetching: filterQueryIsFetching,
            filterQueryIsNetworkError: filterQueryIsNetworkError
        }), [
        filterQueryIsFetching,
        filterQueryIsNetworkError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99e32d8ca2cce6d8$var$FilterQueryContext.Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("jpJd3", function(module, exports) {

$parcel$export(module.exports, "addFilterToRecent", () => $2c8dfd154f8cdde8$export$1f166118234b128e);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $2c8dfd154f8cdde8$export$1f166118234b128e = async (filterId, analyticsEvent)=>{
    try {
        await (0, $lRmyA.performPostRequest)((0, $2e7c19c8e80df97b$export$3fdeac1311ebf841) + filterId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            event: analyticsEvent,
            meta: {
                id: 'addFilterToRecent',
                packageName: 'jiraIssueNavigatorCustomFilters'
            }
        });
    }
};

});
const $2e7c19c8e80df97b$export$3fdeac1311ebf841 = '/rest/issueNav/1/history/saveFilter/';



parcelRegister("ejYx7", function(module, exports) {

$parcel$export(module.exports, "IssueSearch", () => $082998465bfaa87a$export$ce2913cefc6e57dc);

var $ixyrG = parcelRequire("ixyrG");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5as0a = parcelRequire("5as0a");

var $dWLk9 = parcelRequire("dWLk9");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $3mEVr = parcelRequire("3mEVr");

var $6phOL = parcelRequire("6phOL");

var $edbn4 = parcelRequire("edbn4");
const $082998465bfaa87a$export$ce2913cefc6e57dc = ({ children: children, onPageDataLoad: onPageDataLoad, view: view, refetch: refetch, onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious })=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { jql: jql, filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const issueSearchInput = (0, $eUqFw.useMemo)(()=>jql === undefined && (0, $5as0a.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    const onSelectedViewMutation = (0, $edbn4.useSelectedViewMutation)();
    const viewData = (0, $iWLL0.useFragment)((0, $ixyrG.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6phOL.IssueSearchServiceContainer), {
        cloudId: cloudId,
        environment: environment,
        issueSearchInput: issueSearchInput,
        viewId: (0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(viewData?.viewId, (0, $jccNB.DEFAULT_VIEW_ID)),
        onPageDataLoad: onPageDataLoad,
        onSelectedViewMutation: onSelectedViewMutation,
        refetch: refetch,
        onLoadNext: onLoadNext,
        onLoadPrevious: onLoadPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious
    }, children);
};

});
parcelRegister("ixyrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $55471389d7fcb8d3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aef77ba13ca109722cbb13f7c1c07d3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55471389d7fcb8d3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        }
    ],
    "type": "JiraIssueSearchView"
};
$55471389d7fcb8d3$var$node.hash = "948ce2677fadfd61c1d24c19e846b034";
var $55471389d7fcb8d3$export$2e2bcd8739ae039 = $55471389d7fcb8d3$var$node;

});

parcelRegister("6phOL", function(module, exports) {

$parcel$export(module.exports, "IssueSearchServiceContainer", () => $d3197e84eac4d33b$export$3744f0b7d0dd1936);
$parcel$export(module.exports, "Store", () => $d3197e84eac4d33b$export$390f32400eaf98c9);

var $jG2Eu = parcelRequire("jG2Eu");

var $5iZBp = parcelRequire("5iZBp");

var $WBLbN = parcelRequire("WBLbN");

var $chJLE = parcelRequire("chJLE");
const $d3197e84eac4d33b$var$initialState = {
    onLoadNext: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onLoadPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    isLoadingNext: false,
    isLoadingPrevious: false,
    hasNext: false,
    hasPrevious: false,
    disposables: [],
    isFetching: false,
    networkError: false,
    searchKey: null
};
const $d3197e84eac4d33b$export$3744f0b7d0dd1936 = (0, $WBLbN.createContainer)();
const $d3197e84eac4d33b$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    initialState: $d3197e84eac4d33b$var$initialState,
    actions: $chJLE.actions,
    containedBy: $d3197e84eac4d33b$export$3744f0b7d0dd1936,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch((0, $chJLE.onContainerUpdate)()),
        onContainerUpdate: (nextProps, prevProps)=>({ dispatch: dispatch })=>{
                dispatch((0, $chJLE.onContainerUpdate)());
                const hasIssueSearchInputChanged = !(0, $5iZBp.isShallowEqual)(nextProps.issueSearchInput, prevProps.issueSearchInput);
                if (hasIssueSearchInputChanged) dispatch((0, $chJLE.actions).onRefetch());
            },
        onDestroy: ()=>({ getState: getState })=>{
                const { disposables: disposables } = getState();
                // Dispose of any manually retained operations when the container is unmounted
                disposables.forEach((disposable)=>disposable.dispose());
            }
    }
});

});
parcelRegister("chJLE", function(module, exports) {

$parcel$export(module.exports, "onContainerUpdate", () => $5d167967d5aed28e$export$ab8f0de40a3a2d2d);
$parcel$export(module.exports, "actions", () => $5d167967d5aed28e$export$e324594224ef24da);

var $lEfVV = parcelRequire("lEfVV");

var $cNy9K = parcelRequire("cNy9K");

var $eI5EY = parcelRequire("eI5EY");

var $bQuAU = parcelRequire("bQuAU");

var $jccNB = parcelRequire("jccNB");
const $5d167967d5aed28e$export$ab8f0de40a3a2d2d = ()=>({ setState: setState }, { onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious })=>{
        const infiniteScrollProps = {
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        };
        setState(infiniteScrollProps);
    };
const $5d167967d5aed28e$export$e324594224ef24da = {
    onChangeView: (viewId)=>({ dispatch: dispatch }, { onSelectedViewMutation: onSelectedViewMutation })=>{
            onSelectedViewMutation(viewId);
            dispatch($5d167967d5aed28e$export$e324594224ef24da.onRefetch({
                viewId: viewId
            }));
        },
    onRefetch: (variables = {}, options = {})=>({ getState: getState, setState: setState }, { cloudId: cloudId, environment: environment, issueSearchInput: issueSearchInput, refetch: refetch, viewId: viewId })=>{
            let { inFlightRequest: inFlightRequest } = getState();
            // Some consumers may fire refetch queries before in-flight query
            // has been completed (e.g. while user is toggling columns on and off in
            // the column picker). In these situations, we always want to fetch latest
            // data from the API as column configuration may have changed for the user.
            // To do that, we disable Relay's automatic de-deduping of requests.
            inFlightRequest?.unsubscribe();
            const finalVariables = {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                first: (0, $jccNB.MAX_ISSUES_PER_PAGE),
                after: null,
                namespace: 'ISSUE_NAVIGATOR',
                viewId: viewId,
                options: null,
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                amountOfColumns: (0, $jccNB.MAX_AMOUNT_OF_COLUMNS),
                filterId: null,
                queryStatusForIssuekeyStrikethrough: (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough'),
                ...variables
            };
            inFlightRequest = (0, $cNy9K.fetchQuery)(environment, (0, $bQuAU.default), finalVariables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    /*
					 * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
					 * data will remain saved in the Relay store at any point after the request completes.
					 * We need to explicitly retain the operation to ensure it doesn't get deleted.
					 * See https://relay.dev/docs/api-reference/fetch-query/#behavior
					 */ const operation = (0, $cNy9K.createOperationDescriptor)((0, $cNy9K.getRequest)((0, $bQuAU.default)), finalVariables);
                    const { disposables: disposables } = getState();
                    setState({
                        disposables: disposables.concat([
                            environment.retain(operation)
                        ])
                    });
                    let hasStoreRefetchCompleted = false;
                    // We need to batch these updates as without it, Relay will cause multiple renders and invoke the
                    // onComplete callback multiple times. This causes our success/fail analytics events to become
                    // unreliable.
                    // We introduced a similar fix for fetchQuery (see src/packages/platform/graphql/relay-scheduler/src/index.js)
                    // and in React 18 will be able to remove this in favour of the startTransition/useTransition APIs.
                    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
                        refetch(finalVariables, {
                            fetchPolicy: 'store-only',
                            onComplete: ()=>{
                                // Relay will dispose the cached operation after a 5m timeout, in which case it will
                                // refetch the query from the store and retrigger the onComplete callback. We need to
                                // ensure this callback is invoked strictly once to prevent unexpected side effects,
                                // e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
                                if (hasStoreRefetchCompleted) return;
                                hasStoreRefetchCompleted = true;
                                setState({
                                    isFetching: false
                                });
                                options.onComplete?.();
                            // TODO JSC-175 Port search key reset logic
                            // TODO JSC-176 Port total issue count reset logic
                            }
                        });
                    });
                },
                error: ()=>{
                    setState({
                        isFetching: false,
                        networkError: true
                    });
                    options.onError?.();
                // TODO JSC-174 Port over error handling
                },
                unsubscribe: ()=>{
                    options.onUnsubscribe?.();
                }
            });
            setState({
                inFlightRequest: inFlightRequest,
                isFetching: true,
                networkError: false
            });
        }
};

});



parcelRegister("8CJEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bee20b057014f4$export$2e2bcd8739ae039);

var $6a5PX = parcelRequire("6a5PX");

var $fIE7K = parcelRequire("fIE7K");

var $aVBi2 = parcelRequire("aVBi2");

var $ldWhx = parcelRequire("ldWhx");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $hPdNw = parcelRequire("hPdNw");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5as0a = parcelRequire("5as0a");

var $cHJdq = parcelRequire("cHJdq");

var $hzcvF = parcelRequire("hzcvF");

var $d6f6c = parcelRequire("d6f6c");

var $jccNB = parcelRequire("jccNB");

var $3Lg4c = parcelRequire("3Lg4c");

var $cWCvn = parcelRequire("cWCvn");

var $g8nwX = parcelRequire("g8nwX");

var $3Ic6q = parcelRequire("3Ic6q");

var $4RwIp = parcelRequire("4RwIp");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");

var $cQBUE = parcelRequire("cQBUE");

var $cXdDi = parcelRequire("cXdDi");

var $58gge = parcelRequire("58gge");

var $j6Pvv = parcelRequire("j6Pvv");

var $lY5rz = parcelRequire("lY5rz");

var $5nM3q = parcelRequire("5nM3q");

var $fWUVl = parcelRequire("fWUVl");

var $7QBK4 = parcelRequire("7QBK4");

var $jTcpY = parcelRequire("jTcpY");
const $16bee20b057014f4$export$397fa57fff06920f = ({ CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, filter: filter, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, defaultJql: defaultJql, onRefinement: onRefinement, issueResults: issueResults, viewResult: viewResult, userPreferences: userPreferences, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_UI_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_NAVIGATOR_UI_END);
    }, []);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [caughtIssueSearchError, setCaughtIssueSearchError] = (0, $eUqFw.useState)();
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $dCaOY.useFilterQuery)();
    const handleReset = (0, $eUqFw.useCallback)((isResetToFilter = false)=>{
        if (isResetToFilter) onChangeFilter && onChangeFilter();
        else onChangeJql && onChangeJql(defaultJql, true);
    }, [
        onChangeFilter,
        onChangeJql,
        defaultJql
    ]);
    const onChange = (0, $eUqFw.useCallback)((jql)=>{
        onRefinement && onRefinement();
        onChangeJql && onChangeJql(jql, !filterQueryIsFetching && filter === null && (0, $5as0a.isFilterId)(filterId));
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        onChangeJql,
        onRefinement
    ]);
    const { searchKey: searchKey } = (0, $cQBUE.useIssueSearchQuery)();
    const previousData = (0, $hzcvF.usePrevious)(searchKey);
    const hasSearchChanged = Boolean(searchKey && searchKey !== previousData);
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $ldWhx.default), issueResults);
    const viewResultData = (0, $iWLL0.useFragment)((0, $aVBi2.default), viewResult);
    const viewResultError = (0, $eUqFw.useMemo)(()=>viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== undefined && viewResultData?.extensions?.[0]?.statusCode !== null ? new (0, $7byHA.default)(viewResultData?.extensions?.[0]?.statusCode, viewResultData?.message ?? '') : undefined, [
        viewResultData
    ]);
    const userPreferencesData = (0, $iWLL0.useFragment)((0, $fIE7K.default), userPreferences);
    const jqlBuilderWithAiData = (0, $iWLL0.useFragment)((0, $6a5PX.default), jqlBuilderWithAiKey);
    const shouldAnnounceInfo = (0, $eUqFw.useMemo)(()=>issueResultsData !== null && hasSearchChanged && typeof issueResultsData.totalIssueSearchResultCount === 'number', [
        issueResultsData,
        hasSearchChanged
    ]);
    const [isAiEnabled, setIsAiEnabled] = (0, $eUqFw.useState)(false);
    const onToggleAi = (0, $eUqFw.useCallback)((isEnabled)=>{
        setIsAiEnabled(isEnabled);
    }, []);
    const noFilterReason = (0, $eUqFw.useMemo)(()=>{
        if (!filterQueryIsFetching && filter === null && (0, $5as0a.isFilterId)(filterId)) return 'Filter query mismatch';
        if (viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode === 404) return 'Filter not found in view result';
        return undefined;
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        viewResultData?.__typename,
        viewResultData?.extensions
    ]);
    const IssueNavigatorTopBar = (0, $eUqFw.useMemo)(()=>{
        const jqlBuilder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lY5rz.default), {
            onChangeJql: onChange,
            defaultJql: defaultJql,
            filter: filter,
            onReset: handleReset,
            onFilterSave: onChangeFilter,
            issueResults: issueResultsData,
            onToggleAi: onToggleAi,
            jqlBuilderWithAiKey: jqlBuilderWithAiData,
            jqlBuilderProps: jqlBuilderProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jTcpY.default), {
            ActionMenu: ActionMenu,
            filter: filter,
            issueResults: issueResultsData,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jqlBuilder: jqlBuilder
        }), CustomHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $58gge.default), {
            CustomHeader: CustomHeader,
            filter: filter,
            issueResults: issueResultsData,
            HeaderSkeletonImage: HeaderSkeletonImage
        }), jqlBuilder));
    }, [
        defaultJql,
        filter,
        handleReset,
        issueResultsData,
        jqlBuilderProps,
        jqlBuilderWithAiData,
        onChange,
        onChangeFilter,
        onToggleAi,
        ActionMenu,
        CustomHeader,
        HeaderSkeletonImage
    ]);
    let IssueNavigatorContent = (0, $eUqFw.useMemo)(()=>{
        const getMessageString = ()=>{
            if (issueResultsData?.isCappingIssueSearchResult) return (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5nM3q.default).screenReaderSearchResultMoreInfoIssueTermRefresh : (0, $5nM3q.default).screenReaderSearchResultMoreInfo;
            return (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5nM3q.default).screenReaderSearchResultInfoIssueTermRefresh : (0, $5nM3q.default).screenReaderSearchResultInfo;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16bee20b057014f4$var$IssueNavigatorContentContainer, {
            selectedView: selectedView
        }, IssueNavigatorTopBar, !filterQueryIsFetching && filter === null && (0, $5as0a.isFilterId)(filterId) || viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode === 404 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Lg4c.NoFilter), {
            reason: noFilterReason
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPdNw.AnnouncerV2), {
            message: formatMessage(getMessageString(), {
                total: issueResultsData?.totalIssueSearchResultCount
            }),
            shouldAnnounce: shouldAnnounceInfo,
            testId: "issue-navigator.ui.search-announcer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j6Pvv.default), {
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            onChangeJql: onChangeJql,
            onCaughtIssueSearchError: setCaughtIssueSearchError,
            issueResults: issueResultsData,
            viewResult: viewResultData,
            isFeedbackButtonDisabled: isFeedbackButtonDisabled,
            issueTableProps: issueTableProps,
            filter: filter
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QBK4.default), {
            hasIssueResults: !!issueResultsData?.totalIssueSearchResultCount,
            userPreferences: userPreferencesData,
            isAiEnabled: isAiEnabled
        }));
    }, [
        IssueNavigatorTopBar,
        selectedView,
        filter,
        issueResultsData,
        filterQueryIsFetching,
        filterId,
        noFilterReason,
        formatMessage,
        shouldAnnounceInfo,
        onChangeColumnConfiguration,
        onChangeJql,
        viewResultData,
        isFeedbackButtonDisabled,
        issueTableProps,
        userPreferencesData,
        isAiEnabled
    ]);
    const isFullPageIssueAppMode = (0, $3Ic6q.useIsFullPageIssueAppMode)();
    if (isFullPageIssueAppMode) IssueNavigatorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cXdDi.default), {
        onChangeIssue: onChangeIssue,
        issueResults: issueResultsData,
        view: viewResultData?.__typename === 'JiraIssueSearchView' ? viewResultData : null
    });
     // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1ybV0.ff)('nin.global-scope_aqec8') && (0, $cHJdq.useGlobalScopeOptInFlag)();
    const isFailedIssueSearch = !issueResultsData || issueResultsData.issueSearchError?.__typename === 'JiraServerError' || caughtIssueSearchError !== undefined || !viewResultData || viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== 404;
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, IssueNavigatorContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWUVl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), isFailedIssueSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8nwX.IssueSearchFail), {
            location: `${(0, $jccNB.PACKAGE_NAME)}.ui`,
            error: caughtIssueSearchError || viewResultError || new Error('There was an error searching for issues'),
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g8nwX.IssueSearchSuccess), {
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled
            }
        })), [
        IssueNavigatorContent,
        isFailedIssueSearch,
        caughtIssueSearchError,
        viewResultError,
        onPageDataLoad,
        isAiEnabled
    ]);
};
// re-render regression detection
$16bee20b057014f4$export$397fa57fff06920f.whyDidYouRender = true;
var $16bee20b057014f4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($16bee20b057014f4$export$397fa57fff06920f);
const $16bee20b057014f4$var$IssueNavigatorContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedView: selectedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _18s8fkly",
            __cmplp.selectedView !== 'detail' && "_n3tdv47k _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6a5PX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9714f471128517a8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b028ab22d769af59e1b92eab949e2221>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9714f471128517a8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$9714f471128517a8$var$node.hash = "e9088c921273ca13e8f1d0f476e2f2fb";
var $9714f471128517a8$export$2e2bcd8739ae039 = $9714f471128517a8$var$node;

});

parcelRegister("fIE7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $129c0b1f02e8204b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da52f0913815b9fe1e6847953ff7bea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $129c0b1f02e8204b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "spotlight_issueNavigator_IssueNavigatorSpotlight"
        }
    ],
    "type": "JiraUserPreferences"
};
$129c0b1f02e8204b$var$node.hash = "aa84b2b1589fd8e695aa782c018fd60c";
var $129c0b1f02e8204b$export$2e2bcd8739ae039 = $129c0b1f02e8204b$var$node;

});

parcelRegister("aVBi2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb20baea2ff018d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a7f9208a4921150782f15879664730c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ffb20baea2ff018d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_viewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_viewResult"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_FullPageIssueApp_view"
                }
            ],
            "type": "JiraIssueSearchView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "JiraIssueSearchViewResult",
    "abstractKey": "__isJiraIssueSearchViewResult"
};
$ffb20baea2ff018d$var$node.hash = "4dc3b9ef76a1616435fbd5d36dccfd03";
var $ffb20baea2ff018d$export$2e2bcd8739ae039 = $ffb20baea2ff018d$var$node;

});

parcelRegister("ldWhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942cd14536cc89d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4e273d46b301a3a64f937bedb234d4f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6942cd14536cc89d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_FullPageIssueApp_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$6942cd14536cc89d$var$node.hash = "25011407199d044957f67ed09ae941d4";
var $6942cd14536cc89d$export$2e2bcd8739ae039 = $6942cd14536cc89d$var$node;

});

parcelRegister("hPdNw", function(module, exports) {

$parcel$export(module.exports, "AnnouncerV2", () => $f3fdf175d37cb8cd$export$a43c8a2f4981e0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kjXsi = parcelRequire("kjXsi");
const $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE = '\u00A0';
const $f3fdf175d37cb8cd$export$a43c8a2f4981e0e = /*#__PURE__*/ (0, $eUqFw.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
    const previousMessage = (0, $eUqFw.useRef)('');
    const setAlternatePolite = (0, $eUqFw.useRef)(false);
    const addSuffix = (0, $eUqFw.useRef)(false);
    const [oldMessage, setOldMessage] = (0, $eUqFw.useState)('');
    const [newMessage, setNewMessage] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        let message = shouldAnnounce ? originalMessage : $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        if (previousMessage.current === message) {
            addSuffix.current = !addSuffix.current;
            if (addSuffix.current) message += $f3fdf175d37cb8cd$var$NON_BREAKING_SPACE;
        }
        setOldMessage(setAlternatePolite.current ? '' : message);
        setNewMessage(setAlternatePolite.current ? message : '');
        if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
        previousMessage.current = originalMessage;
    }, [
        originalMessage,
        shouldAnnounce
    ]);
    // 2 aria-live containers needed to prevent bugs in browsers that will stop
    // announcing updates to the same div if these are too repetitive.
    return /*#__PURE__*/ $eUqFw.createElement("div", {
        "data-testid": testId,
        className: (0, $7JEyt.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ $eUqFw.createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, oldMessage), /*#__PURE__*/ $eUqFw.createElement((0, $kjXsi.ScreenReaderText), {
        role: "status",
        "aria-live": liveMode,
        "aria-relevant": "additions text",
        "aria-atomic": "true"
    }, newMessage));
});
const $f3fdf175d37cb8cd$var$positionRelative = null;

});
parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $cfcbcec828cf2e62$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("cHJdq", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $12b6aa65edf761e5$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $12b6aa65edf761e5$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $12b6aa65edf761e5$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $12b6aa65edf761e5$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $12b6aa65edf761e5$export$9e9f507adee88e58);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3QLcd = parcelRequire("3QLcd");

var $jSWn5 = parcelRequire("jSWn5");

var $geV2Y = parcelRequire("geV2Y");

var $4Qa4O = parcelRequire("4Qa4O");

var $bn9O6 = parcelRequire("bn9O6");
const $12b6aa65edf761e5$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $12b6aa65edf761e5$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($12b6aa65edf761e5$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $12b6aa65edf761e5$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eUqFw.useContext)($12b6aa65edf761e5$export$b349f970aff316d8);
    if (!(0, $1ybV0.ff)('nin.global-scope_aqec8') || !isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Qa4O.default), {
        engagementId: engagementId
    }, children);
};
const $12b6aa65edf761e5$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eUqFw.useContext)($12b6aa65edf761e5$export$b349f970aff316d8);
    if (!(0, $1ybV0.ff)('nin.global-scope_aqec8') || !isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geV2Y.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $12b6aa65edf761e5$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eUqFw.useContext)($12b6aa65edf761e5$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    const onLearnMore = (0, $eUqFw.useCallback)(()=>{
        if (onOpenInProductHelpArticle !== undefined) onOpenInProductHelpArticle?.((0, $jSWn5.LEARN_MORE_IPH_ARTICLE_ID));
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open((0, $jSWn5.FALLBACK_SUPPORT_ARTICLE));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldShowOptInFlag = sessionStorage.getItem('showNinOptInFlag');
        if ((0, $1ybV0.ff)('nin.global-scope_aqec8') && isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bn9O6.default).successOptInTitleIssueTermRefresh : (0, $bn9O6.default).successOptInTitle,
                description: (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bn9O6.default).successOptInDescIssueTermRefresh : (0, $bn9O6.default).successOptInDesc,
                actions: [
                    {
                        content: (0, $bn9O6.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $bbUin = parcelRequire("bbUin");

var $nsZmq = parcelRequire("nsZmq");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $bbUin.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $bbUin.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, href: href, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $eI5EY.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $bbUin.ARTICLE_TYPE)[type]);
    };
    if ((0, $eI5EY.fg)('help_panel_as_link')) return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nsZmq.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("jSWn5", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $c905222c653b3744$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $c905222c653b3744$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $c905222c653b3744$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $c905222c653b3744$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $c905222c653b3744$export$d0079916fe6800ac);
const $c905222c653b3744$export$565b01733f42b193 = 'https://community.atlassian.com/t5/Jira-articles/We-re-bringing-updates-to-the-issue-navigator/ba-p/2096660';
const $c905222c653b3744$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $c905222c653b3744$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $c905222c653b3744$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $c905222c653b3744$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $c905222c653b3744$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $c905222c653b3744$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("geV2Y", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $1112eadbf801540c$export$40e85aa59c198f98);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1112eadbf801540c$var$SpotlightCard = (0, $dyfd9.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("2TSdW")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $1112eadbf801540c$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1112eadbf801540c$var$SpotlightCard, props)));

});
parcelRegister("2TSdW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("cwy0j")
]).then(()=>parcelRequire('l56q4'));

});


parcelRegister("4Qa4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $1828e5e0fe5f546b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $cx8Zw = parcelRequire("cx8Zw");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1828e5e0fe5f546b$var$EngagementSpotlightAsync = (0, $dyfd9.lazy)(()=>(parcelRequire("eDGHn")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $1828e5e0fe5f546b$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cx8Zw.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1828e5e0fe5f546b$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $1828e5e0fe5f546b$export$2e2bcd8739ae039 = $1828e5e0fe5f546b$var$SpotlightTourTarget;

});
parcelRegister("eDGHn", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("g7115")
]).then(()=>parcelRequire('3SH6P'));

});


parcelRegister("bn9O6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d3be14eb932981d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $7d3be14eb932981d$var$messages = (0, $90IgZ.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    }
});
var $7d3be14eb932981d$export$2e2bcd8739ae039 = $7d3be14eb932981d$var$messages;

});


parcelRegister("3Lg4c", function(module, exports) {

$parcel$export(module.exports, "NoFilter", () => $d207ffa811f2a7fb$export$fba2cdeecf4e314d);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $lCjSV = parcelRequire("lCjSV");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $79xbN = parcelRequire("79xbN");

var $hgbp4 = parcelRequire("hgbp4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $f5Nzv = parcelRequire("f5Nzv");
const $d207ffa811f2a7fb$var$ANOTHER_FILTER_LINK = '/jira/filters';
const $d207ffa811f2a7fb$export$fba2cdeecf4e314d = ({ reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "noFilter",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: reason ? {
            reason: reason
        } : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCjSV.default), {
        header: formatMessage((0, $f5Nzv.default).weCouldntFindThisFilter),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $f5Nzv.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $f5Nzv.default).tryAnotherFilterIssueTermRefresh : (0, $f5Nzv.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            href: $d207ffa811f2a7fb$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $f5Nzv.default).viewFilters)),
        primaryAction: // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $f5Nzv.default).searchIssuesIssueTermRefresh : (0, $f5Nzv.default).searchIssues)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                xcss: $d207ffa811f2a7fb$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
                alt: ""
            }))
    }));
};
var $d207ffa811f2a7fb$export$2e2bcd8739ae039 = $d207ffa811f2a7fb$export$fba2cdeecf4e314d;
const $d207ffa811f2a7fb$var$ImageWrapperStyles = (0, $8Vv3m.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("hgbp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d2ebe01d4784a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1lasE")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $9TZf5 = parcelRequire("9TZf5");

var $gMIRj = parcelRequire("gMIRj");

var $1lasE = parcelRequire("1lasE");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $d2d2ebe01d4784a8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1lasE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gMIRj))
});
var $d2d2ebe01d4784a8$export$2e2bcd8739ae039 = $d2d2ebe01d4784a8$var$Illustration;
// for advanced use only
const $d2d2ebe01d4784a8$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("gMIRj", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("1lasE", function(module, exports) {
module.exports = new URL("search-no-results.10b14394.svg", import.meta.url).toString();

});


parcelRegister("f5Nzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7080d3169c338e73$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7080d3169c338e73$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    weCouldntFindThisFilter: {
        "id": "issue-navigator.common.no-filter.we-couldnt-find-this-filter",
        "defaultMessage": "We couldn't find this filter"
    },
    filterNoExistOrNoPermissions: {
        "id": "issue-navigator.common.no-filter.filter-no-exist-or-no-permissions",
        "defaultMessage": "This filter may not exist, or you don\u2019t have permissions to view it."
    },
    tryAnotherFilter: {
        "id": "issue-navigator.common.no-filter.try-another-filter",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    viewFilters: {
        "id": "issue-navigator.common.no-filter.view-filters",
        "defaultMessage": "View filters"
    },
    searchIssues: {
        "id": "issue-navigator.common.no-filter.search-issues",
        "defaultMessage": "Search issues"
    },
    tryAnotherFilterIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.try-another-filter-issue-term-refresh",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    searchIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.search-issues-issue-term-refresh",
        "defaultMessage": "Search issues"
    }
});

});


parcelRegister("g8nwX", function(module, exports) {

$parcel$export(module.exports, "IssueSearchSuccess", () => $6c2b80cae36e3261$export$3ee6d2830e5ead03);
$parcel$export(module.exports, "IssueSearchFail", () => $6c2b80cae36e3261$export$91886a55521e4fad);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $fsuyl = parcelRequire("fsuyl");

var $cQBUE = parcelRequire("cQBUE");

var $4RwIp = parcelRequire("4RwIp");
const $6c2b80cae36e3261$export$3ee6d2830e5ead03 = ({ attributes: attributes, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { onIssueSearchSuccess: onIssueSearchSuccess } = (0, $fsuyl.useExperienceAnalytics)(onPageDataLoad, view, attributes);
    const { isFetching: isFetching, isNetworkError: isNetworkError } = (0, $cQBUE.useIssueSearchQuery)();
    const prevIsFetching = (0, $hzcvF.usePrevious)(isFetching);
    (0, $eUqFw.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching && !isNetworkError) onIssueSearchSuccess();
    }, [
        isFetching,
        isNetworkError,
        onIssueSearchSuccess,
        prevIsFetching
    ]);
    return null;
};
const $6c2b80cae36e3261$export$91886a55521e4fad = ({ attributes: attributes, location: location, error: error, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { onIssueSearchFail: onIssueSearchFail } = (0, $fsuyl.useExperienceAnalytics)(onPageDataLoad, view, attributes);
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const prevIsFetching = (0, $hzcvF.usePrevious)(isFetching);
    (0, $eUqFw.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching) onIssueSearchFail(location, error);
    }, [
        error,
        isFetching,
        location,
        onIssueSearchFail,
        prevIsFetching
    ]);
    return null;
};

});

parcelRegister("3Ic6q", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueKey", () => $4be9c969fd856d47$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useSelectedIssueIndex", () => $4be9c969fd856d47$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $4be9c969fd856d47$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $4be9c969fd856d47$export$988cbddd89e853c0);

var $79xbN = parcelRequire("79xbN");

var $4w4xT = parcelRequire("4w4xT");

var $6FIwx = parcelRequire("6FIwx");
const $4be9c969fd856d47$export$7cedcbfb2da7e49d = ()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $6FIwx.useSelectedIssueKey)() : (0, $4w4xT.useSelectedIssueKey)();
const $4be9c969fd856d47$export$a4b375f8f9b094ad = ()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $6FIwx.useSelectedIssueIndex)() : (0, $4w4xT.useSelectedIssueIndex)();
const $4be9c969fd856d47$export$ed5cb04ac9d88e95 = ()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $6FIwx.useSelectedIssueDebouncedState)() : (0, $4w4xT.useSelectedIssueDebouncedState)();
const $4be9c969fd856d47$export$988cbddd89e853c0 = ()=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $6FIwx.useIsFullPageIssueAppMode)() : (0, $4w4xT.useIsFullPageIssueAppMode)();

});
parcelRegister("6FIwx", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueIndex", () => $dfcda003b6d60ac4$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useNextIssueKey", () => $dfcda003b6d60ac4$export$a357f91232534409);
$parcel$export(module.exports, "usePreviousIssueKey", () => $dfcda003b6d60ac4$export$ee05f65713c12ae3);
$parcel$export(module.exports, "useSelectedIssueKey", () => $dfcda003b6d60ac4$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useIsSelectedIssue", () => $dfcda003b6d60ac4$export$ccd07516e284d793);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $dfcda003b6d60ac4$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $dfcda003b6d60ac4$export$988cbddd89e853c0);
$parcel$export(module.exports, "useSelectedIssueActions", () => $dfcda003b6d60ac4$export$d1c4608e18de4f02);

var $WBLbN = parcelRequire("WBLbN");

var $3wKQY = parcelRequire("3wKQY");

var $7Lvuw = parcelRequire("7Lvuw");

var $eD03n = parcelRequire("eD03n");
const $dfcda003b6d60ac4$export$a4b375f8f9b094ad = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: (0, $eD03n.getSelectedIssueIndex)
});
const $dfcda003b6d60ac4$export$a357f91232534409 = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: (0, $eD03n.getNextIssueKey)
});
const $dfcda003b6d60ac4$export$ee05f65713c12ae3 = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: (0, $eD03n.getPreviousIssueKey)
});
const $dfcda003b6d60ac4$export$7cedcbfb2da7e49d = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey
});
const $dfcda003b6d60ac4$export$ccd07516e284d793 = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey }, issueKey)=>selectedIssueKey === issueKey
});
const $dfcda003b6d60ac4$export$ed5cb04ac9d88e95 = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: (0, $3wKQY.createRememoizeSelector)((state)=>state, ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey)
});
const $dfcda003b6d60ac4$export$988cbddd89e853c0 = (0, $WBLbN.createStateHook)((0, $7Lvuw.Store), {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});
const $dfcda003b6d60ac4$export$d1c4608e18de4f02 = (0, $WBLbN.createActionsHook)((0, $7Lvuw.Store));

});
parcelRegister("7Lvuw", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueContainer", () => $e6f96782f2c8136c$export$8b7bb55917259a5d);
$parcel$export(module.exports, "Store", () => $e6f96782f2c8136c$export$390f32400eaf98c9);

var $6vrw7 = parcelRequire("6vrw7");

var $WBLbN = parcelRequire("WBLbN");

var $jccNB = parcelRequire("jccNB");

var $5jidY = parcelRequire("5jidY");
const $e6f96782f2c8136c$export$8b7bb55917259a5d = (0, $WBLbN.createContainer)();
const $e6f96782f2c8136c$var$initialState = {
    _rememoize: Date.now(),
    selectedIssueKey: (0, $6vrw7.toIssueKey)(''),
    isFullPageIssueAppMode: false,
    issueKeys: []
};
const $e6f96782f2c8136c$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    containedBy: $e6f96782f2c8136c$export$8b7bb55917259a5d,
    initialState: $e6f96782f2c8136c$var$initialState,
    actions: $5jidY.default,
    handlers: {
        onInit: ()=>({ setState: setState, dispatch: dispatch }, { selectedIssueKey: selectedIssueKey, view: view, issueKeys: issueKeys })=>{
                dispatch((0, $5jidY.privateActions).onContainerUpdate());
                const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $jccNB.views).list;
                const initialIssueKey = selectedIssueKey || issueKeys[0] || (0, $6vrw7.toIssueKey)('');
                setState({
                    _rememoize: Date.now(),
                    selectedIssueKey: initialIssueKey,
                    isFullPageIssueAppMode: isFullPageIssueAppMode
                });
            },
        onContainerUpdate: ({ searchKey: searchKey, selectedIssueKey: selectedIssueKey }, prevProps)=>({ dispatch: dispatch })=>{
                dispatch((0, $5jidY.privateActions).onContainerUpdate());
                if (searchKey !== prevProps.searchKey) dispatch((0, $5jidY.privateActions).resetSelectedIssue());
                else if (selectedIssueKey && selectedIssueKey !== prevProps.selectedIssueKey) {
                    dispatch($e6f96782f2c8136c$export$390f32400eaf98c9.actions.setSelectedIssueByKey(selectedIssueKey, {
                        shouldDebounce: false,
                        shouldNotifyOnChange: false,
                        isSelectedByUserInteraction: false
                    }));
                    // If an issue key has been specified while in list view then enter full page issue app mode.
                    if (dispatch((0, $5jidY.privateActions).isListViewWithoutIssueApp())) dispatch($e6f96782f2c8136c$export$390f32400eaf98c9.actions.enterFullPageIssueAppMode());
                // TODO JSC-185 Fetch next/previous page when last/first issue is selected
                } else if (!selectedIssueKey && dispatch((0, $5jidY.privateActions).isListViewWithIssueAppAndKey())) dispatch($e6f96782f2c8136c$export$390f32400eaf98c9.actions.exitFullPageIssueAppMode());
            }
    }
});

});
parcelRegister("5jidY", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $c8d4cd5f142ad5be$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $c8d4cd5f142ad5be$export$2e2bcd8739ae039);

var $dxIU5 = parcelRequire("dxIU5");

var $6vrw7 = parcelRequire("6vrw7");

var $jccNB = parcelRequire("jccNB");

var $eD03n = parcelRequire("eD03n");
const $c8d4cd5f142ad5be$var$doSideEffectUpdate = ({ getState: getState, setState: setState }, { onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange = true, isSelectedByUserInteraction: isSelectedByUserInteraction = true })=>{
    const { selectedIssueKey: selectedIssueKey } = getState();
    setState({
        _rememoize: Date.now()
    });
    shouldNotifyOnChange && onChange && onChange(selectedIssueKey, isSelectedByUserInteraction);
};
const $c8d4cd5f142ad5be$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($c8d4cd5f142ad5be$var$doSideEffectUpdate, 600);
const $c8d4cd5f142ad5be$var$doSideEffectUpdates = (actions, options)=>{
    options.shouldDebounce ? $c8d4cd5f142ad5be$var$doDebouncedSideEffectUpdate(actions, options) : $c8d4cd5f142ad5be$var$doSideEffectUpdate(actions, options);
};
const $c8d4cd5f142ad5be$var$setSelectedIssueByKey = (selectedIssueKey, options = {})=>(actions, { onChange: onChange })=>{
        if (!selectedIssueKey.length) return false;
        actions.setState({
            selectedIssueKey: selectedIssueKey
        });
        $c8d4cd5f142ad5be$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
        return true;
    };
const $c8d4cd5f142ad5be$var$setSelectedIssueByIndex = (issueIndex, options)=>({ dispatch: dispatch }, { issueKeys: issueKeys })=>{
        return dispatch($c8d4cd5f142ad5be$var$setSelectedIssueByKey(issueKeys[issueIndex] ?? (0, $6vrw7.toIssueKey)(''), options));
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $c8d4cd5f142ad5be$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($c8d4cd5f142ad5be$var$setSelectedIssueByKey((0, $eD03n.getNextIssueKey)(getState()) ?? (0, $6vrw7.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $c8d4cd5f142ad5be$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($c8d4cd5f142ad5be$var$setSelectedIssueByKey((0, $eD03n.getPreviousIssueKey)(getState()) ?? (0, $6vrw7.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
const $c8d4cd5f142ad5be$var$deselectIssue = (options)=>(actions, { onChange: onChange })=>{
        actions.setState({
            selectedIssueKey: (0, $6vrw7.toIssueKey)('')
        });
        $c8d4cd5f142ad5be$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
    };
const $c8d4cd5f142ad5be$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $c8d4cd5f142ad5be$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $c8d4cd5f142ad5be$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $jccNB.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $c8d4cd5f142ad5be$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssueKey: selectedIssueKey } = getState();
        return view === (0, $jccNB.views).list && isFullPageIssueAppMode && !!selectedIssueKey;
    };
/**
 * Reset the selected issue to the first issue in the connection.
 */ const $c8d4cd5f142ad5be$var$resetSelectedIssue = ()=>({ dispatch: dispatch })=>{
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($c8d4cd5f142ad5be$var$isListViewWithoutIssueApp());
        dispatch($c8d4cd5f142ad5be$var$setSelectedIssueByIndex(0, {
            shouldDebounce: false,
            shouldNotifyOnChange: shouldNotifyOnChange,
            isSelectedByUserInteraction: false
        }));
    };
const $c8d4cd5f142ad5be$export$ab8f0de40a3a2d2d = ()=>({ setState: setState }, { issueKeys: issueKeys })=>{
        setState({
            issueKeys: issueKeys
        });
    };
const $c8d4cd5f142ad5be$export$e324594224ef24da = {
    setSelectedIssueByKey: $c8d4cd5f142ad5be$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $c8d4cd5f142ad5be$var$setSelectedIssueByIndex,
    selectNextIssue: $c8d4cd5f142ad5be$var$selectNextIssue,
    selectPreviousIssue: $c8d4cd5f142ad5be$var$selectPreviousIssue,
    deselectIssue: $c8d4cd5f142ad5be$var$deselectIssue,
    enterFullPageIssueAppMode: $c8d4cd5f142ad5be$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $c8d4cd5f142ad5be$var$exitFullPageIssueAppMode
};
const $c8d4cd5f142ad5be$export$3f1be494d407b77a = {
    isListViewWithoutIssueApp: $c8d4cd5f142ad5be$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $c8d4cd5f142ad5be$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $c8d4cd5f142ad5be$var$resetSelectedIssue,
    onContainerUpdate: $c8d4cd5f142ad5be$export$ab8f0de40a3a2d2d
};
var $c8d4cd5f142ad5be$export$2e2bcd8739ae039 = $c8d4cd5f142ad5be$export$e324594224ef24da;

});
parcelRegister("eD03n", function(module, exports) {

$parcel$export(module.exports, "getSelectedIssueIndex", () => $0e88e88274ecb0fe$export$b5bba5025e9754c0);
$parcel$export(module.exports, "getNextIssueKey", () => $0e88e88274ecb0fe$export$2a413bfa3aeed781);
$parcel$export(module.exports, "getPreviousIssueKey", () => $0e88e88274ecb0fe$export$5e257a264fce89f7);

var $WBLbN = parcelRequire("WBLbN");
const $0e88e88274ecb0fe$export$b5bba5025e9754c0 = (0, $WBLbN.createSelector)((state)=>state.selectedIssueKey, (state)=>state.issueKeys, (selectedIssueKey, issueKeys)=>issueKeys.indexOf(selectedIssueKey));
const $0e88e88274ecb0fe$export$2a413bfa3aeed781 = (state)=>{
    const index = $0e88e88274ecb0fe$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > -1 && index < issueKeys.length - 1 ? issueKeys[index + 1] : null;
};
const $0e88e88274ecb0fe$export$5e257a264fce89f7 = (state)=>{
    const index = $0e88e88274ecb0fe$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > 0 ? issueKeys[index - 1] : null;
};

});





parcelRegister("cXdDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb8468cf89444516$export$2e2bcd8739ae039);

var $gPsMl = parcelRequire("gPsMl");

var $d7Bjs = parcelRequire("d7Bjs");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lUg8E = parcelRequire("lUg8E");

var $9aFSa = parcelRequire("9aFSa");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $6vrw7 = parcelRequire("6vrw7");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $cIZjs = parcelRequire("cIZjs");

var $4w4xT = parcelRequire("4w4xT");

var $3Ic6q = parcelRequire("3Ic6q");

var $6FIwx = parcelRequire("6FIwx");

var $cQBUE = parcelRequire("cQBUE");

var $j3TLk = parcelRequire("j3TLk");

var $21fwU = parcelRequire("21fwU");
const $eb8468cf89444516$var$FullPageIssueApp = ({ onChangeIssue: onChangeIssue, issueResults: issueResults, view: view })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    // TODO Remove this condition when cleaning up jira_spreadsheet_component_m1
    const isForcedSelectionOnReset = !(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4w4xT.useIsForcedSelectionOnReset)();
    const { exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6FIwx.useSelectedIssueActions)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4w4xT.useSelectedIssueStateOldActions)();
    const onBackToSearch = (0, $eUqFw.useCallback)(()=>{
        // Clear the selected issue key from the URL and return to normal view mode
        onChangeIssue((0, $6vrw7.toIssueKey)(''), true);
        exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        onChangeIssue
    ]);
    const onBackToSearchByButton = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.clone(), 'returnToSearch');
        onBackToSearch();
    }, [
        onBackToSearch
    ]);
    const onBackToSearchByKeyboardShortcut = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'issue'
        }), 'returnToSearch', {
            keyPressed: 'z',
            keyboardShortcut: true
        });
        onBackToSearch();
    }, [
        onBackToSearch,
        createAnalyticsEvent
    ]);
    const onNextIssue = (0, $eUqFw.useCallback)(()=>{
        if (selectNextIssue()) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'nextIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectNextIssue
    ]);
    const onPreviousIssue = (0, $eUqFw.useCallback)(()=>{
        if (selectPreviousIssue()) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'previousIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectPreviousIssue
    ]);
    // If a new search is being run and we do not have forced issue selection (i.e. issue app pagination) then return to
    // normal view mode. This can happen when a filter is clicked in the sidebar or browser history navigation.
    (0, $eUqFw.useEffect)(()=>{
        if (isFetching && !isForcedSelectionOnReset) exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        isFetching,
        isForcedSelectionOnReset
    ]);
    const backToSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        testId: "issue-navigator.ui.full-page-issue-app.return-to-search",
        onClick: onBackToSearchByButton,
        interactionName: "issue-navigator-full-page-issue-app-return-to-search"
    }, formatMessage((0, $21fwU.default).returnText));
    const issueResultsData = (0, $iWLL0.useFragment)((0, $d7Bjs.default), issueResults);
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        const { hasPrevious: hasPrevious, isLoadingPrevious: isLoadingPrevious, onLoadPrevious: onLoadPrevious, hasNext: hasNext, isLoadingNext: isLoadingNext, onLoadNext: onLoadNext } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $j3TLk.useInfiniteScroll)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const selectedIssueKey = (0, $3Ic6q.useSelectedIssueKey)();
        const edges = issueResultsData?.edges ?? [];
        const isFirstIssueSelected = edges[0]?.node?.key === selectedIssueKey;
        const isLastIssueSelected = edges[edges.length - 1]?.node?.key === selectedIssueKey;
        // Automatically fetch previous and next pages while navigating issues in full page mode
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            if (isFirstIssueSelected && hasPrevious && !isLoadingPrevious) onLoadPrevious?.();
        }, [
            hasPrevious,
            isFirstIssueSelected,
            isLoadingPrevious,
            onLoadPrevious
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            if (isLastIssueSelected && hasNext && !isLoadingNext) onLoadNext?.();
        }, [
            hasNext,
            isLastIssueSelected,
            isLoadingNext,
            onLoadNext
        ]);
    }
    const viewData = (0, $iWLL0.useFragment)((0, $gPsMl.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "full-page-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $jccNB.ANALYTICS_LIST_VIEW_SOURCE_NAME),
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            z: {
                callback: onBackToSearchByKeyboardShortcut
            },
            j: {
                callback: onNextIssue
            },
            k: {
                callback: onPreviousIssue
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIZjs.default), {
        isEmbedView: false,
        extraHeaderActions: backToSearch,
        issueResults: issueResultsData,
        view: viewData
    })));
};
var $eb8468cf89444516$export$2e2bcd8739ae039 = $eb8468cf89444516$var$FullPageIssueApp;

});
parcelRegister("gPsMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $912ee1282c1cd063$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a77bc15f947513b3b7750cebe8bbe84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $912ee1282c1cd063$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        }
    ],
    "type": "JiraIssueSearchView"
};
$912ee1282c1cd063$var$node.hash = "468ea16df2cfa07839ca03ecd97948b9";
var $912ee1282c1cd063$export$2e2bcd8739ae039 = $912ee1282c1cd063$var$node;

});

parcelRegister("d7Bjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $17cec4a36cfb1ca8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e191fe8f978a91a8364f661a75b25c8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $17cec4a36cfb1ca8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$17cec4a36cfb1ca8$var$node.hash = "c76ea1c159a6e1be56c13b6262324ca3";
var $17cec4a36cfb1ca8$export$2e2bcd8739ae039 = $17cec4a36cfb1ca8$var$node;

});

parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});


parcelRegister("cIZjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $21a48eadd1523c55$export$2e2bcd8739ae039);

var $6iVMI = parcelRequire("6iVMI");

var $4FhGM = parcelRequire("4FhGM");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dyfd9 = parcelRequire("dyfd9");

var $iWLL0 = parcelRequire("iWLL0");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $iH6jq = parcelRequire("iH6jq");

var $cavjE = parcelRequire("cavjE");

var $fE3Ua = parcelRequire("fE3Ua");

var $gJYxu = parcelRequire("gJYxu");

var $9mxRp = parcelRequire("9mxRp");

var $bsdZ2 = parcelRequire("bsdZ2");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $8WuJm = parcelRequire("8WuJm");
var $6Fbwh = parcelRequire("6Fbwh");

var $6vrw7 = parcelRequire("6vrw7");

var $iJHZm = parcelRequire("iJHZm");

var $kOOpn = parcelRequire("kOOpn");

var $4w4xT = parcelRequire("4w4xT");

var $3Ic6q = parcelRequire("3Ic6q");

var $6FIwx = parcelRequire("6FIwx");

var $cQBUE = parcelRequire("cQBUE");

var $5qkO2 = parcelRequire("5qkO2");

var $7YJjT = parcelRequire("7YJjT");

var $jccNB = parcelRequire("jccNB");

var $cWCvn = parcelRequire("cWCvn");

var $lCzk9 = parcelRequire("lCzk9");
const $21a48eadd1523c55$var$isEcClientEnabled = ()=>{
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.issueview', '').split(',');
    return Array.isArray(experiences) && experiences.includes('nin-issue-view');
}; // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $21a48eadd1523c55$var$AsyncIssueAppComponent = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("7KNWV")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $21a48eadd1523c55$var$AsyncIssueAppUsingLoadingPhases = ({ isEmbedView: isEmbedView, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gJYxu.IssueBoundary), {
        packageName: "issue-navigator",
        isEmbedView: isEmbedView,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cavjE.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$AsyncIssueAppComponent, rest));
const $21a48eadd1523c55$var$issueCardChangeExcludedEventTypes = [
    (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
    (0, $fE3Ua.ChangeEventTypes).FIELD_CHANGE_FAILED,
    (0, $fE3Ua.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $fE3Ua.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED
];
const $21a48eadd1523c55$var$useJSCM1CompatibleActions = (connectionId, fieldSetIds)=>{
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey // eslint-disable-next-line react-hooks/rules-of-hooks
         } = (0, $6FIwx.useSelectedIssueActions)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const onDeleteIssue = (0, $5qkO2.useOnDeleteIssue)(connectionId); // eslint-disable-next-line react-hooks/rules-of-hooks
        const onIssueByFieldsRefetch = (0, $7YJjT.useIssueByFieldsRefetch)(fieldSetIds);
        return {
            deselectIssue: deselectIssue,
            exitFullPageIssueAppMode: exitFullPageIssueAppMode,
            setSelectedIssueByKey: setSelectedIssueByKey,
            onDeleteIssue: onDeleteIssue,
            onIssueByFieldsRefetch: onIssueByFieldsRefetch
        };
    }
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4w4xT.useSelectedIssueStateOldActions)();
    const { onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $cQBUE.useIssueSearchQuery)();
    return {
        deselectIssue: deselectIssue,
        exitFullPageIssueAppMode: exitFullPageIssueAppMode,
        setSelectedIssueByKey: setSelectedIssueByKey,
        onDeleteIssue: onDeleteIssue,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch
    };
};
const $21a48eadd1523c55$var$IssueAppWithData = ({ IssueApp: IssueApp = $21a48eadd1523c55$var$AsyncIssueAppUsingLoadingPhases, extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, issueResults: issueResults, view: view })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_APP_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_APP_END);
    }, []);
    const selectedIssueKey = (0, $3Ic6q.useSelectedIssueDebouncedState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)(); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let saveIssueMutationToCache;
    if ($21a48eadd1523c55$var$isEcClientEnabled()) // eslint-disable-next-line react-hooks/rules-of-hooks
    saveIssueMutationToCache = (0, $bsdZ2.useEcClient)().saveIssueMutationToCache;
    const issueResultsData = (0, $iWLL0.useFragment)((0, $4FhGM.default), issueResults);
    let fieldSetIds = [];
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const viewData = (0, $iWLL0.useFragment)((0, $6iVMI.default), view); // eslint-disable-next-line react-hooks/rules-of-hooks
        fieldSetIds = (0, $eUqFw.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
            viewData?.fieldSets?.edges
        ]);
    }
    const { onInteractive: onInteractive } = (0, $kOOpn.useStartNinIssueAppAnalytics)(selectedIssueKey);
    const issueAppMetrics = (0, $eUqFw.useMemo)(()=>({
            onInteractive: onInteractive
        }), [
        onInteractive
    ]);
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey, onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = $21a48eadd1523c55$var$useJSCM1CompatibleActions(issueResultsData?.__id, fieldSetIds);
    const refetchCallback = (0, $eUqFw.useRef)(onIssueByFieldsRefetch);
    refetchCallback.current = onIssueByFieldsRefetch;
    const onIssueDeleteSuccess = (0, $eUqFw.useCallback)(({ issueKey: deletedIssueKey })=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(); // Return to list view if we were in full page mode
            exitFullPageIssueAppMode();
        } else setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKeyToSelect));
    }, [
        deselectIssue,
        exitFullPageIssueAppMode,
        onDeleteIssue,
        setSelectedIssueByKey
    ]);
    const onIssueKeyChange = (0, $eUqFw.useCallback)((issueKeys)=>{
        setSelectedIssueByKey(issueKeys.toIssueKey);
    }, [
        setSelectedIssueByKey
    ]); // When we're in non-embedded view (i.e. full page) we need to define a max width to ensure correct full page
    // styling within the issue app.
    const maxWidth = !isEmbedView ? (0, $9mxRp.getIssueContainerMaxWidth)() : undefined;
    if (!(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [issueSelection] = (0, $4w4xT.useIssueSelectionState)();
        if (issueSelection === (0, $4w4xT.selectionState).BLANK_ISSUE_SELECTED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$IssueAppContainer, {
            isEmbedView: isEmbedView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCzk9.default), {
            issueResults: issueResultsData,
            extraHeaderActions: extraHeaderActions,
            isEmbedView: isEmbedView,
            maxWidth: maxWidth
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iH6jq.PermissionErrorView), null));
    }
    if (!selectedIssueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageErrorReady), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$IssueAppContainer, {
        isEmbedView: isEmbedView
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCzk9.default), {
        issueResults: issueResultsData,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21a48eadd1523c55$var$IssueAppHeightAdjustment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "issueNavigatorEmbeddedIssueView",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueApp, {
        metrics: issueAppMetrics,
        key: selectedIssueKey,
        isEmbedView: isEmbedView,
        analyticsSource: (0, $jccNB.ANALYTICS_SOURCE),
        issueKey: (0, $6vrw7.toIssueKey)(selectedIssueKey),
        issueMaxWidth: maxWidth,
        onIssueKeyChange: onIssueKeyChange,
        onChange: (event)=>{
            if (event && !$21a48eadd1523c55$var$issueCardChangeExcludedEventTypes.includes(event.type)) refetchCallback.current(String(selectedIssueKey));
            if (event?.type === 'FIELD_CHANGED') {
                const analyticsEventObj = createAnalyticsEvent({});
                const analyticsDataKey = {
                    analyticsEventObj: analyticsEventObj,
                    analyticsMetadata: {
                        scenario: 'nin-issue-view'
                    }
                };
                if ($21a48eadd1523c55$var$isEcClientEnabled()) saveIssueMutationToCache(new (0, $48mPv.default)(event?.issueId, (0, $d7Wfe.MutationSource).UPDATE), analyticsDataKey, {
                    errorMsg: 'FAILED_NIN_ISSUEVIEW',
                    error: true
                });
            }
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: false
    }))));
};
var $21a48eadd1523c55$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $21a48eadd1523c55$var$IssueAppWithData;
const $21a48eadd1523c55$var$IssueAppContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1ul9idpf _1e0c1txw _2lx21bp4 _vchhusvi",
            !__cmplp.isEmbedView && "_ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21a48eadd1523c55$var$IssueAppHeightAdjustment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6iVMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65bfed5798f273e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8944a9714785b3758071f3764b2d5f38>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e65bfed5798f273e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchView"
};
$e65bfed5798f273e$var$node.hash = "ce25af81610df0649d4af4ae354822f1";
var $e65bfed5798f273e$export$2e2bcd8739ae039 = $e65bfed5798f273e$var$node;

});

parcelRegister("4FhGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d683d45d6e630623$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1eb167471fb64a02bbc7a0985243c9bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d683d45d6e630623$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "headerActions_issueNavigator"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$d683d45d6e630623$var$node.hash = "267fadd3844f360bfc7e5d9f255f3ee7";
var $d683d45d6e630623$export$2e2bcd8739ae039 = $d683d45d6e630623$var$node;

});

parcelRegister("iH6jq", function(module, exports) {

$parcel$export(module.exports, "PermissionErrorView", () => $481adf0d32cb7785$export$1bd3db7a0a8884d3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $02Brq = parcelRequire("02Brq");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1HfVs = parcelRequire("1HfVs");

var $gAcfY = parcelRequire("gAcfY");

var $lXKjT = parcelRequire("lXKjT");
const $481adf0d32cb7785$var$ErrorImage = ()=>(0, $eI5EY.fg)('move_issue_view_assets_into_central_location') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02Brq.default), {
        width: 90,
        height: 130,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($481adf0d32cb7785$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HfVs))),
        alt: ""
    });
const $481adf0d32cb7785$export$1bd3db7a0a8884d3 = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lXKjT.messages).permissionErrorHeaderIssueTermRefresh : (0, $lXKjT.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lXKjT.messages).permissionErrorDescriptionIssueTermRefresh : (0, $lXKjT.messages).permissionErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($481adf0d32cb7785$var$ErrorImage, null)
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $481adf0d32cb7785$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i53f4 _1bsb10bg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("02Brq", function(module, exports) {

$parcel$export(module.exports, "default", () => $078460ec2710d3c8$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $9TZf5 = parcelRequire("9TZf5");

var $be4cc = parcelRequire("be4cc");

var $adQm7 = parcelRequire("adQm7");
const $078460ec2710d3c8$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($adQm7)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($be4cc))
});
var $078460ec2710d3c8$export$2e2bcd8739ae039 = $078460ec2710d3c8$var$Illustration;
// for advanced use only
const $078460ec2710d3c8$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("be4cc", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("adQm7", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("1HfVs", function(module, exports) {
module.exports = new URL("permission-error.da9ec123.svg", import.meta.url).toString();

});

parcelRegister("gAcfY", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $72830fdda25402b0$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $72830fdda25402b0$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($72830fdda25402b0$var$Description, null, props.description), props.children);
$72830fdda25402b0$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $72830fdda25402b0$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $72830fdda25402b0$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$72830fdda25402b0$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72830fdda25402b0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _2lx21bp4 _syaz1fxt _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $72830fdda25402b0$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8o0gd _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $72830fdda25402b0$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lXKjT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $44ae321cec7c5988$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $44ae321cec7c5988$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.permission-error-view.permission-error-header",
        "defaultMessage": "You don't have access to this issue"
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.permission-error-view.permission-error-description",
        "defaultMessage": "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues."
    },
    permissionErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.permission-error-view.permission-error-header-issue-term-refresh",
        "defaultMessage": "You don't have access to this issue"
    },
    permissionErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.permission-error-view.permission-error-description-issue-term-refresh",
        "defaultMessage": "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues."
    }
});

});


parcelRegister("cavjE", function(module, exports) {

$parcel$export(module.exports, "UnknownErrorView", () => $6c37277dc48ad946$export$f23f26771420affd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $po38W = parcelRequire("po38W");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c7ALH = parcelRequire("c7ALH");

var $gAcfY = parcelRequire("gAcfY");

var $iSa7H = parcelRequire("iSa7H");
const $6c37277dc48ad946$var$ErrorImage = ()=>(0, $eI5EY.fg)('move_issue_view_assets_into_central_location') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $po38W.default), {
        width: 90,
        height: 130,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c37277dc48ad946$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c7ALH))),
        alt: ""
    });
const $6c37277dc48ad946$export$f23f26771420affd = ()=>{
    const intl = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAcfY.ErrorDisplay), {
        header: intl.formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iSa7H.messages).unknownErrorHeaderIssueTermRefresh : (0, $iSa7H.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iSa7H.messages).unknownErrorDescriptionIssueTermRefresh : (0, $iSa7H.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c37277dc48ad946$var$ErrorImage, null)
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c37277dc48ad946$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1j4a _1bsb68cl",
            __cmplp.className
        ])
    });
});

});
parcelRegister("po38W", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb6273fce2cbf57$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $4ingX = parcelRequire("4ingX");
const $9eb6273fce2cbf57$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4ingX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4ingX))
});
var $9eb6273fce2cbf57$export$2e2bcd8739ae039 = $9eb6273fce2cbf57$var$Illustration;
// for advanced use only
const $9eb6273fce2cbf57$export$a179c88182cb9d56 = [
    0,
    0,
    104,
    140
];

});
parcelRegister("4ingX", function(module, exports) {
module.exports = new URL("empty-search-error-colour.f0aa9e5e.svg", import.meta.url).toString();

});


parcelRegister("c7ALH", function(module, exports) {
module.exports = new URL("unknown-error.af4eba12.svg", import.meta.url).toString();

});

parcelRegister("iSa7H", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1416a448c428a41e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1416a448c428a41e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    },
    unknownErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header-issue-term-refresh",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    }
});

});


parcelRegister("fE3Ua", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $407ab16d43881e85$export$8db21fc94823e1cc);
const $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $407ab16d43881e85$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $407ab16d43881e85$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $407ab16d43881e85$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $407ab16d43881e85$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $407ab16d43881e85$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $407ab16d43881e85$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $407ab16d43881e85$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $407ab16d43881e85$export$8db21fc94823e1cc = {
    [$407ab16d43881e85$var$FIELD_CHANGE_REQUESTED]: $407ab16d43881e85$var$FIELD_CHANGE_REQUESTED,
    [$407ab16d43881e85$var$FIELD_CHANGE_FAILED]: $407ab16d43881e85$var$FIELD_CHANGE_FAILED,
    [$407ab16d43881e85$var$FIELD_CHANGED]: $407ab16d43881e85$var$FIELD_CHANGED,
    [$407ab16d43881e85$var$ISSUE_TYPE_CHANGED]: $407ab16d43881e85$var$ISSUE_TYPE_CHANGED,
    [$407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED]: $407ab16d43881e85$var$ISSUE_RELATIONSHIP_UPDATED,
    [$407ab16d43881e85$var$ISSUE_LINKS_CREATED]: $407ab16d43881e85$var$ISSUE_LINKS_CREATED,
    [$407ab16d43881e85$var$ISSUE_LINK_DELETED]: $407ab16d43881e85$var$ISSUE_LINK_DELETED,
    [$407ab16d43881e85$var$CHILD_ISSUE_ADDED]: $407ab16d43881e85$var$CHILD_ISSUE_ADDED,
    [$407ab16d43881e85$var$SUBTASK_ADDED]: $407ab16d43881e85$var$SUBTASK_ADDED,
    [$407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED]: $407ab16d43881e85$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED]: $407ab16d43881e85$var$CHILD_ISSUE_FIELD_UPDATED,
    [$407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $407ab16d43881e85$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("gJYxu", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $47dde6f657625382$export$fbf48ede0cf52b5a);
$parcel$export(module.exports, "IssueModalBoundary", () => $47dde6f657625382$export$74d408982642a541);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $5GxEP = parcelRequire("5GxEP");

var $cyVXS = parcelRequire("cyVXS");

var $gGtKh = parcelRequire("gGtKh");

var $c4qEZ = parcelRequire("c4qEZ");
const $47dde6f657625382$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $47dde6f657625382$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4qEZ.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("cyVXS", function(module, exports) {

$parcel$export(module.exports, "ModalBoundary", () => $f96d169c5da11246$export$c3f500e812fb1bb3);

var $eUqFw = parcelRequire("eUqFw");

var $h97Af = parcelRequire("h97Af");

var $fee69 = parcelRequire("fee69");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $f96d169c5da11246$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
    const ErrorState = (0, $eUqFw.useCallback)((args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: args.error
        }), [
        id
    ]);
    const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
        metricKey: metricKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        render: ErrorState,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: id,
        fallback: fallback
    }, children));
};

});


parcelRegister("9mxRp", function(module, exports) {

$parcel$export(module.exports, "HEADER_BREADCRUMBS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$eb0ef5297b0cdc23);
$parcel$export(module.exports, "HEADER_BREADCRUMBS_END_MARK_KEY", () => $3849cfed910e9285$export$9c0a7052eb43d49c);
$parcel$export(module.exports, "HEADER_ACTIONS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$ff64d9f93169b1f0);
$parcel$export(module.exports, "HEADER_ACTIONS_END_MARK_KEY", () => $3849cfed910e9285$export$e696e07345d019c7);
$parcel$export(module.exports, "ISSUE_NAME_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$39f2c7a88d6952c7);
$parcel$export(module.exports, "ISSUE_NAME_END_MARK_KEY", () => $3849cfed910e9285$export$6b38db117e6a59c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$e4ec603cd2ae64c3);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$485e8138df2fade3);
$parcel$export(module.exports, "CONTENT_ITEMS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$37c39403f63dfe50);
$parcel$export(module.exports, "CONTENT_ITEMS_END_MARK_KEY", () => $3849cfed910e9285$export$bcac34901554ce05);
$parcel$export(module.exports, "ACTIVITY_FEED_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$cfd354167a2170f3);
$parcel$export(module.exports, "ACTIVITY_FEED_END_MARK_KEY", () => $3849cfed910e9285$export$e20857c483438d46);
$parcel$export(module.exports, "FOOTNOTE_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$2f7e8d259a68175d);
$parcel$export(module.exports, "FOOTNOTE_END_MARK_KEY", () => $3849cfed910e9285$export$8c4857e697bb9a6b);
$parcel$export(module.exports, "ISSUE_STATUS_BEGIN_MARK_KEY", () => $3849cfed910e9285$export$6669013ba0004c0);
$parcel$export(module.exports, "ISSUE_STATUS_END_MARK_KEY", () => $3849cfed910e9285$export$ff2ebe781d7bd44e);
$parcel$export(module.exports, "defaultRatioRightColumn", () => $3849cfed910e9285$export$7fec582ac43ca9da);
$parcel$export(module.exports, "getIssueContainerMaxWidth", () => $3849cfed910e9285$export$c76181843186885);
const $3849cfed910e9285$export$eb0ef5297b0cdc23 = 'HEADER_BREADCRUMBS_BEGIN_MARK';
const $3849cfed910e9285$export$9c0a7052eb43d49c = 'HEADER_BREADCRUMBS_END_MARK';
const $3849cfed910e9285$export$ff64d9f93169b1f0 = 'HEADER_ACTIONS_BEGIN_MARK';
const $3849cfed910e9285$export$e696e07345d019c7 = 'HEADER_ACTIONS_END_MARK';
const $3849cfed910e9285$export$39f2c7a88d6952c7 = 'ISSUE_NAME_BEGIN_MARK';
const $3849cfed910e9285$export$6b38db117e6a59c3 = 'ISSUE_NAME_END_MARK';
const $3849cfed910e9285$export$e4ec603cd2ae64c3 = 'QUICK_ADD_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$485e8138df2fade3 = 'QUICK_ADD_ITEMS_END_MARK';
const $3849cfed910e9285$export$37c39403f63dfe50 = 'CONTENT_ITEMS_BEGIN_MARK';
const $3849cfed910e9285$export$bcac34901554ce05 = 'CONTENT_ITEMS_END_MARK';
const $3849cfed910e9285$export$cfd354167a2170f3 = 'ACTIVITY_FEED_BEGIN_MARK';
const $3849cfed910e9285$export$e20857c483438d46 = 'ACTIVITY_FEED_END_MARK';
const $3849cfed910e9285$export$2f7e8d259a68175d = 'FOOTNOTE_BEGIN_MARK';
const $3849cfed910e9285$export$8c4857e697bb9a6b = 'FOOTNOTE_END_MARK';
const $3849cfed910e9285$export$6669013ba0004c0 = 'ISSUE_STATUS_BEGIN_MARK';
const $3849cfed910e9285$export$ff2ebe781d7bd44e = 'ISSUE_STATUS_END_MARK';
const $3849cfed910e9285$export$7fec582ac43ca9da = 0.35;
const $3849cfed910e9285$export$c76181843186885 = ()=>1680;

});

parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});
parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $fqqil = parcelRequire("fqqil");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $fqqil.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';


parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});




parcelRegister("kOOpn", function(module, exports) {

$parcel$export(module.exports, "useStartNinIssueAppAnalytics", () => $b4a559458c987e5d$export$39482b240f0b451f);

var $eUqFw = parcelRequire("eUqFw");

var $cFpT4 = parcelRequire("cFpT4");

var $hzcvF = parcelRequire("hzcvF");

var $4RwIp = parcelRequire("4RwIp");
const $b4a559458c987e5d$export$b9b395b52bdc3f4a = (0, $cFpT4.metrics).pageSegmentLoad({
    key: 'new-issue-navigator.issue-app'
});
const $b4a559458c987e5d$export$39482b240f0b451f = (issueKey)=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const previousIssueKey = (0, $hzcvF.usePrevious)(issueKey);
    // We explicitly start during render instead of an effect hook as onInteractive can be fired before the effect hook
    // has run for cached issues.
    if (issueKey !== previousIssueKey) $b4a559458c987e5d$export$b9b395b52bdc3f4a.start();
    const onInteractive = (0, $eUqFw.useCallback)(()=>{
        $b4a559458c987e5d$export$b9b395b52bdc3f4a.stop({
            customData: {
                view: view
            }
        });
    }, [
        view
    ]);
    return {
        onInteractive: onInteractive
    };
};

});

parcelRegister("5qkO2", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $9aaae6c61c9dedac$export$45e2b3c3de4980ed);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");
const $9aaae6c61c9dedac$var$getKeyForEdge = (edge)=>{
    const { NODE: NODE } = (0, $cNy9K.ConnectionInterface).get();
    return edge?.getLinkedRecord(NODE)?.getValue('key');
};
const $9aaae6c61c9dedac$var$getFirstEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $cNy9K.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[0]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $9aaae6c61c9dedac$var$getLastEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $cNy9K.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[edges.length - 1]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $9aaae6c61c9dedac$var$updatePageInfoCursor = (pageInfo, pageInfoField, replacementCursor, edgeToDelete)=>{
    if (!pageInfo || !replacementCursor) return;
    const { CURSOR: CURSOR } = (0, $cNy9K.ConnectionInterface).get();
    const pageInfoCursor = pageInfo.getValue(pageInfoField);
    if (pageInfoCursor && pageInfoCursor === edgeToDelete.getValue(CURSOR)) pageInfo.setValue(replacementCursor, pageInfoField);
};
const $9aaae6c61c9dedac$var$updatePageInfo = (connectionRecord, edgeToDelete)=>{
    const { START_CURSOR: START_CURSOR, END_CURSOR: END_CURSOR, PAGE_INFO: PAGE_INFO } = (0, $cNy9K.ConnectionInterface).get();
    const pageInfo = connectionRecord.getLinkedRecord(PAGE_INFO);
    $9aaae6c61c9dedac$var$updatePageInfoCursor(pageInfo, START_CURSOR, $9aaae6c61c9dedac$var$getFirstEdgeCursor(connectionRecord), edgeToDelete);
    $9aaae6c61c9dedac$var$updatePageInfoCursor(pageInfo, END_CURSOR, $9aaae6c61c9dedac$var$getLastEdgeCursor(connectionRecord), edgeToDelete);
};
const $9aaae6c61c9dedac$export$45e2b3c3de4980ed = (connectionId)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((issueKeyToDelete)=>{
        let previousIssueKey;
        let nextIssueKey;
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            const connectionRecord = connectionId ? store.get(connectionId) : undefined;
            if (!connectionRecord) return;
            const { EDGES: EDGES } = (0, $cNy9K.ConnectionInterface).get();
            const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
            const index = edges.findIndex((edge)=>$9aaae6c61c9dedac$var$getKeyForEdge(edge) === issueKeyToDelete);
            if (index > -1) {
                nextIssueKey = $9aaae6c61c9dedac$var$getKeyForEdge(edges[index + 1]);
                previousIssueKey = $9aaae6c61c9dedac$var$getKeyForEdge(edges[index - 1]);
                // Filter out deleted record from our connection
                connectionRecord.setLinkedRecords(edges.slice(0, index).concat(edges.slice(index + 1)), EDGES);
                // Update page start/end cursors if necessary following record delete
                $9aaae6c61c9dedac$var$updatePageInfo(connectionRecord, edges[index]);
                // Decrement the total count
                const totalCount = connectionRecord.getValue('totalIssueSearchResultCount');
                if (typeof totalCount === 'number') connectionRecord.setValue(totalCount - 1, 'totalIssueSearchResultCount');
            }
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        connectionId
    ]);
};

});

parcelRegister("lCzk9", function(module, exports) {

$parcel$export(module.exports, "default", () => $159f546a51e6e323$export$2e2bcd8739ae039);

var $4Iv1W = parcelRequire("4Iv1W");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iWLL0 = parcelRequire("iWLL0");

var $3Hdmt = parcelRequire("3Hdmt");

var $79xbN = parcelRequire("79xbN");

var $4w4xT = parcelRequire("4w4xT");

var $6FIwx = parcelRequire("6FIwx");

var $bt01S = parcelRequire("bt01S");
/**
 * Render extraHeaderActions if provided or otherwise return an empty render.
 */ const $159f546a51e6e323$var$HeaderActionsFallback = ({ extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, maxWidth: maxWidth })=>extraHeaderActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView
    }, extraHeaderActions) : null;
/**
 * Render issue pagination controls and extraHeaderActions if provided.
 */ const $159f546a51e6e323$var$HeaderActions = (props)=>{
    const { extraHeaderActions: extraHeaderActions, issueResults: issueResults, maxWidth: maxWidth, isEmbedView: isEmbedView } = props;
    const issueResultsData = (0, $iWLL0.useFragment)((0, $4Iv1W.default), issueResults);
    let selectedIssuePosition;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const selectedIssueIndex = (0, $6FIwx.useSelectedIssueIndex)();
        // If selectedIssueIndex is negative then our selected issue key does not exist in the result set, so there
        // are no pagination controls to show.
        if (selectedIssueIndex === -1 || issueResultsData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsFallback, props);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { getSelectedIssuePosition: getSelectedIssuePosition } = (0, $4w4xT.useSelectedIssueStateOldActions)();
        selectedIssuePosition = getSelectedIssuePosition();
        // If selectedIssuePosition is not defined then our selected issue key does not exist in the result set, so there
        // are no pagination controls to show.
        if (selectedIssuePosition == null || issueResultsData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsFallback, props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($159f546a51e6e323$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView
    }, extraHeaderActions ?? null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bt01S.default), {
        issueResults: issueResultsData,
        // TODO Remove prop when cleaning up jira_spreadsheet_component_m1
        selectedIssuePosition: selectedIssuePosition
    }));
};
var $159f546a51e6e323$export$2e2bcd8739ae039 = (0, $3Hdmt.withRecoverableErrorBoundary)($159f546a51e6e323$var$HeaderActions, {
    recoveryProp: 'issueResults',
    Fallback: $159f546a51e6e323$var$HeaderActionsFallback
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $159f546a51e6e323$var$HeaderActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, maxWidth: maxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1bahesu3 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1bsb1osq _vchhusvi _10nju2gc _7zw6v47k",
            __cmplp.isEmbedView && "_n3tdu2gc",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Iv1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e05a0534779c0d07$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bc51f9494de5d6fa2940f677e3da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e05a0534779c0d07$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "headerActions_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issuePagination_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$e05a0534779c0d07$var$node.hash = "701bdde8a1a96783e68d573053dd8362";
var $e05a0534779c0d07$export$2e2bcd8739ae039 = $e05a0534779c0d07$var$node;

});

parcelRegister("3Hdmt", function(module, exports) {

$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $1e0342b6d6628cc9$export$c25a1c850f00ce39);

var $eUqFw = parcelRequire("eUqFw");
function $1e0342b6d6628cc9$export$c25a1c850f00ce39(WrappedComponent, { recoveryProp: recoveryProp, Fallback: Fallback }) {
    class RecoverableErrorBoundary extends (0, $eUqFw.Component) {
        componentDidUpdate(prevProps) {
            if (this.state.errorProps && prevProps[recoveryProp] !== this.props[recoveryProp]) this.setState({
                errorProps: null
            });
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                errorProps: {
                    error: error,
                    errorInfo: errorInfo
                }
            });
        }
        render() {
            if (this.state.errorProps) return Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Fallback, {
                ...this.props,
                ...this.state.errorProps
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, this.props);
        }
        constructor(...args){
            super(...args);
            this.state = {
                errorProps: null
            };
        }
    }
    return RecoverableErrorBoundary;
}

});

parcelRegister("bt01S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f244c1c37c30a036$export$2e2bcd8739ae039);

var $dpAaW = parcelRequire("dpAaW");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $32p04 = parcelRequire("32p04");

var $79xbN = parcelRequire("79xbN");

var $g3uGD = parcelRequire("g3uGD");

var $6LS1L = parcelRequire("6LS1L");

var $53tMP = parcelRequire("53tMP");

var $2uQ5n = parcelRequire("2uQ5n");
const $f244c1c37c30a036$var$IssuePagination = ({ issueResults: issueResults, selectedIssuePosition: selectedIssuePosition })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $dpAaW.default), issueResults);
    const { totalIssueSearchResultCount: totalIssueSearchResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult } = issueResultsData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) && /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f244c1c37c30a036$var$PaginationTextContainer, {
        "data-testid": "issue-pagination.pagination-text"
    }, totalIssueSearchResultCount <= 0 ? selectedIssuePosition : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3uGD.default), {
        prependMessage: (0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6LS1L.default).issueIndexTotalKnownIssueTermRefresh : (0, $6LS1L.default).issueIndexTotalKnown,
        prependMessageValues: {
            issueIndex: selectedIssuePosition
        },
        isCapped: isCappingIssueSearchResult ?? false,
        stableCount: totalIssueSearchResultCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32p04.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uQ5n.default), {
        selectedIssuePosition: selectedIssuePosition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53tMP.default), {
        totalResultCount: totalIssueSearchResultCount,
        selectedIssuePosition: selectedIssuePosition,
        isCappingIssueSearchResult: isCappingIssueSearchResult ?? false
    })));
};
var $f244c1c37c30a036$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f244c1c37c30a036$var$IssuePagination;
const $f244c1c37c30a036$var$PaginationTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dpAaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d0d5304740ceb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdeacb15335634351a83b6eeb614c997>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $55d0d5304740ceb0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issuePagination_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            "action": "THROW",
            "path": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$55d0d5304740ceb0$var$node.hash = "252cad0134e2ce14b78595c597895b8f";
var $55d0d5304740ceb0$export$2e2bcd8739ae039 = $55d0d5304740ceb0$var$node;

});

parcelRegister("g3uGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2aec0ba6ba3acd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3DZcj = parcelRequire("3DZcj");
/**
 * Display the total number of issues from a search with the ability to toggle from stable to unstable values.
 *
 * Stable vs Unstable
 *  - the **stable count** is returned from the issueSearchStable query. It will be capped at 1000 if
 *    there are more than 1000 results. This is the default count that is displayed
 *
 *  - the **unstable count** is returned from the totalIssueCountQuery query. It is the true number of results
 *    for a search and does not have a cap. This value must be requested by the user via button click.
 */ const $aa2aec0ba6ba3acd$var$TotalIssueCountWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "TotalIssueCount",
        packageName: "jiraIssueNavigator",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage(props.prependMessage, {
                ...props.prependMessageValues,
                totalNumberIssues: props.isCapped ? `${props.stableCount}+` : props.stableCount
            })),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3DZcj.default), props));
};
var $aa2aec0ba6ba3acd$export$2e2bcd8739ae039 = $aa2aec0ba6ba3acd$var$TotalIssueCountWrapper;

});
parcelRegister("3DZcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f770e002076665c$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bEBof = parcelRequire("bEBof");

var $80vF2 = parcelRequire("80vF2");

var $bBdMg = parcelRequire("bBdMg");

var $jl1we = parcelRequire("jl1we");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $cQBUE = parcelRequire("cQBUE");

var $3QTv4 = parcelRequire("3QTv4");

var $cQUrR = parcelRequire("cQUrR");
const $8f770e002076665c$var$TotalIssueCount = ({ prependMessage: prependMessage, prependMessageValues: prependMessageValues, isCapped: isCapped, stableCount: stableCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { uncappedTotalIssueCount: uncappedTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $cQBUE.useIssueSearchQuery)();
    const { count: unstableCount, isError: isError, isFetching: isFetching } = uncappedTotalIssueCount;
    if (isCapped) {
        if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: `${stableCount}+`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            position: "top",
            content: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cQUrR.default).errorTooltipTextIssueTermRefresh : (0, $cQUrR.default).errorTooltipText)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f770e002076665c$var$ErrorIconContainer, {
                ...tooltipProps,
                "data-testid": "issue-navigator.common.ui.total-issue-count.error-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEBof))), {
                label: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cQUrR.default).errorIconLabelIssueTermRefresh : (0, $cQUrR.default).errorIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "errorIcon",
            actionSubjectId: "totalIssueCount"
        }));
        if (isFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f770e002076665c$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
            size: "small",
            testId: "issue-navigator.common.ui.total-issue-count.spinner"
        })));
        if (!unstableCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QTv4.default), {
                displayText: `${stableCount}+`,
                fetch: onFetchUncappedTotalIssueCount
            })
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: unstableCount
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        as: "span"
    }, formatMessage(prependMessage, {
        ...prependMessageValues,
        totalNumberIssues: stableCount
    }));
};
var $8f770e002076665c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $eUqFw.memo)($8f770e002076665c$var$TotalIssueCount);
const $8f770e002076665c$var$ErrorIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _4t3i1tcg _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f770e002076665c$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _otyr1l7b _18u01y44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3QTv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $089c35c277622008$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $jl1we = parcelRequire("jl1we");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $cQUrR = parcelRequire("cQUrR");
const $089c35c277622008$var$LoadUncappedCountButton = ({ fetch: fetch, displayText: displayText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fetchCount = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        fetch();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'totalIssueCountButton');
    }, [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cQUrR.default).cappedCountTooltipIssueTermRefresh : (0, $cQUrR.default).cappedCountTooltip),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        tabIndex: 0,
        appearance: "link",
        spacing: "none",
        onClick: fetchCount,
        "aria-label": formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cQUrR.default).cappedCountTooltipIssueTermRefresh : (0, $cQUrR.default).cappedCountTooltip),
        testId: "issue-navigator.common.ui.total-issue-count.load-uncapped-count-button.button"
    }, displayText));
};
var $089c35c277622008$export$2e2bcd8739ae039 = $089c35c277622008$var$LoadUncappedCountButton;

});
parcelRegister("cQUrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $512543f6a1aec6d7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $512543f6a1aec6d7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorTooltipText: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabel: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltip: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip",
        "defaultMessage": "See the total number of issues."
    },
    errorTooltipTextIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label-issue-term-refresh",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip-issue-term-refresh",
        "defaultMessage": "See the total number of issues."
    }
});

});




parcelRegister("6LS1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $75951b7edeaf903c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $75951b7edeaf903c$var$messages = (0, $90IgZ.defineMessages)({
    issueIndexTotalKnown: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.issue-index-total-known",
        "defaultMessage": "{issueIndex} of {totalNumberIssues}"
    },
    issueIndexTotalKnownIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.issue-index-total-known-issue-term-refresh",
        "defaultMessage": "{issueIndex} of {totalNumberIssues}"
    }
});
var $75951b7edeaf903c$export$2e2bcd8739ae039 = $75951b7edeaf903c$var$messages;

});

parcelRegister("53tMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $528a37d41af402b3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kRXDJ = parcelRequire("kRXDJ");

var $5IJsn = parcelRequire("5IJsn");

var $jl1we = parcelRequire("jl1we");

var $7uIWw = parcelRequire("7uIWw");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $4w4xT = parcelRequire("4w4xT");

var $6FIwx = parcelRequire("6FIwx");

var $ia9pY = parcelRequire("ia9pY");
const $528a37d41af402b3$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($528a37d41af402b3$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $528a37d41af402b3$var$IssuePaginationNextButton = ({ selectedIssuePosition: selectedIssuePosition, totalResultCount: totalResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let selectNextIssue;
    let issueKey;
    let isDisabled;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $6FIwx.useSelectedIssueActions)();
        selectNextIssue = actions.selectNextIssue; // eslint-disable-next-line react-hooks/rules-of-hooks
        issueKey = (0, $6FIwx.useNextIssueKey)();
        isDisabled = !issueKey;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $4w4xT.useSelectedIssueStateOldActions)();
        selectNextIssue = actions.selectNextIssue;
        issueKey = actions.getNextIssue().issueKey;
        isDisabled = selectedIssuePosition === totalResultCount;
    }
    const nextIssueMessage = issueKey ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ia9pY.default).nextIssueTooltipIssueTermRefresh : (0, $ia9pY.default).nextIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ia9pY.default).nextIssueWithoutKeyTooltipIssueTermRefresh : (0, $ia9pY.default).nextIssueWithoutKeyTooltip);
    const onClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        if (selectNextIssue()) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'nextIssue');
    }, [
        selectNextIssue
    ]);
    if (isDisabled && isCappingIssueSearchResult) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ia9pY.default).disabledButtonTooltipIssueTermRefresh : (0, $ia9pY.default).disabledButtonTooltip),
        tag: $528a37d41af402b3$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uIWw.default), {
        tabIndex: 0,
        isDisabled: true,
        "data-testid": "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))),
        label: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ia9pY.default).disabledButtonTooltipIssueTermRefresh : (0, $ia9pY.default).disabledButtonTooltip),
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact"
    }), ")"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))),
        label: isDisabled ? formatMessage((0, $ia9pY.default).disabledButtonLabel, {
            issueCount: totalResultCount
        }) : nextIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $528a37d41af402b3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $528a37d41af402b3$var$IssuePaginationNextButton;
const $528a37d41af402b3$var$StyledTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7uIWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23000ce719f2bef$export$2e2bcd8739ae039);

var $kwce8 = parcelRequire("kwce8");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c23000ce719f2bef$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $kwce8.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$c23000ce719f2bef$export$2e2bcd8739ae039 = $c23000ce719f2bef$var$DisabledButtonWithTooltip;

});

parcelRegister("ia9pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $56da645f7a9feeb7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $56da645f7a9feeb7$var$messages = (0, $90IgZ.defineMessages)({
    nextIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label",
        "defaultMessage": "{issueCount} of {issueCount} issues, select previous issues to go back"
    },
    nextIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    }
});
var $56da645f7a9feeb7$export$2e2bcd8739ae039 = $56da645f7a9feeb7$var$messages;

});


parcelRegister("2uQ5n", function(module, exports) {

$parcel$export(module.exports, "default", () => $512743b19bcac109$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kRXDJ = parcelRequire("kRXDJ");

var $9hzlR = parcelRequire("9hzlR");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $4w4xT = parcelRequire("4w4xT");

var $6FIwx = parcelRequire("6FIwx");

var $dr4QU = parcelRequire("dr4QU");
const $512743b19bcac109$var$IssuePaginationPreviousButton = ({ selectedIssuePosition: selectedIssuePosition })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let selectPreviousIssue;
    let issueKey;
    let isDisabled;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $6FIwx.useSelectedIssueActions)();
        selectPreviousIssue = actions.selectPreviousIssue;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        issueKey = (0, $6FIwx.usePreviousIssueKey)();
        isDisabled = !issueKey;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $4w4xT.useSelectedIssueStateOldActions)();
        selectPreviousIssue = actions.selectPreviousIssue;
        issueKey = actions.getPreviousIssue().issueKey;
        isDisabled = selectedIssuePosition === 1;
    }
    const previousIssueMessage = issueKey ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dr4QU.default).previousIssueTooltipIssueTermRefresh : (0, $dr4QU.default).previousIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dr4QU.default).previousIssueWithoutKeyTooltipIssueTermRefresh : (0, $dr4QU.default).previousIssueWithoutKeyTooltip);
    const onClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        if (selectPreviousIssue()) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'previousIssue');
    }, [
        selectPreviousIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9hzlR))),
        label: isDisabled ? formatMessage((0, $dr4QU.default).disabledButtonLabel) : previousIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $512743b19bcac109$export$2e2bcd8739ae039 = $512743b19bcac109$var$IssuePaginationPreviousButton;

});
parcelRegister("9hzlR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c211fae37ecff14$var$_react = $6c211fae37ecff14$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6c211fae37ecff14$var$_chevronUp = $6c211fae37ecff14$var$_interopRequireDefault((parcelRequire("4twc2")));
function $6c211fae37ecff14$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6c211fae37ecff14$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $6c211fae37ecff14$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $6c211fae37ecff14$var$_chevronUp.default,
        iconType: "utility"
    }));
$6c211fae37ecff14$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $6c211fae37ecff14$var$_default = module.exports.default = $6c211fae37ecff14$var$ChevronUpIcon;

});

parcelRegister("dr4QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7ba253ad3aa957c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $f7ba253ad3aa957c$var$messages = (0, $90IgZ.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip",
        "defaultMessage": "Previous issue (Type 'k')"
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label",
        "defaultMessage": "No previous issue, select next issue"
    },
    previousIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Previous issue (Type 'k')"
    }
});
var $f7ba253ad3aa957c$export$2e2bcd8739ae039 = $f7ba253ad3aa957c$var$messages;

});




parcelRegister("7KNWV", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("dsiAd"),
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});


parcelRegister("j3TLk", function(module, exports) {

$parcel$export(module.exports, "useSearchKey", () => $3a91773e39a2eb49$export$89b7d8d2a901e7f3);
$parcel$export(module.exports, "useInfiniteScroll", () => $3a91773e39a2eb49$export$a973cef5093a8d22);

var $eUqFw = parcelRequire("eUqFw");

var $a4IeB = parcelRequire("a4IeB");

var $WBLbN = parcelRequire("WBLbN");

var $jccNB = parcelRequire("jccNB");

var $6phOL = parcelRequire("6phOL");
const $3a91773e39a2eb49$var$INFINITE_SCROLL_DEFAULT_OPTIONS = {
    pageSize: (0, $jccNB.MAX_ISSUES_PER_PAGE),
    threshold: 5 * (0, $a4IeB.ROW_HEIGHT)
};
const $3a91773e39a2eb49$export$89b7d8d2a901e7f3 = (0, $WBLbN.createStateHook)((0, $6phOL.Store), {
    selector: (state)=>state.searchKey
});
const $3a91773e39a2eb49$export$77a801a298598c57 = (0, $WBLbN.createActionsHook)((0, $6phOL.Store));
/** Get all infinite scroll related props to avoid prop drilling. */ const $3a91773e39a2eb49$var$useInfiniteScrollProps = (0, $WBLbN.createStateHook)((0, $6phOL.Store), {
    selector: ({ onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious })=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        })
});
function $3a91773e39a2eb49$export$a973cef5093a8d22(options) {
    const { pageSize: pageSize, threshold: threshold } = {
        ...$3a91773e39a2eb49$var$INFINITE_SCROLL_DEFAULT_OPTIONS,
        ...options
    };
    const { onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...rest } = $3a91773e39a2eb49$var$useInfiniteScrollProps();
    const onLoadNext = (0, $eUqFw.useCallback)(()=>onLoadNextProp(pageSize), [
        onLoadNextProp,
        pageSize
    ]);
    const onLoadPrevious = (0, $eUqFw.useCallback)(()=>onLoadPreviousProp(pageSize), [
        onLoadPreviousProp,
        pageSize
    ]);
    const infiniteScrollProps = (0, $eUqFw.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            activationThreshold: threshold,
            ...rest
        }), [
        onLoadNext,
        onLoadPrevious,
        threshold,
        rest
    ]);
    return infiniteScrollProps;
}

});

parcelRegister("21fwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a751113e57fea4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $63a751113e57fea4$var$messages = (0, $90IgZ.defineMessages)({
    returnText: {
        "id": "issue-navigator.full-page-issue-app.return-text",
        "defaultMessage": "Return to search"
    }
});
var $63a751113e57fea4$export$2e2bcd8739ae039 = $63a751113e57fea4$var$messages;

});


parcelRegister("58gge", function(module, exports) {

$parcel$export(module.exports, "default", () => $555333a428a60e6a$export$2e2bcd8739ae039);

var $4hVpa = parcelRequire("4hVpa");

var $KXsuD = parcelRequire("KXsuD");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1lXFP = parcelRequire("1lXFP");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $kmXw8 = parcelRequire("kmXw8");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");
const $555333a428a60e6a$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $555333a428a60e6a$var$Header = ({ CustomHeader: CustomHeader, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $KXsuD.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $555333a428a60e6a$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eUqFw.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const jql = (0, $3mEVr.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $dCaOY.useFilterQuery)();
    const filterData = (0, $iWLL0.useFragment)((0, $4hVpa.default), filter);
    const filterDetails = (0, $eUqFw.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomHeader, {
        jql: jql,
        filterId: filterId,
        filterDetails: filterDetails,
        searchResultPageData: searchResultPageData
    }));
};
var $555333a428a60e6a$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($555333a428a60e6a$var$Header, {
    id: 'ui.header.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});

});
parcelRegister("4hVpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e9b43d50c1f1c7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59decce3d17ede33536b0b36f9eb2f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45e9b43d50c1f1c7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$45e9b43d50c1f1c7$var$node.hash = "49ae72938f954e62114776575c662bd8";
var $45e9b43d50c1f1c7$export$2e2bcd8739ae039 = $45e9b43d50c1f1c7$var$node;

});

parcelRegister("KXsuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0010939d46d22e40$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<904e0d39da2e4e2100f94fcd59ddca44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0010939d46d22e40$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Header_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$0010939d46d22e40$var$node.hash = "a6845643ea9e8dc218ebb8df7988c3f7";
var $0010939d46d22e40$export$2e2bcd8739ae039 = $0010939d46d22e40$var$node;

});

parcelRegister("kmXw8", function(module, exports) {

$parcel$export(module.exports, "withReportErrors", () => $1607c3a4dbba9548$export$89614e972c8b110);

var $eUqFw = parcelRequire("eUqFw");

var $aR8n6 = parcelRequire("aR8n6");
const $1607c3a4dbba9548$export$89614e972c8b110 = (WrappedComponent, config)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), config, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props));

});


parcelRegister("j6Pvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $685027018ced4552$export$2e2bcd8739ae039);

var $8eeq7 = parcelRequire("8eeq7");

var $112QR = parcelRequire("112QR");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lgxha = parcelRequire("lgxha");

var $1lXFP = parcelRequire("1lXFP");

var $79xbN = parcelRequire("79xbN");

var $7byHA = parcelRequire("7byHA");

var $8WuJm = parcelRequire("8WuJm");

var $idiDE = parcelRequire("idiDE");

var $lB25E = parcelRequire("lB25E");

var $jccNB = parcelRequire("jccNB");

var $bnzDM = parcelRequire("bnzDM");

var $kmXw8 = parcelRequire("kmXw8");

var $cWCvn = parcelRequire("cWCvn");

var $4w4xT = parcelRequire("4w4xT");

var $6FIwx = parcelRequire("6FIwx");

var $4RwIp = parcelRequire("4RwIp");

var $2ycZm = parcelRequire("2ycZm");

var $3mEVr = parcelRequire("3mEVr");

var $cQBUE = parcelRequire("cQBUE");

var $9w10X = parcelRequire("9w10X");

var $clId8 = parcelRequire("clId8");

var $4OYZ7 = parcelRequire("4OYZ7");
const $685027018ced4552$var$IssueResults = ({ onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onCaughtIssueSearchError: onCaughtIssueSearchError, issueResults: issueResults, viewResult: viewResult, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps, filter: filter })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_START);
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    const jql = (0, $3mEVr.useResolvedJql)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    let onSelectedRowChange;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $6FIwx.useSelectedIssueActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onSelectedRowChange = (0, $eUqFw.useCallback)((rowIndex)=>{
            setSelectedIssueByIndex(rowIndex, {
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: true
            });
        }, [
            setSelectedIssueByIndex
        ]);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $4w4xT.useSelectedIssueStateOldActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onSelectedRowChange = (0, $eUqFw.useCallback)((rowIndex)=>{
            setSelectedIssueByIndex(rowIndex, false, false, true);
        }, [
            setSelectedIssueByIndex
        ]);
    }
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $112QR.default), issueResults);
    const viewResultData = (0, $iWLL0.useFragment)((0, $8eeq7.default), viewResult);
    const viewResultError = (0, $eUqFw.useMemo)(()=>viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== undefined && viewResultData?.extensions?.[0]?.statusCode !== null ? new (0, $7byHA.default)(viewResultData?.extensions?.[0]?.statusCode, viewResultData?.message ?? '') : undefined, [
        viewResultData
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_END);
    }, []);
    const onNavigateToIssue = (0, $eUqFw.useCallback)((issueKey)=>push(`/browse/${issueKey}`), [
        push
    ]);
    const sourceName = selectedView === 'detail' ? (0, $jccNB.ANALYTICS_DETAIL_VIEW_SOURCE_NAME) : (0, $jccNB.ANALYTICS_LIST_VIEW_SOURCE_NAME);
    if (!issueResultsData || issueResultsData.issueSearchError?.__typename === 'JiraServerError' || !viewResultData || viewResultData?.__typename === 'QueryError') return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnzDM.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clId8.default), {
        error: viewResultError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "issue-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clId8.RecoverableErrorViewBoundary), {
        recoveryProp: isFetching,
        onCaughtIssueSearchError: onCaughtIssueSearchError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ycZm.SortContainer), {
        jql: jql,
        onChangeJql: onChangeJql
    }, selectedView !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4OYZ7.default), {
        loading: isFetching,
        onSelectedRowChange: onSelectedRowChange,
        issueResults: issueResultsData,
        view: viewResultData,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled,
        issueTableProps: issueTableProps,
        filter: filter
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9w10X.default), {
        loading: isFetching,
        onNavigateToIssue: onNavigateToIssue,
        issueResults: issueResultsData,
        view: viewResultData,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>{
            onCaughtIssueSearchError && onCaughtIssueSearchError(undefined);
        }
    }))));
};
var $685027018ced4552$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($685027018ced4552$var$IssueResults, {
    id: 'ui.issue-results.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});

});
parcelRegister("8eeq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97ec8efb561a616$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4fec987cb83538f5f89e3acf9e28c55d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a97ec8efb561a616$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_viewResult",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_DetailView_view"
                }
            ],
            "type": "JiraIssueSearchView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "JiraIssueSearchViewResult",
    "abstractKey": "__isJiraIssueSearchViewResult"
};
$a97ec8efb561a616$var$node.hash = "c62e6e48eccad98fb8d9de957a0d79e9";
var $a97ec8efb561a616$export$2e2bcd8739ae039 = $a97ec8efb561a616$var$node;

});

parcelRegister("112QR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21245e866ce8637$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<491c31a1803eb30780981652cfcf0aa0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d21245e866ce8637$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_DetailView_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$d21245e866ce8637$var$node.hash = "f2381a118526d5996bae8676671dd01c";
var $d21245e866ce8637$export$2e2bcd8739ae039 = $d21245e866ce8637$var$node;

});

parcelRegister("bnzDM", function(module, exports) {

$parcel$export(module.exports, "ListViewSkeleton", () => $529f2d925551424b$export$8465c21c33452ecb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $29WMc = parcelRequire("29WMc");
const $529f2d925551424b$export$8465c21c33452ecb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($529f2d925551424b$var$StyledListViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29WMc.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $529f2d925551424b$var$StyledListViewContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("29WMc", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $789c5663e6a91d78$export$309a6db85e3f2aaa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $9ASBV = parcelRequire("9ASBV");
const $789c5663e6a91d78$var$customCssStyles = null;
const $789c5663e6a91d78$var$containerStyles = {
    height: '448px'
};
const $789c5663e6a91d78$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9ASBV))),
        containerStyles: $789c5663e6a91d78$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9ASBV", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("2ycZm", function(module, exports) {

$parcel$export(module.exports, "SortContainer", () => $c9c41efbbe9f4892$export$f2d9f14f583efb1a);
$parcel$export(module.exports, "useSortFieldAndDirection", () => $c9c41efbbe9f4892$export$951ead8cec7da319);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $gLzLS = parcelRequire("gLzLS");
const $c9c41efbbe9f4892$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        field: 'created',
        direction: 'DESC'
    },
    actions: {
        setField: (field, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField } = getState();
                if (field !== prevField) {
                    setState({
                        field: field
                    });
                    const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, undefined, aliases).toJql();
                    typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                }
            },
        setFieldAndDirection: (field, direction, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField, direction: prevDirection } = getState();
                if (field !== prevField || direction !== prevDirection) {
                    setState({
                        field: field,
                        direction: direction
                    });
                    // TODO EM-4079 - remove this and update types once old issue table FF is cleaned up
                    if (direction !== 'NONE') {
                        const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, direction, aliases).toJql();
                        typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                    }
                }
            }
    },
    name: 'IssueNavigatorSelectedViewState'
});
const $c9c41efbbe9f4892$export$f4b3414b22b0750b = ()=>({ getState: getState, setState: setState }, { jql: jql, JqlUtils: JqlUtils })=>{
        const field = JqlUtils?.jql(jql).getPrimarySortField();
        const direction = JqlUtils?.jql(jql).getPrimarySortDirection();
        const { field: prevField, direction: prevDirection } = getState();
        if (field !== prevField || direction !== prevDirection) setState({
            field: field,
            direction: direction
        });
    };
const $c9c41efbbe9f4892$export$42a852a2b6b56249 = (0, $WBLbN.createContainer)($c9c41efbbe9f4892$var$Store, {
    onInit: $c9c41efbbe9f4892$export$f4b3414b22b0750b,
    onUpdate: $c9c41efbbe9f4892$export$f4b3414b22b0750b
});
const $c9c41efbbe9f4892$export$f2d9f14f583efb1a = (props)=>{
    const Utils = (0, $gLzLS.useJqlUtils)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9c41efbbe9f4892$export$42a852a2b6b56249, {
        JqlUtils: Utils,
        ...props
    });
};
const $c9c41efbbe9f4892$export$951ead8cec7da319 = (0, $WBLbN.createHook)($c9c41efbbe9f4892$var$Store, {
    selector: ({ field: field, direction: direction })=>({
            field: field,
            direction: direction
        })
});

});
parcelRegister("gLzLS", function(module, exports) {

$parcel$export(module.exports, "useJqlUtils", () => $38a994a560642a71$export$c7c2706ff288264f);

var $eUqFw = parcelRequire("eUqFw");

const $38a994a560642a71$export$4a178a021cc96ab5 = async ()=>{
    const module = await (parcelRequire("fZhtr"));
    const { JqlUtils: JqlUtils } = module;
    return new JqlUtils();
};
const $38a994a560642a71$export$c7c2706ff288264f = ()=>{
    const [Utils, setUtils] = (0, $eUqFw.useState)();
    const asyncEffect = async ()=>{
        const ResolvedUtils = await $38a994a560642a71$export$4a178a021cc96ab5();
        setUtils(ResolvedUtils);
    };
    (0, $eUqFw.useEffect)(()=>{
        asyncEffect();
    }, []);
    return Utils;
};

});
parcelRegister("fZhtr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("8tD1c").then(()=>parcelRequire('71TnQ'));

});



parcelRegister("9w10X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d4197b9e8007c3$export$2e2bcd8739ae039);

var $g8tvz = parcelRequire("g8tvz");

var $3goVy = parcelRequire("3goVy");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $1lXFP = parcelRequire("1lXFP");

var $6FP8W = parcelRequire("6FP8W");

var $d6f6c = parcelRequire("d6f6c");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $cIZjs = parcelRequire("cIZjs");

var $kmXw8 = parcelRequire("kmXw8");

var $cWCvn = parcelRequire("cWCvn");

var $jP0l8 = parcelRequire("jP0l8");

var $3Jl0V = parcelRequire("3Jl0V");
const $b1d4197b9e8007c3$var$ConditionalContentContainer = ({ children: children })=>(0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $b1d4197b9e8007c3$var$ContentContainerStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d4197b9e8007c3$var$ContentStyledContainer, null, children);
const $b1d4197b9e8007c3$var$DetailView = ({ IssueApp: IssueApp = (0, $cIZjs.default), issueResults: issueResults, view: view, isFeedbackButtonDisabled: isFeedbackButtonDisabled, ...props })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_END);
    }, []);
    const detailViewData = (0, $iWLL0.useFragment)((0, $3goVy.default), issueResults);
    const viewData = (0, $iWLL0.useFragment)((0, $g8tvz.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "detail-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1d4197b9e8007c3$var$ConditionalContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jP0l8.default), {
        issueResults: detailViewData,
        isFeedbackButtonDisabled: isFeedbackButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Jl0V.default), {
        fragment: detailViewData,
        ...props
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueApp, {
        isEmbedView: true,
        issueResults: detailViewData,
        view: viewData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// re-render regression detection
$b1d4197b9e8007c3$var$DetailView.whyDidYouRender = true;
var $b1d4197b9e8007c3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $kmXw8.withReportErrors)($b1d4197b9e8007c3$var$DetailView, {
    id: 'ui.issue-results.detail-view.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});
const $b1d4197b9e8007c3$var$ContentStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1osq _16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $b1d4197b9e8007c3$var$ContentContainerStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    flexBasis: 0
});

});
parcelRegister("g8tvz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ccc08f1857cc59f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<81c294351dba4a1299d24ceb84cb8c13>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ccc08f1857cc59f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        }
    ],
    "type": "JiraIssueSearchView"
};
$0ccc08f1857cc59f$var$node.hash = "1b2ee54f76732e67326f37ebaa7aeb47";
var $0ccc08f1857cc59f$export$2e2bcd8739ae039 = $0ccc08f1857cc59f$var$node;

});

parcelRegister("3goVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $19138ad38d09ab56$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0fef9f6c732c3417421becd8db3fa6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19138ad38d09ab56$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_CardList_fragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$19138ad38d09ab56$var$node.hash = "acd05b914a5bafcb574b727c9c0ecbc7";
var $19138ad38d09ab56$export$2e2bcd8739ae039 = $19138ad38d09ab56$var$node;

});

parcelRegister("jP0l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e206e729eacf0d8$export$2e2bcd8739ae039);

var $dCq8X = parcelRequire("dCq8X");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $iWDmo = parcelRequire("iWDmo");

var $g6NWY = parcelRequire("g6NWY");

var $9DxNr = parcelRequire("9DxNr");

var $kxyTJ = parcelRequire("kxyTJ");

var $4bsMQ = parcelRequire("4bsMQ");
const $7e206e729eacf0d8$var$CardContainer = ({ OrderDropdown: OrderDropdown, SortButton: SortButton, children: children, issueResults: issueResults, isFeedbackButtonDisabled: isFeedbackButtonDisabled })=>{
    const data = (0, $iWLL0.useFragment)((0, $dCq8X.default), issueResults);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$StyledContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.styled-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$HeaderStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(OrderDropdown, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6NWY.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$CardListStyledContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$FooterStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kxyTJ.default), {
        issueResults: data
    })), !(0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates') && !isFeedbackButtonDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e206e729eacf0d8$var$FeedbackWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWDmo.default), null))));
};
$7e206e729eacf0d8$var$CardContainer.defaultProps = {
    OrderDropdown: (0, $9DxNr.default),
    SortButton: (0, $4bsMQ.default)
};
var $7e206e729eacf0d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7e206e729eacf0d8$var$CardContainer;
const $7e206e729eacf0d8$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _2rko1y44 _bfhk1s4m _1yt4v77o _otyru2gc _2hwxpxbi _1ul91k99 _p12f1k99",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$CardListStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dl1kxc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$HeaderStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zidpf _4t3izwfg _n3tdv77o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$FooterStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4sb0y _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7e206e729eacf0d8$var$FeedbackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _1bsbu6a3 _ca0qpxbi _n3tdv77o _1e0c1txw _1bah1h6o _19pkidpf _otyrx0bf _18u0x0bf _2hwxx0bf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dCq8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04e5009bd1e5050$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<39b9b6eadc1c9787774f142b4f7d9df9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b04e5009bd1e5050$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Paginator"
        }
    ],
    "type": "JiraIssueConnection"
};
$b04e5009bd1e5050$var$node.hash = "fca6b24420a589562ac27147066c1572";
var $b04e5009bd1e5050$export$2e2bcd8739ae039 = $b04e5009bd1e5050$var$node;

});

parcelRegister("iWDmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1a6fead981b646$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $2Gub2 = parcelRequire("2Gub2");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");

var $79xbN = parcelRequire("79xbN");

var $1c02D = parcelRequire("1c02D");

var $bCwLs = parcelRequire("bCwLs");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9Anw5 = parcelRequire("9Anw5");

var $hWc1w = parcelRequire("hWc1w");
const $3b1a6fead981b646$var$FEEDBACK_GROUP_ID = 'issue-navigator';
const $3b1a6fead981b646$var$FeedbackTitleDetails = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $3b1a6fead981b646$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Gub2.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        as: "p"
    }, formatMessage((0, $hWc1w.default).feedbackTitleDetails)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        as: "p"
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hWc1w.default).feedbackTitleDetailsContactSupportIssueTermRefresh : (0, $hWc1w.default).feedbackTitleDetailsContactSupport))));
};
const $3b1a6fead981b646$var$Feedback = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const feedbackContext = [
        {
            id: (0, $1c02D.EntryKeys).LOCATION,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: (0, $9Anw5.default)(window?.location?.href ?? '')
        },
        {
            id: (0, $1c02D.EntryKeys).SCREEN_RESOLUTION,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
        },
        {
            id: (0, $1c02D.EntryKeys).USER_AGENT,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: window?.navigator?.userAgent ?? 'unknown'
        }
    ];
    const feedbackGroupLabels = {
        // Custom dropdown placeholder
        empty: {
            selectOptionLabel: formatMessage((0, $hWc1w.default).feedbackTypePlaceholder)
        },
        // Use default labels for other options
        bug: {},
        comment: {},
        suggestion: {},
        question: {}
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCwLs.FeedbackCollectorButton), {
        testId: "issue-navigator.common.ui.feedback.feedback-button",
        entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
        feedbackGroupId: $3b1a6fead981b646$var$FEEDBACK_GROUP_ID,
        feedbackTitle: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hWc1w.default).feedbackTitleIssueTermRefresh : (0, $hWc1w.default).feedbackTitle),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3b1a6fead981b646$var$FeedbackTitleDetails, null),
        feedbackContext: feedbackContext,
        feedbackGroupLabels: feedbackGroupLabels
    });
};
var $3b1a6fead981b646$export$2e2bcd8739ae039 = $3b1a6fead981b646$var$Feedback;
const $3b1a6fead981b646$var$feedbackTitleDetailsContainerStyles = (0, $8Vv3m.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("bCwLs", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $096795107747cbd5$export$b39479f42d974760);

var $eUqFw = parcelRequire("eUqFw");

var $7lKTY = parcelRequire("7lKTY");

var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $k74dc = parcelRequire("k74dc");

var $3liet = parcelRequire("3liet");
const $096795107747cbd5$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: customLabel || formatMessage((0, $k74dc.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $096795107747cbd5$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($7lKTY))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $1c02D.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $1c02D.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};

});
parcelRegister("7lKTY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $559ee0447b697f77$var$_react = $559ee0447b697f77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $559ee0447b697f77$var$_feedback = $559ee0447b697f77$var$_interopRequireDefault((parcelRequire("7pmIa")));

var $559ee0447b697f77$var$_feedback2 = $559ee0447b697f77$var$_interopRequireDefault((parcelRequire("2EUPS")));
function $559ee0447b697f77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $559ee0447b697f77$var$FeedbackIcon = (props)=>/*#__PURE__*/ $559ee0447b697f77$var$_react.default.createElement($559ee0447b697f77$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $559ee0447b697f77$var$_feedback2.default
    }, props));
$559ee0447b697f77$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $559ee0447b697f77$var$_default = module.exports.default = $559ee0447b697f77$var$FeedbackIcon;

});
parcelRegister("7pmIa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $564c7c33344a53e9$var$_react = $564c7c33344a53e9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $564c7c33344a53e9$var$_UNSAFE_baseNew = $564c7c33344a53e9$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $564c7c33344a53e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $564c7c33344a53e9$var$FeedbackIcon = (props)=>/*#__PURE__*/ $564c7c33344a53e9$var$_react.default.createElement($564c7c33344a53e9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$564c7c33344a53e9$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $564c7c33344a53e9$var$_default = module.exports.default = $564c7c33344a53e9$var$FeedbackIcon;

});

parcelRegister("2EUPS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1efb67966bd3f6ce$var$_react = $1efb67966bd3f6ce$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $1efb67966bd3f6ce$var$_feedback = $1efb67966bd3f6ce$var$_interopRequireDefault((parcelRequire("7pmIa")));
function $1efb67966bd3f6ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1efb67966bd3f6ce$var$FeedbackIcon = (props)=>/*#__PURE__*/ $1efb67966bd3f6ce$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $1efb67966bd3f6ce$var$_feedback.default
    }));
$1efb67966bd3f6ce$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $1efb67966bd3f6ce$var$_default = module.exports.default = $1efb67966bd3f6ce$var$FeedbackIcon;

});


parcelRegister("k74dc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a622284001ff525a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a622284001ff525a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("3liet", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $37102939becff71f$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");
const $37102939becff71f$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $lUg8E.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hWc1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $aefdab523271fd9d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $aefdab523271fd9d$var$messages = (0, $90IgZ.defineMessages)({
    feedbackTitle: {
        "id": "issue-navigator.common.feedback.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator.common.feedback.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator.common.feedback.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator.common.feedback.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    },
    feedbackTitleIssueTermRefresh: {
        "id": "issue-navigator.common.feedback.feedback-title-issue-term-refresh",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetailsContactSupportIssueTermRefresh: {
        "id": "issue-navigator.common.feedback.feedback-title-details-contact-support-issue-term-refresh",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    }
});
var $aefdab523271fd9d$export$2e2bcd8739ae039 = $aefdab523271fd9d$var$messages;

});


parcelRegister("g6NWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50e514201b34112$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kRXDJ = parcelRequire("kRXDJ");

var $3ipdN = parcelRequire("3ipdN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $cQBUE = parcelRequire("cQBUE");

var $9ZmUP = parcelRequire("9ZmUP");
const $e50e514201b34112$var$RefreshButton = ()=>{
    const { isRefreshing: isRefreshing, onIssueSearchRefresh: onIssueSearchRefresh } = (0, $cQBUE.useIssueSearchQuery)();
    const handleClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'reloadIssueListButton');
        onIssueSearchRefresh();
    }, [
        onIssueSearchRefresh
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        appearance: "subtle",
        onClick: handleClick,
        testId: "issue-navigator.common.ui.refresh-button.refresh-button",
        label: formatMessage((0, $9ZmUP.default).tooltip),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ipdN))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)",
                LEGACY_size: "small",
                LEGACY_primaryColor: "color.icon.subtle"
            }),
        isLoading: isRefreshing
    });
};
var $e50e514201b34112$export$2e2bcd8739ae039 = $e50e514201b34112$var$RefreshButton;

});
parcelRegister("3ipdN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e77e094a0aa1d7ca1d4c9b1f496feee5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26669e0642da4dde$var$_react = $26669e0642da4dde$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26669e0642da4dde$var$_refresh = $26669e0642da4dde$var$_interopRequireDefault((parcelRequire("11PZK")));

var $26669e0642da4dde$var$_refresh2 = $26669e0642da4dde$var$_interopRequireDefault((parcelRequire("6MHi8")));
function $26669e0642da4dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26669e0642da4dde$var$RefreshIcon = (props)=>/*#__PURE__*/ $26669e0642da4dde$var$_react.default.createElement($26669e0642da4dde$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $26669e0642da4dde$var$_refresh2.default
    }, props));
$26669e0642da4dde$var$RefreshIcon.Name = 'RefreshIconMigration';
var $26669e0642da4dde$var$_default = module.exports.default = $26669e0642da4dde$var$RefreshIcon;

});
parcelRegister("11PZK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53a1e2fd011260ddfe6bcff1f1f84f50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0bfe378c6b5d90c8$var$_react = $0bfe378c6b5d90c8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0bfe378c6b5d90c8$var$_UNSAFE_baseNew = $0bfe378c6b5d90c8$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $0bfe378c6b5d90c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding a object or panel.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0bfe378c6b5d90c8$var$RefreshIcon = (props)=>/*#__PURE__*/ $0bfe378c6b5d90c8$var$_react.default.createElement($0bfe378c6b5d90c8$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6V1.75H2m5.5 12.48c-3.218-.254-5.75-2.447-5.75-5.73 0-3.368 2.42-4.921 4-6.29m4 7.77v4.25H14M8.5 1.75c3.218.255 5.75 2.447 5.75 5.73 0 3.352-2.397 4.906-3.977 6.27"/>`
    }, props));
$0bfe378c6b5d90c8$var$RefreshIcon.displayName = 'RefreshIcon';
var $0bfe378c6b5d90c8$var$_default = module.exports.default = $0bfe378c6b5d90c8$var$RefreshIcon;

});

parcelRegister("6MHi8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f08ce899a518e5a$var$_react = $4f08ce899a518e5a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $4f08ce899a518e5a$var$_refresh = $4f08ce899a518e5a$var$_interopRequireDefault((parcelRequire("11PZK")));
function $4f08ce899a518e5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f08ce899a518e5a$var$RefreshIcon = (props)=>/*#__PURE__*/ $4f08ce899a518e5a$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $4f08ce899a518e5a$var$_refresh.default
    }));
$4f08ce899a518e5a$var$RefreshIcon.displayName = 'RefreshIcon';
var $4f08ce899a518e5a$var$_default = module.exports.default = $4f08ce899a518e5a$var$RefreshIcon;

});


parcelRegister("9ZmUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $87bbaa605c3e53c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ // TODO - Port i18n string translations to new module ID keys
$87bbaa605c3e53c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "issue-navigator.refresh-button.tooltip",
        "defaultMessage": "Refresh"
    },
    loading: {
        "id": "issue-navigator.refresh-button.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("9DxNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $708e6757af50f17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $lUg8E = parcelRequire("lUg8E");

var $f5xzw = parcelRequire("f5xzw");
var $2hMIB = parcelRequire("2hMIB");
var $ItVxm = parcelRequire("ItVxm");

var $3yGlo = parcelRequire("3yGlo");

var $eGI9v = parcelRequire("eGI9v");

var $79xbN = parcelRequire("79xbN");

var $4ksts = parcelRequire("4ksts");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $eNjET = parcelRequire("eNjET");

var $2ycZm = parcelRequire("2ycZm");

var $7aM56 = parcelRequire("7aM56");
const $708e6757af50f17c$export$e813e910f52c9aab = {
    appearance: 'subtle',
    'data-testid': 'issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown.button'
};
const $708e6757af50f17c$var$customFieldIdPattern = /^cf\[\d+\]$/;
const $708e6757af50f17c$var$DropdownItemRadioWithAnalytics = (0, $eGI9v.default)('dropdownItemRadio', {
    onClick: 'clicked'
})((0, $2hMIB.default));
class $708e6757af50f17c$export$50f2c227513bcdb7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    onItemClick(order, aliases) {
        const { onChange: onChange, onBlur: onBlur } = this.props;
        onChange(order, aliases);
        onBlur();
    }
    renderItems() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField } = this.props;
        return Object.values((0, $jccNB.supportedOrderFields)).filter((0, $3wKQY.isNonNullish)).map(({ jqlTerm: jqlTerm, aliases: aliases })=>{
            let jqlTermForMessage = jqlTerm;
            if ([
                'issuetype'
            ].includes(jqlTermForMessage)) jqlTermForMessage = `${jqlTerm}${(0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? 'IssueTermRefresh' : ''}`;
            const messageDescriptor = (0, $7aM56.messageLookup)[jqlTermForMessage];
            const fieldName = messageDescriptor ? formatMessage(messageDescriptor) : jqlTerm;
            const props = {
                id: jqlTerm,
                onClick: ()=>{
                    this.onItemClick(jqlTerm, aliases);
                },
                isSelected: jqlTerm === orderField || orderField && aliases.includes(orderField)
            };
            return /* @ts-expect-error - Type '{ children: string; id: string; onClick: () => void; isSelected: boolean | "" | undefined; key: string; }' is not assignable to type 'Omit<{ children: ReactNode; description?: string | Element | undefined; isDisabled?: boolean | undefined; shouldTitleWrap?: boolean | undefined; shouldDescriptionWrap?: boolean | undefined; ... 5 more ...; testId?: string | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$DropdownItemRadioWithAnalytics, {
                key: jqlTerm,
                ...props
            }, fieldName);
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField, isOpen: isOpen, className: className } = this.props;
        let fallbackMessage = '';
        let fieldName = '';
        if (typeof orderField === 'string') {
            const isCustomFieldId = $708e6757af50f17c$var$customFieldIdPattern.test(orderField);
            const expectedOrderField = (0, $jccNB.supportedOrderFields)[(0, $jccNB.getSupportedFieldForAlias)(orderField) ?? orderField];
            const fallbackMessageDescriptor = expectedOrderField ? (0, $7aM56.messageLookup)[expectedOrderField.jqlTerm] : null;
            if (isCustomFieldId) fallbackMessage = formatMessage((0, $7aM56.default).customField);
            else if (expectedOrderField && fallbackMessageDescriptor) fallbackMessage = formatMessage(fallbackMessageDescriptor);
            else fieldName = orderField;
        } else fallbackMessage = formatMessage((0, $7aM56.default).defaultLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$StyledContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                    ...props,
                    appearance: "subtle",
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yGlo))), {
                        label: formatMessage((0, $7aM56.default).defaultLabel)
                    })
                }, fieldName || fallbackMessage)),
            shouldFlip: true,
            placement: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$var$StyledDropdownMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ItVxm.default), {
            id: "sort-field-group",
            title: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7aM56.default).fieldGroupIssueTermRefresh : (0, $7aM56.default).fieldGroup)
        }, this.renderItems()))));
    }
    constructor(...args){
        super(...args);
        this.onOpenChange = ({ isOpen: isOpen } = {
            isOpen: false
        })=>{
            if (isOpen) this.props.onFocus();
            else this.props.onBlur();
        };
    }
}
const $708e6757af50f17c$export$f6d8103ec9453c7f = ()=>{
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $eNjET.useOrderByOpenState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const intl = (0, $4ksts.useIntlV2)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $2ycZm.useSortFieldAndDirection)();
    const handleOnChange = (0, $eUqFw.useCallback)((orderField, aliases)=>{
        setFieldAndDirection(orderField, direction, aliases);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItemRadio'
        });
        const { fieldType: fieldType = null } = (0, $jccNB.supportedOrderFields)[(0, $jccNB.getSupportedFieldForAlias)(orderField) ?? orderField] ?? {};
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sortFieldDropdownItemRadio', {
            fieldType: fieldType,
            order: direction
        });
    }, [
        createAnalyticsEvent,
        direction,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($708e6757af50f17c$export$50f2c227513bcdb7, {
        orderField: field,
        onChange: handleOnChange,
        isOpen: isOpen,
        onFocus: open,
        onBlur: close,
        intl: intl
    });
};
var $708e6757af50f17c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
 = $708e6757af50f17c$export$f6d8103ec9453c7f;
const $708e6757af50f17c$var$StyledButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1s3g12gs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $708e6757af50f17c$var$StyledDropdownMenuContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3inklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $708e6757af50f17c$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eNjET", function(module, exports) {

$parcel$export(module.exports, "useOrderByOpenState", () => $fa07b5eb711ba6fd$export$32869ae0582ab3ff);

var $WBLbN = parcelRequire("WBLbN");
const $fa07b5eb711ba6fd$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'IssueNavigatorOrderByOpenState'
});
const $fa07b5eb711ba6fd$export$2ba8216bf1290828 = (0, $WBLbN.createSubscriber)($fa07b5eb711ba6fd$var$Store);
const $fa07b5eb711ba6fd$export$32869ae0582ab3ff = (0, $WBLbN.createHook)($fa07b5eb711ba6fd$var$Store);

});

parcelRegister("7aM56", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c750902a6922dd7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $2c750902a6922dd7$export$3a16bd55b6aaaf91);

var $90IgZ = parcelRequire("90IgZ");
/* eslint-disable jira/i18n/id-named-by-package */ const $2c750902a6922dd7$var$messages = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "issue-navigator.card-container.order-dropdown.loading",
        "defaultMessage": "Loading"
    },
    fieldGroup: {
        "id": "issue-navigator.card-container.order-dropdown.field-group",
        "defaultMessage": "Order issues by"
    },
    created: {
        "id": "issue-navigator.card-container.order-dropdown.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-navigator.card-container.order-dropdown.updated",
        "defaultMessage": "Updated"
    },
    lastviewed: {
        "id": "issue-navigator.card-container.order-dropdown.lastviewed",
        "defaultMessage": "Last viewed"
    },
    status: {
        "id": "issue-navigator.card-container.order-dropdown.status",
        "defaultMessage": "Status"
    },
    priority: {
        "id": "issue-navigator.card-container.order-dropdown.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "issue-navigator.card-container.order-dropdown.assignee",
        "defaultMessage": "Assignee"
    },
    resolved: {
        "id": "issue-navigator.card-container.order-dropdown.resolved",
        "defaultMessage": "Resolved"
    },
    issuekey: {
        "id": "issue-navigator.card-container.order-dropdown.issuekey",
        "defaultMessage": "Key"
    },
    key: {
        "id": "issue-navigator.card-container.order-dropdown.key",
        "defaultMessage": "Key"
    },
    issuetype: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype",
        "defaultMessage": "Issue Type"
    },
    duedate: {
        "id": "issue-navigator.card-container.order-dropdown.duedate",
        "defaultMessage": "Due date"
    },
    summary: {
        "id": "issue-navigator.card-container.order-dropdown.summary",
        "defaultMessage": "Summary"
    },
    reporter: {
        "id": "issue-navigator.card-container.order-dropdown.reporter",
        "defaultMessage": "Reporter"
    },
    customField: {
        "id": "issue-navigator.card-container.order-dropdown.custom-field",
        "defaultMessage": "Custom field"
    },
    defaultLabel: {
        "id": "issue-navigator.card-container.order-dropdown.default-label",
        "defaultMessage": "Order by"
    },
    fieldGroupIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.field-group-issue-term-refresh",
        "defaultMessage": "Order issues by"
    },
    issuetypeIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype-issue-term-refresh",
        "defaultMessage": "Issue Type"
    }
});
var $2c750902a6922dd7$export$2e2bcd8739ae039 = $2c750902a6922dd7$var$messages;
const $2c750902a6922dd7$export$3a16bd55b6aaaf91 = $2c750902a6922dd7$var$messages;

});


parcelRegister("kxyTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9421a0b368682070$export$2e2bcd8739ae039);

var $dQEQi = parcelRequire("dQEQi");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lUg8E = parcelRequire("lUg8E");

var $9bVLl = parcelRequire("9bVLl");

var $8rvQ8 = parcelRequire("8rvQ8");

var $jl1we = parcelRequire("jl1we");

var $9aFSa = parcelRequire("9aFSa");

var $7uIWw = parcelRequire("7uIWw");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $a1tkg = parcelRequire("a1tkg");

var $cQBUE = parcelRequire("cQBUE");

var $4LIKY = parcelRequire("4LIKY");
const $9421a0b368682070$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $9421a0b368682070$var$getPageCursor = (pageCursors, page)=>{
    const { first: first, last: last, around: around } = pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $9421a0b368682070$var$TooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9421a0b368682070$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $9421a0b368682070$var$Paginator = ({ issueResults: issueResults })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $dQEQi.default), issueResults);
    const currentPage = data.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const lastPage = $9421a0b368682070$var$getLastPage(data.pageCursors) ?? 1;
    const { isFetching: isFetching, isStalePage: isStalePage, onIssueSearchForPage: onIssueSearchForPage } = (0, $cQBUE.useIssueSearchQuery)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const onChange = (0, $eUqFw.useCallback)((pageNumber)=>{
        // @ts-expect-error - Argument of type '{ readonly around: readonly ({ readonly cursor: string | null | undefined; readonly isCurrent: boolean | null | undefined; readonly pageNumber: number | null | undefined; } | null | undefined)[] | null | undefined; readonly first: { ...; } | ... 1 more ... | undefined; readonly last: { ...; } | ... 1 more ... | unde...' is not assignable to parameter of type '{ readonly around: readonly ({ readonly cursor: string | null | undefined; readonly isCurrent: boolean | null | undefined; readonly pageNumber: number | null | undefined; } | null | undefined)[] | null | undefined; readonly first: { ...; } | ... 1 more ... | undefined; readonly last: { ...; } | ... 1 more ... | unde...'.
        const pageCursor = $9421a0b368682070$var$getPageCursor(data.pageCursors, pageNumber);
        if (pageCursor == null) return;
        onIssueSearchForPage(pageCursor);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'pageNumber'
        }), 'issueListPagination', {
            currentPage: currentPage,
            nextPage: pageNumber
        });
    }, [
        data.pageCursors,
        onIssueSearchForPage,
        createAnalyticsEvent,
        currentPage
    ]);
    const onChangePrevious = (0, $eUqFw.useCallback)(()=>onChange(currentPage - 1), [
        currentPage,
        onChange
    ]);
    const onChangeNext = (0, $eUqFw.useCallback)(()=>onChange(currentPage + 1), [
        currentPage,
        onChange
    ]);
    const keyMap = (0, $eUqFw.useMemo)(()=>({
            arrowleft: {
                callback: onChangePrevious,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $4LIKY.default).nextPageShortcutLabel))
            },
            arrowright: {
                callback: onChangeNext,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $4LIKY.default).prevPageShortcutLabel))
            }
        }), [
        formatMessage,
        onChangeNext,
        onChangePrevious
    ]);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    if (totalIssues === 0 || isFetching || isStalePage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9421a0b368682070$var$StyledContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bVLl))), {
            label: formatMessage((0, $4LIKY.default).prevPageButton)
        }),
        appearance: "subtle",
        onClick: onChangePrevious,
        isDisabled: currentPage === 1,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.prev-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9421a0b368682070$var$PageAndCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1tkg.default), {
        startIssueRange: data.issueNavigatorPageInfo?.firstIssuePosition ?? 0,
        endIssueRange: data.issueNavigatorPageInfo?.lastIssuePosition ?? 0,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult,
        loadedIssuesCount: -1,
        isInfiniteScrollEnabled: false
    })), currentPage === lastPage && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4LIKY.default).disabledButtonTooltipIssueTermRefresh : (0, $4LIKY.default).disabledButtonTooltip),
        tag: $9421a0b368682070$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uIWw.default), {
        tabIndex: 0,
        isDisabled: true,
        "aria-label": formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4LIKY.default).disabledButtonTooltipIssueTermRefresh : (0, $4LIKY.default).disabledButtonTooltip),
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rvQ8))), {
            label: formatMessage((0, $4LIKY.default).nextPageButton)
        }),
        appearance: "subtle",
        isDisabled: true,
        onClick: onChangeNext,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-button"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rvQ8))), {
            label: formatMessage((0, $4LIKY.default).nextPageButton)
        }),
        appearance: "subtle",
        isDisabled: currentPage === lastPage,
        onClick: onChangeNext,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-button"
    }));
};
var $9421a0b368682070$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9421a0b368682070$var$Paginator;
const $9421a0b368682070$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9421a0b368682070$var$PageAndCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9421a0b368682070$var$StyledTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dQEQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4bba3bd0a5e13ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eac20d88dcaa529e2cd27fff9885a4df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e4bba3bd0a5e13ba$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Paginator",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$e4bba3bd0a5e13ba$var$node.hash = "a148b81aa698fb69850df944c78ece55";
var $e4bba3bd0a5e13ba$export$2e2bcd8739ae039 = $e4bba3bd0a5e13ba$var$node;

});

parcelRegister("9bVLl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b11f29364b2329c$var$_react = $6b11f29364b2329c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6b11f29364b2329c$var$_chevronLeft = $6b11f29364b2329c$var$_interopRequireDefault((parcelRequire("7kIpn")));
function $6b11f29364b2329c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6b11f29364b2329c$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $6b11f29364b2329c$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $6b11f29364b2329c$var$_chevronLeft.default,
        iconType: "utility"
    }));
$6b11f29364b2329c$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $6b11f29364b2329c$var$_default = module.exports.default = $6b11f29364b2329c$var$ChevronLeftLargeIcon;

});
parcelRegister("7kIpn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $556cd93b235a515b$var$_react = $556cd93b235a515b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $556cd93b235a515b$var$_UNSAFE_baseNew = $556cd93b235a515b$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $556cd93b235a515b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $556cd93b235a515b$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $556cd93b235a515b$var$_react.default.createElement($556cd93b235a515b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$556cd93b235a515b$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $556cd93b235a515b$var$_default = module.exports.default = $556cd93b235a515b$var$ChevronLeftIcon;

});


parcelRegister("8rvQ8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62598b16219f9d15$var$_react = $62598b16219f9d15$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $62598b16219f9d15$var$_chevronRight = $62598b16219f9d15$var$_interopRequireDefault((parcelRequire("ggtDU")));
function $62598b16219f9d15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $62598b16219f9d15$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $62598b16219f9d15$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $62598b16219f9d15$var$_chevronRight.default,
        iconType: "utility"
    }));
$62598b16219f9d15$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $62598b16219f9d15$var$_default = module.exports.default = $62598b16219f9d15$var$ChevronRightLargeIcon;

});

parcelRegister("a1tkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2786d7d96d357760$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g3uGD = parcelRequire("g3uGD");

var $jBPYs = parcelRequire("jBPYs");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2786d7d96d357760$export$2e2bcd8739ae039 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) {
        if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, loadedIssuesCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3uGD.default), {
            prependMessage: (0, $jBPYs.default).loadedIssuesTotalKnown,
            prependMessageValues: {
                loadedIssuesCount: loadedIssuesCount
            },
            stableCount: total,
            isCapped: countExceedsMaxResults
        });
    }
    if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $jBPYs.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g3uGD.default), {
        prependMessage: (0, $jBPYs.default).issueRangeKnown,
        prependMessageValues: {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange
        },
        stableCount: total,
        isCapped: countExceedsMaxResults
    });
};

});
parcelRegister("jBPYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $692125d6ec524a42$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $692125d6ec524a42$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "issue-navigator.common.page-text.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "issue-navigator.card-container.paginator.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-navigator.card-container.paginator.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});


parcelRegister("4LIKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d1ebcc01df7186$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $85d1ebcc01df7186$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nextPageShortcutLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.next-page-shortcut-label",
        "defaultMessage": "Next page"
    },
    prevPageShortcutLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.prev-page-shortcut-label",
        "defaultMessage": "Previous page"
    },
    prevPageButton: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.prev-page-button",
        "defaultMessage": "Previous page"
    },
    nextPageButton: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.next-page-button",
        "defaultMessage": "Next page"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    }
});

});


parcelRegister("4bsMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $567b73d4957820de$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $kRXDJ = parcelRequire("kRXDJ");

var $70oKY = parcelRequire("70oKY");

var $dc69E = parcelRequire("dc69E");

var $gk64j = parcelRequire("gk64j");

var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $jccNB = parcelRequire("jccNB");

var $2ycZm = parcelRequire("2ycZm");

var $l4Fde = parcelRequire("l4Fde");

var $bYbFf = parcelRequire("bYbFf");

var $dDisy = parcelRequire("dDisy");
class $567b73d4957820de$export$e464399b18ba2124 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.sortDirection !== nextProps.sortDirection || this.props.isDisabled !== nextProps.isDisabled;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, sortDirection: sortDirection, isDisabled: isDisabled } = this.props;
        const tooltipText = sortDirection === (0, $jccNB.sortDirections).ASC ? formatMessage((0, $dDisy.default).tooltipAsc) : formatMessage((0, $dDisy.default).tooltipDesc);
        const glyph = sortDirection === (0, $jccNB.sortDirections).ASC ? (0, $bYbFf.ArrowUpIcon) : (0, $l4Fde.ArrowDownIcon);
        const SortIcon = sortDirection === (0, $jccNB.sortDirections).ASC ? (0, (/*@__PURE__*/$parcel$interopDefault($dc69E))) : (0, (/*@__PURE__*/$parcel$interopDefault($gk64j)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
            appearance: "subtle",
            onClick: this.onClick,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.sort-button.sort-button",
            isDisabled: isDisabled,
            icon: (props)=>(0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortIcon, {
                    ...props,
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70oKY.default), {
                    ...props,
                    size: "small",
                    glyph: glyph
                }),
            label: tooltipText
        }));
    }
    constructor(...args){
        super(...args);
        this.onClick = ()=>{
            const { onSort: onSort, sortDirection: sortDirection } = this.props;
            const newSortDirection = sortDirection === (0, $jccNB.sortDirections).ASC ? (0, $jccNB.sortDirections).DESC : (0, $jccNB.sortDirections).ASC;
            onSort(newSortDirection);
        };
    }
}
const $567b73d4957820de$export$86b24d49f595c6f2 = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $2ycZm.useSortFieldAndDirection)();
    const handleOnSort = (0, $eUqFw.useCallback)((newSortDirection)=>{
        typeof field === 'string' && setFieldAndDirection(field, newSortDirection, []);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const orderField = field ? (0, $jccNB.supportedOrderFields)[(0, $jccNB.getSupportedFieldForAlias)(field) ?? field] : undefined;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sortOrderChangeButton', {
            fieldType: orderField?.fieldType ?? null,
            sortOrder: newSortDirection
        });
        return true;
    }, [
        createAnalyticsEvent,
        field,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($567b73d4957820de$export$e464399b18ba2124, {
        isDisabled: typeof field !== 'string',
        sortDirection: direction,
        onSort: handleOnSort,
        ...props,
        intl: intl
    });
};
var $567b73d4957820de$export$2e2bcd8739ae039 = $567b73d4957820de$export$86b24d49f595c6f2;

});
parcelRegister("dc69E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c97101fed2bc35c007908dcd93aaaba4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99b12b8f97c69b6d$var$_react = $99b12b8f97c69b6d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $99b12b8f97c69b6d$var$_UNSAFE_baseNew = $99b12b8f97c69b6d$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $99b12b8f97c69b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99b12b8f97c69b6d$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $99b12b8f97c69b6d$var$_react.default.createElement($99b12b8f97c69b6d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 13.25h14M1 2.75h5M1 8h7m1.5-3.25 3-3 3 3m-3 4v-6.5"/>`
    }, props));
$99b12b8f97c69b6d$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $99b12b8f97c69b6d$var$_default = module.exports.default = $99b12b8f97c69b6d$var$SortAscendingIcon;

});

parcelRegister("gk64j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7058f8aa8d62dbae7d10d4935810560f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be2338aab4f753e7$var$_react = $be2338aab4f753e7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $be2338aab4f753e7$var$_UNSAFE_baseNew = $be2338aab4f753e7$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $be2338aab4f753e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be2338aab4f753e7$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $be2338aab4f753e7$var$_react.default.createElement($be2338aab4f753e7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 2.75h14M1 13.25h5M1 8h7m1.5 3.25 3 3 3-3m-3-4v6.5"/>`
    }, props));
$be2338aab4f753e7$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $be2338aab4f753e7$var$_default = module.exports.default = $be2338aab4f753e7$var$SortDescendingIcon;

});

parcelRegister("l4Fde", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $4fc098f2b37ee2c6$export$1c939d3c9b6931b);

var $eUqFw = parcelRequire("eUqFw");
const $4fc098f2b37ee2c6$export$1c939d3c9b6931b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.8,4.3 C6.6,4.1 6.3,4 6,4 C5.7,4 5.4,4.1 5.2,4.3 L2.3,7.2 C1.9,7.6 1.9,8.3 2.3,8.7 C2.7,9.1 3.3,9.1 3.7,8.7 L5,7.4 L5,19.1 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19.1 L7,7.4 L8.3,8.7 C8.7,9.1 9.3,9.1 9.7,8.7 C10.1,8.3 10.1,7.6 9.7,7.2 C9.04754611,6.54754611 8.5582057,6.0582057 8.23197876,5.73197876 C7.91376126,5.41376126 7.436435,4.936435 6.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero",
        transform: "translate(6.000000, 12.000000) rotate(180.000000) translate(-6.000000, -12.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 L21,7 C21.6,7 22,6.6 22,6 C22,5.4 21.6,5 21,5 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,19 L16,19 C16.6,19 17,18.6 17,18 C17,17.4 16.6,17 16,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("bYbFf", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $0df80519a043ecad$export$f1a507b991affc46);

var $eUqFw = parcelRequire("eUqFw");
const $0df80519a043ecad$export$f1a507b991affc46 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.8,4.3 C7.6,4.1 7.3,4 7,4 C6.7,4 6.4,4.1 6.2,4.3 L3.3,7.2 C2.9,7.6 2.9,8.3 3.3,8.7 C3.7,9.1 4.3,9.1 4.7,8.7 L6,7.4 L6,19.1 C6,19.6 6.4,20 7,20 C7.6,20 8,19.6 8,19.1 L8,7.4 L9.3,8.7 C9.7,9.1 10.3,9.1 10.7,8.7 C11.1,8.3 11.1,7.6 10.7,7.2 C10.0475461,6.54754611 9.5582057,6.0582057 9.23197876,5.73197876 C8.91376126,5.41376126 8.436435,4.936435 7.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 L21,19 C21.6,19 22,18.6 22,18 C22,17.4 21.6,17 21,17 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13,7 L16,7 C16.6,7 17,6.6 17,6 C17,5.4 16.6,5 16,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("dDisy", function(module, exports) {

$parcel$export(module.exports, "default", () => $41fa97ba4f41941a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $41fa97ba4f41941a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltipAsc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-asc",
        "defaultMessage": "Sort ascending"
    },
    tooltipDesc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-desc",
        "defaultMessage": "Sort descending"
    }
});

});



parcelRegister("3Jl0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $f21a8ed6276ba002$export$2e2bcd8739ae039);

var $9LObT = parcelRequire("9LObT");

var $dHRsO = parcelRequire("dHRsO");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iWLL0 = parcelRequire("iWLL0");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $4w4xT = parcelRequire("4w4xT");

var $3Ic6q = parcelRequire("3Ic6q");

var $6FIwx = parcelRequire("6FIwx");

var $1EVUo = parcelRequire("1EVUo");

var $fluRZ = parcelRequire("fluRZ");

var $fNFQe = parcelRequire("fNFQe");

var $3wPFH = parcelRequire("3wPFH");

var $hrpGF = parcelRequire("hrpGF");

var $h75Xv = parcelRequire("h75Xv");
const $f21a8ed6276ba002$var$BLANK_CARD_ANALYTICS_ID = 'blankIssueCard';
const $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID = 'issueCard';
const $f21a8ed6276ba002$var$CardWithSelectedIssue = ({ fragment: fragment, isFocused: isFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const fragmentData = (0, $iWLL0.useFragment)((0, $dHRsO.default), fragment);
    const { key: key } = fragmentData;
    const isSelected = (0, $6FIwx.useIsSelectedIssue)(key);
    const { setSelectedIssueByKey: setSelectedIssueByKey } = (0, $6FIwx.useSelectedIssueActions)();
    const onCardFocus = (0, $eUqFw.useCallback)(()=>{
        onFocus(key);
        setSelectedIssueByKey(key, {
            shouldDebounce: true
        });
    }, [
        key,
        onFocus,
        setSelectedIssueByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$var$CardWithAnalytics, {
        fragment: fragmentData,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: onBlur
    });
};
const $f21a8ed6276ba002$var$CardWithSelectedIssueStateOld = ({ index: index, fragment: fragment })=>{
    const selectedIssueIndex = (0, $3Ic6q.useSelectedIssueIndex)();
    const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $4w4xT.useSelectedIssueStateOldActions)();
    const [focusedIssueIndex, { setFocusedIssueByIndex: setFocusedIssueByIndex, resetFocusedIssue: resetFocusedIssue }] = (0, $4w4xT.useFocusedIssueIndex)();
    const isSelected = selectedIssueIndex === index;
    const isFocused = focusedIssueIndex === index;
    const onCardFocus = (0, $eUqFw.useCallback)(()=>{
        setFocusedIssueByIndex(index);
        setSelectedIssueByIndex(index, true);
    }, [
        index,
        setFocusedIssueByIndex,
        setSelectedIssueByIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$var$CardWithAnalytics, {
        fragment: fragment,
        index: index,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: resetFocusedIssue
    });
};
const $f21a8ed6276ba002$var$CardWithAnalytics = ({ index: index, isFocused: isFocused, isSelected: isSelected, fragment: fragment, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const cardRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (isSelected) {
            // Scroll to the card whenever it is selected and focus on it
            cardRef.current?.scrollIntoView && cardRef.current?.scrollIntoView({
                block: 'nearest'
            });
            isFocused && cardRef.current?.focus();
        }
    }, [
        isSelected,
        isFocused
    ]);
    const onClickWithAnalytics = (0, $eUqFw.useCallback)((event)=>{
        const id = fragment ? $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID : $f21a8ed6276ba002$var$BLANK_CARD_ANALYTICS_ID;
        const attributes = {
            keyboardShortcut: false,
            // TODO Remove attribute when cleaning up jira_spreadsheet_component_m1
            issueIndex: index !== undefined ? index + 1 : undefined
        };
        if ((0, $3wKQY.isNormalClick)(event)) {
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'card'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, id, attributes);
        } else {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, id, attributes);
        }
    }, [
        createAnalyticsEvent,
        fragment,
        index
    ]);
    const onContextMenuHandler = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'contextMenu clicked',
            actionSubject: 'card'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID, {
            keyboardShortcut: false,
            // TODO Remove attribute when cleaning up jira_spreadsheet_component_m1
            issueIndex: index !== undefined ? index + 1 : undefined
        });
    }, [
        createAnalyticsEvent,
        index
    ]);
    return fragment == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNFQe.default), {
        ref: cardRef,
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        ...(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? {
            onFocus: onFocus
        } : {}
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wPFH.default), {
        ref: cardRef,
        fragment: fragment,
        onClick: onClickWithAnalytics,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        onContextMenu: onContextMenuHandler
    });
};
const $f21a8ed6276ba002$export$4683131014ccb7f3 = ()=>(0, $eUqFw.useState)(null);
const $f21a8ed6276ba002$var$CardList = ({ fragment: fragment, loading: loading, onNavigateToIssue: onNavigateToIssue })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START); // Analytics
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)(); // Main
    let focusedIssueIndex = null;
    let setFocusedIssueByIndex = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    if (!(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $4w4xT.useFocusedIssueIndex)();
        focusedIssueIndex = result[0];
        setFocusedIssueByIndex = result[1].setFocusedIssueByIndex;
    }
    const [focusedIssueKey, setFocusedIssueKey] = $f21a8ed6276ba002$export$4683131014ccb7f3();
    const maxIssuesPerPage = (0, $jccNB.getMaxIssuesPerPage)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END);
    }, []);
    const fragmentData = (0, $iWLL0.useFragment)((0, $9LObT.default), fragment);
    const onIssueChangeEvent = (0, $eUqFw.useCallback)(// TODO Remove issueIndex argument when cleaning up jira_spreadsheet_component_m1
    (issueKey, issueIndex)=>{
        if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
            if (issueKey) setFocusedIssueKey(issueKey);
        } else if (issueIndex !== null) setFocusedIssueByIndex(issueIndex);
        const id = issueKey ? $f21a8ed6276ba002$var$ISSUE_CARD_ANALYTICS_ID : $f21a8ed6276ba002$var$BLANK_CARD_ANALYTICS_ID;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'card'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, id, {
            keyboardShortcut: true,
            issueIndex: issueIndex == null ? null : issueIndex + 1
        });
    }, [
        createAnalyticsEvent,
        setFocusedIssueByIndex,
        setFocusedIssueKey
    ]);
    if (loading) {
        if ((0, $eI5EY.fg)('nin_serious_accessibility_issues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$export$22a81bdd3a723b46, {
            "aria-label": formatMessage((0, $h75Xv.default).issues)
        }, [
            ...Array(maxIssuesPerPage)
        ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fluRZ.default), {
                key: index,
                issueIndex: index,
                issueCount: maxIssuesPerPage
            })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, [
            ...Array(maxIssuesPerPage)
        ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fluRZ.default), {
                key: index,
                issueIndex: index,
                issueCount: maxIssuesPerPage
            })));
    }
    let cards;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    cards = (0, $eUqFw.useMemo)(()=>fragmentData?.edges?.map((edge)=>edge?.node)?.filter(Boolean).map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$var$CardWithSelectedIssue, {
                key: node.key,
                isFocused: node.key === focusedIssueKey,
                fragment: node,
                onFocus: setFocusedIssueKey,
                onBlur: ()=>setFocusedIssueKey(null)
            })) ?? [], [
        fragmentData?.edges,
        focusedIssueKey,
        setFocusedIssueKey
    ]);
    else cards = fragmentData?.edges?.filter((0, $3wKQY.isNonNullish)).map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$var$CardWithSelectedIssueStateOld, {
            key: index,
            index: index,
            fragment: edge.node ?? undefined
        })) ?? [];
    if (cards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1EVUo.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrpGF.default), {
        focusedIssueIndex: focusedIssueIndex,
        focusedIssueKey: focusedIssueKey,
        onIssueChangeEvent: onIssueChangeEvent,
        onNavigateToIssue: onNavigateToIssue,
        disableListControls: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f21a8ed6276ba002$export$22a81bdd3a723b46, {
        "aria-label": formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $h75Xv.default).issuesIssueTermRefresh : (0, $h75Xv.default).issues),
        ...(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? {} : {
            role: 'listbox'
        }
    }, cards));
};
var $f21a8ed6276ba002$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $f21a8ed6276ba002$var$CardList;
const $f21a8ed6276ba002$export$22a81bdd3a723b46 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9LObT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee784fad7ddce81d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<47dfb295bccdcf1a251d054c5e318803>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ee784fad7ddce81d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardList_fragment",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_fragment"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_fragment"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$ee784fad7ddce81d$var$node.hash = "d3cb3598f2ff377ca459674b752821e1";
var $ee784fad7ddce81d$export$2e2bcd8739ae039 = $ee784fad7ddce81d$var$node;

});

parcelRegister("dHRsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5c2d8627950a14f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d77f3184acb93140cebf6a3d5b19aa44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5c2d8627950a14f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_fragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_fragment"
        }
    ],
    "type": "JiraIssue"
};
$b5c2d8627950a14f$var$node.hash = "193ffe36e5f982599fda1349dc93ab4d";
var $b5c2d8627950a14f$export$2e2bcd8739ae039 = $b5c2d8627950a14f$var$node;

});

parcelRegister("1EVUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ef5e672c009785$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cslVd = parcelRequire("cslVd");
const $02ef5e672c009785$export$36d139f95680ab4e = ()=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02ef5e672c009785$var$StyledContainer, {
        "data-testid": "issue-navigator.issue-results.detail-view.card-list.card-empty-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cslVd.default), null));
var $02ef5e672c009785$export$2e2bcd8739ae039 = $02ef5e672c009785$export$36d139f95680ab4e;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02ef5e672c009785$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cslVd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72adb8f08035046$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $79xbN = parcelRequire("79xbN");

var $hgbp4 = parcelRequire("hgbp4");

var $giAhk = parcelRequire("giAhk");

var $2YNcp = parcelRequire("2YNcp");
const $f72adb8f08035046$export$f3f2e7ed2b6256b1 = ({ intl: { formatMessage: formatMessage } })=>{
    const noIssues = formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2YNcp.default).noIssuesIssueTermRefresh : (0, $2YNcp.default).noIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $f72adb8f08035046$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, noIssues));
};
var /* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ $f72adb8f08035046$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($f72adb8f08035046$export$f3f2e7ed2b6256b1);
const $f72adb8f08035046$var$ImageWrapperStyles = (0, $8Vv3m.xcss)({
    height: '146px',
    width: '160px'
});

});
parcelRegister("2YNcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $37741942ebd390b0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37741942ebd390b0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh",
        "defaultMessage": "No issues were found matching your search"
    }
});

});



parcelRegister("fluRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $262b322093dcab08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bEBof = parcelRequire("bEBof");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $12tYT = parcelRequire("12tYT");

var $lfCsT = parcelRequire("lfCsT");

var $9Ms52 = parcelRequire("9Ms52");

var $jeAfN = parcelRequire("jeAfN");
const $262b322093dcab08$var$BoxFG = ({ children: children, ariaLabel: ariaLabel, isFirstCard: isFirstCard, isLastCard: isLastCard, hasError: hasError })=>(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        as: "li",
        xcss: $262b322093dcab08$var$ListItemStyle,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($262b322093dcab08$var$CardContainer, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.Wrapper), {
        role: "option",
        "aria-selected": false,
        "aria-label": ariaLabel,
        isFirstCard: isFirstCard,
        isLastCard: isLastCard,
        hasError: hasError
    }, children);
const $262b322093dcab08$var$IssueCardSkeleton = ({ hasError: hasError = false, issueIndex: issueIndex, issueCount: issueCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($262b322093dcab08$var$BoxFG, {
        ariaLabel: formatMessage((0, $9Ms52.default).issueLoadingLabel, {
            number: issueIndex
        }),
        isFirstCard: issueIndex === 0,
        isLastCard: issueIndex + 1 === issueCount,
        hasError: hasError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SkeletonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SkeletonBackground), {
        hasError: hasError,
        "data-component-selector": (0, $jeAfN.skeletonBackgroundSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ColumnMask), {
        "data-component-selector": (0, $jeAfN.columnMaskSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SummaryMask), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TextLineMask), {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TextLineMask), {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 60
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.FooterMask), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.TypeMask), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.SeparatorMask), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.IssueKeyMask), null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ErrorIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bEBof))), {
        primaryColor: `var(--ds-icon-danger, ${(0, $1b343b038f6c23ec$exports).R400})`,
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.BlankMask), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeAfN.ErrorWrapper), {
        "data-component-selector": (0, $jeAfN.errorWrapperSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfCsT.default), null))));
};
var $262b322093dcab08$export$2e2bcd8739ae039 = $262b322093dcab08$var$IssueCardSkeleton;
const $262b322093dcab08$var$ListItemStyle = (0, $8Vv3m.xcss)({
    marginBlockStart: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $262b322093dcab08$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $12tYT.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
var $1b343b038f6c23ec$exports = {};

$parcel$export($1b343b038f6c23ec$exports, "R50", () => $1b343b038f6c23ec$export$4b84fd0e2c617bd);
$parcel$export($1b343b038f6c23ec$exports, "R75", () => $1b343b038f6c23ec$export$b34b069eff244586);
$parcel$export($1b343b038f6c23ec$exports, "R100", () => $1b343b038f6c23ec$export$be802dd0d8b57f35);
$parcel$export($1b343b038f6c23ec$exports, "R200", () => $1b343b038f6c23ec$export$60847d42f9da92a6);
$parcel$export($1b343b038f6c23ec$exports, "R300", () => $1b343b038f6c23ec$export$4a7404f376229999);
$parcel$export($1b343b038f6c23ec$exports, "R400", () => $1b343b038f6c23ec$export$2010d0fb4295b346);
$parcel$export($1b343b038f6c23ec$exports, "R500", () => $1b343b038f6c23ec$export$2837b5a1a71d5c02);
$parcel$export($1b343b038f6c23ec$exports, "Y50", () => $1b343b038f6c23ec$export$8d9596b529bbb9cf);
$parcel$export($1b343b038f6c23ec$exports, "Y75", () => $1b343b038f6c23ec$export$41060a744ab0b7ae);
$parcel$export($1b343b038f6c23ec$exports, "Y100", () => $1b343b038f6c23ec$export$1cc05bbbf340e559);
$parcel$export($1b343b038f6c23ec$exports, "Y200", () => $1b343b038f6c23ec$export$5aae31392d72caaa);
$parcel$export($1b343b038f6c23ec$exports, "Y300", () => $1b343b038f6c23ec$export$c6930421db9fa514);
$parcel$export($1b343b038f6c23ec$exports, "Y400", () => $1b343b038f6c23ec$export$59619663aa6500fb);
$parcel$export($1b343b038f6c23ec$exports, "Y500", () => $1b343b038f6c23ec$export$874739ea9e379ab6);
$parcel$export($1b343b038f6c23ec$exports, "G50", () => $1b343b038f6c23ec$export$8a6341c32b6a3ee6);
$parcel$export($1b343b038f6c23ec$exports, "G75", () => $1b343b038f6c23ec$export$69a3bf21b9686c2b);
$parcel$export($1b343b038f6c23ec$exports, "G100", () => $1b343b038f6c23ec$export$afbce1382ec95f73);
$parcel$export($1b343b038f6c23ec$exports, "G200", () => $1b343b038f6c23ec$export$747d86715d4175de);
$parcel$export($1b343b038f6c23ec$exports, "G300", () => $1b343b038f6c23ec$export$940e1f69e873f202);
$parcel$export($1b343b038f6c23ec$exports, "G400", () => $1b343b038f6c23ec$export$a49394138f7b8e85);
$parcel$export($1b343b038f6c23ec$exports, "G500", () => $1b343b038f6c23ec$export$6fa04827ac68a4fb);
$parcel$export($1b343b038f6c23ec$exports, "B50", () => $1b343b038f6c23ec$export$226de0355ed012f8);
$parcel$export($1b343b038f6c23ec$exports, "B75", () => $1b343b038f6c23ec$export$8c13c2ee36917869);
$parcel$export($1b343b038f6c23ec$exports, "B100", () => $1b343b038f6c23ec$export$ecfc1dff386a3e7a);
$parcel$export($1b343b038f6c23ec$exports, "B200", () => $1b343b038f6c23ec$export$215b7063051591f1);
$parcel$export($1b343b038f6c23ec$exports, "B300", () => $1b343b038f6c23ec$export$e62e8919cca44969);
$parcel$export($1b343b038f6c23ec$exports, "B400", () => $1b343b038f6c23ec$export$b3de0ae08da2ce64);
$parcel$export($1b343b038f6c23ec$exports, "B500", () => $1b343b038f6c23ec$export$a6ee3d71bc067634);
$parcel$export($1b343b038f6c23ec$exports, "B600", () => $1b343b038f6c23ec$export$67f15409e87642a1);
$parcel$export($1b343b038f6c23ec$exports, "B700", () => $1b343b038f6c23ec$export$f0539dbc42dbb067);
$parcel$export($1b343b038f6c23ec$exports, "P50", () => $1b343b038f6c23ec$export$363e4475840015bb);
$parcel$export($1b343b038f6c23ec$exports, "P75", () => $1b343b038f6c23ec$export$4b0a4417ed59760f);
$parcel$export($1b343b038f6c23ec$exports, "P100", () => $1b343b038f6c23ec$export$6011520a64d9a187);
$parcel$export($1b343b038f6c23ec$exports, "P200", () => $1b343b038f6c23ec$export$a7175d4e9206bc80);
$parcel$export($1b343b038f6c23ec$exports, "P300", () => $1b343b038f6c23ec$export$b48405b95304b5a1);
$parcel$export($1b343b038f6c23ec$exports, "P400", () => $1b343b038f6c23ec$export$c71e4279dd54a18d);
$parcel$export($1b343b038f6c23ec$exports, "P500", () => $1b343b038f6c23ec$export$147899de772240ec);
$parcel$export($1b343b038f6c23ec$exports, "T50", () => $1b343b038f6c23ec$export$2cf711fe14c66f06);
$parcel$export($1b343b038f6c23ec$exports, "T75", () => $1b343b038f6c23ec$export$7a8f4d33f6f9772c);
$parcel$export($1b343b038f6c23ec$exports, "T100", () => $1b343b038f6c23ec$export$776c9c497ef08533);
$parcel$export($1b343b038f6c23ec$exports, "T200", () => $1b343b038f6c23ec$export$69cb3ca10c1e330e);
$parcel$export($1b343b038f6c23ec$exports, "T300", () => $1b343b038f6c23ec$export$9dc1ef0f3f48059b);
$parcel$export($1b343b038f6c23ec$exports, "T400", () => $1b343b038f6c23ec$export$7c835c78b6fcdef8);
$parcel$export($1b343b038f6c23ec$exports, "T500", () => $1b343b038f6c23ec$export$6036577f95c3877e);
$parcel$export($1b343b038f6c23ec$exports, "N0", () => $1b343b038f6c23ec$export$29a4f05edc054374);
$parcel$export($1b343b038f6c23ec$exports, "N10", () => $1b343b038f6c23ec$export$e655ef011c4aa1a2);
$parcel$export($1b343b038f6c23ec$exports, "N20", () => $1b343b038f6c23ec$export$9fdfb749e33cdf97);
$parcel$export($1b343b038f6c23ec$exports, "N30", () => $1b343b038f6c23ec$export$3e51e8f1440314ba);
$parcel$export($1b343b038f6c23ec$exports, "N40", () => $1b343b038f6c23ec$export$1ce2d1575d444ceb);
$parcel$export($1b343b038f6c23ec$exports, "N50", () => $1b343b038f6c23ec$export$8754fc7e6d8b3000);
$parcel$export($1b343b038f6c23ec$exports, "N60", () => $1b343b038f6c23ec$export$c2e91cbeada39b8b);
$parcel$export($1b343b038f6c23ec$exports, "N70", () => $1b343b038f6c23ec$export$5f71e19f3a7ad9de);
$parcel$export($1b343b038f6c23ec$exports, "N80", () => $1b343b038f6c23ec$export$eaa8c8a70ac22806);
$parcel$export($1b343b038f6c23ec$exports, "N90", () => $1b343b038f6c23ec$export$7c87d337fb91a97d);
$parcel$export($1b343b038f6c23ec$exports, "N100", () => $1b343b038f6c23ec$export$d6447c357493214f);
$parcel$export($1b343b038f6c23ec$exports, "N200", () => $1b343b038f6c23ec$export$f563ee71e9ee74cd);
$parcel$export($1b343b038f6c23ec$exports, "N300", () => $1b343b038f6c23ec$export$e2ef2124cf4024b1);
$parcel$export($1b343b038f6c23ec$exports, "N400", () => $1b343b038f6c23ec$export$eece5f492e429f08);
$parcel$export($1b343b038f6c23ec$exports, "N500", () => $1b343b038f6c23ec$export$c39c0fe0f26207ae);
$parcel$export($1b343b038f6c23ec$exports, "N600", () => $1b343b038f6c23ec$export$7090862dc3038a9f);
$parcel$export($1b343b038f6c23ec$exports, "N700", () => $1b343b038f6c23ec$export$ad0bacf983b7ddaa);
$parcel$export($1b343b038f6c23ec$exports, "N800", () => $1b343b038f6c23ec$export$7d61b15e0da132af);
$parcel$export($1b343b038f6c23ec$exports, "N900", () => $1b343b038f6c23ec$export$fbda843f0a27fe96);
$parcel$export($1b343b038f6c23ec$exports, "N10A", () => $1b343b038f6c23ec$export$791e57b27ca738ef);
$parcel$export($1b343b038f6c23ec$exports, "N20A", () => $1b343b038f6c23ec$export$8d43898f60b96a82);
$parcel$export($1b343b038f6c23ec$exports, "N30A", () => $1b343b038f6c23ec$export$920c0d5c49070351);
$parcel$export($1b343b038f6c23ec$exports, "N40A", () => $1b343b038f6c23ec$export$46987b49aab6d1a8);
$parcel$export($1b343b038f6c23ec$exports, "N50A", () => $1b343b038f6c23ec$export$7d3359664e8bb0e5);
$parcel$export($1b343b038f6c23ec$exports, "N60A", () => $1b343b038f6c23ec$export$d2d3bedfb276cac0);
$parcel$export($1b343b038f6c23ec$exports, "N70A", () => $1b343b038f6c23ec$export$6e5e7499ff054f6d);
$parcel$export($1b343b038f6c23ec$exports, "N80A", () => $1b343b038f6c23ec$export$59264b346c877fa7);
$parcel$export($1b343b038f6c23ec$exports, "N90A", () => $1b343b038f6c23ec$export$d092757d7c64925c);
$parcel$export($1b343b038f6c23ec$exports, "N100A", () => $1b343b038f6c23ec$export$486ab785e4bac3c6);
$parcel$export($1b343b038f6c23ec$exports, "N200A", () => $1b343b038f6c23ec$export$fba592bbc6419fea);
$parcel$export($1b343b038f6c23ec$exports, "N300A", () => $1b343b038f6c23ec$export$13609db0e6812ab8);
$parcel$export($1b343b038f6c23ec$exports, "N400A", () => $1b343b038f6c23ec$export$fbae4efaa892d883);
$parcel$export($1b343b038f6c23ec$exports, "N500A", () => $1b343b038f6c23ec$export$f13946d26f440ce6);
$parcel$export($1b343b038f6c23ec$exports, "N600A", () => $1b343b038f6c23ec$export$19f58225ac52a306);
$parcel$export($1b343b038f6c23ec$exports, "N700A", () => $1b343b038f6c23ec$export$6384f09da70e7b62);
$parcel$export($1b343b038f6c23ec$exports, "N800A", () => $1b343b038f6c23ec$export$d0dccc730683edc2);
$parcel$export($1b343b038f6c23ec$exports, "DN900", () => $1b343b038f6c23ec$export$2f6319cf7d736c2a);
$parcel$export($1b343b038f6c23ec$exports, "DN800", () => $1b343b038f6c23ec$export$95126bc8884d6634);
$parcel$export($1b343b038f6c23ec$exports, "DN700", () => $1b343b038f6c23ec$export$8338d8c35d44ff1);
$parcel$export($1b343b038f6c23ec$exports, "DN600", () => $1b343b038f6c23ec$export$5368d76ae4fbbda7);
$parcel$export($1b343b038f6c23ec$exports, "DN500", () => $1b343b038f6c23ec$export$9f0a771d16ec8d36);
$parcel$export($1b343b038f6c23ec$exports, "DN400", () => $1b343b038f6c23ec$export$abcf8c38338b4aa5);
$parcel$export($1b343b038f6c23ec$exports, "DN300", () => $1b343b038f6c23ec$export$97e81faa16a182c7);
$parcel$export($1b343b038f6c23ec$exports, "DN200", () => $1b343b038f6c23ec$export$bfe21c59123ecf33);
$parcel$export($1b343b038f6c23ec$exports, "DN100", () => $1b343b038f6c23ec$export$ee82aa2ea6a1558);
$parcel$export($1b343b038f6c23ec$exports, "DN90", () => $1b343b038f6c23ec$export$682927c6ed76be02);
$parcel$export($1b343b038f6c23ec$exports, "DN80", () => $1b343b038f6c23ec$export$91fd9994c5be9757);
$parcel$export($1b343b038f6c23ec$exports, "DN70", () => $1b343b038f6c23ec$export$d281fbfe3cff2df6);
$parcel$export($1b343b038f6c23ec$exports, "DN60", () => $1b343b038f6c23ec$export$3902c91d8b98a753);
$parcel$export($1b343b038f6c23ec$exports, "DN50", () => $1b343b038f6c23ec$export$8e8133c1ba5845b5);
$parcel$export($1b343b038f6c23ec$exports, "DN40", () => $1b343b038f6c23ec$export$33ff357f6620b39);
$parcel$export($1b343b038f6c23ec$exports, "DN30", () => $1b343b038f6c23ec$export$633847cf062b69e0);
$parcel$export($1b343b038f6c23ec$exports, "DN20", () => $1b343b038f6c23ec$export$9776a6e503bdbf76);
$parcel$export($1b343b038f6c23ec$exports, "DN10", () => $1b343b038f6c23ec$export$6c813d5160dff5db);
$parcel$export($1b343b038f6c23ec$exports, "DN0", () => $1b343b038f6c23ec$export$3d4f271a500072a);
$parcel$export($1b343b038f6c23ec$exports, "DN800A", () => $1b343b038f6c23ec$export$fe151285c22759ec);
$parcel$export($1b343b038f6c23ec$exports, "DN700A", () => $1b343b038f6c23ec$export$a101c6190d0da34);
$parcel$export($1b343b038f6c23ec$exports, "DN600A", () => $1b343b038f6c23ec$export$4b16f52932fda51);
$parcel$export($1b343b038f6c23ec$exports, "DN500A", () => $1b343b038f6c23ec$export$a74bcd7b9845b0d8);
$parcel$export($1b343b038f6c23ec$exports, "DN400A", () => $1b343b038f6c23ec$export$9209c179316d1751);
$parcel$export($1b343b038f6c23ec$exports, "DN300A", () => $1b343b038f6c23ec$export$88f55133f636c8dd);
$parcel$export($1b343b038f6c23ec$exports, "DN200A", () => $1b343b038f6c23ec$export$51126f85d1009512);
$parcel$export($1b343b038f6c23ec$exports, "DN100A", () => $1b343b038f6c23ec$export$a069b547bd23af78);
$parcel$export($1b343b038f6c23ec$exports, "DN90A", () => $1b343b038f6c23ec$export$40cce05af3b2600a);
$parcel$export($1b343b038f6c23ec$exports, "DN80A", () => $1b343b038f6c23ec$export$b78942185925a0d);
$parcel$export($1b343b038f6c23ec$exports, "DN70A", () => $1b343b038f6c23ec$export$e058fb44b8eaafca);
$parcel$export($1b343b038f6c23ec$exports, "DN60A", () => $1b343b038f6c23ec$export$92b0b8de26920c18);
$parcel$export($1b343b038f6c23ec$exports, "DN50A", () => $1b343b038f6c23ec$export$67564f7459d3fc9e);
$parcel$export($1b343b038f6c23ec$exports, "DN40A", () => $1b343b038f6c23ec$export$77868e1ca884ffa3);
$parcel$export($1b343b038f6c23ec$exports, "DN30A", () => $1b343b038f6c23ec$export$2afd71d7d3ea2cd5);
$parcel$export($1b343b038f6c23ec$exports, "DN20A", () => $1b343b038f6c23ec$export$f2a0acaab9972c70);
$parcel$export($1b343b038f6c23ec$exports, "DN10A", () => $1b343b038f6c23ec$export$9ab70e67d6475361);
$parcel$export($1b343b038f6c23ec$exports, "T30", () => $1b343b038f6c23ec$export$d2adc5dedf09fced);
$parcel$export($1b343b038f6c23ec$exports, "L50", () => $1b343b038f6c23ec$export$f51762073d2bb381);
$parcel$export($1b343b038f6c23ec$exports, "L75", () => $1b343b038f6c23ec$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $1b343b038f6c23ec$export$4b84fd0e2c617bd = '#FFEBE6';
const $1b343b038f6c23ec$export$b34b069eff244586 = '#FFBDAD';
const $1b343b038f6c23ec$export$be802dd0d8b57f35 = '#FF8F73';
const $1b343b038f6c23ec$export$60847d42f9da92a6 = '#FF7452';
const $1b343b038f6c23ec$export$4a7404f376229999 = '#FF5630';
const $1b343b038f6c23ec$export$2010d0fb4295b346 = '#DE350B';
const $1b343b038f6c23ec$export$2837b5a1a71d5c02 = '#BF2600';
const $1b343b038f6c23ec$export$8d9596b529bbb9cf = '#FFFAE6';
const $1b343b038f6c23ec$export$41060a744ab0b7ae = '#FFF0B3';
const $1b343b038f6c23ec$export$1cc05bbbf340e559 = '#FFE380';
const $1b343b038f6c23ec$export$5aae31392d72caaa = '#FFC400';
const $1b343b038f6c23ec$export$c6930421db9fa514 = '#FFAB00';
const $1b343b038f6c23ec$export$59619663aa6500fb = '#FF991F';
const $1b343b038f6c23ec$export$874739ea9e379ab6 = '#FF8B00';
const $1b343b038f6c23ec$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $1b343b038f6c23ec$export$69a3bf21b9686c2b = '#ABF5D1';
const $1b343b038f6c23ec$export$afbce1382ec95f73 = '#79F2C0';
const $1b343b038f6c23ec$export$747d86715d4175de = '#57D9A3';
const $1b343b038f6c23ec$export$940e1f69e873f202 = '#36B37E';
const $1b343b038f6c23ec$export$a49394138f7b8e85 = '#00875A';
const $1b343b038f6c23ec$export$6fa04827ac68a4fb = '#006644';
const $1b343b038f6c23ec$export$226de0355ed012f8 = '#DEEBFF';
const $1b343b038f6c23ec$export$8c13c2ee36917869 = '#B3D4FF';
const $1b343b038f6c23ec$export$ecfc1dff386a3e7a = '#4C9AFF';
const $1b343b038f6c23ec$export$215b7063051591f1 = '#2684FF';
const $1b343b038f6c23ec$export$e62e8919cca44969 = '#0065FF';
const $1b343b038f6c23ec$export$b3de0ae08da2ce64 = '#0052CC';
const $1b343b038f6c23ec$export$a6ee3d71bc067634 = '#0747A6';
const $1b343b038f6c23ec$export$67f15409e87642a1 = '#669DF1';
const $1b343b038f6c23ec$export$f0539dbc42dbb067 = '#8FB8F6';
const $1b343b038f6c23ec$export$363e4475840015bb = '#EAE6FF';
const $1b343b038f6c23ec$export$4b0a4417ed59760f = '#C0B6F2';
const $1b343b038f6c23ec$export$6011520a64d9a187 = '#998DD9';
const $1b343b038f6c23ec$export$a7175d4e9206bc80 = '#8777D9';
const $1b343b038f6c23ec$export$b48405b95304b5a1 = '#6554C0';
const $1b343b038f6c23ec$export$c71e4279dd54a18d = '#5243AA';
const $1b343b038f6c23ec$export$147899de772240ec = '#403294';
const $1b343b038f6c23ec$export$2cf711fe14c66f06 = '#E6FCFF';
const $1b343b038f6c23ec$export$7a8f4d33f6f9772c = '#B3F5FF';
const $1b343b038f6c23ec$export$776c9c497ef08533 = '#79E2F2';
const $1b343b038f6c23ec$export$69cb3ca10c1e330e = '#00C7E6';
const $1b343b038f6c23ec$export$9dc1ef0f3f48059b = '#00B8D9';
const $1b343b038f6c23ec$export$7c835c78b6fcdef8 = '#00A3BF';
const $1b343b038f6c23ec$export$6036577f95c3877e = '#008DA6';
const $1b343b038f6c23ec$export$29a4f05edc054374 = '#FFFFFF';
const $1b343b038f6c23ec$export$e655ef011c4aa1a2 = '#FAFBFC';
const $1b343b038f6c23ec$export$9fdfb749e33cdf97 = '#F4F5F7';
const $1b343b038f6c23ec$export$3e51e8f1440314ba = '#EBECF0';
const $1b343b038f6c23ec$export$1ce2d1575d444ceb = '#DFE1E6';
const $1b343b038f6c23ec$export$8754fc7e6d8b3000 = '#C1C7D0';
const $1b343b038f6c23ec$export$c2e91cbeada39b8b = '#B3BAC5';
const $1b343b038f6c23ec$export$5f71e19f3a7ad9de = '#A5ADBA';
const $1b343b038f6c23ec$export$eaa8c8a70ac22806 = '#97A0AF';
const $1b343b038f6c23ec$export$7c87d337fb91a97d = '#8993A4';
const $1b343b038f6c23ec$export$d6447c357493214f = '#7A869A';
const $1b343b038f6c23ec$export$f563ee71e9ee74cd = '#6B778C';
const $1b343b038f6c23ec$export$e2ef2124cf4024b1 = '#5E6C84';
const $1b343b038f6c23ec$export$eece5f492e429f08 = '#505F79';
const $1b343b038f6c23ec$export$c39c0fe0f26207ae = '#42526E';
const $1b343b038f6c23ec$export$7090862dc3038a9f = '#344563';
const $1b343b038f6c23ec$export$ad0bacf983b7ddaa = '#253858';
const $1b343b038f6c23ec$export$7d61b15e0da132af = '#172B4D';
const $1b343b038f6c23ec$export$fbda843f0a27fe96 = '#091E42';
const $1b343b038f6c23ec$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $1b343b038f6c23ec$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $1b343b038f6c23ec$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $1b343b038f6c23ec$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $1b343b038f6c23ec$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $1b343b038f6c23ec$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $1b343b038f6c23ec$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $1b343b038f6c23ec$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $1b343b038f6c23ec$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $1b343b038f6c23ec$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $1b343b038f6c23ec$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $1b343b038f6c23ec$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $1b343b038f6c23ec$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $1b343b038f6c23ec$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $1b343b038f6c23ec$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $1b343b038f6c23ec$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $1b343b038f6c23ec$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $1b343b038f6c23ec$export$2f6319cf7d736c2a = '#E6EDFA';
const $1b343b038f6c23ec$export$95126bc8884d6634 = '#DCE5F5';
const $1b343b038f6c23ec$export$8338d8c35d44ff1 = '#CED9EB';
const $1b343b038f6c23ec$export$5368d76ae4fbbda7 = '#B8C7E0';
const $1b343b038f6c23ec$export$9f0a771d16ec8d36 = '#ABBBD6';
const $1b343b038f6c23ec$export$abcf8c38338b4aa5 = '#9FB0CC';
const $1b343b038f6c23ec$export$97e81faa16a182c7 = '#8C9CB8';
const $1b343b038f6c23ec$export$bfe21c59123ecf33 = '#7988A3';
const $1b343b038f6c23ec$export$ee82aa2ea6a1558 = '#67758F';
const $1b343b038f6c23ec$export$682927c6ed76be02 = '#56637A';
const $1b343b038f6c23ec$export$91fd9994c5be9757 = '#455166';
const $1b343b038f6c23ec$export$d281fbfe3cff2df6 = '#3B475C';
const $1b343b038f6c23ec$export$3902c91d8b98a753 = '#313D52';
const $1b343b038f6c23ec$export$8e8133c1ba5845b5 = '#283447';
const $1b343b038f6c23ec$export$33ff357f6620b39 = '#202B3D';
const $1b343b038f6c23ec$export$633847cf062b69e0 = '#1B2638';
const $1b343b038f6c23ec$export$9776a6e503bdbf76 = '#121A29';
const $1b343b038f6c23ec$export$6c813d5160dff5db = '#0E1624';
const $1b343b038f6c23ec$export$3d4f271a500072a = '#0D1424';
const $1b343b038f6c23ec$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $1b343b038f6c23ec$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $1b343b038f6c23ec$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $1b343b038f6c23ec$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $1b343b038f6c23ec$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $1b343b038f6c23ec$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $1b343b038f6c23ec$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $1b343b038f6c23ec$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $1b343b038f6c23ec$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $1b343b038f6c23ec$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $1b343b038f6c23ec$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $1b343b038f6c23ec$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $1b343b038f6c23ec$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $1b343b038f6c23ec$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $1b343b038f6c23ec$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $1b343b038f6c23ec$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $1b343b038f6c23ec$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $1b343b038f6c23ec$export$d2adc5dedf09fced = '#292A2E';
const $1b343b038f6c23ec$export$f51762073d2bb381 = '#94C748';
const $1b343b038f6c23ec$export$95e26d54def96891 = '#B3DF72';

parcelRegister("12tYT", function(module, exports) {

$parcel$export(module.exports, "CardBaseStyle", () => $bb7771c5d12bb102$export$d10d52f6c0613cc3);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $7uIWw = parcelRequire("7uIWw");
const $bb7771c5d12bb102$var$backgroundColorSelected = `var(--ds-background-selected, ${(0, $1b343b038f6c23ec$exports).B50})`;
const $bb7771c5d12bb102$var$backgroundColor = `var(--ds-surface-raised, ${(0, $1b343b038f6c23ec$exports).N0})`;
const $bb7771c5d12bb102$var$borderColor = `var(--ds-border, ${(0, $1b343b038f6c23ec$exports).N30})`;
const $bb7771c5d12bb102$var$boxShadowColor = `1px 0px ${`var(--ds-shadow-raised, ${(0, $1b343b038f6c23ec$exports).N40})`}`;
const $bb7771c5d12bb102$export$d10d52f6c0613cc3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykidgo": (0, $9t7rW.default)($bb7771c5d12bb102$var$boxShadowColor),
            "--_37cwmb": (0, $9t7rW.default)($bb7771c5d12bb102$var$borderColor),
            "--_1hwiu8a": (0, $9t7rW.default)($bb7771c5d12bb102$var$backgroundColorSelected),
            "--_1ly4823": (0, $9t7rW.default)($bb7771c5d12bb102$var$backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt4u2gc _vchhusvi _x3doidpf _16qsycq2 _n7zl1jb4 _1kl71jb4 _14t01jb4 _1jc11j8p _13jw1lq3 _e6md1se7 _1tzh1y44 _7ehihmda _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected ? "_bfhk12tn" : "_bfhkaxbu",
            __cmplp.className
        ])
    });
});
const $bb7771c5d12bb102$export$b15a6cf2987e4b39 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7uIWw.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lfCsT", function(module, exports) {

$parcel$export(module.exports, "default", () => $35274886020d1e04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $lUg8E = parcelRequire("lUg8E");

var $79xbN = parcelRequire("79xbN");

var $giAhk = parcelRequire("giAhk");

var $gHMhg = parcelRequire("gHMhg");

var $lxN7X = parcelRequire("lxN7X");
class $35274886020d1e04$export$e8132eb38e030ec6 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onResetErrors: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxN7X.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxN7X.InfoMessage), null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gHMhg.default).infoTextIssueTermRefresh : (0, $gHMhg.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "link",
            onClick: this.onReloadIssueClick,
            spacing: "none"
        }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gHMhg.default).reloadIssueIssueTermRefresh : (0, $gHMhg.default).reloadIssue)));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReloadIssueClick = (...attrs)=>{
            const analyticsEvent = attrs.pop();
            this.props.onResetErrors(analyticsEvent);
        };
    }
}
var $35274886020d1e04$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($35274886020d1e04$export$e8132eb38e030ec6);

});
parcelRegister("gHMhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0dee8c93103479$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $ac0dee8c93103479$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    infoText: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssue: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue",
        "defaultMessage": "Reload issue"
    },
    infoTextIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text-issue-term-refresh",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue-issue-term-refresh",
        "defaultMessage": "Reload issue"
    }
});

});

parcelRegister("lxN7X", function(module, exports) {

$parcel$export(module.exports, "Container", () => $f04b9ffc218e2fdd$export$42a852a2b6b56249);
$parcel$export(module.exports, "InfoMessage", () => $f04b9ffc218e2fdd$export$4bf8682ab34d3383);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f04b9ffc218e2fdd$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kw7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $f04b9ffc218e2fdd$export$4bf8682ab34d3383 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9Ms52", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b391a2e35d91f50$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b391a2e35d91f50$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueLoadingLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label",
        "defaultMessage": "Issue card {number} loading"
    }
});

});

parcelRegister("jeAfN", function(module, exports) {

$parcel$export(module.exports, "SkeletonContainer", () => $909f5a6ffeec6b52$export$66b8cea0c448285);
$parcel$export(module.exports, "SkeletonBackground", () => $909f5a6ffeec6b52$export$c3b0ebed856b8b1a);
$parcel$export(module.exports, "ColumnMask", () => $909f5a6ffeec6b52$export$439b7c87164a9b43);
$parcel$export(module.exports, "SummaryMask", () => $909f5a6ffeec6b52$export$792e72b41c80f830);
$parcel$export(module.exports, "FooterMask", () => $909f5a6ffeec6b52$export$ab3fe3ddc5c7354f);
$parcel$export(module.exports, "TextLineMask", () => $909f5a6ffeec6b52$export$f3e0fd2d5209f88b);
$parcel$export(module.exports, "TypeMask", () => $909f5a6ffeec6b52$export$59d16c2cd3bc3a2);
$parcel$export(module.exports, "IssueKeyMask", () => $909f5a6ffeec6b52$export$ca1c048394ed3dbb);
$parcel$export(module.exports, "SeparatorMask", () => $909f5a6ffeec6b52$export$bdc7d72765b181c3);
$parcel$export(module.exports, "BlankMask", () => $909f5a6ffeec6b52$export$a1b9063b4cbc0844);
$parcel$export(module.exports, "ErrorIconContainer", () => $909f5a6ffeec6b52$export$90993d2d9550d725);
$parcel$export(module.exports, "ErrorWrapper", () => $909f5a6ffeec6b52$export$bb27b7e39840238f);
$parcel$export(module.exports, "errorWrapperSelector", () => $909f5a6ffeec6b52$export$a03455d77d6a4ea);
$parcel$export(module.exports, "skeletonBackgroundSelector", () => $909f5a6ffeec6b52$export$85fe8f1edff78b98);
$parcel$export(module.exports, "columnMaskSelector", () => $909f5a6ffeec6b52$export$67b279fb398d016e);
$parcel$export(module.exports, "Wrapper", () => $909f5a6ffeec6b52$export$e6dfd72ab29f8598);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $909f5a6ffeec6b52$var$defaultIssueCardHeight = 97;
const $909f5a6ffeec6b52$export$66b8cea0c448285 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$var$shimmer = null;
const $909f5a6ffeec6b52$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhk1u4r _1itkxsyt _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$439b7c87164a9b43 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$792e72b41c80f830 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$ab3fe3ddc5c7354f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _kqswh2mm _n7zlv4vr _x3do16sd",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$f3e0fd2d5209f88b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $9t7rW.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $9t7rW.default)(__cmplp.intrusion, "px"),
            "--_ppkzip": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i3gti _1s7z87mc _x3do1age _n7zl1age",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$59d16c2cd3bc3a2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$ca1c048394ed3dbb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$bdc7d72765b181c3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$a1b9063b4cbc0844 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$90993d2d9550d725 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$export$bb27b7e39840238f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $909f5a6ffeec6b52$var$getBorderRadius = (isFirstCard, isLastCard)=>{
    if (isFirstCard && isLastCard) // rounded corners on top and bottom
    return `${(0, $c9TLT.gridSize) * 0.5}px`;
    if (isFirstCard) // rounded corners on top
    return `${(0, $c9TLT.gridSize) * 0.5}px ${(0, $c9TLT.gridSize) * 0.5}px 0 0`;
    if (isLastCard) // rounded corners on bottom
    return `0 0 ${(0, $c9TLT.gridSize) * 0.5}px ${(0, $c9TLT.gridSize) * 0.5}px`;
    // no border radius for other cards
    return '0';
};
const $909f5a6ffeec6b52$export$a03455d77d6a4ea = 'jira-issue-navigator-card-skeleton-error-wrapper';
const $909f5a6ffeec6b52$export$85fe8f1edff78b98 = 'jira-issue-navigator-card-skeleton-skeleton-background';
const $909f5a6ffeec6b52$export$67b279fb398d016e = 'jira-issue-navigator-card-skeleton-column-mask';
const $909f5a6ffeec6b52$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstCard: isFirstCard, isLastCard: isLastCard, hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_63r7hy": (0, $9t7rW.default)($909f5a6ffeec6b52$var$getBorderRadius(__cmplp.isFirstCard, __cmplp.isLastCard))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1yt4f522 _vchhusvi _1kl71l7n _1s7z1l7n _bfhkvuon _2rko1nxs _syaz1kw7 _7ehihmda _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _irr31nz6 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isFirstCard ? "_x3do1l7n" : "_x3doidpf",
            __cmplp.isLastCard ? "_n7zlh6cr" : "_n7zl1l7n",
            __cmplp.hasError ? "_1s2q1txw" : "_1s2qglyw",
            __cmplp.hasError && "_czo0glyw",
            __cmplp.hasError && "_1y4vglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("fNFQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7237c5bd5b482c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $12tYT = parcelRequire("12tYT");

var $ld07P = parcelRequire("ld07P");
const $3a7237c5bd5b482c$var$BoxFG = ({ children: children, isSelected: isSelected })=>(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        as: "li",
        xcss: $3a7237c5bd5b482c$var$ListItemStyle
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        as: "li",
        role: "option",
        "aria-selected": isSelected,
        xcss: $3a7237c5bd5b482c$var$ListItemStyle,
        tabIndex: isSelected ? 0 : -1
    }, children);
const $3a7237c5bd5b482c$var$EmptyCard = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isSelected: isSelected = false, onClick: onClick, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a7237c5bd5b482c$var$BoxFG, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3a7237c5bd5b482c$var$EmptyCardContainer, {
        ...(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? {
            tabIndex: isSelected ? 0 : -1
        } : {},
        ref: ref ?? undefined,
        isSelected: isSelected,
        onClick: onClick,
        href: "#",
        ...(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? {
            onFocus: onFocus
        } : {}
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ld07P.default).emptyCardTextIssueTermRefresh : (0, $ld07P.default).emptyCardText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    })));
});
var $3a7237c5bd5b482c$export$2e2bcd8739ae039 = $3a7237c5bd5b482c$var$EmptyCard;
const $3a7237c5bd5b482c$var$textColorActiveState = `var(--ds-text-selected, ${(0, $1b343b038f6c23ec$exports).N600})`;
const $3a7237c5bd5b482c$var$textColor = `var(--ds-text, ${(0, $1b343b038f6c23ec$exports).N200})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a7237c5bd5b482c$var$EmptyCardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $12tYT.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ebr96o": (0, $9t7rW.default)($3a7237c5bd5b482c$var$textColorActiveState),
            "--_srel9g": (0, $9t7rW.default)($3a7237c5bd5b482c$var$textColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _80omtlke",
            __cmplp.isSelected ? "_syaz1c3g" : "_syaz1u00",
            __cmplp.isSelected ? "_f8pj1c3g _30l31c3g" : "_f8pj1u00 _30l31u00",
            __cmplp.className
        ])
    });
});
const $3a7237c5bd5b482c$var$ListItemStyle = (0, $8Vv3m.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("ld07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0f2dfe01a69c34b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d0f2dfe01a69c34b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    blankText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text-issue-term-refresh",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text-issue-term-refresh",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip-issue-term-refresh",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("3wPFH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29c279ff2e19f03$export$2e2bcd8739ae039);

var $2g6fS = parcelRequire("2g6fS");

var $5NHsh = parcelRequire("5NHsh");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");


var $eI5EY = parcelRequire("eI5EY");

var $6vrw7 = parcelRequire("6vrw7");

var $12tYT = parcelRequire("12tYT");

var $2tLOO = parcelRequire("2tLOO");
const $b29c279ff2e19f03$var$backgroundColorSelected = `var(--ds-background-selected, ${(0, $1b343b038f6c23ec$exports).B50})`;
const $b29c279ff2e19f03$var$backgroundColorHovered = `var(--ds-background-neutral-subtle-hovered, ${(0, $1b343b038f6c23ec$exports).N10})`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b29c279ff2e19f03$var$StyledListElement = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $b29c279ff2e19f03$export$1d41361302b577a1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $12tYT.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1hwiu8a": (0, $9t7rW.default)($b29c279ff2e19f03$var$backgroundColorSelected),
            "--_1xad3ln": (0, $9t7rW.default)($b29c279ff2e19f03$var$backgroundColorHovered)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_f8pj1kw7 _30l31kw7",
            ((0, $eI5EY.fg)('nin_serious_accessibility_issues') || (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough')) && "_kqswh2mm",
            __cmplp.isSelected ? "_syaz1ldt" : "_syaz1kw7",
            __cmplp.isSelected ? "_irr312tn" : "_irr31iq0",
            __cmplp.className
        ])
    });
});
const $b29c279ff2e19f03$export$c3fc4c88db352deb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_slp31hna _1i4q1hna _1nmz1hna _otyr1b66",
            __cmplp.className
        ])
    });
});
const $b29c279ff2e19f03$var$Card = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ style: style, onMounted: onMounted, onClick: onClick, onFocus: onFocus, onBlur: onBlur, fragment: fragment, isSelected: isSelected, onContextMenu: onContextMenu }, ref)=>{
    const fragmentData = (0, $iWLL0.useFragment)((0, $5NHsh.default), fragment);
    const fieldSetsForIssueSearchViewData = (0, $iWLL0.useFragment)((0, $2g6fS.default), fragmentData.fieldSetsForIssueSearchView);
    const issueKey = fragmentData.key;
    (0, $eUqFw.useEffect)(()=>{
        onMounted && onMounted();
    }, [
        onMounted
    ]);
    const fieldEdges = fieldSetsForIssueSearchViewData?.edges ?? null;
    const summary = (0, $2tLOO.byFieldId)(fieldEdges, 'summary', (summaryEdge)=>summaryEdge?.node?.text);
    const avatarUser = (0, $2tLOO.byFieldId)(fieldEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const avatarSrc = avatarUser?.picture || '';
    const avatarDisplayName = avatarUser?.name || '';
    const type = (0, $2tLOO.byFieldId)(fieldEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const issueType = {
        iconSrc: type?.avatar?.small || '',
        name: type?.name || ''
    };
    const statusCategoryId = (0, $2tLOO.byFieldId)(fieldEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId) ?? -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b29c279ff2e19f03$var$StyledListElement, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.list-item",
        ...(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? {} : {
            role: 'option',
            'aria-selected': isSelected
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b29c279ff2e19f03$export$1d41361302b577a1 // @ts-expect-error incorrect ref type
    , {
        ref: ref ?? undefined,
        onContextMenu: onContextMenu,
        isSelected: isSelected,
        onBlur: onBlur,
        tabIndex: isSelected ? 0 : -1,
        onClick: onClick,
        onFocus: onFocus,
        style: style,
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card",
        href: `/browse/${issueKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b29c279ff2e19f03$export$c3fc4c88db352deb, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.summary"
    }, summary), (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2tLOO.Footer), {
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        isResolved: fragmentData.isResolved,
        fieldSets: fragmentData.fieldSetsForIssueSearchView,
        isSelected: isSelected
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2tLOO.FooterOld), {
        issueKey: (0, $6vrw7.toIssueKey)(issueKey),
        isSelected: isSelected,
        statusCategoryId: Number(statusCategoryId),
        avatarSrc: avatarSrc,
        avatarDisplayName: avatarDisplayName,
        issueType: issueType
    })));
});
var $b29c279ff2e19f03$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($b29c279ff2e19f03$var$Card);

});
parcelRegister("2g6fS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f95b82dcd53e2334$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ad648efe21a523fb11d7116e02353b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f95b82dcd53e2334$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$f95b82dcd53e2334$var$node.hash = "4b5a5fcdeceffe2ed348ebd86689df52";
var $f95b82dcd53e2334$export$2e2bcd8739ae039 = $f95b82dcd53e2334$var$node;

});

parcelRegister("5NHsh", function(module, exports) {

$parcel$export(module.exports, "default", () => $81722ca8123a1fd6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9c60d93de6ae25d908fe89f5739b4db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81722ca8123a1fd6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "filterId"
        },
        {
            "kind": "RootArgument",
            "name": "namespace"
        },
        {
            "kind": "RootArgument",
            "name": "queryStatusForIssuekeyStrikethrough"
        },
        {
            "kind": "RootArgument",
            "name": "viewId"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_fragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "condition": "queryStatusForIssuekeyStrikethrough",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isResolved"
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filterId",
                        "variableName": "filterId"
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    },
                    {
                        "kind": "Variable",
                        "name": "namespace",
                        "variableName": "namespace"
                    },
                    {
                        "kind": "Variable",
                        "name": "viewId",
                        "variableName": "viewId"
                    }
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsForIssueSearchView",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_Card_fieldSetsForIssueSearchView"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "footer_issueNavigator_FooterInternal"
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSetsForIssueSearchView"
        }
    ],
    "type": "JiraIssue"
};
$81722ca8123a1fd6$var$node.hash = "018b8b942c08a25417a510d00656da5d";
var $81722ca8123a1fd6$export$2e2bcd8739ae039 = $81722ca8123a1fd6$var$node;

});

parcelRegister("2tLOO", function(module, exports) {

$parcel$export(module.exports, "byFieldId", () => $c043bf85e70e757c$export$7a6e1e67b4eca178);
$parcel$export(module.exports, "Footer", () => $c043bf85e70e757c$export$a06f1c675e846f6f);
$parcel$export(module.exports, "FooterOld", () => $c043bf85e70e757c$export$ce87cc6e173806ad);

var $kkg3A = parcelRequire("kkg3A");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $k9isx = parcelRequire("k9isx");

var $jl1we = parcelRequire("jl1we");

var $kjXsi = parcelRequire("kjXsi");

var $8Qd0L = parcelRequire("8Qd0L");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $27ydI = parcelRequire("27ydI");

var $8rQuz = parcelRequire("8rQuz");

var $3wKQY = parcelRequire("3wKQY");

var $lNcD8 = parcelRequire("lNcD8");
const $c043bf85e70e757c$export$7a6e1e67b4eca178 = (edges, fieldId, mapperFn)=>edges?.map((edge)=>edge?.node?.fields?.edges?.[0]).filter((edge)=>edge?.node?.fieldId === fieldId).filter((0, $3wKQY.isNonNullish)).map(mapperFn)[0];
const $c043bf85e70e757c$var$FooterInternal = ({ issueKey: issueKey, isResolved: isResolvedProp, isSelected: isSelected, fieldSets: fieldSets })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fieldSetsData = (0, $iWLL0.useFragment)((0, $kkg3A.default), fieldSets);
    const fieldSetEdges = fieldSetsData?.edges;
    const assignee = $c043bf85e70e757c$export$7a6e1e67b4eca178(fieldSetEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const issueType = $c043bf85e70e757c$export$7a6e1e67b4eca178(fieldSetEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const statusCategoryId = $c043bf85e70e757c$export$7a6e1e67b4eca178(fieldSetEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId);
    const isResolved = (0, $27ydI.shouldDisplayStrikethrough)(isResolvedProp ?? undefined, (0, $8Qd0L.statusCategoryForId)(statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$TypeIcon, {
        src: issueType?.avatar?.small ?? undefined,
        alt: issueType?.name ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$export$263c092b561e7355, {
        isSelected: isSelected,
        isResolved: isResolved,
        isVisualRefresh: (0, $8rQuz.isVisualRefreshEnabled)()
    }, issueKey, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status"
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lNcD8.default).screenReaderFooterKeyResolvedIssueTermRefresh : (0, $lNcD8.default).screenReaderFooterKeyResolved, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: assignee?.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
        src: assignee?.picture,
        name: assignee?.name,
        size: "small"
    }))));
};
const $c043bf85e70e757c$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $eUqFw.memo)($c043bf85e70e757c$var$FooterInternal); // Cleanup with jiv-18659-query-status-for-issuekey-strikethrough
const $c043bf85e70e757c$var$FooterOldInternal = ({ issueKey: issueKey, isSelected: isSelected, statusCategoryId: statusCategoryId, avatarSrc: avatarSrc, avatarDisplayName: avatarDisplayName, issueType: issueType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDone = statusCategoryId === (0, $8Qd0L.categoryIdForStatusCategory)((0, $8Qd0L.DONE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$TypeIcon, {
        src: issueType?.iconSrc,
        alt: issueType?.name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$export$263c092b561e7355, {
        isSelected: isSelected,
        isResolved: isDone,
        ...(0, $eI5EY.fg)('nin_serious_accessibility_issues') ? {} : {
            'aria-label': isDone ? formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lNcD8.default).screenReaderFooterKeyDoneIssueTermRefresh : (0, $lNcD8.default).screenReaderFooterKeyDone, {
                issueKey: issueKey
            }) : undefined
        },
        isVisualRefresh: (0, $8rQuz.isVisualRefreshEnabled)()
    }, issueKey, isDone && (0, $eI5EY.fg)('nin_serious_accessibility_issues') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), {
        role: "status"
    }, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lNcD8.default).screenReaderFooterKeyDoneIssueTermRefresh : (0, $lNcD8.default).screenReaderFooterKeyDone, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c043bf85e70e757c$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: avatarDisplayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
        src: avatarSrc,
        name: avatarDisplayName,
        size: "small"
    }))));
}; // Cleanup with jiv-18659-query-status-for-issuekey-strikethrough
const $c043bf85e70e757c$export$ce87cc6e173806ad = /*#__PURE__*/ (0, $eUqFw.memo)($c043bf85e70e757c$var$FooterOldInternal); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c043bf85e70e757c$var$StyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c043bf85e70e757c$var$TypeIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _2hwx1b66 _2rkoyh40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c043bf85e70e757c$var$AvatarStyledContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _19bvu2gc _18u01wug _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c043bf85e70e757c$export$263c092b561e7355 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, isSelected: isSelected, isResolved: isResolved, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37",
            ((0, $eI5EY.fg)('nin_serious_accessibility_issues') || (0, $eI5EY.fg)('jiv-18659-query-status-for-issuekey-strikethrough')) && "_kqswh2mm",
            __cmplp.isVisualRefresh ? "_k48p1wq8" : "_k48pmoej",
            __cmplp.isSelected ? "_syaz1ldt" : "_syazloe7",
            __cmplp.isResolved ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kkg3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5aabe39432ce4e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<712b8382a039d6f47a7d17276d070a82>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5aabe39432ce4e7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "footer_issueNavigator_FooterInternal",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$f5aabe39432ce4e7$var$node.hash = "ff91859fc2077d6630bd31c57d23cf62";
var $f5aabe39432ce4e7$export$2e2bcd8739ae039 = $f5aabe39432ce4e7$var$node;

});

parcelRegister("27ydI", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $efd04ed94f1a5b80$export$1e1e848245d3a6f7);

var $8Qd0L = parcelRequire("8Qd0L");
const { DONE: $efd04ed94f1a5b80$var$DONE } = (0, $8Qd0L);
const $efd04ed94f1a5b80$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $efd04ed94f1a5b80$var$DONE;
};

});

parcelRegister("lNcD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f279c702485213f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f279c702485213f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    screenReaderFooterKeyResolved: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDone: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done",
        "defaultMessage": "Done issue: {issueKey}"
    },
    screenReaderFooterKeyResolvedIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved-issue-term-refresh",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDoneIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done-issue-term-refresh",
        "defaultMessage": "Done issue: {issueKey}"
    }
});

});



parcelRegister("hrpGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ffd42531b464cf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $eNjET = parcelRequire("eNjET");

var $4w4xT = parcelRequire("4w4xT");

var $3Ic6q = parcelRequire("3Ic6q");

var $6FIwx = parcelRequire("6FIwx");

var $ei0RD = parcelRequire("ei0RD");
const $e8ffd42531b464cf$var$useUpdatingRef = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
};
const $e8ffd42531b464cf$var$KeyboardShortcuts = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const propsRef = $e8ffd42531b464cf$var$useUpdatingRef(props);
    const openStateRef = $e8ffd42531b464cf$var$useUpdatingRef((0, $eNjET.useOrderByOpenState)());
    const selectedIssueKey = (0, $3Ic6q.useSelectedIssueKey)();
    const selectedIssueKeyRef = $e8ffd42531b464cf$var$useUpdatingRef(selectedIssueKey);
    let handleNext;
    let handlePrevious;
    let selectedIssueIndex = null;
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        const { selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6FIwx.useSelectedIssueActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const nextIssueKey = (0, $6FIwx.useNextIssueKey)() ?? (0, $6vrw7.toIssueKey)('');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const nextIssueKeyRef = (0, $eUqFw.useRef)(nextIssueKey);
        nextIssueKeyRef.current = nextIssueKey;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handleNext = (0, $eUqFw.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(nextIssueKeyRef.current);
        // Dependencies must be stable as downstream useMemo has an empty dependencies array
        }, [
            propsRef,
            selectNextIssue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousIssueKey = (0, $6FIwx.usePreviousIssueKey)() ?? (0, $6vrw7.toIssueKey)('');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousIssueKeyRef = (0, $eUqFw.useRef)(previousIssueKey);
        previousIssueKeyRef.current = previousIssueKey;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handlePrevious = (0, $eUqFw.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(previousIssueKeyRef.current);
        // Dependencies must be stable as downstream useMemo has an empty dependencies array
        }, [
            propsRef,
            selectPreviousIssue
        ]);
    } else {
        const { getNextIssue: getNextIssue, selectNextIssue: selectNextIssue, getPreviousIssue: getPreviousIssue, selectPreviousIssue: selectPreviousIssue } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4w4xT.useSelectedIssueStateOldActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handleNext = (0, $eUqFw.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            // getNextIssue and selectNextIssue need to be stable function references as
            // useMemo has an empty dependencies array
            const { issueKey: issueKey, issueIndex: issueIndex } = getNextIssue();
            if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
        }, [
            propsRef,
            getNextIssue,
            selectNextIssue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handlePrevious = (0, $eUqFw.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            // getPreviousIssue and selectPreviousIssue need to be stable function references as
            // useMemo has an empty dependencies array
            const { issueKey: issueKey, issueIndex: issueIndex } = getPreviousIssue();
            if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
        }, [
            propsRef,
            getPreviousIssue,
            selectPreviousIssue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        selectedIssueIndex = (0, $3Ic6q.useSelectedIssueIndex)();
    }
    // TODO Remove when cleaning up jira_spreadsheet_component_m1
    const selectedIssueIndexRef = $e8ffd42531b464cf$var$useUpdatingRef(selectedIssueIndex);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: (0, $eUqFw.useMemo)(()=>({
                j: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handleNext needs to be a stable function references as useMemo has an empty dependencies array
                        handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ei0RD.default).nextIssueIssueTermRefresh : (0, $ei0RD.default).nextIssue))
                },
                k: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handlePrevious needs to be a stable function references as useMemo has an empty dependencies array
                        handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ei0RD.default).previousIssueIssueTermRefresh : (0, $ei0RD.default).previousIssue))
                },
                y: {
                    callback: ()=>{
                        const [{ isOpen: isOpen }, { open: open, close: close }] = openStateRef.current;
                        isOpen ? close() : open();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $ei0RD.default).displaySortFields))
                },
                z: {
                    callback: ()=>{
                        if (selectedIssueKeyRef.current) propsRef.current.onNavigateToIssue(selectedIssueKeyRef.current);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ei0RD.default).openIssueFullScreenIssueTermRefresh : (0, $ei0RD.default).openIssueFullScreen))
                },
                arrowup: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueIndex: focusedIssueIndex, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        let isSelectedIssueFocused;
                        if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        else isSelectedIssueFocused = focusedIssueIndex !== null && focusedIssueIndex === selectedIssueIndexRef.current;
                        if (isSelectedIssueFocused) handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ei0RD.default).previousIssueIssueTermRefresh : (0, $ei0RD.default).previousIssue))
                },
                arrowdown: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueIndex: focusedIssueIndex, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        let isSelectedIssueFocused;
                        if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        else isSelectedIssueFocused = focusedIssueIndex !== null && focusedIssueIndex === selectedIssueIndexRef.current;
                        if (isSelectedIssueFocused) handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ei0RD.default).nextIssueIssueTermRefresh : (0, $ei0RD.default).nextIssue))
                }
            }), [] // eslint-disable-line react-hooks/exhaustive-deps
        )
    });
};
$e8ffd42531b464cf$var$KeyboardShortcuts.defaultProps = {
    disableListControls: false
};
var $e8ffd42531b464cf$export$2e2bcd8739ae039 = $e8ffd42531b464cf$var$KeyboardShortcuts;

});
parcelRegister("ei0RD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b77679a90380738$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var /* eslint-disable jira/i18n/id-named-by-package */ $0b77679a90380738$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    nextIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue",
        "defaultMessage": "Previous issue"
    },
    displaySortFields: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.display-sort-fields",
        "defaultMessage": "Detail view order by"
    },
    openIssueFullScreen: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen",
        "defaultMessage": "Open issue fullscreen"
    },
    nextIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue-issue-term-refresh",
        "defaultMessage": "Next issue"
    },
    previousIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue-issue-term-refresh",
        "defaultMessage": "Previous issue"
    },
    openIssueFullScreenIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-term-refresh",
        "defaultMessage": "Open issue fullscreen"
    }
});

});


parcelRegister("h75Xv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7480e1a99482c29a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7480e1a99482c29a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues-issue-term-refresh",
        "defaultMessage": "Issues"
    }
});

});



parcelRegister("clId8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc630eeca29da2f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RecoverableErrorViewBoundary", () => $1bc630eeca29da2f$export$d42c1f6e3e564ee9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $lCjSV = parcelRequire("lCjSV");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $3Hdmt = parcelRequire("3Hdmt");

var $hgbp4 = parcelRequire("hgbp4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $cQBUE = parcelRequire("cQBUE");

var $8lVKl = parcelRequire("8lVKl");
const $1bc630eeca29da2f$var$ErrorView = ({ onCaughtIssueSearchError: onCaughtIssueSearchError, error: errorProp })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onIssueSearchRefresh: onIssueSearchRefresh } = (0, $cQBUE.useIssueSearchQuery)();
    const onClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent.clone(), 'refreshFromError');
        onIssueSearchRefresh();
    }, [
        onIssueSearchRefresh
    ]);
    const error = (0, $eUqFw.useMemo)(()=>errorProp || new Error('There was an error searching for issues'), [
        errorProp
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        onCaughtIssueSearchError && onCaughtIssueSearchError(error);
    }, [
        onCaughtIssueSearchError,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bc630eeca29da2f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCjSV.default), {
        header: formatMessage((0, $8lVKl.default).emptyStateErrorHeader),
        description: formatMessage((0, $8lVKl.default).emptyStateErrorDescription),
        testId: "issue-navigator.ui.issue-results.error-view.error-message",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $8lVKl.default).emptyStateErrorAction)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                xcss: $1bc630eeca29da2f$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgbp4.default), {
                alt: ""
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "screen",
        actionSubjectId: "issueSearchError"
    }));
};
var $1bc630eeca29da2f$export$2e2bcd8739ae039 = $1bc630eeca29da2f$var$ErrorView;
const $1bc630eeca29da2f$export$d42c1f6e3e564ee9 = (0, $3Hdmt.withRecoverableErrorBoundary)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children), {
    recoveryProp: 'recoveryProp',
    Fallback: $1bc630eeca29da2f$var$ErrorView
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bc630eeca29da2f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1bc630eeca29da2f$var$ImageWrapperStyles = (0, $8Vv3m.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("8lVKl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6774220360df31ef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6774220360df31ef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyStateErrorHeader: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-header",
        "defaultMessage": "We couldn\u2019t load your search results"
    },
    emptyStateErrorDescription: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-description",
        "defaultMessage": "Refresh to try again."
    },
    emptyStateErrorAction: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("4OYZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d39cf8a057e809$export$2e2bcd8739ae039);

var $6coCb = parcelRequire("6coCb");

var $cWger = parcelRequire("cWger");

var $jrg0f = parcelRequire("jrg0f");

var $6aI4i = parcelRequire("6aI4i");

var $b7C4R = parcelRequire("b7C4R");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $iWLL0 = parcelRequire("iWLL0");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $guiFP = parcelRequire("guiFP");

var $1lXFP = parcelRequire("1lXFP");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $kZhcJ = parcelRequire("kZhcJ");

var $gsqQn = parcelRequire("gsqQn");

var $a4IeB = parcelRequire("a4IeB");

var $jLtGz = parcelRequire("jLtGz");

var $6FP8W = parcelRequire("6FP8W");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $dWLk9 = parcelRequire("dWLk9");

var $6yplV = parcelRequire("6yplV");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $kmXw8 = parcelRequire("kmXw8");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $9PZPM = parcelRequire("9PZPM");

var $4w4xT = parcelRequire("4w4xT");

var $3Ic6q = parcelRequire("3Ic6q");

var $4RwIp = parcelRequire("4RwIp");

var $2ycZm = parcelRequire("2ycZm");

var $3mEVr = parcelRequire("3mEVr");

var $dil2Z = parcelRequire("dil2Z");

var $cQBUE = parcelRequire("cQBUE");

var $j3TLk = parcelRequire("j3TLk");

var $aZxZH = parcelRequire("aZxZH");

var $1LgE9 = parcelRequire("1LgE9");

var $hps0t = parcelRequire("hps0t");

var $lJD7j = parcelRequire("lJD7j");

var $9flur = parcelRequire("9flur");

var $iNqNA = parcelRequire("iNqNA");

var $2SicN = parcelRequire("2SicN");

var $50IaJ = parcelRequire("50IaJ");

var $6Nns0 = parcelRequire("6Nns0");

var $1kw3p = parcelRequire("1kw3p");

var $8umcI = parcelRequire("8umcI");
const $d5d39cf8a057e809$var$reorderColumnsErrorFlag = {
    type: 'error',
    title: (0, $9flur.default).reorderColumnsErrorTitle,
    description: (0, $9flur.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true
};
const $d5d39cf8a057e809$var$resetColumnsErrorFlag = {
    type: 'error',
    title: (0, $9flur.default).resetColumnsErrorTitle,
    description: (0, $9flur.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true
};
const $d5d39cf8a057e809$var$TableContainer = ({ children: children })=>(0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $d5d39cf8a057e809$var$TableContainerStyles
    }, children) : children;
const $d5d39cf8a057e809$export$bec6bbce63eee986 = ()=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $eUqFw.useState)(false);
    return {
        isRestoringDefaultColumns: isRestoringDefaultColumns,
        setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
    };
};
const $d5d39cf8a057e809$export$b4f6a715a9e57e85 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { isFilterEditable: isFilterEditable } = (0, $3mEVr.useActiveJql)();
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { hasViewIdChanged: hasViewIdChanged, isRefreshing: isRefreshing, isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const { isRestoringDefaultColumns: isRestoringDefaultColumns } = $d5d39cf8a057e809$export$bec6bbce63eee986();
    return !isAnonymous && (!(0, $3wKQY.isFilterViewId)(view) || isFilterEditable === true) && !(isFetching && hasViewIdChanged) && !isRefreshing && !isRestoringDefaultColumns;
};
const $d5d39cf8a057e809$export$539ae4acd804b244 = (onRestoreDefaultColumns, viewData)=>{
    const { isFilterEditable: isFilterEditable } = (0, $3mEVr.useActiveJql)();
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    return !((0, $3wKQY.isFilterViewId)(selectedView) && isFilterEditable === false) && viewData?.hasDefaultFieldSets === false ? onRestoreDefaultColumns : undefined;
};
const $d5d39cf8a057e809$export$3e7a75a1659bbaae = (onColumnsChange)=>{
    const canEditColumns = $d5d39cf8a057e809$export$b4f6a715a9e57e85();
    return canEditColumns ? onColumnsChange : undefined;
};
const $d5d39cf8a057e809$export$d7623a323994e4cc = (selectedColumns)=>{
    const [{ view: selectedView }] = (0, $4RwIp.useSelectedViewState)();
    const canEditColumns = $d5d39cf8a057e809$export$b4f6a715a9e57e85();
    return (0, $dil2Z.useColumnLoader)(selectedView, canEditColumns, selectedColumns);
};
const $d5d39cf8a057e809$export$90b784197d8a906f = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous ? $d5d39cf8a057e809$export$d7623a323994e4cc : undefined;
};
const $d5d39cf8a057e809$export$6a2cc3745a117f8 = ()=>{
    const { hasViewIdChanged: hasViewIdChanged, isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const { isRestoringDefaultColumns: isRestoringDefaultColumns } = $d5d39cf8a057e809$export$bec6bbce63eee986();
    return {
        isColumnPickerLoading: isRestoringDefaultColumns || isFetching && hasViewIdChanged
    };
};
const $d5d39cf8a057e809$var$ListView = ({ loading: loading, onChangeColumnConfiguration: onChangeColumnConfiguration, onSelectedRowChange: onSelectedRowChange, issueResults: issueResults, view: view, isFeedbackButtonDisabled: isFeedbackButtonDisabled, issueTableProps: issueTableProps, filter: filter })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_LIST_VIEW_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).ISSUE_RESULTS_LIST_VIEW_END);
    }, []);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const issueResultsData = (0, $iWLL0.useFragment)((0, $b7C4R.default), issueResults);
    const viewData = (0, $iWLL0.useFragment)((0, $6aI4i.default), view);
    const filterData = (0, $iWLL0.useFragment)((0, $jrg0f.default), filter);
    const selectedIssueKey = (0, $3Ic6q.useSelectedIssueKey)();
    const selectedIssueIndex = (0, $3Ic6q.useSelectedIssueIndex)();
    const currentPage = issueResultsData.pageCursors?.around?.find((cursor)=>cursor?.isCurrent)?.pageNumber ?? 1;
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $2ycZm.useSortFieldAndDirection)();
    const { onIssueSearchForCurrentPage: onIssueSearchForCurrentPage } = (0, $cQBUE.useIssueSearchQuery)();
    const { isRestoringDefaultColumns: isRestoringDefaultColumns, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = $d5d39cf8a057e809$export$bec6bbce63eee986();
    const onModifyColumns = (0, $eUqFw.useCallback)(()=>{
        onChangeColumnConfiguration && onChangeColumnConfiguration();
        onIssueSearchForCurrentPage();
    }, [
        onChangeColumnConfiguration,
        onIssueSearchForCurrentPage
    ]);
    let onPageChange;
    let fieldSetIds = [];
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    fieldSetIds = (0, $eUqFw.useMemo)(()=>viewData.fieldSets.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets.edges
    ]);
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { selectIssueOnPage: selectIssueOnPage } = (0, $4w4xT.useSelectedIssueStateOldActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onPageChange = (0, $eUqFw.useCallback)((cursor, shouldSelectLastIssue)=>{
            selectIssueOnPage(cursor, shouldSelectLastIssue);
        }, [
            selectIssueOnPage
        ]);
    }
    const eventHandlers = (0, $8umcI.useEventHandlers)(issueResultsData.__id, fieldSetIds);
    let infiniteScrollProps = {};
    if ((0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    infiniteScrollProps = (0, $j3TLk.useInfiniteScroll)();
    const onSortOrderChange = (0, $eUqFw.useCallback)((sortField, sortDirection)=>setFieldAndDirection(sortField, sortDirection, []), [
        setFieldAndDirection
    ]);
    const overriddenTableComponents = issueTableProps?.components;
    const projectContext = issueTableProps?.projectContext;
    const hasMaxSelectedColumns = viewData?.fieldSets?.totalCount ? viewData?.fieldSets?.totalCount >= (0, $a4IeB.MAX_COLUMNS) : false;
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const Footer = (0, $eI5EY.fg)('jira_spreadsheet_component_m1_api_updates') ? (0, $hps0t.Footer) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hps0t.useFooterOverride)(isFeedbackButtonDisabled);
    const tableComponents = (0, $eUqFw.useMemo)(// We shallow merge these objects to make it easier for issue-navigator consumers to revert custom column
    // picker components, which are very NIN specific. This decision can be reconsidered if we need to introduce
    // additional nested custom components in the issue table and make those available to all consumers.
    ()=>({
            columnPicker: {
                Container: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZxZH.ColumnPickerContainer), {
                        viewIdFromResponse: (0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(viewData.viewId),
                        isRestoringDefaults: isRestoringDefaultColumns
                    }, children),
                PopupComponent: (0, $1LgE9.default)
            },
            Footer: Footer,
            IssueCount: $lJD7j.IssueCount,
            NoColumns: $iNqNA.NoColumns,
            NoIssues: $2SicN.NoIssues,
            ...overriddenTableComponents
        }), [
        Footer,
        isRestoringDefaultColumns,
        overriddenTableComponents,
        viewData.viewId
    ]);
    const [replaceListViewFieldSets] = (0, $iWLL0.useMutation)((0, $cWger.default));
    const onColumnsChange = (0, $eUqFw.useCallback)((columnIds, changeType, optimisticFieldSets)=>{
        // This handler can be called from a native event listener hence React does not batch state updates.
        // We manually batch this update for better rendering performance and more accurate measurement of
        // drag-and-drop interaction performance. We can remove this with React 18's automatic batching.
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unstable_batchedUpdates(()=>{
            if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).start();
            replaceListViewFieldSets({
                variables: {
                    id: viewData.id,
                    amountOfColumns: (0, $a4IeB.MAX_COLUMNS),
                    fieldSetsInput: {
                        replaceFieldSetsInput: {
                            nodes: columnIds
                        }
                    },
                    includeView: changeType === (0, $a4IeB.REORDER_COLUMNS)
                },
                optimisticResponse: changeType === (0, $a4IeB.REORDER_COLUMNS) && optimisticFieldSets ? {
                    jira: {
                        replaceIssueSearchViewFieldSets: {
                            success: true,
                            view: {
                                id: viewData.id,
                                viewId: viewData.viewId,
                                hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                fieldSets: {
                                    ...optimisticFieldSets
                                }
                            }
                        }
                    }
                } : undefined,
                onCompleted (data) {
                    if (data.jira?.replaceIssueSearchViewFieldSets?.success) {
                        if (changeType === (0, $a4IeB.MODIFY_COLUMNS)) onModifyColumns();
                        else if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).success();
                    } else {
                        showFlag($d5d39cf8a057e809$var$reorderColumnsErrorFlag);
                        (0, $guiFP.default)({
                            meta: {
                                id: 'commitReplaceListViewFieldSetsMutationUnsuccessful',
                                packageName: (0, $jccNB.PACKAGE_NAME),
                                teamName: (0, $jccNB.TEAM_NAME)
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: {
                                changeType: changeType
                            }
                        });
                        if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).failure();
                    }
                },
                onError (error) {
                    showFlag($d5d39cf8a057e809$var$reorderColumnsErrorFlag);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'commitReplaceListViewFieldSetsMutationError',
                            packageName: (0, $jccNB.PACKAGE_NAME),
                            teamName: (0, $jccNB.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            changeType: changeType
                        }
                    });
                    if (changeType === (0, $a4IeB.REORDER_COLUMNS)) (0, $6Nns0.dragAndDropExperience).failure();
                }
            });
        });
    }, [
        replaceListViewFieldSets,
        onModifyColumns,
        showFlag,
        viewData.hasDefaultFieldSets,
        viewData.id,
        viewData.viewId
    ]);
    const [updateFieldSetPreferences] = (0, $iWLL0.useMutation)((0, $6coCb.default));
    const cloudId = (0, $dWLk9.useCloudId)();
    const updateColumnWidth = (0, $1kw3p.useColumnWidthUpdater)(viewData.fieldSets.__id);
    const onColumnResize = (0, $eUqFw.useCallback)((columnId, width)=>{
        // skip mutation for anonymous users as they don't have access to user preferences
        if (!isAnonymous) // we intentionally don't optimistically update the store to avoid rolling back column widths
        // in case of a mutation error, which would be very jarring for the user
        updateFieldSetPreferences({
            variables: {
                cloudId: cloudId,
                input: {
                    nodes: [
                        {
                            fieldSetId: columnId,
                            width: width ?? null
                        }
                    ]
                }
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) // silently fail as column will remain at the desired width until the next page load
                (0, $guiFP.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onError (error) {
                // silently fail as column will remain at the desired width until the next page load
                (0, $guiFP.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        // commit local update to the store independently of the mutation result to preserve user's desired width
        updateColumnWidth(columnId, width);
    }, [
        cloudId,
        isAnonymous,
        updateColumnWidth,
        updateFieldSetPreferences
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $6Nns0.dragAndDropExperience).markInlineResponse();
    });
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            hasMaxSelectedColumns: hasMaxSelectedColumns,
            filterName: filterData?.name
        }), [
        filterData?.name,
        hasMaxSelectedColumns
    ]);
    const { onIssueSearchRefresh: onIssueSearchRefresh } = (0, $cQBUE.useIssueSearchQuery)();
    const onRestoreDefaultColumns = (0, $eUqFw.useCallback)(()=>{
        setIsRestoringDefaultColumns(true);
        replaceListViewFieldSets({
            variables: {
                id: viewData.id,
                amountOfColumns: (0, $a4IeB.MAX_COLUMNS),
                includeView: true,
                fieldSetsInput: {
                    resetToDefaultFieldSets: true
                }
            },
            onCompleted (data) {
                setIsRestoringDefaultColumns(false);
                if (data.jira?.replaceIssueSearchViewFieldSets?.success) onIssueSearchRefresh();
                else {
                    showFlag($d5d39cf8a057e809$var$resetColumnsErrorFlag);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'commitReplaceListViewUsingResetFieldSetsMutationUnsuccessful',
                            packageName: (0, $jccNB.PACKAGE_NAME),
                            teamName: (0, $jccNB.TEAM_NAME)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                setIsRestoringDefaultColumns(false);
                showFlag($d5d39cf8a057e809$var$resetColumnsErrorFlag);
                (0, $guiFP.default)({
                    meta: {
                        id: 'commitReplaceListViewUsingResetFieldSetsMutationError',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    }, [
        replaceListViewFieldSets,
        onIssueSearchRefresh,
        setIsRestoringDefaultColumns,
        showFlag,
        viewData.id
    ]);
    /**
   * returns undefined if there are default field sets
   * returns undefined if the user is on filter tab but cannot edit filter
   */ const conditionalOnRestoreDefaults = $d5d39cf8a057e809$export$539ae4acd804b244(onRestoreDefaultColumns, viewData);
    const conditionalOnChange = $d5d39cf8a057e809$export$3e7a75a1659bbaae(onColumnsChange);
    const { isColumnPickerLoading: isColumnPickerLoading } = $d5d39cf8a057e809$export$6a2cc3745a117f8();
    const conditionalColumnLoader = $d5d39cf8a057e809$export$90b784197d8a906f();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsqQn.DialogContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            currentPage: currentPage,
            isAnonymous: isAnonymous
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $50IaJ.AsyncRegisterShortcutDialogActions), {
        issues: issueResultsData,
        // TODO Remove when cleaning up jira_spreadsheet_component_m1
        selectedIssueIndex: selectedIssueIndex,
        selectedIssueKey: selectedIssueKey,
        eventHandlers: eventHandlers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PZPM.ColumnPickerMessageContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5d39cf8a057e809$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jLtGz.default), {
        issues: issueResultsData,
        columns: viewData.fieldSets,
        onColumnsChange: conditionalOnChange,
        onRestoreDefaultColumns: conditionalOnRestoreDefaults,
        useColumnLoader: conditionalColumnLoader,
        loading: loading,
        eventHandlers: eventHandlers,
        onSelectedRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        selectedRow: selectedIssueIndex,
        sortField: field,
        sortDirection: direction,
        onSortChange: onSortOrderChange,
        components: tableComponents,
        issueSearchBaseUrl: "" // Relative to current route rendering the issue navigator
        ,
        isColumnPickerLoading: isColumnPickerLoading,
        projectContext: projectContext,
        onColumnResize: onColumnResize,
        ...infiniteScrollProps
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZhcJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// re-render regression detection
$d5d39cf8a057e809$var$ListView.whyDidYouRender = true;
var $d5d39cf8a057e809$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($d5d39cf8a057e809$var$ListView, {
    id: 'ui.issue-results.list-view.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});
const $d5d39cf8a057e809$var$TableContainerStyles = (0, $8Vv3m.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column'
});

});
parcelRegister("6coCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e594bde34f16e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f869b29cb2bead806de4a76c098662d6>>
 * @relayHash 49c7fff6a0e7619f946ea6858ac070f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa78c7137d4bf2c426f358e5e8e25a3d05afb5062d08ddd15fa808b550e9004e
const $38e594bde34f16e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "aa78c7137d4bf2c426f358e5e8e25a3d05afb5062d08ddd15fa808b550e9004e",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$38e594bde34f16e5$var$node.hash = "5e33dd509f20cf3d934020e4f1ce2386";
var $38e594bde34f16e5$export$2e2bcd8739ae039 = $38e594bde34f16e5$var$node;

});

parcelRegister("cWger", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ebdaf70bae45743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98a4126a66181f6c7cc4f3cc26cdcb8a>>
 * @relayHash ff4d091d96c84ca8c39277a86d58244b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9990b9dc884ef7836d9ee434f48470b0d93787f7109b909380fd4a028d55917
const $9ebdaf70bae45743$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceListViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceIssueSearchViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "main_issueNavigator_ListView_view"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_replaceListViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceIssueSearchViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "fieldSetSelectedState": "SELECTED"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "first",
                                                            "variableName": "amountOfColumns"
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9990b9dc884ef7836d9ee434f48470b0d93787f7109b909380fd4a028d55917",
            "metadata": {},
            "name": "main_replaceListViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9ebdaf70bae45743$var$node.hash = "9be997dbbfbbbdee8b96e0b00eeacd80";
var $9ebdaf70bae45743$export$2e2bcd8739ae039 = $9ebdaf70bae45743$var$node;

});

parcelRegister("jrg0f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7b70283925939a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ac4ee09aa06d0c162ef3bdadd8c445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c7b70283925939a2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$c7b70283925939a2$var$node.hash = "42fd583d4b19e59270b0aa45271f2d67";
var $c7b70283925939a2$export$2e2bcd8739ae039 = $c7b70283925939a2$var$node;

});

parcelRegister("6aI4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8947169e59ecfe8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0825269334b2da5c53b1ae21a50b815>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d8947169e59ecfe8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        },
        {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSets"
        }
    ],
    "type": "JiraIssueSearchView"
};
$d8947169e59ecfe8$var$node.hash = "0ebdff72d31eee64ce60fc441c37b19e";
var $d8947169e59ecfe8$export$2e2bcd8739ae039 = $d8947169e59ecfe8$var$node;

});

parcelRegister("b7C4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c93a083c91eea26f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14c673bea588898dc9074f64c01fc286>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c93a083c91eea26f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_issues"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ],
            "storageKey": "pageCursors(maxCursors:7)"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$c93a083c91eea26f$var$node.hash = "26e5557aa71bd28be0879894b7dd8134";
var $c93a083c91eea26f$export$2e2bcd8739ae039 = $c93a083c91eea26f$var$node;

});

parcelRegister("kZhcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41c1a8886a2b716$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $cyVXS = parcelRequire("cyVXS");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f41c1a8886a2b716$var$AsyncAttachFileModal = (0, $dyfd9.lazy)(()=>(parcelRequire("e6gir")), {
    moduleId: "./src/packages/issue-navigator/issue-operations/dialogs/attach-file-dialog/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f41c1a8886a2b716$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyVXS.ModalBoundary), {
        id: "attach-file-dialog",
        packageName: "native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f41c1a8886a2b716$var$AsyncAttachFileModal, null));

});
parcelRegister("e6gir", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bHFwf")
]).then(()=>parcelRequire('3ae2d'));

});


parcelRegister("gsqQn", function(module, exports) {

$parcel$export(module.exports, "DialogContextContainer", () => $a8f0ee5e4e8c0872$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $a8f0ee5e4e8c0872$export$a2a00ec2da7337e);

var $WBLbN = parcelRequire("WBLbN");
const $a8f0ee5e4e8c0872$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    mediaUploadContext: null
};
const $a8f0ee5e4e8c0872$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext
            });
        }
};
const $a8f0ee5e4e8c0872$var$Store = (0, $WBLbN.createStore)({
    initialState: $a8f0ee5e4e8c0872$var$initialState,
    actions: $a8f0ee5e4e8c0872$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $a8f0ee5e4e8c0872$export$8e9ef3fae6d51d86 = (0, $WBLbN.createContainer)($a8f0ee5e4e8c0872$var$Store);
const $a8f0ee5e4e8c0872$export$a2a00ec2da7337e = (0, $WBLbN.createHook)($a8f0ee5e4e8c0872$var$Store);

});

parcelRegister("jLtGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $627054f58fabcc4b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $gGtKh = parcelRequire("gGtKh");

var $hlomJ = parcelRequire("hlomJ");

const $627054f58fabcc4b$var$AsyncNativeIssueTable = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("5mXDo")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/ui/index.tsx"
});
const $627054f58fabcc4b$var$AsyncNativeIssueTableWithWrapper = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hlomJ.IssueTableSkeleton), null),
        name: "async-native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($627054f58fabcc4b$var$AsyncNativeIssueTable, props)));
var $627054f58fabcc4b$export$2e2bcd8739ae039 = $627054f58fabcc4b$var$AsyncNativeIssueTableWithWrapper;

});
parcelRegister("hlomJ", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $9b0846c29dcc68be$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $29WMc = parcelRequire("29WMc");
const $9b0846c29dcc68be$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b0846c29dcc68be$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29WMc.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b0846c29dcc68be$var$SkeletonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5mXDo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("4yBIX")
]).then(()=>parcelRequire('8iViP'));

});


parcelRegister("9PZPM", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMessageContext", () => $d76ac61a9eba46fd$export$2f14e8286acf4660);

var $eUqFw = parcelRequire("eUqFw");
const $d76ac61a9eba46fd$var$defaultMessageContext = {
    hasMaxSelectedColumns: false
};
const $d76ac61a9eba46fd$export$2f14e8286acf4660 = /*#__PURE__*/ (0, $eUqFw.createContext)($d76ac61a9eba46fd$var$defaultMessageContext);

});

parcelRegister("dil2Z", function(module, exports) {

$parcel$export(module.exports, "useColumnLoader", () => $87ff64cc8e13943b$export$6dc2ac601f90aafc);

var $eoc2T = parcelRequire("eoc2T");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1JJay = parcelRequire("1JJay");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aIxxL = parcelRequire("aIxxL");

var $3jzIw = parcelRequire("3jzIw");

var $d7cju = parcelRequire("d7cju");

var $dWLk9 = parcelRequire("dWLk9");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $4h281 = parcelRequire("4h281");

var $5cwmS = parcelRequire("5cwmS");
const $87ff64cc8e13943b$var$mapColumnPickerOptions = (data, search, intl, selectedColumns, canEditColumns)=>{
    let totalCount = 0;
    let edges;
    let endCursor;
    if (data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets) {
        totalCount = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor : undefined;
    }
    // @ts-expect-error - Argument of type '(edge: Node) => { secondaryLabel?: JSX.Element | undefined; isDisabled?: true | undefined; disabledMessage?: React.ReactNode; optionType: "option"; cursor: string; value: string; label: string; }' is not assignable to parameter of type '(value: { readonly cursor: string; readonly node: { readonly displayName: string; readonly fieldSetId: string; readonly fieldType?: { readonly displayName: string | null | undefined; } | null | undefined; readonly type: string; }; }, index: number, array: { ...; }[]) => { ...; }'.
    const options = edges?.filter((0, $3wKQY.isNonNullish)).map((edge)=>{
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d7cju.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const isOnlyUnselectable = (0, $5cwmS.isOnlyUnselectableField)(edge.node.type, canEditColumns);
        return {
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $3jzIw.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            ...isOnlyUnselectable && {
                isOnlyUnselectable: isOnlyUnselectable,
                disabledMessage: intl.formatMessage((0, $4h281.default).deprecatedParentyLinkMessage, {
                    field: edge.node.displayName,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                })
            }
        };
    });
    if (!options?.length) return {
        options: [],
        totalCount: 0
    };
    if (search.length) return {
        options: options,
        totalCount: totalCount,
        endCursor: endCursor
    };
    // total count is the count of unselected options for non-search queries
    totalCount += selectedColumns.length;
    return {
        options: [
            {
                label: intl.formatMessage((0, $4h281.default).columnGroupHeader),
                optionType: 'group',
                options: options
            }
        ],
        totalCount: totalCount,
        endCursor: endCursor
    };
};
const $87ff64cc8e13943b$export$6dc2ac601f90aafc = (viewId, canEditColumns, selectedColumns)=>{
    const intl = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    // refs for selectedColumns, endCursor and search prevent outdated data in the relay store from being used
    // in cases when selected options changes & picker is paginated
    const columnsRef = (0, $eUqFw.useRef)(selectedColumns);
    const endCursorRef = (0, $eUqFw.useRef)();
    const searchRef = (0, $eUqFw.useRef)();
    const loadedOptionsRef = (0, $eUqFw.useRef)();
    return (0, $eUqFw.useMemo)(()=>(0, $aIxxL.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            let cursor = endCursor;
            if (!canEditColumns) {
                const options = selectedColumns ? selectedColumns.filter((col)=>col.optionType === 'option' && (search ? col.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true)) : [];
                return Promise.resolve({
                    options: options,
                    totalCount: options.length
                });
            }
            // calculate cursor from edges, since endCursor might not be valid anymore when last option was selected
            if (endCursor !== undefined && loadedOptionsRef.current && selectedColumns) cursor = (0, $5cwmS.getCursorOfLastUnselectedOption)(loadedOptionsRef.current, selectedColumns, search, endCursor);
            try {
                const result = await (0, $iWLL0.fetchQuery)(environment, (0, $eoc2T.default), {
                    cloudId: cloudId,
                    namespace: (0, $jccNB.ISSUE_SEARCH_NAMESPACE),
                    viewId: viewId,
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: !search ? 'NON_SELECTED' : 'ALL'
                    }
                }, {
                    fetchPolicy: columnsRef.current !== selectedColumns || endCursorRef.current !== cursor || searchRef.current !== search ? 'network-only' : 'store-or-network'
                }).toPromise();
                columnsRef.current = selectedColumns;
                endCursorRef.current = cursor;
                searchRef.current = search;
                const pickerOptions = $87ff64cc8e13943b$var$mapColumnPickerOptions(result, search, intl, selectedColumns, canEditColumns);
                loadedOptionsRef.current = pickerOptions.options || undefined;
                return pickerOptions;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'fetchColumnPickerOptions',
                        packageName: (0, $jccNB.PACKAGE_NAME),
                        teamName: (0, $jccNB.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                loadedOptionsRef.current = undefined;
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        canEditColumns,
        cloudId,
        environment,
        intl,
        selectedColumns,
        viewId
    ]);
};

});
parcelRegister("eoc2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7c77884534ed2ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<140068a82225ca3e6b3fc9a32209f60e>>
 * @relayHash e7018d1ccf85dde8ada50bb8f93d8d96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2fc2bdb7e99242c748d59a003f006e50b4a56a963e6ef08e6ffb31bdfa8c511d
const $e7c77884534ed2ad$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v7 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v7 /*: any*/ ,
                                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldSets",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                                                    },
                                                    v9 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueSearchFieldSet",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v12 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v13 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                                                            },
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.issueSearchViewByNamespaceAndViewId"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "JiraIssueSearchView",
                            "kind": "LinkedField",
                            "name": "issueSearchViewByNamespaceAndViewId",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldSets",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2fc2bdb7e99242c748d59a003f006e50b4a56a963e6ef08e6ffb31bdfa8c511d",
            "metadata": {},
            "name": "fetchColumnPickerOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7c77884534ed2ad$var$node.hash = "374080c39c08d2cf25a28460ad1b6425";
var $e7c77884534ed2ad$export$2e2bcd8739ae039 = $e7c77884534ed2ad$var$node;

});

parcelRegister("aIxxL", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $b078fb111bae5b9f$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $b078fb111bae5b9f$export$a6cff24b97727de1);

var $5oamh = parcelRequire("5oamh");

const $b078fb111bae5b9f$export$b8b9d90f9e5bd72b = 'jiraIssueTableColumnHeader';
const $b078fb111bae5b9f$export$d57b6b390e78d90f = 'empanada';
const $b078fb111bae5b9f$export$7ec4af037f372df4 = 500;
const $b078fb111bae5b9f$export$a6cff24b97727de1 = (0, $5oamh.createGenericDebouncableDataLoader);

});
parcelRegister("5oamh", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $44c3b46c69e4d46d$export$ea63a11564958c9e);

var $dxIU5 = parcelRequire("dxIU5");
const $44c3b46c69e4d46d$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $44c3b46c69e4d46d$export$2e2bcd8739ae039 = $44c3b46c69e4d46d$export$ea63a11564958c9e;

});


parcelRegister("3jzIw", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $65199b03f9eafe7f$export$de24d837eb50c435);

var $eUqFw = parcelRequire("eUqFw");
const $65199b03f9eafe7f$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("d7cju", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $64116c3db17e9766$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $64116c3db17e9766$export$4641b622f6c36f58);
$parcel$export(module.exports, "FieldTypeIcon", () => $64116c3db17e9766$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $64116c3db17e9766$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $70oKY = parcelRequire("70oKY");

var $sLJuB = parcelRequire("sLJuB");

var $dxEjV = parcelRequire("dxEjV");

var $3Cdnl = parcelRequire("3Cdnl");

var $jRURa = parcelRequire("jRURa");

var $eI5EY = parcelRequire("eI5EY");

var $lO4Or = parcelRequire("lO4Or");

var $lO4Or = parcelRequire("lO4Or");
var $6bYiA = parcelRequire("6bYiA");

var $fiSip = parcelRequire("fiSip");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $64116c3db17e9766$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70oKY.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $64116c3db17e9766$var$checkedFieldTypesIcons = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.numberGlyph)
    }),
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.numberGlyph)
    }),
    [(0, $lO4Or.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    [(0, $lO4Or.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.radioGlyph)
    }),
    [(0, $lO4Or.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.doubleDropdownGlyph)
    }),
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $6bYiA.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $6bYiA.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    [(0, $lO4Or.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $lO4Or.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Cdnl))), {
        label: ""
    }),
    [(0, $lO4Or.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.shipGlyph)
    }),
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGroupGlyph)
    }),
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.officeBuildingGlyph)
    }),
    [(0, $lO4Or.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.attachmentGlyph)
    }),
    [(0, $lO4Or.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    [(0, $lO4Or.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    [(0, $lO4Or.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.priorityGlyph)
    }),
    [(0, $lO4Or.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    [(0, $lO4Or.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeTrackingGlyph)
    }),
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.originalTimeEstimateGlyph)
    }),
    [(0, $lO4Or.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.screenGlyph)
    }),
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    [(0, $lO4Or.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.arrowRightGlyph)
    }),
    [(0, $lO4Or.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.shortTextGlyph)
    }),
    [(0, $6bYiA.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.shortTextGlyph)
    }),
    [(0, $6bYiA.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.checkboxGlyph)
    }),
    [(0, $lO4Or.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $6bYiA.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.commentGlyph)
    }),
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.appAccessGlyph)
    }),
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.appAccessGlyph)
    }),
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.folderGlyph)
    }),
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    [(0, $lO4Or.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.jwmCategoryGlyph)
    }),
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    [(0, $lO4Or.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    }),
    [(0, $lO4Or.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($sLJuB))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$64116c3db17e9766$var$checkedFieldTypesIcons
});
const $64116c3db17e9766$export$67f993f3bbfb364d = $64116c3db17e9766$var$checkedFieldTypesIcons;
const $64116c3db17e9766$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dxEjV))), {
        label: "",
        size: "medium"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dxEjV))), {
        label: "",
        size: "medium"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jRURa))), {
        label: "",
        size: "medium"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $64116c3db17e9766$var$allIcons = {
    ...$64116c3db17e9766$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64116c3db17e9766$var$ResizedIcon, {
        glyph: (0, $fiSip.customFieldGlyph)
    })
};
const $64116c3db17e9766$var$checkedFieldTypesGlyphs = {
    [(0, $lO4Or.NUMBER_CF_TYPE)]: (0, $fiSip.numberGlyph),
    [(0, $lO4Or.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $fiSip.numberGlyph),
    [(0, $lO4Or.LABELS_CF_TYPE)]: (0, $fiSip.labelGlyph),
    [(0, $lO4Or.DATE_CF_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.DATETIME_CF_TYPE)]: (0, $fiSip.timeStampGlyph),
    [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: (0, $fiSip.radioGlyph),
    [(0, $lO4Or.SELECT_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: (0, $fiSip.doubleDropdownGlyph),
    [(0, $lO4Or.MULTI_VERSION_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.VERSION_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.GROUP_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.MULTI_GROUP_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.USER_CF_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $6bYiA.USERPICKER_FIELD_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.MULTI_USER_CF_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $6bYiA.MULTIUSERPICKER_FIELD_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.PEOPLE_CF_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.FLAGGED_CF_TYPE)]: (0, $fiSip.timeStampGlyph),
    [(0, $lO4Or.URL_CF_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $lO4Or.TEAM_CF_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $lO4Or.PARENT_CF_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $lO4Or.BASELINE_START_CF_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.BASELINE_END_CF_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.SPRINT_TYPE)]: (0, $fiSip.shipGlyph),
    [(0, $lO4Or.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $fiSip.peopleGroupGlyph),
    [(0, $lO4Or.ORGANIZATIONS_CF_TYPE)]: (0, $fiSip.officeBuildingGlyph),
    [(0, $lO4Or.REPORTER_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.ATTACHMENT_TYPE)]: (0, $fiSip.attachmentGlyph),
    [(0, $lO4Or.ASSIGNEE_TYPE)]: (0, $fiSip.peopleGlyph),
    [(0, $lO4Or.LABELS_TYPE)]: (0, $fiSip.labelGlyph),
    [(0, $lO4Or.PRIORITY_TYPE)]: (0, $fiSip.priorityGlyph),
    [(0, $lO4Or.DUE_DATE_TYPE)]: (0, $fiSip.dateGlyph),
    [(0, $lO4Or.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $fiSip.timeStampGlyph),
    [(0, $lO4Or.TIME_TRACKING_TYPE)]: (0, $fiSip.timeTrackingGlyph),
    [(0, $lO4Or.TIME_ESTIMATE_TYPE)]: (0, $fiSip.originalTimeEstimateGlyph),
    [(0, $lO4Or.ASSETS_CF_TYPE)]: (0, $fiSip.screenGlyph),
    [(0, $lO4Or.SERVICE_ENTITY_CF_TYPE)]: (0, $fiSip.labelGlyph),
    [(0, $lO4Or.STATUS_TYPE)]: (0, $fiSip.arrowRightGlyph),
    [(0, $lO4Or.SUMMARY_TYPE)]: (0, $fiSip.shortTextGlyph),
    [(0, $6bYiA.DESCRIPTION_FIELD_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.TEXT_CF_TYPE)]: (0, $fiSip.shortTextGlyph),
    [(0, $6bYiA.TEXT_AREA_CF_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: (0, $fiSip.checkboxGlyph),
    [(0, $lO4Or.ISSUE_LINKS_TYPE)]: (0, $fiSip.customFieldGlyph),
    [(0, $6bYiA.ENVIRONMENT_FIELD_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.COMMENT_TYPE)]: (0, $fiSip.commentGlyph),
    [(0, $lO4Or.APPROVERS_LIST_CF_TYPE)]: (0, $fiSip.appAccessGlyph),
    [(0, $lO4Or.APPROVALS_CF_TYPE)]: (0, $fiSip.appAccessGlyph),
    [(0, $lO4Or.PROJECT_PICKER_CF_TYPE)]: (0, $fiSip.folderGlyph),
    [(0, $lO4Or.MESSAGE_EDIT_CF_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.MESSAGE_VIEW_CF_TYPE)]: (0, $fiSip.paragraphGlyph),
    [(0, $lO4Or.CATEGORY_TYPE)]: (0, $fiSip.jwmCategoryGlyph),
    [(0, $lO4Or.ENTITLEMENT_CF_TYPE)]: (0, $fiSip.dropdownGlyph),
    [(0, $lO4Or.SENTIMENT_CF_TYPE)]: (0, $fiSip.customFieldGlyph)
};
const $64116c3db17e9766$export$14355977bfae6aaa = {
    ...$64116c3db17e9766$var$checkedFieldTypesGlyphs,
    text: (0, $fiSip.paragraphGlyph),
    number: (0, $fiSip.numberGlyph),
    date: (0, $fiSip.dateGlyph),
    datetime: (0, $fiSip.timeStampGlyph),
    dropdown: (0, $fiSip.dropdownGlyph),
    addon: (0, $fiSip.addonGlyph),
    checkbox: (0, $fiSip.checkboxGlyph),
    user: (0, $fiSip.peopleGlyph),
    radio: (0, $fiSip.radioGlyph),
    time: (0, $fiSip.timeStampGlyph),
    message: (0, $fiSip.commentGlyph),
    bulletList: (0, $fiSip.bulletListGlyph),
    label: (0, $fiSip.labelGlyph),
    labelpicker: (0, $fiSip.labelGlyph),
    close: (0, $fiSip.closeGlyph),
    assetspicker: (0, $fiSip.screenGlyph),
    select: (0, $fiSip.dropdownGlyph),
    multiselect: (0, $fiSip.dropdownGlyph),
    cascadingselect: (0, $fiSip.doubleDropdownGlyph),
    multigrouppicker: (0, $fiSip.dropdownGlyph),
    grouppicker: (0, $fiSip.dropdownGlyph),
    multiversion: (0, $fiSip.dropdownGlyph),
    version: (0, $fiSip.dropdownGlyph),
    projectpicker: (0, $fiSip.dropdownGlyph),
    customField: (0, $fiSip.customFieldGlyph)
};
const $64116c3db17e9766$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eUqFw.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Cdnl))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $lO4Or.GOALS_CF_TYPE) && (0, $eI5EY.fg)('native_goals_integration_on_list_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($sLJuB))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70oKY.default), {
        label: "",
        glyph: $64116c3db17e9766$var$checkedFieldTypesGlyphs[type] || $64116c3db17e9766$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $64116c3db17e9766$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eUqFw.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $lO4Or.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Cdnl))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $lO4Or.GOALS_CF_TYPE) && (0, $eI5EY.fg)('native_goals_integration_on_list_view')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($sLJuB))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70oKY.default), {
        label: "",
        glyph: $64116c3db17e9766$export$14355977bfae6aaa[type] || $64116c3db17e9766$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $64116c3db17e9766$export$2e2bcd8739ae039 = $64116c3db17e9766$var$allIcons;

});
parcelRegister("dxEjV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dbda23b158d1182$var$_react = $9dbda23b158d1182$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $9dbda23b158d1182$var$_branch = $9dbda23b158d1182$var$_interopRequireDefault((parcelRequire("2PSAP")));
function $9dbda23b158d1182$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9dbda23b158d1182$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $9dbda23b158d1182$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $9dbda23b158d1182$var$_branch.default
    }));
$9dbda23b158d1182$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $9dbda23b158d1182$var$_default = module.exports.default = $9dbda23b158d1182$var$BitbucketBranchesIcon;

});
parcelRegister("2PSAP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::819aaba4ce720b386ac455b06c3dfba2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $210ab13da0a402ff$var$_react = $210ab13da0a402ff$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $210ab13da0a402ff$var$_UNSAFE_baseNew = $210ab13da0a402ff$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $210ab13da0a402ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $210ab13da0a402ff$var$BranchIcon = (props)=>/*#__PURE__*/ $210ab13da0a402ff$var$_react.default.createElement($210ab13da0a402ff$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M4.25 4.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 0V9m1.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 0h3.5a2.5 2.5 0 0 0 2.5-2.5v-5.5m0 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>`
    }, props));
$210ab13da0a402ff$var$BranchIcon.displayName = 'BranchIcon';
var $210ab13da0a402ff$var$_default = module.exports.default = $210ab13da0a402ff$var$BranchIcon;

});


parcelRegister("3Cdnl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a1f4bd309170316$var$_react = $2a1f4bd309170316$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $2a1f4bd309170316$var$_peopleGroup = $2a1f4bd309170316$var$_interopRequireDefault((parcelRequire("dylHY")));
function $2a1f4bd309170316$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2a1f4bd309170316$var$PeopleIcon = (props)=>/*#__PURE__*/ $2a1f4bd309170316$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $2a1f4bd309170316$var$_peopleGroup.default
    }));
$2a1f4bd309170316$var$PeopleIcon.displayName = 'PeopleIcon';
var $2a1f4bd309170316$var$_default = module.exports.default = $2a1f4bd309170316$var$PeopleIcon;

});

parcelRegister("jRURa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e76f1214d27b4758$var$_react = $e76f1214d27b4758$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $e76f1214d27b4758$var$_stopwatch = $e76f1214d27b4758$var$_interopRequireDefault((parcelRequire("8bK78")));
function $e76f1214d27b4758$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e76f1214d27b4758$var$StopwatchIcon = (props)=>/*#__PURE__*/ $e76f1214d27b4758$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $e76f1214d27b4758$var$_stopwatch.default
    }));
$e76f1214d27b4758$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $e76f1214d27b4758$var$_default = module.exports.default = $e76f1214d27b4758$var$StopwatchIcon;

});
parcelRegister("8bK78", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab7d8646125aaad443a203db920002e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f631f1b92786134$var$_react = $5f631f1b92786134$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5f631f1b92786134$var$_UNSAFE_baseNew = $5f631f1b92786134$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $5f631f1b92786134$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f631f1b92786134$var$StopwatchIcon = (props)=>/*#__PURE__*/ $5f631f1b92786134$var$_react.default.createElement($5f631f1b92786134$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 3.75v-3m0 3a5.73 5.73 0 0 1 3.885 1.511M8 3.75a5.73 5.73 0 0 0-3.885 1.511M8 .75h3m-3 0H5m8.5 2.75-1.615 1.761M2.5 3.5l1.615 1.761m7.77 0a5.75 5.75 0 1 1-7.77 0M7.75 9.75 10.292 7"/>`
    }, props));
$5f631f1b92786134$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $5f631f1b92786134$var$_default = module.exports.default = $5f631f1b92786134$var$StopwatchIcon;

});


parcelRegister("fiSip", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $032123c5fd7d43cf$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $032123c5fd7d43cf$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $032123c5fd7d43cf$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $032123c5fd7d43cf$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $032123c5fd7d43cf$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $032123c5fd7d43cf$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $032123c5fd7d43cf$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $032123c5fd7d43cf$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $032123c5fd7d43cf$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $032123c5fd7d43cf$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $032123c5fd7d43cf$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $032123c5fd7d43cf$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $032123c5fd7d43cf$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $032123c5fd7d43cf$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $032123c5fd7d43cf$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $032123c5fd7d43cf$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $032123c5fd7d43cf$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $032123c5fd7d43cf$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $032123c5fd7d43cf$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $032123c5fd7d43cf$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $032123c5fd7d43cf$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $032123c5fd7d43cf$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $032123c5fd7d43cf$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $032123c5fd7d43cf$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $032123c5fd7d43cf$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $032123c5fd7d43cf$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $032123c5fd7d43cf$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $032123c5fd7d43cf$export$88453606d7da6ff7);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $032123c5fd7d43cf$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $032123c5fd7d43cf$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $032123c5fd7d43cf$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $032123c5fd7d43cf$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("4h281", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16e240582606b3c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f16e240582606b3c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    columnGroupHeader: {
        "id": "issue-table-column-picker.common.column-group-header",
        "defaultMessage": "All columns"
    },
    deprecatedParentyLinkMessage: {
        "id": "issue-navigator.services.fetch-column-picker-options.deprecated-parenty-link-message",
        "defaultMessage": "<strong>{field}</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    }
});

});

parcelRegister("5cwmS", function(module, exports) {

$parcel$export(module.exports, "getCursorOfLastUnselectedOption", () => $0233ce4f9175c609$export$5918fea5c056698b);
$parcel$export(module.exports, "isOnlyUnselectableField", () => $0233ce4f9175c609$export$bf5bbd6344a5f1aa);

var $bCHHi = parcelRequire("bCHHi");

var $1ybV0 = parcelRequire("1ybV0");

var $iwfPv = parcelRequire("iwfPv");

var $jccNB = parcelRequire("jccNB");
const $0233ce4f9175c609$var$isNotinSelectedList = (selectedOptions, option)=>{
    const optionFound = selectedOptions.find((select)=>(0, $iwfPv.isSingleValueOption)(select) && (0, $iwfPv.isSingleValueOption)(option) && select.cursor === option.cursor);
    return optionFound === undefined;
};
const $0233ce4f9175c609$export$5918fea5c056698b = (options, selectedOptions, search, endCursor)=>{
    const flatten = options.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    const lastUnselectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($bCHHi)))(flatten, (option)=>(0, $iwfPv.isSingleValueOption)(option) && !!option.cursor && $0233ce4f9175c609$var$isNotinSelectedList(selectedOptions, option));
    let cursor = lastUnselectedOption && (0, $iwfPv.isSingleValueOption)(lastUnselectedOption) ? lastUnselectedOption?.cursor : undefined;
    // with a given search input, don't set cursor to undefined when there are only selected options in the list, because we query with 'ALL' options
    if (search && cursor === undefined && endCursor) cursor = endCursor;
    return cursor;
};
const $0233ce4f9175c609$export$bf5bbd6344a5f1aa = (fieldType, canEditColumns)=>{
    if ((0, $1ybV0.ff)('nin-show-field-options-as-only-unselectable_0s1y2')) {
        if (fieldType === (0, $jccNB.COLUMN_TYPE_EPIC_LINK)) return canEditColumns;
        if (fieldType === (0, $jccNB.COLUMN_TYPE_PARENT_LINK)) return canEditColumns;
    }
    return false;
};

});
parcelRegister("bCHHi", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $gJXdx = parcelRequire("gJXdx");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $876523ae23ec930f$var$findLast = $e5OGm($gJXdx);
module.exports = $876523ae23ec930f$var$findLast;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("gJXdx", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2fec8a2b4cc30dc$var$nativeMax = Math.max, $c2fec8a2b4cc30dc$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $c2fec8a2b4cc30dc$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $hNahz(fromIndex);
        index = fromIndex < 0 ? $c2fec8a2b4cc30dc$var$nativeMax(length + index, 0) : $c2fec8a2b4cc30dc$var$nativeMin(index, length - 1);
    }
    return $9mB9u(array, $7qARj(predicate, 3), index, true);
}
module.exports = $c2fec8a2b4cc30dc$var$findLastIndex;

});


parcelRegister("iwfPv", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $9fd9b9682c9a75f2$export$35faed52a6bc243e);
const $9fd9b9682c9a75f2$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});



parcelRegister("aZxZH", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $71bb256a733956fb$export$e1286e1cb3fa0dec);

var $eUqFw = parcelRequire("eUqFw");

var $4RwIp = parcelRequire("4RwIp");
const $71bb256a733956fb$export$e1286e1cb3fa0dec = ({ children: children, viewIdFromResponse: viewIdFromResponse, isRestoringDefaults: isRestoringDefaults })=>{
    const [{ view: optimisticViewId }] = (0, $4RwIp.useSelectedViewState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        key: isRestoringDefaults ? 'loading' : optimisticViewId + viewIdFromResponse
    }, children);
};

});

parcelRegister("1LgE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $96325f416cc3ac7e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $nsZmq = parcelRequire("nsZmq");

var $8uD7Y = parcelRequire("8uD7Y");

var $9PZPM = parcelRequire("9PZPM");

var $4RwIp = parcelRequire("4RwIp");

var $3mEVr = parcelRequire("3mEVr");

var $eobVZ = parcelRequire("eobVZ");

var $dC0v6 = parcelRequire("dC0v6");

var $ctGRP = parcelRequire("ctGRP");

var $5hr6J = parcelRequire("5hr6J");
const $96325f416cc3ac7e$var$ColumnPickerPopupComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>{
    const { filterId: filterId, isFilterEditable: isFilterEditable } = (0, $3mEVr.useActiveJql)();
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const { hasMaxSelectedColumns: hasMaxSelectedColumns, filterName: filterName } = (0, $eUqFw.useContext)((0, $9PZPM.ColumnPickerMessageContext));
    let bannerMessage = null;
    if (hasMaxSelectedColumns) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC0v6.ColumnPickerMaxSelectedColumns), null);
    else if (view === 'list_system') bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eobVZ.ColumnPickerBannerMessage), {
        bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5hr6J.default).listSystemWarningMessage),
        type: "warning"
    });
    else if (view === `list_filter_${filterId}`) {
        if (isFilterEditable === false) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eobVZ.ColumnPickerBannerMessage), {
            type: "info",
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $5hr6J.default).listNonEditableFilterInfoMessage,
                values: {
                    // To remove @ts-expect-error below we need to upgrade intl to v6
                    // https://stackoverflow.com/questions/67884173/formattedmessage-values-chunks-using-typescript
                    // @ts-expect-error TS2322: Type '(chunks: ReactNode[]) => JSX.Element' is not assignable to type 'ReactNode'.
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nsZmq.default), {
                            href: `/jira/filters${filterName ? `?name="${encodeURIComponent(filterName)}"` : ''}`,
                            target: "_blank"
                        }, chunks)
                }
            })
        });
        else bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eobVZ.ColumnPickerBannerMessage), {
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $5hr6J.default).listFilterWarningMessage),
            type: "warning"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96325f416cc3ac7e$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctGRP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($96325f416cc3ac7e$var$TabsContentContainer, null, bannerMessage, children)));
});
var $96325f416cc3ac7e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $96325f416cc3ac7e$var$ColumnPickerPopupComponent;
const $96325f416cc3ac7e$var$PopupComponentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv _bfhk1bhr _2rko1l7b _16qs1mxi _1pby1nn1 _ca0q1b66 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $96325f416cc3ac7e$var$TabsContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eobVZ", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerBannerMessage", () => $d16e423e8d97de57$export$3ccab74b576df308);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kfXvt = parcelRequire("kfXvt");

var $9r2Te = parcelRequire("9r2Te");
const $d16e423e8d97de57$export$3ccab74b576df308 = ({ bannerMessage: bannerMessage, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d16e423e8d97de57$var$BannerContent, {
        type: type
    }, type === 'warning' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9r2Te))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfXvt))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d16e423e8d97de57$var$BannerMessage, null, bannerMessage));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d16e423e8d97de57$var$BannerContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41uce _syazjjyb",
            __cmplp.type === 'warning' ? "_bfhk1bai" : "_bfhk1fpu",
            __cmplp.className
        ])
    });
});
const $d16e423e8d97de57$var$BannerMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8171m _11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kfXvt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e457cb24ac9ea7300ef511f2118ffa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebf35e246a02b71d$var$_react = $ebf35e246a02b71d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ebf35e246a02b71d$var$_information = $ebf35e246a02b71d$var$_interopRequireDefault((parcelRequire("jgkb5")));

var $ebf35e246a02b71d$var$_info = $ebf35e246a02b71d$var$_interopRequireDefault((parcelRequire("2RI87")));
function $ebf35e246a02b71d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ebf35e246a02b71d$var$InformationIcon = (props)=>/*#__PURE__*/ $ebf35e246a02b71d$var$_react.default.createElement($ebf35e246a02b71d$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $ebf35e246a02b71d$var$_info.default
    }, props));
$ebf35e246a02b71d$var$InformationIcon.Name = 'InformationIconMigration';
var $ebf35e246a02b71d$var$_default = module.exports.default = $ebf35e246a02b71d$var$InformationIcon;

});
parcelRegister("jgkb5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e05f29d97b191313$var$_react = $e05f29d97b191313$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e05f29d97b191313$var$_UNSAFE_baseNew = $e05f29d97b191313$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $e05f29d97b191313$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e05f29d97b191313$var$InformationIcon = (props)=>/*#__PURE__*/ $e05f29d97b191313$var$_react.default.createElement($e05f29d97b191313$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$e05f29d97b191313$var$InformationIcon.displayName = 'InformationIcon';
var $e05f29d97b191313$var$_default = module.exports.default = $e05f29d97b191313$var$InformationIcon;

});



parcelRegister("dC0v6", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMaxSelectedColumns", () => $df275368a5d4fd75$export$3ec21851fe32329c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7NH8G = parcelRequire("7NH8G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $a4IeB = parcelRequire("a4IeB");

var $d6f6c = parcelRequire("d6f6c");

var $kU57W = parcelRequire("kU57W");
const $df275368a5d4fd75$export$3ec21851fe32329c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df275368a5d4fd75$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7NH8G))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($df275368a5d4fd75$var$Message, null, formatMessage((0, $kU57W.default).maxSelectedColumns, {
        maxColumns: (0, $a4IeB.MAX_COLUMNS)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "maxSelectedFieldsMessage",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df275368a5d4fd75$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _bfhk1s4m _1yt41uce _syazjjyb _19pku2gc",
            __cmplp.className
        ])
    });
});
const $df275368a5d4fd75$var$Message = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8171m _11c81vlj",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7NH8G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ade9280da525a54$var$_react = $5ade9280da525a54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $5ade9280da525a54$var$_information = $5ade9280da525a54$var$_interopRequireDefault((parcelRequire("jgkb5")));
function $5ade9280da525a54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5ade9280da525a54$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $5ade9280da525a54$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $5ade9280da525a54$var$_information.default
    }));
$5ade9280da525a54$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $5ade9280da525a54$var$_default = module.exports.default = $5ade9280da525a54$var$EditorPanelIcon;

});

parcelRegister("kU57W", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bfa33a30d99569$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06bfa33a30d99569$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    maxSelectedColumns: {
        "id": "issue-navigator.issue-results.list-view.column-picker-max-selected-columns.max-selected-columns",
        "defaultMessage": "The column limit is {maxColumns, number}. Remove and add the most important ones to your view."
    }
});

});


parcelRegister("ctGRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $40560f7893704d25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");

var $7O3hY = parcelRequire("7O3hY");
var $g27zK = parcelRequire("g27zK");
var $hH840 = parcelRequire("hH840");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5as0a = parcelRequire("5as0a");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $c7H0g = parcelRequire("c7H0g");

var $3wKQY = parcelRequire("3wKQY");

var $4RwIp = parcelRequire("4RwIp");

var $3mEVr = parcelRequire("3mEVr");

var $5EX8F = parcelRequire("5EX8F");

var $31uzl = parcelRequire("31uzl");
const $40560f7893704d25$var$CustomTabPanel = ({ children: children })=>{
    /**
   * We can omit the tab index as our panel always contains a focusable input as the first element https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic#accessibilityfeatures.
   * > It is recommended that all tabpanel elements in a tab set are focusable if there are any panels in the set that
   * > contain content where the first element in the panel is not focusable.
   */ const { tabIndex: tabIndex, ...tabPanelAttributes } = (0, $hH840.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", tabPanelAttributes, children);
};
const $40560f7893704d25$var$ColumnPickerTabs = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const [{ view: view }, { setView: setView }] = (0, $4RwIp.useSelectedViewState)();
    const isFilterTabEnabled = filterId != null && (0, $5as0a.isCustomFilter)(filterId);
    const tabsMetaData = (0, $eUqFw.useMemo)(()=>{
        const resultTabs = [
            {
                key: 'Default',
                label: formatMessage((0, $5EX8F.default).pickerTabTextDefault),
                view: 'list_default'
            }
        ];
        if (isFilterTabEnabled) {
            const filterViewId = (0, $3wKQY.convertFilterIdToIssueNavigatorId)(filterId);
            if (filterViewId != null) resultTabs.push({
                key: 'Filter',
                label: formatMessage((0, $5EX8F.default).pickerTabTextFilter),
                view: filterViewId
            });
        }
        if (isAdmin) resultTabs.push({
            key: 'System',
            label: formatMessage((0, $5EX8F.default).pickerTabTextSystem),
            view: 'list_system'
        });
        return resultTabs;
    }, [
        formatMessage,
        isFilterTabEnabled,
        filterId,
        isAdmin
    ]);
    const handleUpdate = (0, $eUqFw.useCallback)((index, event)=>{
        if (view !== tabsMetaData[index].view) {
            (0, $jMP2a.fireUIAnalytics)(event, 'columnPickerTabs', {
                tab: tabsMetaData[index].view
            });
            setView(tabsMetaData[index].view, (0, $6vrw7.toIssueKey)(''));
        }
    }, [
        setView,
        tabsMetaData,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7O3hY.default), {
        id: "issue-table-column-picker.ui.column-picker.picker-tabs",
        onChange: handleUpdate,
        selected: tabsMetaData.findIndex((tab)=>tab.view === view),
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g27zK.default), null, tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31uzl.default), {
            key: tab.key,
            label: tab.label,
            maxWidth: `${Math.floor(100 / (tabsMetaData.length || 1))}%`
        })))), tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($40560f7893704d25$var$CustomTabPanel, {
            key: tab.key
        }, children)));
};
var $40560f7893704d25$export$2e2bcd8739ae039 = $40560f7893704d25$var$ColumnPickerTabs;

});
parcelRegister("7O3hY", function(module, exports) {

$parcel$export(module.exports, "default", () => $867511875c9bde84$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iiktD = parcelRequire("iiktD");

var $j9zCm = parcelRequire("j9zCm");

var $gAvUR = parcelRequire("gAvUR");
function $867511875c9bde84$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $867511875c9bde84$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $867511875c9bde84$var$tabsStyles = (0, $gAvUR.getTabsStyles)();
const $867511875c9bde84$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $867511875c9bde84$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9zCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $867511875c9bde84$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $iiktD.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$867511875c9bde84$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $867511875c9bde84$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$867511875c9bde84$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $867511875c9bde84$var$baseStyles,
            $867511875c9bde84$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9zCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $867511875c9bde84$export$2e2bcd8739ae039 = $867511875c9bde84$var$Tabs;

});
parcelRegister("j9zCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $87fa6e1b0882920a$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $87fa6e1b0882920a$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $87fa6e1b0882920a$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $87fa6e1b0882920a$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $87fa6e1b0882920a$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $87fa6e1b0882920a$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("gAvUR", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f0bc79ce119f39cc$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f0bc79ce119f39cc$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $f0bc79ce119f39cc$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $akD1p = parcelRequire("akD1p");
const $f0bc79ce119f39cc$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f0bc79ce119f39cc$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f0bc79ce119f39cc$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f0bc79ce119f39cc$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f0bc79ce119f39cc$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f0bc79ce119f39cc$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f0bc79ce119f39cc$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f0bc79ce119f39cc$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f0bc79ce119f39cc$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f0bc79ce119f39cc$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f0bc79ce119f39cc$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f0bc79ce119f39cc$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f0bc79ce119f39cc$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $akD1p.tabLineColors).lineColor
        }
    });
const $f0bc79ce119f39cc$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $akD1p.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f0bc79ce119f39cc$var$tabBlockPadding} ${$f0bc79ce119f39cc$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f0bc79ce119f39cc$var$tabLineStyles,
                insetInlineEnd: $f0bc79ce119f39cc$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $akD1p.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f0bc79ce119f39cc$var$tabLineStyles,
                insetInlineEnd: $f0bc79ce119f39cc$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $akD1p.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f0bc79ce119f39cc$var$tabLineStyles,
                insetInlineEnd: $f0bc79ce119f39cc$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $akD1p.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $f0bc79ce119f39cc$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f0bc79ce119f39cc$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f0bc79ce119f39cc$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f0bc79ce119f39cc$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f0bc79ce119f39cc$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f0bc79ce119f39cc$var$tabLineStylesOld,
            height: $f0bc79ce119f39cc$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $akD1p.tabLineColors).lineColor
        }
    });
const $f0bc79ce119f39cc$export$442d081208938078 = ()=>{
    const colors = (0, $akD1p.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f0bc79ce119f39cc$var$tabBlockPadding} ${$f0bc79ce119f39cc$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f0bc79ce119f39cc$var$tabLineStylesOld,
                insetInlineEnd: $f0bc79ce119f39cc$var$tabInlinePadding,
                borderBottom: `${$f0bc79ce119f39cc$var$underlineHeight} solid ${(0, $akD1p.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f0bc79ce119f39cc$var$tabLineStylesOld,
                insetInlineEnd: $f0bc79ce119f39cc$var$tabInlinePadding,
                borderBottom: `${$f0bc79ce119f39cc$var$underlineHeight} solid ${(0, $akD1p.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f0bc79ce119f39cc$var$tabLineStylesOld,
                insetInlineEnd: $f0bc79ce119f39cc$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f0bc79ce119f39cc$var$underlineHeight} solid ${(0, $akD1p.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("akD1p", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $2b8aba8f3016c077$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $2b8aba8f3016c077$export$6be6fa4649b31472);

const $2b8aba8f3016c077$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a)})`
};
const $2b8aba8f3016c077$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $1b343b038f6c23ec$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $1b343b038f6c23ec$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("g27zK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6ccd99a202e162$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $hH840 = parcelRequire("hH840");

var $j9zCm = parcelRequire("j9zCm");

var $gAvUR = parcelRequire("gAvUR");
function $7a6ccd99a202e162$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a6ccd99a202e162$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $7a6ccd99a202e162$var$tabListStyles = (0, $gAvUR.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $7a6ccd99a202e162$var$tabListStylesOld = (0, $gAvUR.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7a6ccd99a202e162$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $hH840.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $j9zCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $7a6ccd99a202e162$var$baseStyles,
            (0, $gYrJM.fg)('platform-component-visual-refresh') ? $7a6ccd99a202e162$var$tabListStyles : $7a6ccd99a202e162$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $7a6ccd99a202e162$export$2e2bcd8739ae039 = $7a6ccd99a202e162$var$TabList;

});
parcelRegister("hH840", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $d8ff851045a3d73d$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $d8ff851045a3d73d$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $d8ff851045a3d73d$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $j9zCm = parcelRequire("j9zCm");
const $d8ff851045a3d73d$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $j9zCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $d8ff851045a3d73d$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $j9zCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $d8ff851045a3d73d$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $j9zCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("5EX8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $283c5e8ea41dd7c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $283c5e8ea41dd7c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pickerTabTextDefault: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-default",
        "defaultMessage": "My defaults"
    },
    pickerTabTextFilter: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-filter",
        "defaultMessage": "Filter"
    },
    pickerTabTextSystem: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-system",
        "defaultMessage": "System"
    }
});

});

parcelRegister("31uzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8091a14fe4b03ba7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $hH840 = parcelRequire("hH840");

var $8jv9r = parcelRequire("8jv9r");
const $8091a14fe4b03ba7$var$Tab = ({ label: label, maxWidth: maxWidth = '100%' })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eUqFw.useState)(false);
    const tabAttributes = (0, $hH840.useTab)();
    const onLabelRef = (0, $eUqFw.useCallback)((node)=>{
        if (node != null) {
            const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
            isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
        }
    }, [
        labelOverflows
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8091a14fe4b03ba7$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jv9r.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        ref: onLabelRef,
        xcss: $8091a14fe4b03ba7$var$textStyles
    }, label)));
};
const $8091a14fe4b03ba7$var$textStyles = (0, $8Vv3m.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8091a14fe4b03ba7$var$TabStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidthValue: maxWidthValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ocvhpw": (0, $9t7rW.default)(__cmplp.maxWidthValue)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fd0nw _vchhusvi",
            __cmplp.className
        ])
    });
});
var $8091a14fe4b03ba7$export$2e2bcd8739ae039 = $8091a14fe4b03ba7$var$Tab;

});
parcelRegister("8jv9r", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $e6120ff78736b217$export$d8abb7a1cfbd4b6b);

var $eUqFw = parcelRequire("eUqFw");

var $jl1we = parcelRequire("jl1we");
const $e6120ff78736b217$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});



parcelRegister("5hr6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $341a7b6c7d5fdcc5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $341a7b6c7d5fdcc5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    listSystemWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message",
        "defaultMessage": "Any changes here will modify columns for all users."
    },
    listFilterWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-filter-warning-message",
        "defaultMessage": "Any changes here will affect all users of this filter."
    },
    listNonEditableFilterInfoMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-non-editable-filter-info-message",
        "defaultMessage": "You can\u2019t modify this filter. Contact the owner using the <link>Filters directory</link> for edit permission."
    }
});

});


parcelRegister("hps0t", function(module, exports) {

$parcel$export(module.exports, "useFooterOverride", () => $8c3066532dc30771$export$d8b42fa25d3fad8c);
$parcel$export(module.exports, "Footer", () => $8c3066532dc30771$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jt8Db = parcelRequire("jt8Db");

var $iWDmo = parcelRequire("iWDmo");

var $cQBUE = parcelRequire("cQBUE");
const $8c3066532dc30771$export$d8b42fa25d3fad8c = (isFeedbackButtonDisabled)=>{
    const { isStalePage: isStalePage } = (0, $cQBUE.useIssueSearchQuery)();
    return (0, $eUqFw.useMemo)(()=>({ end: end, center: center, ...props })=>{
            let start;
            if (!isFeedbackButtonDisabled) start = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c3066532dc30771$var$FeedbackContainer, {
                "data-testid": "issue-navigator.ui.issue-results.list-view.footer.feedback-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWDmo.default), null));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt8Db.components).Footer, {
                ...props,
                start: start,
                // Do not show pagination controls while issue data is stale as page cursor information will be inaccurate
                center: isStalePage && props.isNewFooterOrderEnabled ? undefined : center,
                end: isStalePage && !props.isNewFooterOrderEnabled ? undefined : end
            });
        }, [
        isFeedbackButtonDisabled,
        isStalePage
    ]);
};
const $8c3066532dc30771$export$a06f1c675e846f6f = ({ end: end, center: center, ...props })=>{
    const { isStalePage: isStalePage } = (0, $cQBUE.useIssueSearchQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt8Db.components).Footer, {
        ...props,
        // Do not show pagination controls while issue data is stale as page cursor information will be inaccurate
        center: isStalePage && props.isNewFooterOrderEnabled ? undefined : center,
        end: isStalePage && !props.isNewFooterOrderEnabled ? undefined : end
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8c3066532dc30771$var$FeedbackContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jt8Db", function(module, exports) {

$parcel$export(module.exports, "components", () => $e1ef31792b343138$export$9b5ac10f59f76296);

var $PACdv = parcelRequire("PACdv");

var $5og2Q = parcelRequire("5og2Q");

var $6baW2 = parcelRequire("6baW2");
const $e1ef31792b343138$export$9b5ac10f59f76296 = {
    columnPicker: $PACdv.components,
    Footer: $5og2Q.Footer,
    NoColumns: $6baW2.NoColumns
};

});
parcelRegister("PACdv", function(module, exports) {

$parcel$export(module.exports, "components", () => $7fc1301f004ca79d$export$9b5ac10f59f76296);

var $eNBUj = parcelRequire("eNBUj");
const $7fc1301f004ca79d$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $eNBUj.default
};

});
parcelRegister("eNBUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $666689ae855bc618$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bpk0U = parcelRequire("bpk0U");

var $2Gub2 = parcelRequire("2Gub2");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $8rQuz = parcelRequire("8rQuz");

var $4EqNx = parcelRequire("4EqNx");
const $666689ae855bc618$var$IconContainerConditional = ({ children: children })=>{
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$IconContainer, null, children);
};
const $666689ae855bc618$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Gub2.default), {
        space: "space.150",
        xcss: $666689ae855bc618$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text"
    }, formatMessage((0, $4EqNx.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $4EqNx.default).noOptionsSecondaryMessage)), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$Container, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$StyledTitle, null, formatMessage((0, $4EqNx.default).title)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $666689ae855bc618$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($666689ae855bc618$var$IconContainerConditional, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpk0U))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            LEGACY_primaryColor: "currentColor"
        }))
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $666689ae855bc618$export$2e2bcd8739ae039 = $666689ae855bc618$var$NoOptionsMessage;
const $666689ae855bc618$var$stackStyles = (0, $8Vv3m.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $666689ae855bc618$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1e0c1txw _2lx21bp4 _4cvr1h6o _18s81gzt",
            __cmplp.className
        ])
    });
});
const $666689ae855bc618$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $666689ae855bc618$var$StyledTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4EqNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3788bf9c7aa987cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3788bf9c7aa987cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});



parcelRegister("5og2Q", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $99d3214e2e1df43d$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2U8YO = parcelRequire("2U8YO");

var $lyeLC = parcelRequire("lyeLC");
const $99d3214e2e1df43d$export$a06f1c675e846f6f = ({ start: start = $99d3214e2e1df43d$var$SpacerElement, center: center = $99d3214e2e1df43d$var$SpacerElement, end: end = $99d3214e2e1df43d$var$SpacerElement })=>{
    const { height: containerHeight, scrollTop: scrollTop } = (0, $2U8YO.useScrollState)();
    const { height: tableHeight } = (0, $lyeLC.useTableSize)();
    // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
    const hasShadow = containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99d3214e2e1df43d$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, start, center, end);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99d3214e2e1df43d$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _x3doi319 _1yt41b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $99d3214e2e1df43d$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $99d3214e2e1df43d$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($99d3214e2e1df43d$export$d7a54cba636a8cd6, null);

});
parcelRegister("2U8YO", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $93b1ae720a2f9e16$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $93b1ae720a2f9e16$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $eUqFw = parcelRequire("eUqFw");
const $93b1ae720a2f9e16$export$50b6b7783d156e1b = 200;
const $93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $93b1ae720a2f9e16$var$ScrollStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
const $93b1ae720a2f9e16$export$98084ad349e2edae = ()=>(0, $eUqFw.useContext)($93b1ae720a2f9e16$var$ScrollStateContext);
const $93b1ae720a2f9e16$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $93b1ae720a2f9e16$var$useElementScrollState = (scrollRef)=>{
    const [scrollState, setScrollState] = (0, $eUqFw.useState)($93b1ae720a2f9e16$var$INITIAL_SCROLL_STATE);
    (0, $eUqFw.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $93b1ae720a2f9e16$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $93b1ae720a2f9e16$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef
    ]);
    return scrollState;
};
const $93b1ae720a2f9e16$export$7cc0055278d35041 = ({ scrollRef: scrollRef, children: children })=>{
    const scrollState = $93b1ae720a2f9e16$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($93b1ae720a2f9e16$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("lyeLC", function(module, exports) {

$parcel$export(module.exports, "TableSizeProvider", () => $cd30c94ec98433e0$export$d5a5e307b6cc4da8);
$parcel$export(module.exports, "useTableSize", () => $cd30c94ec98433e0$export$95b939e430a260c);

var $eUqFw = parcelRequire("eUqFw");

var $3NMXU = parcelRequire("3NMXU");
const $cd30c94ec98433e0$var$TableSizeContext = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $3NMXU.DEFAULT_SIZE));
const $cd30c94ec98433e0$export$d5a5e307b6cc4da8 = ({ children: children, tableRef: tableRef })=>{
    const tableSize = (0, $3NMXU.useElementSize)(tableRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cd30c94ec98433e0$var$TableSizeContext.Provider, {
        value: tableSize
    }, children);
};
const $cd30c94ec98433e0$export$95b939e430a260c = ()=>(0, $eUqFw.useContext)($cd30c94ec98433e0$var$TableSizeContext);

});
parcelRegister("3NMXU", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SIZE", () => $e207dd03dc715dfb$export$e4c0458e30711294);
$parcel$export(module.exports, "useElementSize", () => $e207dd03dc715dfb$export$2b86bedf890eab8);

var $eUqFw = parcelRequire("eUqFw");
const $e207dd03dc715dfb$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $e207dd03dc715dfb$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $eUqFw.useState)($e207dd03dc715dfb$export$e4c0458e30711294);
    (0, $eUqFw.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};

});



parcelRegister("6baW2", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $8db98c71e6dd45e0$export$a0e9f6d02eee4aa4);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $lCjSV = parcelRequire("lCjSV");

var $80vF2 = parcelRequire("80vF2");

var $5JgJ2 = parcelRequire("5JgJ2");

var $532yW = parcelRequire("532yW");

var $jMP2a = parcelRequire("jMP2a");

var $kIdhg = parcelRequire("kIdhg");
const $8db98c71e6dd45e0$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isOpen: isOpen }, actions] = (0, $532yW.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCjSV.default), {
        header: formatMessage((0, $kIdhg.default).noColumnsHeaderText),
        description: formatMessage((0, $kIdhg.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $kIdhg.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("532yW", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $80222f4587dd1d1e$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $80222f4587dd1d1e$export$81588ffe8d9d4add);

var $WBLbN = parcelRequire("WBLbN");
const $80222f4587dd1d1e$export$e1286e1cb3fa0dec = (0, $WBLbN.createContainer)();
const $80222f4587dd1d1e$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $80222f4587dd1d1e$export$e1286e1cb3fa0dec
});
const $80222f4587dd1d1e$export$81588ffe8d9d4add = (0, $WBLbN.createHook)($80222f4587dd1d1e$var$Store);

});

parcelRegister("kIdhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $50d96196bc902630$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $50d96196bc902630$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});




parcelRegister("lJD7j", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $1af2b6094fb0a475$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $a1tkg = parcelRequire("a1tkg");

var $g6NWY = parcelRequire("g6NWY");

var $cQBUE = parcelRequire("cQBUE");
const $1af2b6094fb0a475$export$542fba90cc9c1bd1 = (issueCountProps)=>{
    const { isStalePage: isStalePage } = (0, $cQBUE.useIssueSearchQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1af2b6094fb0a475$var$IssueCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count",
        isFlexEnd: issueCountProps.isNewFooterOrderEnabled
    }, !isStalePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1tkg.default), issueCountProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6NWY.default), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1af2b6094fb0a475$var$IssueCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _k48pni7l _zulp1b66",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9flur", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2f8ef25d7837c6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a2f8ef25d7837c6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reorderColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    resetColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reset-columns-error-title",
        "defaultMessage": "We couldn't restore your default columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-navigator.issue-results.list-view.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    }
});

});

parcelRegister("iNqNA", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $b1056760b5970830$export$a0e9f6d02eee4aa4);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $lCjSV = parcelRequire("lCjSV");

var $80vF2 = parcelRequire("80vF2");

var $79xbN = parcelRequire("79xbN");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jt8Db = parcelRequire("jt8Db");

var $jMP2a = parcelRequire("jMP2a");

var $6vrw7 = parcelRequire("6vrw7");

var $6yplV = parcelRequire("6yplV");

var $4RwIp = parcelRequire("4RwIp");

var $c4vwn = parcelRequire("c4vwn");
const $b1056760b5970830$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, children);
const $b1056760b5970830$var$NoColumnsAnonymous = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setView: setView }] = (0, $4RwIp.useSelectedViewState)();
    const onClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton', {
            isAnon: true
        });
        setView('detail', (0, $6vrw7.toIssueKey)(''));
    }, [
        setView
    ]);
    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCjSV.default), {
        header: formatMessage((0, $c4vwn.default).noColumnsHeaderAnonymous),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            componentsMapping: {
                bold: $b1056760b5970830$var$Bold
            },
            message: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c4vwn.default).noColumnsDescriptionAnonymousIssueTermRefresh : (0, $c4vwn.default).noColumnsDescriptionAnonymous, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }),
        testId: "issue-navigator.ui.issue-results.list-view.no-columns.no-columns-anonymous",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $c4vwn.default).switchView)),
        renderImage: ()=>defaultNoColumnsGlyph
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        paddingBlock: "space.800"
    }, component);
};
const $b1056760b5970830$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1056760b5970830$var$NoColumnsAnonymous, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jt8Db.components).NoColumns, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph,
        hasColumnConfiguration: hasColumnConfiguration
    });
};

});
parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("c4vwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4704c705741385$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
var $fc4704c705741385$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noColumnsHeaderAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-header-anonymous",
        "defaultMessage": "The admin hasn't configured any columns"
    },
    noColumnsDescriptionAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    },
    switchView: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.switch-view",
        "defaultMessage": "Switch to detail view"
    },
    noColumnsDescriptionAnonymousIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous-issue-term-refresh",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    }
});

});


parcelRegister("2SicN", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $82e601460e1cf4fb$export$a7a61a727a1d891b);

var $eUqFw = parcelRequire("eUqFw");

var $lCjSV = parcelRequire("lCjSV");

var $80vF2 = parcelRequire("80vF2");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7FQZS = parcelRequire("7FQZS");
const $82e601460e1cf4fb$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCjSV.default), {
        header: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7FQZS.default).noIssuesIssueTermRefresh : (0, $7FQZS.default).noIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
    }));
};

});
parcelRegister("7FQZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae6434e3c0ef779$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0ae6434e3c0ef779$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.no-issues.no-issues-issue-term-refresh",
        "defaultMessage": "No issues were found matching your search"
    }
});

});


parcelRegister("50IaJ", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterShortcutDialogActions", () => $8d8fb817492edc15$export$53d5920188b673b6);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");
var $cH5zQ = parcelRequire("cH5zQ");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $7uVYl = parcelRequire("7uVYl");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8d8fb817492edc15$var$LazyRegisterShortcutDialogActions = (0, $dyfd9.lazy)(()=>(parcelRequire("ahvBI")), {
    moduleId: "./src/packages/issue-navigator/issue-navigator/src/ui/issue-results/list-view/register-shortcut-dialog-actions/index.tsx"
});
const $8d8fb817492edc15$export$53d5920188b673b6 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $7uVYl.useShortcuts)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigator",
        id: "register-issue-actions-worklflow-shortcuts-dialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cH5zQ.LazyWait), {
        until: isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8d8fb817492edc15$var$LazyRegisterShortcutDialogActions, props))));
};

});
parcelRegister("7uVYl", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $76686ee3e3d6a06c$export$b331ee6e87b9104c);

var $fvC6Z = parcelRequire("fvC6Z");
const $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb = ()=>(0, $fvC6Z.useShortcutsStore)();
const $76686ee3e3d6a06c$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fvC6Z.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fvC6Z", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $896347e3151ace81$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $896347e3151ace81$export$1a29bfef7fa09838);

var $WBLbN = parcelRequire("WBLbN");

var $4Dsz6 = parcelRequire("4Dsz6");
const $896347e3151ace81$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $896347e3151ace81$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $896347e3151ace81$export$d4c72bab9d6cc13a,
    actions: $4Dsz6
});
const $896347e3151ace81$export$a14646bfc7ba8d81 = (0, $WBLbN.createHook)($896347e3151ace81$export$6f57813fe9f31bf9);
const $896347e3151ace81$export$1a29bfef7fa09838 = (0, $WBLbN.createHook)($896347e3151ace81$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("4Dsz6", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $9eb9f475a5856f0f$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $9eb9f475a5856f0f$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $9eb9f475a5856f0f$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $9eb9f475a5856f0f$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $9eb9f475a5856f0f$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $9eb9f475a5856f0f$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $9eb9f475a5856f0f$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $9eb9f475a5856f0f$export$9cf39adf0dec984);

var $iVIEg = parcelRequire("iVIEg");

var $6QsdI = parcelRequire("6QsdI");

var $kh3b8 = parcelRequire("kh3b8");
const $9eb9f475a5856f0f$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $9eb9f475a5856f0f$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $9eb9f475a5856f0f$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $9eb9f475a5856f0f$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $9eb9f475a5856f0f$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $9eb9f475a5856f0f$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $6QsdI.default)();
        const shortcuts = result ? (0, $kh3b8.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $9eb9f475a5856f0f$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $9eb9f475a5856f0f$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("6QsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5b36ae9a64aed1$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dd5b36ae9a64aed1$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $2OdyW.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("kh3b8", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $978ed85a7f52065b$export$5f8c94ecd4c9eb76);
const $978ed85a7f52065b$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$978ed85a7f52065b$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("ahvBI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5Y6rG").then(()=>parcelRequire('a8WBO'));

});


parcelRegister("6Nns0", function(module, exports) {

$parcel$export(module.exports, "dragAndDropExperience", () => $30d1a995291bebbc$export$c1eb53e51d4d0ab3);

var $4zjEa = parcelRequire("4zjEa");
var $4s7r3 = parcelRequire("4s7r3");
const $30d1a995291bebbc$export$c1eb53e51d4d0ab3 = new (0, $4s7r3.UFOExperience)('jira-issue-navigator.list-view.drag-and-drop', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("1kw3p", function(module, exports) {

$parcel$export(module.exports, "useColumnWidthUpdater", () => $2f707ceb19c76471$export$e54397ae25183faf);

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cNy9K = parcelRequire("cNy9K");
const $2f707ceb19c76471$export$e54397ae25183faf = (connectionId)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    return (0, $eUqFw.useCallback)((columnId, width)=>{
        (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
            const fieldSetEdge = fieldSetEdges.find((edge)=>{
                const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                return columnId === fieldSetId;
            });
            if (!fieldSetEdge) return;
            const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
            if (!fieldSetNode) return;
            if (width == null) {
                fieldSetNode.setValue(null, 'fieldSetPreferences');
                return;
            }
            const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
            fieldSetPreferences.setValue(width, 'width');
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("8umcI", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $e8aaff74e3dd72e6$export$8ce912bc34d0dbea);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $6vrw7 = parcelRequire("6vrw7");

var $4w4xT = parcelRequire("4w4xT");

var $6FIwx = parcelRequire("6FIwx");

var $cQBUE = parcelRequire("cQBUE");

var $5qkO2 = parcelRequire("5qkO2");

var $7YJjT = parcelRequire("7YJjT");
const $e8aaff74e3dd72e6$var$useEventHandlersOld = ()=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $4w4xT.useSelectedIssueStateOldActions)();
    const { onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = (0, $cQBUE.useIssueSearchQuery)();
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $eUqFw.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(false, false, false);
            return;
        }
        setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKeyToSelect), false, false, false);
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $eUqFw.useCallback)((issueKey)=>{
        setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKey));
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};
const $e8aaff74e3dd72e6$var$useEventHandlersNew = (connectionId, fieldSetIds)=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $6FIwx.useSelectedIssueActions)();
    const onDeleteIssue = (0, $5qkO2.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $7YJjT.useIssueByFieldsRefetch)(fieldSetIds);
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $eUqFw.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue({
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: false
            });
            return;
        }
        setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKeyToSelect), {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: false
        });
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $eUqFw.useCallback)((issueKey)=>{
        setSelectedIssueByKey((0, $6vrw7.toIssueKey)(issueKey));
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};
const $e8aaff74e3dd72e6$export$8ce912bc34d0dbea = (connectionId, fieldSetIds)=>(0, $79xbN.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? $e8aaff74e3dd72e6$var$useEventHandlersNew(connectionId, fieldSetIds) : $e8aaff74e3dd72e6$var$useEventHandlersOld();

});



parcelRegister("lY5rz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f65bd1394a82c77$export$2e2bcd8739ae039);

var $hGnEz = parcelRequire("hGnEz");

var $jo4uT = parcelRequire("jo4uT");

var $jp8dr = parcelRequire("jp8dr");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dnIAN = parcelRequire("dnIAN");

var $4YE75 = parcelRequire("4YE75");

var $9nyrN = parcelRequire("9nyrN");

var $bmfQK = parcelRequire("bmfQK");

var $1NJeM = parcelRequire("1NJeM");

var $6FP8W = parcelRequire("6FP8W");

var $koU5J = parcelRequire("koU5J");

var $6yplV = parcelRequire("6yplV");

var $jK1pm = parcelRequire("jK1pm");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $651im = parcelRequire("651im");

var $jhYi6 = parcelRequire("jhYi6");

var $1iCRE = parcelRequire("1iCRE");

var $3mEVr = parcelRequire("3mEVr");

var $cQBUE = parcelRequire("cQBUE");

var $lvtWa = parcelRequire("lvtWa");

var $ky48h = parcelRequire("ky48h");

var $lxqp4 = parcelRequire("lxqp4");

var $fIVib = parcelRequire("fIVib");

var $9Vqzg = parcelRequire("9Vqzg");
const $6f65bd1394a82c77$var$JQLBuilderWrapper = ({ defaultJql: defaultJql, onFilterSave: onFilterSave, onReset: onReset, onChangeJql: onChangeJql, onToggleAi: onToggleAi, issueResults: issueResults, filter: filter, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey })=>{
    const { startJqlBuilderMetric: startJqlBuilderMetric, stopJqlBuilderMetric: stopJqlBuilderMetric, markJqlBuilderMetric: markJqlBuilderMetric } = (0, $fIVib.useJqlBuilderInstrumentation)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        startJqlBuilderMetric();
        markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_START);
    }, [
        startJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const { query: query, onSearch: onSearch } = (0, $jhYi6.useJqlSearch)(onChangeJql);
    const { jql: jql, filterJql: filterJql, filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    let jqlErrors;
    const { isFetching: isFetching } = (0, $cQBUE.useIssueSearchQuery)();
    const issueResultsData = (0, $iWLL0.useFragment)((0, $jp8dr.default), issueResults);
    const issueSearchError = issueResultsData?.issueSearchError ?? null;
    if (issueSearchError && !isFetching) {
        if (issueSearchError.__typename === 'JiraInvalidJqlError') jqlErrors = issueSearchError.messages?.filter((0, $3wKQY.isNonNullish)).map((message)=>({
                type: 'error',
                message: message
            })) ?? [];
        else if (issueSearchError.__typename === 'JiraInvalidSyntaxError' && issueSearchError.message != null) jqlErrors = [
            {
                type: 'error',
                message: issueSearchError.message,
                errorType: issueSearchError.errorType ?? undefined
            }
        ];
    }
    const filterData = (0, $iWLL0.useFragment)((0, $jo4uT.default), filter);
    const ResetButtonControl = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxqp4.default), {
            onReset: onReset
        }), [
        onReset
    ]);
    const GoBackToFilterButtonControl = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxqp4.default), {
            onReset: onReset,
            isResetToFilter: true
        }), [
        onReset
    ]);
    const SaveFilterControl = (0, $eUqFw.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $koU5J.AsyncSaveFilterDialog), {
            jql: query,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $1NJeM.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $lvtWa.default).saveFilterButton),
            title: formatMessage((0, $lvtWa.default).saveFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        formatMessage
    ]);
    const SaveFilterDropdownControl = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-dropdown-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnIAN.SaveFilterDropdown), {
            query: query,
            filterId: filterId,
            onFilterSave: onFilterSave
        })), [
        filterId,
        query,
        onFilterSave
    ]);
    const CopyFilterControl = (0, $eUqFw.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.copy-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $koU5J.AsyncSaveFilterDialog), {
            jql: query,
            filterId: filterId,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $1NJeM.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $lvtWa.default).copyFilterButton),
            title: formatMessage((0, $lvtWa.default).copyFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        filterId,
        formatMessage
    ]);
    const renderFilterControls = (0, $eUqFw.useCallback)(()=>{
        const extraControls = []; // Button nor dropdown should be shown when user is anonymous
        if (!isAnonymous) {
            if (filterData) {
                const { isEditable: isEditable } = filterData; // Should not show neither the button nor the dropdown if jql errors
                if (!jqlErrors || jqlErrors.length === 0) {
                    if ((0, $9Vqzg.isFilterJqlModified)({
                        filterJql: filterJql,
                        query: query
                    })) {
                        if (isEditable === true) extraControls.push(SaveFilterDropdownControl);
                        else extraControls.push(SaveFilterControl);
                    } else extraControls.push(CopyFilterControl);
                }
            } else extraControls.push(SaveFilterControl);
        }
        return extraControls;
    }, [
        CopyFilterControl,
        SaveFilterControl,
        SaveFilterDropdownControl,
        filterData,
        filterJql,
        isAnonymous,
        jqlErrors,
        query
    ]);
    const renderExtraControls = (0, $eUqFw.useCallback)(()=>{
        const extraControls = [];
        const showResetButton = (0, $9Vqzg.isOnlyJqlAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $9Vqzg.isOnlyFilterAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $9Vqzg.filterAndJqlIsTheSameAndDifferentToDefault)(jql, defaultJql, filterJql);
        const showGoBackToFilterButton = (0, $9Vqzg.jqlIsDifferentToFilter)(jql, filterJql);
        const addResetButton = ()=>showGoBackToFilterButton || showResetButton;
        if (addResetButton()) extraControls.push(showResetButton ? ResetButtonControl : GoBackToFilterButtonControl);
        extraControls.push(...renderFilterControls());
        return extraControls;
    }, [
        renderFilterControls,
        jql,
        defaultJql,
        filterJql,
        ResetButtonControl,
        GoBackToFilterButtonControl
    ]);
    let jqlMessages = (0, $eUqFw.useMemo)(()=>[
            ...jqlErrors || []
        ], [
        jqlErrors
    ]);
    const { messages: jqlInfos } = (0, $1iCRE.useJqlSearchStatus)({
        query: query,
        isSearching: isFetching
    });
    jqlMessages = (0, $eUqFw.useMemo)(()=>[
            ...jqlErrors || [],
            ...jqlInfos || []
        ], [
        jqlErrors,
        jqlInfos
    ]);
    const onLoad = (0, $eUqFw.useCallback)((mode)=>{
        if (mode === (0, $1NJeM.SEARCH_MODE_BASIC)) markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_BASIC_START);
        else markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_ADVANCED_START);
    }, [
        markJqlBuilderMetric
    ]);
    const onReady = (0, $eUqFw.useCallback)((mode)=>{
        if (mode === (0, $1NJeM.SEARCH_MODE_BASIC)) {
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_BASIC_END);
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_END);
        } else {
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_ADVANCED_END);
            markJqlBuilderMetric((0, $cWCvn.marks).JQL_BUILDER_END);
        }
        stopJqlBuilderMetric();
    }, [
        stopJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const aiBuilderOverrides = (0, $eUqFw.useMemo)(()=>({
            // Only render filter controls (no reset action) for the AI embedded JQL builder
            renderExtraControls: renderFilterControls
        }), [
        renderFilterControls
    ]); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const jqlBuilderWithAiData = (0, $iWLL0.useFragment)((0, $hGnEz.default), jqlBuilderWithAiKey); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const { onJourneyStart: onJourneyStart } = (0, $651im.useAppContextualAnalyticsActions)();
    const handlePerformanceMark = (0, $eUqFw.useCallback)(({ mark: mark })=>{
        markJqlBuilderMetric(mark);
    }, [
        markJqlBuilderMetric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: [
            $6f65bd1394a82c77$var$wrapperStyles,
            (0, $6FP8W.getWillShowNav4)() && $6f65bd1394a82c77$var$newWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YE75.ShortcutsDialogIntegrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmfQK.default), {
        analyticsSource: (0, $jccNB.ANALYTICS_SOURCE),
        query: query,
        onSearch: onSearch,
        renderExtraControls: renderExtraControls,
        jqlMessages: jqlMessages,
        isSearching: isFetching,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        NoOptionComponent: (0, $ky48h.NoOptionsMessage),
        aiBuilderOverrides: aiBuilderOverrides,
        onToggleAi: onToggleAi,
        fragmentKey: jqlBuilderWithAiData,
        onPerformanceMark: handlePerformanceMark,
        ...jqlBuilderProps
    })));
};
const $6f65bd1394a82c77$var$JQLBuilderWrapperWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-navigator-jql-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "ui.jql-builder.error-boundary",
        packageName: (0, $jccNB.PACKAGE_NAME),
        teamName: (0, $jccNB.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $1lXFP.isLoaderErrorAttributes),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nyrN.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f65bd1394a82c77$var$JQLBuilderWrapper, props)));
var $6f65bd1394a82c77$export$2e2bcd8739ae039 = $6f65bd1394a82c77$var$JQLBuilderWrapperWithErrorBoundary;
const $6f65bd1394a82c77$var$wrapperStyles = (0, $8Vv3m.xcss)({
    marginTop: 'space.negative.025',
    marginBottom: 'space.0'
});
const $6f65bd1394a82c77$var$newWrapperStyles = (0, $8Vv3m.xcss)({
    flexGrow: 'var(--jql-wrapper-grow, 0)',
    maxHeight: 'min-content'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f65bd1394a82c77$var$SaveFilterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hGnEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f52c5f65b4554ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96f197ee49bffef91f88aabc89058cb4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f52c5f65b4554ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI"
        }
    ],
    "type": "JiraQuery"
};
$6f52c5f65b4554ea$var$node.hash = "dd0aae667d7d92a8112c28d2dcff0ac8";
var $6f52c5f65b4554ea$export$2e2bcd8739ae039 = $6f52c5f65b4554ea$var$node;

});

parcelRegister("jo4uT", function(module, exports) {

$parcel$export(module.exports, "default", () => $514d6e5abaa080b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a76e30faae7fd3f790cc395215820217>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $514d6e5abaa080b6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$514d6e5abaa080b6$var$node.hash = "46b543f50c73d7423957a8ecbe71b627";
var $514d6e5abaa080b6$export$2e2bcd8739ae039 = $514d6e5abaa080b6$var$node;

});

parcelRegister("jp8dr", function(module, exports) {

$parcel$export(module.exports, "default", () => $949dba300a9ed3b9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3182e66785e68d12090ebb9bf08695e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $949dba300a9ed3b9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$949dba300a9ed3b9$var$node.hash = "eeb59c3a307dc75263f7e39b4f314c7c";
var $949dba300a9ed3b9$export$2e2bcd8739ae039 = $949dba300a9ed3b9$var$node;

});

parcelRegister("dnIAN", function(module, exports) {

$parcel$export(module.exports, "SaveFilterDropdown", () => $82ed147ba143086e$export$4aae2fedc7924eed);

var $ZJZN4 = parcelRequire("ZJZN4");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $lUg8E = parcelRequire("lUg8E");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $3yGlo = parcelRequire("3yGlo");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6JZkO = parcelRequire("6JZkO");

var $hZPqL = parcelRequire("hZPqL");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $iqKE7 = parcelRequire("iqKE7");

var $gd0Sp = parcelRequire("gd0Sp");

var $30zCP = parcelRequire("30zCP");

var $15Iby = parcelRequire("15Iby");
const $82ed147ba143086e$export$a3ca021e3e6c7315 = (0, $eo17r.toFlagId)('issue-navigator-save-filter-success-flag');
const $82ed147ba143086e$export$f5e4c120ac01b615 = (0, $eo17r.toFlagId)('issue-navigator-save-filter-error-flag');
const $82ed147ba143086e$export$4aae2fedc7924eed = ({ defaultOpen: defaultOpen = false, filterId: filterId, query: query, onFilterSave: onFilterSave })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [updateJiraCustomFilterJqlMutation] = (0, $iWLL0.useMutation)((0, $ZJZN4.default));
    const { activationId: activationId, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const onSaveChanges = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterChanges');
        filterId !== undefined && updateJiraCustomFilterJqlMutation({
            variables: {
                id: (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                jql: query
            },
            onCompleted: ({ jira: jira })=>{
                if (jira?.jiraFilterMutation?.updateJiraCustomFilterJql) {
                    const { success: success, filter: filter, errors: jiraErrors } = jira?.jiraFilterMutation?.updateJiraCustomFilterJql;
                    if (success && filter) {
                        const { name: name } = filter;
                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                            actionSubject: 'issueFilterJql',
                            action: 'updated'
                        }), 'issueFilterJql updated');
                        showFlag({
                            id: $82ed147ba143086e$export$a3ca021e3e6c7315,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZPqL.SuccessFlag), {
                                    id: $82ed147ba143086e$export$a3ca021e3e6c7315,
                                    filterName: name,
                                    viewUrl: `${window.location.origin}/issues/?filter=${filterId}`,
                                    analyticsEvent: createAnalyticsEvent({
                                        actionSubject: 'button',
                                        action: 'clicked'
                                    }),
                                    ...renderProps
                                })
                        });
                    } else {
                        const errors = jiraErrors ? jiraErrors.map((error)=>error.message || '') : [];
                        showFlag({
                            id: $82ed147ba143086e$export$f5e4c120ac01b615,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6JZkO.ErrorFlag), {
                                    id: $82ed147ba143086e$export$f5e4c120ac01b615,
                                    errors: errors,
                                    ...renderProps
                                })
                        });
                        (0, $guiFP.default)({
                            event: analyticsEvent,
                            error: new Error(errors[0]),
                            meta: {
                                id: 'updateFilterJqlMutation',
                                packageName: 'jiraIssueNavigatorCustomFilters',
                                teamName: 'empanada'
                            }
                        });
                    }
                }
            },
            onError: (error)=>{
                showFlag({
                    id: $82ed147ba143086e$export$f5e4c120ac01b615,
                    render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6JZkO.ErrorFlag), {
                            id: $82ed147ba143086e$export$f5e4c120ac01b615,
                            ...renderProps,
                            errors: [
                                ''
                            ]
                        })
                });
                (0, $guiFP.default)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'updateFilterJqlMutation',
                        packageName: 'jiraIssueNavigatorCustomFilters',
                        teamName: 'empanada'
                    }
                });
                return undefined;
            }
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        filterId,
        query,
        showFlag,
        updateJiraCustomFilterJqlMutation,
        analyticsEvent
    ]);
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eUqFw.useState)(defaultOpen);
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eUqFw.useState)(false);
    const onOpenSaveFilterModal = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterCopy');
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        setIsModalOpen
    ]);
    const onCloseSaveFilterModal = (0, $eUqFw.useCallback)(()=>{
        setIsModalOpen(false);
    }, [
        setIsModalOpen
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'filterOptions');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $30zCP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82ed147ba143086e$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
            if (attrs.isOpen) {
                setShouldShowThirdPartyNudge(true);
                onTriggerClick();
            }
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                ...props,
                appearance: "link",
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yGlo))), {
                    label: formatMessage((0, $15Iby.default).saveFilter)
                })
            }, formatMessage((0, $15Iby.default).saveFilter))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0IEe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        onClick: onSaveChanges
    }, formatMessage((0, $15Iby.default).saveChanges)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        onClick: onOpenSaveFilterModal
    }, formatMessage((0, $15Iby.default).saveAsACopy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqKE7.AsyncSaveFilterDialogContent), {
        isOpen: isModalOpen,
        jql: query,
        filterId: filterId,
        onCloseModal: onCloseSaveFilterModal,
        onFilterSave: onFilterSave,
        title: formatMessage((0, $15Iby.default).copyFilterDialogTitle)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82ed147ba143086e$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k4hekqvv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ZJZN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ef22570a00bb6d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfa68958cffd28f839eb1cc1261ee729>>
 * @relayHash a8b99d4e5148c557424db90f1be8215c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5
const $72ef22570a00bb6d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterMutation",
                    "kind": "LinkedField",
                    "name": "jiraFilterMutation",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "id"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jql",
                                            "variableName": "jql"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "input"
                                }
                            ],
                            "concreteType": "JiraUpdateCustomFilterJqlPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraCustomFilterJql",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraCustomFilter",
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5",
            "metadata": {},
            "name": "mainUpdateFilterJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$72ef22570a00bb6d$var$node.hash = "6807efed6a00f60f9cf95df455e467fd";
var $72ef22570a00bb6d$export$2e2bcd8739ae039 = $72ef22570a00bb6d$var$node;

});

parcelRegister("5E6sS", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ac3c3a7e824635$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5bNY = parcelRequire("b5bNY");

var $azeZS = parcelRequire("azeZS");

var $hFzXe = parcelRequire("hFzXe");

var $iCgyP = parcelRequire("iCgyP");

var $gYrJM = parcelRequire("gYrJM");

var $lKNwt = parcelRequire("lKNwt");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $35ac3c3a7e824635$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $lKNwt.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFzXe.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCgyP.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $b5bNY.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $gYrJM.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $35ac3c3a7e824635$export$2e2bcd8739ae039 = $35ac3c3a7e824635$var$DropdownMenuItem;

});

parcelRegister("e0IEe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3df5a6f567feefa8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2Pede = parcelRequire("2Pede");

var $cUyTA = parcelRequire("cUyTA");

var $f8stz = parcelRequire("f8stz");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $3df5a6f567feefa8$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $2Pede.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cUyTA.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8stz.default), {
        id: titleId,
        title: title
    }), children);
});
var $3df5a6f567feefa8$export$2e2bcd8739ae039 = $3df5a6f567feefa8$var$DropdownMenuItemGroup;

});

parcelRegister("6JZkO", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $c338baed813df983$export$518ba8e0e60f145f);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aCt1E = parcelRequire("aCt1E");
const $c338baed813df983$export$518ba8e0e60f145f = ({ id: id, errors: errors })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onDismissed = (0, $eUqFw.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    const description = (0, $eUqFw.useMemo)(()=>errors.reduce((desc, error)=>`${desc}\n${error}`), [
        errors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
        id: (0, $eo17r.fromFlagId)(id),
        onDismissed: onDismissed,
        title: formatMessage((0, $aCt1E.default).flagTitle),
        description: description
    });
};

});
parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $dyfd9.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("5eqyk")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $dyfd9.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $dyfd9.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("eWPgg")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("5eqyk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cCYJs")
]).then(()=>parcelRequire('kbpOk'));

});

parcelRegister("eWPgg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hkLGi").then(()=>parcelRequire('jkRT2'));

});



parcelRegister("aCt1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $0995f9c4fca26c6a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0995f9c4fca26c6a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.error-flag.flag-title",
        "defaultMessage": "Filter couldn't be saved"
    }
});

});


parcelRegister("hZPqL", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $eb5b20020abc7bb0$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $guiFP = parcelRequire("guiFP");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $iUwiu = parcelRequire("iUwiu");
const $eb5b20020abc7bb0$export$93bd4963a1d00fd5 = ({ id: id, filterName: filterName, viewUrl: viewUrl, analyticsEvent: analyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [isCopied, setCopied] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eUqFw.useCallback)(()=>{
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            navigator.clipboard.writeText(viewUrl);
            setCopied(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'copyLink');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueNavigatorActionsCommon'
                }
            });
        }
    }, [
        analyticsEvent,
        viewUrl
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>{
        const flagActions = [];
        flagActions.push({
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5b20020abc7bb0$var$CopySuccess, null, formatMessage((0, $iUwiu.default).copyActionCopied)) : formatMessage((0, $iUwiu.default).copyAction),
            onClick: copyToClipboard
        });
        return flagActions;
    }, [
        copyToClipboard,
        formatMessage,
        isCopied
    ]);
    const onDismissed = (0, $eUqFw.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
        id: (0, $eo17r.fromFlagId)(id),
        onDismissed: onDismissed,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb5b20020abc7bb0$var$WordBreakSpan, null, formatMessage((0, $iUwiu.default).flagTitle, {
            name: filterName
        })),
        description: formatMessage((0, $iUwiu.default).flagDescription),
        actions: actions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb5b20020abc7bb0$var$CopySuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazocqs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb5b20020abc7bb0$var$WordBreakSpan = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $eb5b20020abc7bb0$export$7ed12d2a5241e393 = {
    WordBreakSpan: $eb5b20020abc7bb0$var$WordBreakSpan
};

});
parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("iUwiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a18514a929def759$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a18514a929def759$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.success-flag.flag-title",
        "defaultMessage": "\"{name}\" filter saved"
    },
    flagDescription: {
        "id": "issue-navigator-actions-common.success-flag.flag-description",
        "defaultMessage": "We\u2019ve saved this filter successfully."
    },
    viewAction: {
        "id": "issue-navigator-actions-common.success-flag.view-action",
        "defaultMessage": "View filter"
    },
    copyAction: {
        "id": "issue-navigator-actions-common.success-flag.copy-action",
        "defaultMessage": "Copy link"
    },
    copyActionCopied: {
        "id": "issue-navigator-actions-common.success-flag.copy-action-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("iqKE7", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialogContent", () => $5e58e676a807fa79$export$e0d40cb0f88fa57d);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5e58e676a807fa79$var$SaveFilterDialogContent = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("1Pvq5")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/save-filter-dialog-content/index.tsx"
});
const $5e58e676a807fa79$export$e0d40cb0f88fa57d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-save-filters-dialog-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e58e676a807fa79$var$SaveFilterDialogContent, props));

});
parcelRegister("1Pvq5", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("95k46")
]).then(()=>parcelRequire('7Vs69'));

});


parcelRegister("30zCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e168f88652a1d6a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $jVAsY = parcelRequire("jVAsY");
const $e168f88652a1d6a7$var$runtimeProps = {};
const $e168f88652a1d6a7$var$entryPointParams = {};
const $e168f88652a1d6a7$var$AsyncThirdPartyNudge = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $jVAsY.thirdPartyNudgeEntryPoint), $e168f88652a1d6a7$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "third-party-nudge-spotlight",
        packageName: "third-party-nudge",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $e168f88652a1d6a7$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $e168f88652a1d6a7$export$2e2bcd8739ae039 = $e168f88652a1d6a7$var$AsyncThirdPartyNudge;

});
parcelRegister("jVAsY", function(module, exports) {

$parcel$export(module.exports, "thirdPartyNudgeEntryPoint", () => $c2947bce8d5fa853$export$b751b31b276f613a);

var $14fpI = parcelRequire("14fpI");

var $4dIH4 = parcelRequire("4dIH4");

const $c2947bce8d5fa853$export$b751b31b276f613a = (0, $4dIH4.createEntryPoint)({
    root: (0, $14fpI.JSResourceForInteraction)(()=>(parcelRequire("dTCkQ")), {
        moduleId: "3cb7fd8f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("dTCkQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hpb4o")
]).then(()=>parcelRequire('eslmU'));

});



parcelRegister("15Iby", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2566ce00f75555f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d2566ce00f75555f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    saveFilter: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-filter",
        "defaultMessage": "Save filter"
    },
    saveChanges: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-changes",
        "defaultMessage": "Save changes"
    },
    saveAsACopy: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-as-a-copy",
        "defaultMessage": "Save as a copy"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});


parcelRegister("4YE75", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $83eabdb2c34080b3$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $83eabdb2c34080b3$export$97e3ca22c7078b46);

var $eUqFw = parcelRequire("eUqFw");
const $83eabdb2c34080b3$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $83eabdb2c34080b3$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $eUqFw.createContext)($83eabdb2c34080b3$var$PRESET_VALUE.DEFAULT);
const $83eabdb2c34080b3$export$705d46354f301b1c = ()=>(0, $eUqFw.useContext)($83eabdb2c34080b3$var$IntegrateDotDialogContext);
const $83eabdb2c34080b3$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83eabdb2c34080b3$var$IntegrateDotDialogContext.Provider, {
        value: $83eabdb2c34080b3$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("9nyrN", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $315a69b85d231334$export$4c766016a5659721);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $lxsI7 = parcelRequire("lxsI7");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ca8j6 = parcelRequire("ca8j6");
const $315a69b85d231334$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $315a69b85d231334$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxsI7.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $ca8j6.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                appearance: "link",
                spacing: "none",
                onClick: $315a69b85d231334$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("ca8j6", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d3bbe30a896926$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $23d3bbe30a896926$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("bmfQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $125fdf7977b70517$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $gGtKh = parcelRequire("gGtKh");

var $9Yk2t = parcelRequire("9Yk2t");

const $125fdf7977b70517$var$JQLBuilderWithAIAsync = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("j9gJN")), {
    moduleId: "./src/packages/jql-builder/with-ai/src/index.tsx"
});
const $125fdf7977b70517$var$JQLBuilderWithAI = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Yk2t.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($125fdf7977b70517$var$JQLBuilderWithAIAsync, props));
var $125fdf7977b70517$export$2e2bcd8739ae039 = $125fdf7977b70517$var$JQLBuilderWithAI;

});
parcelRegister("9Yk2t", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $2f16dd0eb8999180$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $gk7BR = parcelRequire("gk7BR");
const $2f16dd0eb8999180$var$customCssStyles = null;
const $2f16dd0eb8999180$var$containerStyles = {
    height: '52px'
};
const $2f16dd0eb8999180$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gk7BR))),
        containerStyles: $2f16dd0eb8999180$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("gk7BR", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("j9gJN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("1PcxX")
]).then(()=>parcelRequire('4jxSo'));

});


parcelRegister("koU5J", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialog", () => $d84a4fd590a13eb3$export$2213da0eee0aa8f);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $lUg8E = parcelRequire("lUg8E");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d84a4fd590a13eb3$var$SaveFilterDialog = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("9w70D")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/main.tsx"
});
const $d84a4fd590a13eb3$export$2213da0eee0aa8f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "save-filters-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "link",
            isDisabled: true
        }, props.buttonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d84a4fd590a13eb3$var$SaveFilterDialog, props));

});
parcelRegister("9w70D", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hv5Q6").then(()=>parcelRequire('1IGnv'));

});


parcelRegister("jhYi6", function(module, exports) {

$parcel$export(module.exports, "useJqlSearch", () => $66794e0241f9da0f$export$e69d0de2e354a2cb);

var $eUqFw = parcelRequire("eUqFw");

var $3mEVr = parcelRequire("3mEVr");

var $cQBUE = parcelRequire("cQBUE");
const $66794e0241f9da0f$export$e69d0de2e354a2cb = (changeJql)=>{
    const query = (0, $3mEVr.useResolvedJql)();
    const { onIssueSearch: onIssueSearch } = (0, $cQBUE.useIssueSearchQuery)();
    const onSearch = (0, $eUqFw.useCallback)((jql)=>{
        if (jql === query) // This will execute a new search against the network with current JQL input arguments
        onIssueSearch();
        else changeJql && changeJql(jql);
    }, [
        query,
        onIssueSearch,
        changeJql
    ]);
    return {
        onSearch: onSearch,
        query: query
    };
};

});

parcelRegister("1iCRE", function(module, exports) {

$parcel$export(module.exports, "useJqlSearchStatus", () => $9cfafdf73b327933$export$6d36bd77a6aeafd9);

var $1oZFL = parcelRequire("1oZFL");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $guiFP = parcelRequire("guiFP");

var $bBGpO = parcelRequire("bBGpO");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $dWLk9 = parcelRequire("dWLk9");

var $eUeMJ = parcelRequire("eUeMJ");
const $9cfafdf73b327933$export$529d2e9d8e9d3cad = 2000; // wait 2s before making the request
const $9cfafdf73b327933$export$bbec15ef0a4926b6 = 7000; // wait 7s before retrying after the previous request
const $9cfafdf73b327933$export$cf31b3fd6a57249f = 5; // Check the status no more than 5 times for the same JQL search
const $9cfafdf73b327933$export$2b91517d6d5b4365 = (0, $1oZFL.default);
const $9cfafdf73b327933$var$statusToMessages = (status, formatMessage)=>{
    if (status == null || !('functions' in status) || !Array.isArray(status?.functions)) return [];
    const processing = status.functions.filter((fn)=>fn.app && fn.function && fn.status === 'PROCESSING');
    const functions = Array.from(new Set(processing.map((fn)=>fn.function)));
    const apps = Array.from(new Set(processing.map((fn)=>fn.app)));
    switch(functions.length){
        case 0:
            return [];
        case 1:
            {
                const message = formatMessage((0, $eUeMJ.default).singleSlowForgeFunction, {
                    functionName: functions[0],
                    appName: apps[0]
                });
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
        default:
            {
                let message;
                switch(apps.length){
                    case 1:
                        message = formatMessage((0, $eUeMJ.default).multipleSlowForgeFunctionsFromTheSameApp, {
                            appName: apps[0]
                        });
                        break;
                    case 2:
                        message = formatMessage((0, $eUeMJ.default).multipleSlowForgeFunctionsTwoApps, {
                            appName1: apps[0],
                            appName2: apps[1]
                        });
                        break;
                    default:
                        message = formatMessage((0, $eUeMJ.default).multipleSlowForgeFunctionsThreeApps, {
                            appName1: apps[0],
                            appName2: apps[1],
                            appName3: apps[2]
                        });
                }
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
    }
};
const $9cfafdf73b327933$var$analyticsMeta = {
    id: 'jqlSearchStatus',
    packageName: 'jiraIssueNavigator',
    teamName: 'empanada'
};
const $9cfafdf73b327933$export$6d36bd77a6aeafd9 = ({ query: query, isSearching: isSearching })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [statusMessages, setStatusMessages] = (0, $eUqFw.useState)([]);
    const isSearchingRef = (0, $eUqFw.useRef)(isSearching);
    const timeoutRef = (0, $eUqFw.useRef)(null);
    const fetchCountRef = (0, $eUqFw.useRef)(0);
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const fireOperationalEvent = (0, $eUqFw.useCallback)((action, attributes)=>(0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$9cfafdf73b327933$var$analyticsMeta.packageName}.${$9cfafdf73b327933$var$analyticsMeta.id} ${action}`, attributes), [
        createAnalyticsEvent
    ]);
    const cancelPendingOperations = (0, $eUqFw.useCallback)(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
        fetchCountRef.current = 0;
    }, []);
    const scheduleSearchStatusFetch = (0, $eUqFw.useCallback)((delay)=>{
        const isRetry = delay === $9cfafdf73b327933$export$bbec15ef0a4926b6;
        const defaultAnalyticsAttributes = (0, $bBGpO.createAttributes)({
            isRetry: isRetry
        });
        const timeout = setTimeout(()=>{
            if (fetchCountRef.current >= $9cfafdf73b327933$export$cf31b3fd6a57249f) {
                fireOperationalEvent('interrupted', {
                    ...defaultAnalyticsAttributes,
                    reason: 'MAX_ATTEMPTS_REACHED'
                });
                return;
            }
            fireOperationalEvent('attempt', defaultAnalyticsAttributes);
            fetchCountRef.current += 1;
            (0, $iWLL0.fetchQuery)(environment, $9cfafdf73b327933$export$2b91517d6d5b4365, {
                cloudId: cloudId,
                jql: query
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((data)=>{
                let hasPendingFn = false;
                const status = data?.jira?.issueSearchStatus ?? null;
                if (isSearchingRef.current && timeoutRef.current === timeout) {
                    const infos = $9cfafdf73b327933$var$statusToMessages(status, formatMessage);
                    setStatusMessages(infos);
                    if (infos.length) {
                        hasPendingFn = true;
                        scheduleSearchStatusFetch($9cfafdf73b327933$export$bbec15ef0a4926b6);
                    }
                }
                fireOperationalEvent('finished', {
                    ...defaultAnalyticsAttributes,
                    hasPendingFn: hasPendingFn
                });
            }).catch((error)=>{
                (0, $guiFP.default)({
                    meta: $9cfafdf73b327933$var$analyticsMeta,
                    attributes: (0, $bBGpO.createAttributes)({
                        error: error,
                        isRetry: isRetry
                    })
                });
                if (isSearchingRef.current && timeoutRef.current === timeout) scheduleSearchStatusFetch($9cfafdf73b327933$export$bbec15ef0a4926b6);
            });
        }, delay);
        timeoutRef.current = timeout;
    }, [
        cloudId,
        environment,
        fireOperationalEvent,
        formatMessage,
        query
    ]);
    (0, $eUqFw.useEffect)(()=>{
        isSearchingRef.current = isSearching;
    }, [
        isSearching
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setStatusMessages([]);
        cancelPendingOperations();
        if (isSearching) scheduleSearchStatusFetch($9cfafdf73b327933$export$529d2e9d8e9d3cad);
    }, [
        isSearching,
        query,
        cancelPendingOperations,
        scheduleSearchStatusFetch
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            messages: statusMessages
        }), [
        statusMessages
    ]);
};

});
parcelRegister("1oZFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af6e61027191353$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8
const $4af6e61027191353$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jql",
                            "variableName": "jql"
                        }
                    ],
                    "concreteType": "JiraIssueSearchStatus",
                    "kind": "LinkedField",
                    "name": "issueSearchStatus",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraJqlFunctionProcessingStatus",
                            "kind": "LinkedField",
                            "name": "functions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "function"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "app"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
            "metadata": {},
            "name": "jqlSearchStatus_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4af6e61027191353$var$node.hash = "9dd1bed08ceb0d25df132f36097ae6d1";
var $4af6e61027191353$export$2e2bcd8739ae039 = $4af6e61027191353$var$node;

});

parcelRegister("eUeMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e3bc230e6b13e32$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e3bc230e6b13e32$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    singleSlowForgeFunction: {
        "id": "issue-navigator.controllers.jql-search-status.single-slow-forge-function",
        "defaultMessage": "{appName} is still executing the {functionName} JQL function."
    },
    multipleSlowForgeFunctionsFromTheSameApp: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-from-the-same-app",
        "defaultMessage": "{appName} is still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsTwoApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-two-apps",
        "defaultMessage": "{appName1} and {appName2} are still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsThreeApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-three-apps",
        "defaultMessage": "{appName1}, {appName2}, and {appName3} are still executing multiple JQL functions."
    }
});

});


parcelRegister("lvtWa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bec88e3bc2ce5b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c0bec88e3bc2ce5b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    saveFilterButton: {
        "id": "issue-navigator.jql-builder.save-filter-button",
        "defaultMessage": "Save filter"
    },
    saveFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.save-filter-dialog-title",
        "defaultMessage": "Save filter"
    },
    copyFilterButton: {
        "id": "issue-navigator.jql-builder.copy-filter-button",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});

parcelRegister("ky48h", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $0d80a3e896d1d6ab$export$d58b72b7d3c4072c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bpk0U = parcelRequire("bpk0U");

var $80vF2 = parcelRequire("80vF2");
var $2Gub2 = parcelRequire("2Gub2");
var $1JJay = parcelRequire("1JJay");
var $8Vv3m = parcelRequire("8Vv3m");


var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $l6liB = parcelRequire("l6liB");
const $0d80a3e896d1d6ab$var$IconContainer = ({ children: children })=>{
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd"
        ])
    }, children);
};
const $0d80a3e896d1d6ab$var$MessageContainer = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((0, $8rQuz.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Gub2.default), {
        space: "space.150",
        xcss: $0d80a3e896d1d6ab$var$stackStyles,
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text"
    }, formatMessage((0, $l6liB.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $l6liB.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $0d80a3e896d1d6ab$var$boxStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        className: (0, $7JEyt.default)([
            "_18s861nu _1i4qfg65"
        ])
    }, formatMessage((0, $l6liB.default).fieldNotFoundMessage)));
};
const $0d80a3e896d1d6ab$export$d58b72b7d3c4072c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d80a3e896d1d6ab$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d80a3e896d1d6ab$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpk0U))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $1b343b038f6c23ec$export$f563ee71e9ee74cd)})`
    })));
};
const $0d80a3e896d1d6ab$var$boxStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingBottom: 'space.100',
    color: 'color.text.subtle',
    textAlign: 'center'
});
const $0d80a3e896d1d6ab$var$stackStyles = (0, $8Vv3m.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100'
});
const $0d80a3e896d1d6ab$var$titleStyles = null;
const $0d80a3e896d1d6ab$var$iconContainerStyles = null;

});
parcelRegister("l6liB", function(module, exports) {

$parcel$export(module.exports, "default", () => $786821dc27223105$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $786821dc27223105$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldNotFoundMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.field-not-found-message",
        "defaultMessage": "We couldn't find the field you are looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("lxqp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $24e7033b9949a5f8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lUg8E = parcelRequire("lUg8E");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $9szUL = parcelRequire("9szUL");
const $24e7033b9949a5f8$export$2491f201e3dd9acf = ({ onReset: onReset, isResetToFilter: isResetToFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnReset = (0, $eUqFw.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, isResetToFilter ? 'goBackToFilterButton' : 'resetButton', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onReset && onReset(isResetToFilter);
    }, [
        onReset,
        isResetToFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($24e7033b9949a5f8$var$ResetButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        testId: "issue-navigator.ui.jql-builder.reset-button",
        appearance: "subtle-link",
        onClick: handleOnReset
    }, formatMessage(isResetToFilter ? (0, $9szUL.default).goBackToFilterButtonText : (0, $9szUL.default).resetButtonText)));
};
var $24e7033b9949a5f8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $24e7033b9949a5f8$export$2491f201e3dd9acf;
const $24e7033b9949a5f8$var$ResetButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _i0dlf1ug _p12fuuw1 _4cvr1h6o _4t3izwfg _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9szUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $79b1f16661332645$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79b1f16661332645$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    resetButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.reset-button-text",
        "defaultMessage": "Reset"
    },
    goBackToFilterButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text",
        "defaultMessage": "Go back to filter"
    }
});

});


parcelRegister("fIVib", function(module, exports) {

$parcel$export(module.exports, "useJqlBuilderInstrumentation", () => $d3279b7fae25be36$export$42691712ca1334f9);

var $eUqFw = parcelRequire("eUqFw");

var $jBY8A = parcelRequire("jBY8A");

var $cWCvn = parcelRequire("cWCvn");
const $d3279b7fae25be36$export$42691712ca1334f9 = ()=>{
    const [finished, setFinished] = (0, $eUqFw.useState)(false);
    return (0, $eUqFw.useMemo)(()=>({
            startJqlBuilderMetric: ()=>{
                if (finished) return;
                (0, $cWCvn.NINJqlBuilderAsyncLoad).start();
            },
            stopJqlBuilderMetric: ()=>{
                setFinished(true);
                (0, $cWCvn.NINJqlBuilderAsyncLoad).stop({
                    customData: {
                        ...(0, $jBY8A.getIssueNavigatorFFAndFG)()
                    }
                });
            },
            markJqlBuilderMetric: (mark)=>{
                if (finished) return;
                (0, $cWCvn.markOnce)(mark);
            }
        }), [
        finished
    ]);
};

});

parcelRegister("9Vqzg", function(module, exports) {

$parcel$export(module.exports, "isOnlyJqlAndDifferentToDefault", () => $b7aa2d396541c474$export$3cfc4f52186efe7d);
$parcel$export(module.exports, "isOnlyFilterAndDifferentToDefault", () => $b7aa2d396541c474$export$933470cfeba275aa);
$parcel$export(module.exports, "filterAndJqlIsTheSameAndDifferentToDefault", () => $b7aa2d396541c474$export$a25fc74cc3fc7015);
$parcel$export(module.exports, "jqlIsDifferentToFilter", () => $b7aa2d396541c474$export$7dfcf59726e2b396);
$parcel$export(module.exports, "isFilterJqlModified", () => $b7aa2d396541c474$export$d3d543997ba807);
const $b7aa2d396541c474$export$3cfc4f52186efe7d = (jqlParam, defaultJqlTerm, filterParam)=>filterParam === undefined && jqlParam !== undefined && jqlParam.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $b7aa2d396541c474$export$933470cfeba275aa = (jqlParam, defaultJqlTerm, filterJqlTerm)=>filterJqlTerm !== undefined && jqlParam === undefined && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $b7aa2d396541c474$export$a25fc74cc3fc7015 = (jqlParam, defaultJqlTerm, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && jqlParam.toLowerCase() === filterJqlTerm.toLowerCase() && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $b7aa2d396541c474$export$7dfcf59726e2b396 = (jqlParam, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && filterJqlTerm.toLowerCase() !== jqlParam.toLowerCase();
const $b7aa2d396541c474$export$d3d543997ba807 = ({ query: query, filterJql: filterJql })=>filterJql !== undefined && query.toLowerCase().trim() !== filterJql.toLowerCase().trim();

});


parcelRegister("5nM3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8036252460072f62$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8036252460072f62$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    screenReaderSearchResultInfo: {
        "id": "issue-navigator.screen-reader-search-result-info",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfo: {
        "id": "issue-navigator.screen-reader-search-result-more-info",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    },
    screenReaderSearchResultInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-more-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    }
});

});

parcelRegister("fWUVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab509f176aabbb45$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $9aFSa = parcelRequire("9aFSa");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $7uVYl = parcelRequire("7uVYl");
const $ab509f176aabbb45$var$RegisterDotShortcut = ()=>{
    const [, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $7uVYl.useShortcutsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { open: open } = (0, $gCtL7.useActionsCommandPalette)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            '.': {
                callback: ()=>{
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'pressed',
                        actionSubject: 'keyboardShortcut'
                    }), 'dotDialogKeyboardShortcut', {
                        keyPressed: '.',
                        keyboardShortcut: true
                    });
                    if ((0, $1ybV0.ff)('compal-dot-menu-shortcut-integration_dvvg2')) open();
                    else requestAnimationFrame(()=>setShortcutsDialogVisibility(true));
                }
            }
        }
    });
};
var $ab509f176aabbb45$export$2e2bcd8739ae039 = $ab509f176aabbb45$var$RegisterDotShortcut;

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $9139bfe8dcd2ea64$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $WBLbN.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $WBLbN.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$a18633b655403b12 = (0, $WBLbN.createStateHook)($9139bfe8dcd2ea64$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $WBLbN.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $48b165edb54974f4$export$894e19fc96687503);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));
const $48b165edb54974f4$export$894e19fc96687503 = 250;

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $7Rgho = parcelRequire("7Rgho");

var $kGAxV = parcelRequire("kGAxV");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $476b965ceb7c28b6$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $kGAxV.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $7Rgho.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $kGAxV.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $kGAxV.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $7Rgho.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride,
    setHasPopupOverlay: $476b965ceb7c28b6$var$setHasPopupOverlay,
    forceSearchValue: $476b965ceb7c28b6$var$forceSearchValue,
    resetShouldForceSearchValue: $476b965ceb7c28b6$var$resetShouldForceSearchValue
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});




parcelRegister("7QBK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $41f70f312155455f$export$2e2bcd8739ae039);

var $aA57L = parcelRequire("aA57L");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $cHJdq = parcelRequire("cHJdq");

var $6qOIw = parcelRequire("6qOIw");

var $3wKQY = parcelRequire("3wKQY");

var $4RwIp = parcelRequire("4RwIp");
const $41f70f312155455f$var$IssueNavigatorSpotlight = ({ hasIssueResults: hasIssueResults, userPreferences: userPreferences, isAiEnabled: isAiEnabled })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const searchModeResponse = (0, $iWLL0.useFragment)((0, $aA57L.default), userPreferences);
    const selectedSearchMode = (0, $6qOIw.toSearchModeWithBasicModeFallback)(searchModeResponse?.jqlBuilderSearchMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cHJdq.NinChangeboardingTourCard), {
        mode: selectedSearchMode,
        view: (0, $3wKQY.convertToView)(view),
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
var $41f70f312155455f$export$2e2bcd8739ae039 = $41f70f312155455f$var$IssueNavigatorSpotlight;

});
parcelRegister("aA57L", function(module, exports) {

$parcel$export(module.exports, "default", () => $0407ea6c48c420f0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30a8994404dfcae5d894d268d148ffe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0407ea6c48c420f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlight_issueNavigator_IssueNavigatorSpotlight",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$0407ea6c48c420f0$var$node.hash = "3c8e72948beb901cccd7a6650610b18e";
var $0407ea6c48c420f0$export$2e2bcd8739ae039 = $0407ea6c48c420f0$var$node;

});

parcelRegister("6qOIw", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $696ac313915d0aeb$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $696ac313915d0aeb$export$32a166cc1b3e6927);

var $1NJeM = parcelRequire("1NJeM");
function $696ac313915d0aeb$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $1NJeM.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $1NJeM.SEARCH_MODE_ADVANCED;
        default:
            return 0, $1NJeM.DEFAULT_SEARCH_MODE;
    }
}
function $696ac313915d0aeb$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $1NJeM.SEARCH_MODE_ADVANCED:
            return 0, $1NJeM.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $1NJeM.SERVER_SEARCH_MODE_BASIC;
    }
}

});


parcelRegister("jTcpY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7376c7651fab5b35$export$2e2bcd8739ae039);

var $bZ8IY = parcelRequire("bZ8IY");

var $5Mqjb = parcelRequire("5Mqjb");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $1lXFP = parcelRequire("1lXFP");

var $4ACoF = parcelRequire("4ACoF");

var $6FP8W = parcelRequire("6FP8W");

var $idiDE = parcelRequire("idiDE");

var $jccNB = parcelRequire("jccNB");

var $kmXw8 = parcelRequire("kmXw8");

var $3mEVr = parcelRequire("3mEVr");

var $dCaOY = parcelRequire("dCaOY");
const $7376c7651fab5b35$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $7376c7651fab5b35$var$styles = {
    jqlWrapper: "_5ynfkb7n"
};
const $7376c7651fab5b35$var$TopBar = ({ ActionMenu: ActionMenu, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jqlBuilder: jqlBuilder })=>{
    const issueResultsData = (0, $iWLL0.useFragment)((0, $5Mqjb.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $7376c7651fab5b35$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $eUqFw.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $3mEVr.useActiveJql)();
    const jql = (0, $3mEVr.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $dCaOY.useFilterQuery)();
    const filterData = (0, $iWLL0.useFragment)((0, $bZ8IY.default), filter);
    const filterDetails = (0, $eUqFw.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderSkeletonImage, null);
    const pageTopBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ACoF.PageTopBar), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionMenu, {
            jql: jql,
            filterId: filterId,
            filterDetails: filterDetails,
            searchResultPageData: searchResultPageData
        }),
        bottomBar: jqlBuilder
    });
    if ((0, $6FP8W.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "top-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            $7376c7651fab5b35$var$styles.jqlWrapper
        ])
    }, pageTopBar));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
        name: "top-bar"
    }, pageTopBar);
};
var $7376c7651fab5b35$export$2e2bcd8739ae039 = (0, $kmXw8.withReportErrors)($7376c7651fab5b35$var$TopBar, {
    id: 'ui.topbar.unhandled',
    packageName: (0, $jccNB.PACKAGE_NAME),
    teamName: (0, $jccNB.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $1lXFP.isLoaderErrorAttributes)
});

});
parcelRegister("bZ8IY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8bec0b9cf48557$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ab7c2a8b5f9d7e53e2eda0626fb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b8bec0b9cf48557$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$4b8bec0b9cf48557$var$node.hash = "d1fd34a229f9cb2668ab6793af284885";
var $4b8bec0b9cf48557$export$2e2bcd8739ae039 = $4b8bec0b9cf48557$var$node;

});

parcelRegister("5Mqjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e7b544c29aaa08$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<222e07e55baf5ff3dcc37bb6cbd7a80e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1e7b544c29aaa08$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "topBar_issueNavigator_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$d1e7b544c29aaa08$var$node.hash = "52b4c743e436bc90ea0831559f2c3e48";
var $d1e7b544c29aaa08$export$2e2bcd8739ae039 = $d1e7b544c29aaa08$var$node;

});

parcelRegister("4ACoF", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $d74ce2d0cb0e9587$export$7e5801dc91bf1819);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $2Rsl6 = parcelRequire("2Rsl6");
var $8Vv3m = parcelRequire("8Vv3m");

var $3a8wJ = parcelRequire("3a8wJ");

var $6FP8W = parcelRequire("6FP8W");

var $8rQuz = parcelRequire("8rQuz");

const $d74ce2d0cb0e9587$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        testId: (0, $0b51e3566777dd51$export$90c4434a1e138106),
        xcss: [
            (0, $8rQuz.isVisualRefreshEnabled)() ? $d74ce2d0cb0e9587$var$wrapperStyles : $d74ce2d0cb0e9587$var$wrapperStylesOld,
            wrapAtMd ? $d74ce2d0cb0e9587$var$wrapAtMdStyle : $d74ce2d0cb0e9587$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        testId: (0, $0b51e3566777dd51$export$1742330ac6a668f0),
        xcss: [
            $d74ce2d0cb0e9587$var$actionsBoxStyles,
            wrapAtMd && $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $d74ce2d0cb0e9587$export$7e5801dc91bf1819 = (props)=>(0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d74ce2d0cb0e9587$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), props);
const $d74ce2d0cb0e9587$var$noWrapStyle = (0, $8Vv3m.xcss)({
    flexWrap: 'nowrap'
});
const $d74ce2d0cb0e9587$var$wrapAtMdStyle = (0, $8Vv3m.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $2Rsl6.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $d74ce2d0cb0e9587$var$wrapperStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.250',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $2Rsl6.media).above.md]: {
        gap: 'space.300'
    }
});
const $d74ce2d0cb0e9587$var$wrapperStylesOld = (0, $8Vv3m.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $2Rsl6.media).above.md]: {
        gap: 'space.300'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles = (0, $8Vv3m.xcss)({
    flex: '1 1 auto',
    [(0, $2Rsl6.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxStyles = (0, $8Vv3m.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4PvVz = parcelRequire("4PvVz");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PvVz.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4PvVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f9724b566053b5$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $j1iGE = parcelRequire("j1iGE");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $79f9724b566053b5$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1iGE.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $79f9724b566053b5$export$2e2bcd8739ae039 = $79f9724b566053b5$var$PageHeader;

});
parcelRegister("j1iGE", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $db0664a0dfc3f21a$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $db0664a0dfc3f21a$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $db0664a0dfc3f21a$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $db0664a0dfc3f21a$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $db0664a0dfc3f21a$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $db0664a0dfc3f21a$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
function $db0664a0dfc3f21a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $db0664a0dfc3f21a$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $db0664a0dfc3f21a$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $db0664a0dfc3f21a$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $db0664a0dfc3f21a$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $db0664a0dfc3f21a$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $db0664a0dfc3f21a$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $db0664a0dfc3f21a$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $db0664a0dfc3f21a$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $db0664a0dfc3f21a$var$bottomBarStyles = (0, $8Vv3m.xcss)({
    marginBlockStart: 'space.200'
});
const $db0664a0dfc3f21a$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $db0664a0dfc3f21a$var$outerStyles
    }, children);
};
const $db0664a0dfc3f21a$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $db0664a0dfc3f21a$var$titleStyles,
            truncateTitle && $db0664a0dfc3f21a$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $db0664a0dfc3f21a$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $db0664a0dfc3f21a$var$titleWrapperStyles,
            truncateTitle && $db0664a0dfc3f21a$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $db0664a0dfc3f21a$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $db0664a0dfc3f21a$var$titleContainerStyles,
            truncateTitle && $db0664a0dfc3f21a$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $db0664a0dfc3f21a$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $db0664a0dfc3f21a$var$actionStyles
    }, children);
};
const $db0664a0dfc3f21a$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
        xcss: $db0664a0dfc3f21a$var$bottomBarStyles
    }, children);
};

});



const $0b51e3566777dd51$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $0b51e3566777dd51$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';




parcelRegister("jSaIj", function(module, exports) {

$parcel$export(module.exports, "SelectedIssue", () => $3f5e339c45e240b0$export$39b2b4a30505b395);

var $avdkm = parcelRequire("avdkm");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $6vrw7 = parcelRequire("6vrw7");

var $3wKQY = parcelRequire("3wKQY");

var $7Lvuw = parcelRequire("7Lvuw");

var $4RwIp = parcelRequire("4RwIp");

var $j3TLk = parcelRequire("j3TLk");
const $3f5e339c45e240b0$export$39b2b4a30505b395 = ({ children: children, issues: issues, selectedIssueKey: selectedIssueKey, onChange: onChange })=>{
    const [{ view: view }] = (0, $4RwIp.useSelectedViewState)();
    const searchKey = (0, $j3TLk.useSearchKey)();
    const issueData = (0, $iWLL0.useFragment)((0, $avdkm.default), issues);
    const issueKeys = (0, $eUqFw.useMemo)(()=>issueData?.edges?.map((edge)=>(0, $6vrw7.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issueData?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Lvuw.SelectedIssueContainer), {
        view: (0, $3wKQY.convertToView)(view),
        issueKeys: issueKeys,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        onChange: onChange
    }, children);
};

});
parcelRegister("avdkm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe11c593798853d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861c6a2b5276ec2a8b6ba119835e232f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3fe11c593798853d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssue_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$3fe11c593798853d$var$node.hash = "966aa39a272d43746556adcb1b54c0d8";
var $3fe11c593798853d$export$2e2bcd8739ae039 = $3fe11c593798853d$var$node;

});


parcelRegister("jtc88", function(module, exports) {

$parcel$export(module.exports, "SelectedViewContainer", () => $d826fbbe01eb4d3f$export$6e497a97feb37da2);

var $11JEn = parcelRequire("11JEn");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $4RwIp = parcelRequire("4RwIp");

var $cQBUE = parcelRequire("cQBUE");
const $d826fbbe01eb4d3f$export$6e497a97feb37da2 = ({ children: children, onSetView: onSetView, fragment: fragment })=>{
    const { onIssueSearchForView: onIssueSearchForView } = (0, $cQBUE.useIssueSearchQuery)();
    const data = (0, $iWLL0.useFragment)((0, $11JEn.default), fragment);
    const view = (0, $3wKQY.parseIssueNavigatorViewIdOrDefault)(data?.viewId, (0, $jccNB.DEFAULT_VIEW_ID));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RwIp.Container), {
        view: view,
        onSetView: onSetView,
        onIssueSearchForView: onIssueSearchForView
    }, children);
};

});
parcelRegister("11JEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3caf38b095a9e5ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<499d1dce901e38fe101d2fe7b923ec33>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3caf38b095a9e5ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "viewId"
        }
    ],
    "type": "JiraIssueSearchView"
};
$3caf38b095a9e5ea$var$node.hash = "7715cf1d3aecd1efc3d771f2f7af4bf4";
var $3caf38b095a9e5ea$export$2e2bcd8739ae039 = $3caf38b095a9e5ea$var$node;

});



parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("5palF")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("iFQsc")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("10YNr")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("cVR9C")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5palF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kd6Ju").then(()=>parcelRequire('appSk'));

});

parcelRegister("iFQsc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("5eFqM")
]).then(()=>parcelRequire('ddfk6'));

});

parcelRegister("10YNr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ahRif")
]).then(()=>parcelRequire('1HvEW'));

});

parcelRegister("cVR9C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("cxrYi")
]).then(()=>parcelRequire('f9sDQ'));

});


parcelRegister("1j7Qw", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorHeaderSkeleton", () => $f88dc949a4a496fb$export$28359b78c47abc93);
/* project-header.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8ICxF = parcelRequire("8ICxF");

var $ixagD = parcelRequire("ixagD");
const $f88dc949a4a496fb$var$customCssStyles = null;
const $f88dc949a4a496fb$var$containerStyles = {
    height: '104px'
};
const $f88dc949a4a496fb$export$28359b78c47abc93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ixagD))),
        containerStyles: $f88dc949a4a496fb$var$containerStyles,
        className: (0, $7JEyt.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("ixagD", function(module, exports) {
module.exports = new URL("project-issue-navigator-header-skeleton.tpl.7e712bab.svg", import.meta.url).toString();

});


parcelRegister("2smFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a75bbb3848b365f$export$2e2bcd8739ae039);

var $fbAb9 = parcelRequire("fbAb9");

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $jl1we = parcelRequire("jl1we");

var $c76ap = parcelRequire("c76ap");

var $dpXKE = parcelRequire("dpXKE");

var $3a8wJ = parcelRequire("3a8wJ");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5as0a = parcelRequire("5as0a");

var $5qdh2 = parcelRequire("5qdh2");

var $5lWFW = parcelRequire("5lWFW");

var $euIkl = parcelRequire("euIkl");

var $gGtKh = parcelRequire("gGtKh");

var $fbAb9 = parcelRequire("fbAb9");

var $dWLk9 = parcelRequire("dWLk9");

var $6yplV = parcelRequire("6yplV");

var $fWW8M = parcelRequire("fWW8M");

var $bnHey = parcelRequire("bnHey");

var $iAfyy = parcelRequire("iAfyy");
const $9a75bbb3848b365f$export$49640514ca453805 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a75bbb3848b365f$var$FilterTitleTooltipTagStyled, {
        ref: ref,
        ...props
    }));
const $9a75bbb3848b365f$var$ProjectBreadcrumbWithData = ({ queryReference: queryReference, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.usePreloadedQuery)((0, $fbAb9.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $fWW8M.default).windowTitleMigration, {
            projectName: projectName
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: "",
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)));
};
const $9a75bbb3848b365f$var$BreadcrumbFallback = ({ projectKey: projectKey, projectName: projectName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: "",
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null));
const $9a75bbb3848b365f$var$Header = ({ projectKey: projectKey, jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $fbAb9.default));
    const cloudId = (0, $dWLk9.useCloudId)();
    (0, $eUqFw.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    const heading = formatMessage((0, $fWW8M.default).heading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "page-header",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a75bbb3848b365f$var$BreadcrumbFallback, {
                projectKey: projectKey,
                projectName: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "ui.project-name-query.boundary",
            packageName: "projectIssueNavigator",
            teamName: "empanada",
            sendToPrivacyUnsafeSplunk: true,
            attributes: (0, $1lXFP.isLoaderErrorAttributes),
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a75bbb3848b365f$var$BreadcrumbFallback, {
                    projectKey: projectKey,
                    projectName: projectKey
                })
        }, queryReference !== null && queryReference !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a75bbb3848b365f$var$ProjectBreadcrumbWithData, {
            queryReference: queryReference,
            projectKey: projectKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a75bbb3848b365f$var$BreadcrumbFallback, {
            projectKey: projectKey,
            projectName: ""
        }))),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnHey.default), {
            jql: jql,
            filterId: filterId,
            isModifiedFilter: filterDetails?.jql !== jql,
            searchResultPageData: searchResultPageData,
            isQuickFiltersDisabled: isQuickFiltersDisabled
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iAfyy.HeaderContentWrapper), null, (0, $5as0a.isFilterId)(filterId) && filterDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: filterDetails.name,
        tag: $9a75bbb3848b365f$export$49640514ca453805,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9a75bbb3848b365f$var$FilterTitleTooltipContent, null, filterDetails.name)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $euIkl.FavoriteButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $euIkl.FavoriteButton), {
        filterId: filterDetails.filterId,
        isFavoriteInitial: filterDetails.isFavourite
    })), (0, $5as0a.isCustomFilter)(filterDetails.filterId) && filterId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5lWFW.DetailsButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qdh2.DetailsPopup), {
        filterId: filterId
    }))) : heading)));
};
const $9a75bbb3848b365f$var$MemoHeader = /*#__PURE__*/ (0, $eUqFw.memo)($9a75bbb3848b365f$var$Header);
var $9a75bbb3848b365f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9a75bbb3848b365f$var$MemoHeader;
const $9a75bbb3848b365f$var$FilterTitleTooltipTagStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9a75bbb3848b365f$var$FilterTitleTooltipContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fbAb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $11367ba041175bcd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67e071a33cf45c408e850b759f06d544>>
 * @relayHash 2dcb74ffdda96ee8a118627d99d348d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19
const $11367ba041175bcd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19",
            "metadata": {},
            "name": "mainProjectNameQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$11367ba041175bcd$var$node.hash = "fca14514ec7cc9e866219e1ef4f3f1e9";
var $11367ba041175bcd$export$2e2bcd8739ae039 = $11367ba041175bcd$var$node;

});

parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("5qdh2", function(module, exports) {

$parcel$export(module.exports, "DetailsPopup", () => $dd9f51978c814b26$export$b61797ace80c3d8);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $eruWR = parcelRequire("eruWR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $hZHX2 = parcelRequire("hZHX2");

var $48xaL = parcelRequire("48xaL");

var $daaJ8 = parcelRequire("daaJ8");

const $dd9f51978c814b26$export$b61797ace80c3d8 = ({ filterId: filterId, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(defaultOpen);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'filterDetailsButton');
    }, [
        isOpen,
        setIsOpen
    ]);
    const [isEditFilterModalOpen, setIsEditFilterModalOpen] = (0, $eUqFw.useState)(false);
    const onOpenEditFilterModal = (0, $eUqFw.useCallback)(()=>{
        setIsEditFilterModalOpen(true);
        onClose();
    }, [
        onClose
    ]);
    const onCloseEditFilterModal = (0, $eUqFw.useCallback)(()=>{
        setIsEditFilterModalOpen(false);
    }, []);
    const Content = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $daaJ8.PopupContent), {
            ...props,
            onOpenEditFilterModal: onOpenEditFilterModal,
            onOpenNewSubscriptionModal: onClose,
            filterId: filterId
        }), [
        filterId,
        onClose,
        onOpenEditFilterModal
    ]);
    const Trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            ...props,
            appearance: "link",
            onClick: onTriggerClick,
            isSelected: isOpen,
            onMouseOver: (0, $daaJ8.preloadPopupContentComponent),
            testId: "issue-navigator-custom-filters.ui.details-popup.button"
        }, formatMessage((0, $48xaL.default).filterDetails)), [
        isOpen,
        onTriggerClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hZHX2.AsyncUpdateFilterDialog), {
        filterId: filterId,
        onCloseModal: onCloseEditFilterModal,
        isOpen: isEditFilterModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        content: Content,
        trigger: Trigger,
        testId: "issue-navigator-custom-filters.ui.details-popup.popup"
    }));
};

});
parcelRegister("hZHX2", function(module, exports) {

$parcel$export(module.exports, "AsyncUpdateFilterDialog", () => $b7de3f9465739c07$export$8692e2751472dade);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b7de3f9465739c07$var$UpdateFilterDialog = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("6aIHJ")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/update-filter-dialog/index.tsx"
});
const $b7de3f9465739c07$export$8692e2751472dade = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-update-filter-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7de3f9465739c07$var$UpdateFilterDialog, props));

});
parcelRegister("6aIHJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hYbSO")
]).then(()=>parcelRequire('2CYNQ'));

});


parcelRegister("48xaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a662e9a3c30efdb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1a662e9a3c30efdb$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    filterDetails: {
        "id": "issue-navigator-custom-filters.details-popup.filter-details",
        "defaultMessage": "Filter details"
    }
});

});

parcelRegister("daaJ8", function(module, exports) {

$parcel$export(module.exports, "preloadPopupContentComponent", () => $5d8df9b2f1f656ce$export$c115357d632001d1);
$parcel$export(module.exports, "PopupContent", () => $5d8df9b2f1f656ce$export$2a2c7ba12d3231e3);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $bBdMg = parcelRequire("bBdMg");

var $gGtKh = parcelRequire("gGtKh");

var $fzfah = parcelRequire("fzfah");

var $hLyIA = parcelRequire("hLyIA");

var $bHDAF = parcelRequire("bHDAF");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5d8df9b2f1f656ce$var$LazyPopupContent = (0, $dyfd9.lazy)(()=>Promise.resolve((parcelRequire("bHDAF"))), {
    moduleId: "./src/packages/issue-navigator/custom-filters/src/ui/details-popup/popup-content/index.tsx"
});
const $5d8df9b2f1f656ce$export$c115357d632001d1 = ()=>$5d8df9b2f1f656ce$var$LazyPopupContent.preload();
const $5d8df9b2f1f656ce$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bHDAF.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), null));
const $5d8df9b2f1f656ce$export$2a2c7ba12d3231e3 = (props)=>{
    (0, $fzfah.useUFOComponentExperience)((0, $hLyIA.viewDetailsPopupExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "popup-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d8df9b2f1f656ce$var$LoadingFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d8df9b2f1f656ce$var$LazyPopupContent, props));
};

});
parcelRegister("fzfah", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $4a2246ca40329390$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $4a2246ca40329390$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $4a2246ca40329390$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $4a2246ca40329390$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("hLyIA", function(module, exports) {

$parcel$export(module.exports, "viewDetailsPopupExperience", () => $f9f6413bd9b715bd$export$54c37dd263cb6171);
$parcel$export(module.exports, "viewNewSubscriptionModal", () => $f9f6413bd9b715bd$export$1584a1158c503c0a);

var $4zjEa = parcelRequire("4zjEa");
var $4s7r3 = parcelRequire("4s7r3");
const $f9f6413bd9b715bd$export$54c37dd263cb6171 = new (0, $4s7r3.UFOExperience)('jira-issue-navigator.custom-filters.view-details-popup', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).PageSegmentLoad
});
const $f9f6413bd9b715bd$export$1584a1158c503c0a = new (0, $4s7r3.UFOExperience)('jira-issue-navigator.custom-filters.details-popup.view-new-subscription-modal', {
    type: (0, $4zjEa.ExperienceTypes).Experience,
    performanceType: (0, $4zjEa.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("bHDAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PopupContent", () => $656fba84bd179ccb$export$2a2c7ba12d3231e3);
$parcel$export(module.exports, "ContentWrapper", () => $656fba84bd179ccb$export$6ce170286acaa8d3);
$parcel$export(module.exports, "default", () => $656fba84bd179ccb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LoadingWrapper", () => $656fba84bd179ccb$export$43a792a870d28db2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $huI7r = parcelRequire("huI7r");

var $8WuJm = parcelRequire("8WuJm");

var $2WfMW = parcelRequire("2WfMW");

var $4rWQe = parcelRequire("4rWQe");

var $dWLk9 = parcelRequire("dWLk9");

var $6yplV = parcelRequire("6yplV");


var $hLyIA = parcelRequire("hLyIA");

var $iCDb4 = parcelRequire("iCDb4");

var $31XX4 = parcelRequire("31XX4");
const $656fba84bd179ccb$export$2a2c7ba12d3231e3 = ({ filterId: filterId, ...props })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const activationId = (0, $4rWQe.useActivationId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const filterAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'filter',
            resourceId: filterId,
            activationId: activationId
        }), [
        filterId,
        activationId,
        cloudId
    ]);
    const [queryReference, loadQuery, disposeQuery] = (0, $iWLL0.useQueryLoader)((0, $2WfMW.default));
    (0, $eUqFw.useEffect)(()=>{
        (0, $hLyIA.viewDetailsPopupExperience).start();
        loadQuery({
            filterAri: filterAri,
            isAnonymous: isAnonymous
        });
        return disposeQuery;
    }, [
        loadQuery,
        filterAri,
        isAnonymous,
        disposeQuery
    ]);
    const onRetry = (0, $eUqFw.useCallback)(()=>{
        loadQuery({
            filterAri: filterAri,
            isAnonymous: isAnonymous
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        loadQuery,
        filterAri,
        isAnonymous
    ]);
    const ErrorFallback = (0, $eUqFw.useCallback)((errorStateProps)=>{
        (0, $hLyIA.viewDetailsPopupExperience).failure();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCDb4.ErrorState), {
            ...errorStateProps,
            onRetry: onRetry
        });
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "filterDetails",
        sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($656fba84bd179ccb$export$6ce170286acaa8d3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "DetailsPopupContentWrapper",
        packageName: (0, $3e27b2158b878ad6$export$ad257a98f20ee631),
        teamName: "empanada",
        fallback: ErrorFallback,
        key: queryReference?.fetchKey
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $31XX4.PopupContent), {
        ...props,
        queryReference: queryReference,
        onSuccess: onRetry
    }) : null)));
};
var $656fba84bd179ccb$export$2e2bcd8739ae039 = $656fba84bd179ccb$export$2a2c7ba12d3231e3;
const $656fba84bd179ccb$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1vif _1yt4v47k _1reo1wug _18m91wug _c71lqdd9",
            __cmplp.className
        ])
    });
});
const $656fba84bd179ccb$export$43a792a870d28db2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $656fba84bd179ccb$export$6ce170286acaa8d3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2WfMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8afcbab42633374$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cabde37d42247daed0f55869eb5b6fd9>>
 * @relayHash 9f4cdfd24c4837edbec911e81f56cc4c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d
const $b8afcbab42633374$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v5 /*: any*/ 
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v2 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v10 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "description_issueNavigatorCustomFilters"
                                                },
                                                {
                                                    "condition": "isAnonymous",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "owner_issueNavigatorCustomFilters"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "subscriptions_issueNavigatorCustomFilters"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "permissions_issueNavigatorCustomFilters"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.filter"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityShareGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "shareGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityEditGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "editGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isAnonymous",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "last",
                                                            "value": 5
                                                        }
                                                    ],
                                                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "emailSubscriptions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFilterEmailSubscriptionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFilterEmailSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "emailSubscriptions(last:5)"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d",
            "metadata": {},
            "name": "mainPopupContentFilterByAriQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b8afcbab42633374$var$node.hash = "0d557f612ff494f70f6caa72336c5a34";
var $b8afcbab42633374$export$2e2bcd8739ae039 = $b8afcbab42633374$var$node;

});

const $3e27b2158b878ad6$export$ad257a98f20ee631 = 'jiraIssueNavigatorCustomFilters';

parcelRegister("iCDb4", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $69a6e204ab391229$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cBaEp = parcelRequire("cBaEp");

var $2eEdW = parcelRequire("2eEdW");
const $69a6e204ab391229$export$c1ed4f415b9e7023 = ({ error: error, onRetry: onRetry, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        ...props,
        onRetry: onRetry,
        description: formatMessage((0, $2eEdW.default).errorMessage),
        pageAction: "detailsPopup"
    });
};

});
parcelRegister("cBaEp", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $ef7ae4cf716abcda$export$c1ed4f415b9e7023);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $bpk0U = parcelRequire("bpk0U");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $b1nxp = parcelRequire("b1nxp");

var $i90il = parcelRequire("i90il");
const $ef7ae4cf716abcda$var$BOX_HEIGHT = (0, $c9TLT.gridSize) * 18;
const $ef7ae4cf716abcda$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $c9TLT.gridSize) * 9;
const $ef7ae4cf716abcda$var$ICON_SIZE = (0, $c9TLT.gridSize) * 9;
const $ef7ae4cf716abcda$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onClick = ()=>{
        onRetry();
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledBox), {
        height: $ef7ae4cf716abcda$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledBox), {
        height: $ef7ae4cf716abcda$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $ef7ae4cf716abcda$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bpk0U))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i90il.StyledText), null, description !== undefined ? description : formatMessage((0, $b1nxp.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $b1nxp.default).retryMessage)));
};

});
parcelRegister("b1nxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45599fd1dabaf44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a45599fd1dabaf44$var$messages = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $a45599fd1dabaf44$export$2e2bcd8739ae039 = $a45599fd1dabaf44$var$messages;

});

parcelRegister("i90il", function(module, exports) {

$parcel$export(module.exports, "StyledBox", () => $1347616a23ba87bb$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $1347616a23ba87bb$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hA2nt = parcelRequire("hA2nt");
const $1347616a23ba87bb$export$d675f139b342d51a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $9t7rW.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _18s8dq2u",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $1347616a23ba87bb$var$StyledTextComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $1347616a23ba87bb$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hA2nt.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1347616a23ba87bb$var$StyledTextComponent, props));

});


parcelRegister("2eEdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ec60976b313db7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37ec60976b313db7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.error-state.error-message",
        "defaultMessage": "We couldn't display the filter details."
    }
});

});


parcelRegister("31XX4", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $1809d373ad9c4120$export$2a2c7ba12d3231e3);

var $2WfMW = parcelRequire("2WfMW");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $6yplV = parcelRequire("6yplV");

var $9LnlF = parcelRequire("9LnlF");

var $4uMrU = parcelRequire("4uMrU");

var $haq7W = parcelRequire("haq7W");

var $iutCW = parcelRequire("iutCW");
const $1809d373ad9c4120$export$2a2c7ba12d3231e3 = ({ queryReference: queryReference, update: update, onSuccess: onSuccessParent, onOpenEditFilterModal: onOpenEditFilterModal, onOpenNewSubscriptionModal: onOpenNewSubscriptionModal })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { jira: { filter: filter } } = (0, $iWLL0.usePreloadedQuery)((0, $2WfMW.default), queryReference);
    (0, $eUqFw.useEffect)(()=>{
        if (filter) update();
    }, [
        update,
        filter
    ]);
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const onSuccess = (0, $eUqFw.useCallback)(()=>{
        // Invalidate store in case popup is unmounted before query can be reloaded
        (0, $iWLL0.commitLocalUpdate)(environment, (store)=>{
            const filterRecord = store.get(filter.__id);
            if (filterRecord) filterRecord.invalidateRecord();
        }); // Call the success callback from parent in case popup stays open
        onSuccessParent();
    }, [
        environment,
        filter,
        onSuccessParent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog'
        }), 'filterDetails');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1809d373ad9c4120$var$FilterTitle, null, filter.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9LnlF.Description), {
        filter: filter,
        onOpenEditFilterModal: onOpenEditFilterModal
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4uMrU.Owner), {
        filter: filter
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $haq7W.Permissions), {
        filter: filter,
        onOpenEditFilterModal: onOpenEditFilterModal
    }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iutCW.Subscriptions), {
        filter: filter,
        onOpenNewSubscriptionModal: onOpenNewSubscriptionModal,
        onSuccess: onSuccess
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1809d373ad9c4120$var$FilterTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1i4q1hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9LnlF", function(module, exports) {

$parcel$export(module.exports, "Description", () => $d735a3860c7ec025$export$393edc798c47379d);

var $8rcVO = parcelRequire("8rcVO");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lUg8E = parcelRequire("lUg8E");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $iMRO2 = parcelRequire("iMRO2");

var $3v8lA = parcelRequire("3v8lA");

var $cwtlN = parcelRequire("cwtlN");

var $1MukO = parcelRequire("1MukO");

var $hLyIA = parcelRequire("hLyIA");

var $9mZxX = parcelRequire("9mZxX");
const $d735a3860c7ec025$export$393edc798c47379d = ({ filter: filter, onOpenEditFilterModal: onOpenEditFilterModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $8rcVO.default), filter);
    const openEditFilterNameAndDescriptionModal = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onOpenEditFilterModal();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'editFilterNameAndDescription');
    }, [
        onOpenEditFilterModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v8lA.SectionHeader), {
        actions: data.isEditable === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            onClick: openEditFilterNameAndDescriptionModal,
            appearance: "link",
            spacing: "none",
            testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.description.edit-name-and-description-button"
        }, formatMessage((0, $9mZxX.default).editNameAndDescription)) : null
    }, formatMessage((0, $9mZxX.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cwtlN.ShowMore), null, data.description != null && data.description.length ? data.description : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.PlaceholderText), null, formatMessage((0, $9mZxX.default).descriptionPlaceholder))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMRO2.ExperienceSuccess), {
        experience: (0, $hLyIA.viewDetailsPopupExperience)
    }));
};

});
parcelRegister("8rcVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c17e2bbd5ac3c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d1b4a29cfc95e0b21d359da9825db69>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $19c17e2bbd5ac3c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "description_issueNavigatorCustomFilters",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$19c17e2bbd5ac3c4$var$node.hash = "f9b450af0990be0be18e39994e4e39db";
var $19c17e2bbd5ac3c4$export$2e2bcd8739ae039 = $19c17e2bbd5ac3c4$var$node;

});

parcelRegister("3v8lA", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $6bb444347ca5aaf6$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $45qbL = parcelRequire("45qbL");

var $c9TLT = parcelRequire("c9TLT");

var $6yplV = parcelRequire("6yplV");
const $6bb444347ca5aaf6$export$8adb256d999cd5a0 = ({ actions: actions, children: children })=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45qbL.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.100",
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bb444347ca5aaf6$var$HeaderText, null, children), actions != null && !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bb444347ca5aaf6$var$ActionsContainer, null, actions));
};
const $6bb444347ca5aaf6$var$HEADER_FONT_SIZE = (0, $c9TLT.fontSize);
const $6bb444347ca5aaf6$var$LINE_HEIGHT = 1.25;
const $6bb444347ca5aaf6$export$cdb7fd9d999c7168 = $6bb444347ca5aaf6$var$HEADER_FONT_SIZE * $6bb444347ca5aaf6$var$LINE_HEIGHT;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bb444347ca5aaf6$var$HeaderText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h4", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz410nf _1wybdlk8",
            __cmplp.className
        ])
    });
});
const $6bb444347ca5aaf6$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz410nf _1wybdlk8 _k48p4jg8 _1q9t4jg8",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cwtlN", function(module, exports) {

$parcel$export(module.exports, "ShowMore", () => $b5473e0957cc1354$export$ca7697601dcd7803);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $lUg8E = parcelRequire("lUg8E");

var $5JgJ2 = parcelRequire("5JgJ2");

var $87jqX = parcelRequire("87jqX");
const $b5473e0957cc1354$var$DEFAULT_MAX_HEIGHT = 200;
const $b5473e0957cc1354$export$ca7697601dcd7803 = ({ children: children, maxHeight: maxHeight = $b5473e0957cc1354$var$DEFAULT_MAX_HEIGHT })=>{
    const contentRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    const [shouldShowShowMore, setShouldShowShowMore] = (0, $eUqFw.useState)(false);
    const [collapsed, setCollapsed] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (contentRef.current !== null && contentRef.current.clientHeight > maxHeight) setShouldShowShowMore(true);
    }, [
        contentRef,
        maxHeight
    ]);
    const toggleShowMore = (0, $eUqFw.useCallback)(()=>{
        setCollapsed(!collapsed);
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5473e0957cc1354$var$Container, {
        collapsed: collapsed,
        maxHeight: maxHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        ref: contentRef
    }, children)), shouldShowShowMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5473e0957cc1354$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        appearance: "link",
        spacing: "none",
        onClick: toggleShowMore
    }, collapsed ? formatMessage((0, $87jqX.default).showMore) : formatMessage((0, $87jqX.default).showLess))));
};
const $b5473e0957cc1354$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { collapsed: collapsed, maxHeight: maxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1upm8ip": (0, $9t7rW.default)(__cmplp.maxHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81bpf _14cp1hna",
            __cmplp.collapsed && "_c71l1w9o _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $b5473e0957cc1354$var$ButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1q9t4jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("87jqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $79003edd8702ab19$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79003edd8702ab19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMore: {
        "id": "issue-navigator-custom-filters.common.details-popup.show-more.show-more",
        "defaultMessage": "Show more..."
    },
    showLess: {
        "id": "issue-navigator-custom-filters.common.details-popup.show-more.show-less",
        "defaultMessage": "Show less"
    }
});

});


parcelRegister("1MukO", function(module, exports) {

$parcel$export(module.exports, "PlaceholderText", () => $7f3839abc442c71c$export$5dd7e4f3fa008590);
$parcel$export(module.exports, "Section", () => $7f3839abc442c71c$export$6e2c8f0811a474ce);
$parcel$export(module.exports, "SectionBodyTitle", () => $7f3839abc442c71c$export$1d69e81357d9c7e8);
$parcel$export(module.exports, "SectionBody", () => $7f3839abc442c71c$export$e7049d4e10b2bdab);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7f3839abc442c71c$export$5dd7e4f3fa008590 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1e9r",
            __cmplp.className
        ])
    });
});
const $7f3839abc442c71c$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zlh6cr _syaz1dv3 _1yt4r2fv _1lh4glyw _j2v5utpp",
            __cmplp.className
        ])
    });
});
const $7f3839abc442c71c$export$1d69e81357d9c7e8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazaj1x _11c816g6 _vwz410yn _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $7f3839abc442c71c$export$e7049d4e10b2bdab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz2l1e _vwz4gktf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9mZxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca2d3d1f9b5e488d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca2d3d1f9b5e488d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    description: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.description.description",
        "defaultMessage": "Description"
    },
    editNameAndDescription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.description.edit-name-and-description",
        "defaultMessage": "Edit name and description"
    },
    descriptionPlaceholder: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.description.description-placeholder",
        "defaultMessage": "This filter doesn't have a description."
    }
});

});


parcelRegister("4uMrU", function(module, exports) {

$parcel$export(module.exports, "Owner", () => $261f6fac82080cb3$export$25fb39c3824c9c44);

var $hCXch = parcelRequire("hCXch");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $k9isx = parcelRequire("k9isx");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");

var $aQE4L = parcelRequire("aQE4L");

var $dnbhd = parcelRequire("dnbhd");

var $eI5EY = parcelRequire("eI5EY");

var $3x4sL = parcelRequire("3x4sL");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $2NwGr = parcelRequire("2NwGr");


var $490IT = parcelRequire("490IT");

var $gd0Sp = parcelRequire("gd0Sp");

var $1MukO = parcelRequire("1MukO");

var $dvxZd = parcelRequire("dvxZd");
const $261f6fac82080cb3$var$PROFILE_ACTIONS = [
    (0, $2f37035f7aaf1787$export$23cedd3261bd8015),
    (0, $2f37035f7aaf1787$export$56da0dd0b0aa67b9)
];
const $261f6fac82080cb3$export$25fb39c3824c9c44 = ({ filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { owner: owner } = (0, $iWLL0.useFragment)((0, $hCXch.default), filter);
    const onOwnerLinkClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'filterOwner', {
            filterOwnerId: owner.accountId
        });
    }, [
        owner.accountId
    ]);
    const UserLinkOld = (0, $eUqFw.useCallback)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
            href: (0, $490IT.generateUserLink)(owner.accountId),
            onClick: onOwnerLinkClick
        }, children), [
        owner.accountId,
        onOwnerLinkClick
    ]);
    const UserLink = (0, $eUqFw.useCallback)((msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQE4L.default), {
            xcss: $261f6fac82080cb3$var$linkStyle,
            href: (0, $490IT.generateUserLink)(owner.accountId),
            onClick: onOwnerLinkClick
        }, msg), [
        owner.accountId,
        onOwnerLinkClick
    ]);
    if ((0, $eI5EY.fg)('nin_serious_accessibility_issues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($261f6fac82080cb3$var$OwnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $261f6fac82080cb3$var$avatarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
        accountId: owner.accountId,
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
        actions: $261f6fac82080cb3$var$PROFILE_ACTIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
        src: owner.picture,
        size: "large",
        testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.owner.avatar"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $dvxZd.default).owner,
        values: {
            anchor: UserLink,
            ownerName: owner.name
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($261f6fac82080cb3$var$OwnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $261f6fac82080cb3$var$avatarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k9isx.default), {
        src: owner.picture,
        size: "large",
        testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.owner.avatar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
        accountId: owner.accountId,
        TenantContextSubscriber: (0, $gd0Sp.TenantContextSubscriber),
        actions: $261f6fac82080cb3$var$PROFILE_ACTIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: UserLinkOld
        },
        message: formatMessage((0, $dvxZd.default).ownedBy, {
            ownerName: owner.name,
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        })
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $261f6fac82080cb3$var$OwnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $261f6fac82080cb3$var$avatarContainerStyles = (0, $8Vv3m.xcss)({
    marginRight: 'space.100'
});
const $261f6fac82080cb3$var$linkStyle = (0, $8Vv3m.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});
parcelRegister("hCXch", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7cd5934fc389c38$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c93155984576afec4ca63b038a3900cd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7cd5934fc389c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "owner_issueNavigatorCustomFilters",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    }
                ]
            },
            "action": "THROW",
            "path": "owner"
        }
    ],
    "type": "JiraCustomFilter"
};
$b7cd5934fc389c38$var$node.hash = "cb1b46f3f320b4c4793ee7c164c198c7";
var $b7cd5934fc389c38$export$2e2bcd8739ae039 = $b7cd5934fc389c38$var$node;

});

parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("2NwGr", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $d91bacdeb64d663f$export$a3c0845f856d4292);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d91bacdeb64d663f$var$LazyComponent = (0, $dyfd9.lazy)(()=>(parcelRequire("aWDkE")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $d91bacdeb64d663f$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d91bacdeb64d663f$var$LazyComponent, props)));
var $d91bacdeb64d663f$export$2e2bcd8739ae039 = $d91bacdeb64d663f$export$a3c0845f856d4292;

});
parcelRegister("aWDkE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("keVAk")
]).then(()=>parcelRequire('12NzK'));

});


// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("490IT", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $8b4d5377460cf9d7$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $8b4d5377460cf9d7$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $8b4d5377460cf9d7$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $8b4d5377460cf9d7$export$ffbbcf55d672ec61);

var $jMP2a = parcelRequire("jMP2a");
const $8b4d5377460cf9d7$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $8b4d5377460cf9d7$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $8b4d5377460cf9d7$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $8b4d5377460cf9d7$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $8b4d5377460cf9d7$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($8b4d5377460cf9d7$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $jMP2a.fireScreenAnalytics)(analyticsEvent);
    }
};

});

parcelRegister("dvxZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad864e7c8c980878$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ad864e7c8c980878$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ownedBy: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.owner.owned-by",
        "defaultMessage": "Owned by {linkStart}{ownerName}{linkEnd}"
    },
    owner: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.owner.owner",
        "defaultMessage": "Owned by <anchor>{ownerName}</anchor>"
    }
});

});


parcelRegister("haq7W", function(module, exports) {

$parcel$export(module.exports, "Permissions", () => $530578138fbd4655$export$2d41982586bbb6be);

var $7FI9b = parcelRequire("7FI9b");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $lUg8E = parcelRequire("lUg8E");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3v8lA = parcelRequire("3v8lA");

var $1MukO = parcelRequire("1MukO");

var $7lawF = parcelRequire("7lawF");

var $ckTc8 = parcelRequire("ckTc8");

var $4sACA = parcelRequire("4sACA");
const $530578138fbd4655$export$2d41982586bbb6be = ({ filter: filter, onOpenEditFilterModal: onOpenEditFilterModal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filterData = (0, $iWLL0.useFragment)((0, $7FI9b.default), filter);
    const onOpenEditPermissionsModal = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        onOpenEditFilterModal();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'editFilterPermissions');
    }, [
        onOpenEditFilterModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v8lA.SectionHeader), {
        actions: filterData.isEditable === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            onClick: onOpenEditPermissionsModal,
            appearance: "link",
            spacing: "none",
            testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.permissions.edit-permissions-button"
        }, formatMessage((0, $4sACA.default).editPermissions)) : null
    }, formatMessage((0, $4sACA.default).permissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7lawF.Access), {
        filter: filterData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ckTc8.Edit), {
        filter: filterData
    }));
};

});
parcelRegister("7FI9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a735c3e59a01e4f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0a1736a97120f52a454a8b09e8d9dd6e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7a735c3e59a01e4f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "permissions_issueNavigatorCustomFilters",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "access_issueNavigatorCustomFilters"
        },
        {
            "kind": "FragmentSpread",
            "name": "edit_issueNavigatorCustomFilters"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$7a735c3e59a01e4f$var$node.hash = "31add9aa56167a062969a5bd4dfaec78";
var $7a735c3e59a01e4f$export$2e2bcd8739ae039 = $7a735c3e59a01e4f$var$node;

});

parcelRegister("7lawF", function(module, exports) {

$parcel$export(module.exports, "Access", () => $70c8e75f9df1aead$export$3026e5a52c747d2c);

var $lGs4Z = parcelRequire("lGs4Z");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5XnMI = parcelRequire("5XnMI");

var $fJbsV = parcelRequire("fJbsV");

var $f6n7J = parcelRequire("f6n7J");

var $1MukO = parcelRequire("1MukO");

var $hq0hv = parcelRequire("hq0hv");

var $h3eoP = parcelRequire("h3eoP");

var $9sww0 = parcelRequire("9sww0");
const $70c8e75f9df1aead$export$3026e5a52c747d2c = ({ filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { shareGrants: shareGrants } = (0, $iWLL0.useFragment)((0, $lGs4Z.default), filter);
    const users = (0, $eUqFw.useMemo)(()=>shareGrants?.edges && shareGrants.edges?.length > 0 ? shareGrants?.edges.filter((shareableEntity)=>shareableEntity?.node && shareableEntity.node.__typename === 'JiraShareableEntityUserGrant').map((shareableEntity)=>shareableEntity?.node?.user ? shareableEntity.node.user.name : '') : [], [
        shareGrants?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBodyTitle), null, formatMessage((0, $9sww0.default).visibleTo)), shareGrants?.edges && shareGrants.edges.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, // using index as key because these relations don't have individual IDs
    shareGrants.edges.map((shareableEntity, key)=>{
        if (shareableEntity?.node) {
            const { __typename: __typename } = shareableEntity.node;
            if (__typename === 'JiraShareableEntityProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJbsV.ProjectGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityProjectRoleGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6n7J.ProjectRoleGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityGroupGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5XnMI.GroupGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityAnonymousAccessGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), {
                key: key
            }, formatMessage((0, $9sww0.default).public));
            if (__typename === 'JiraShareableEntityAnyLoggedInUserGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), {
                key: key
            }, formatMessage((0, $9sww0.default).loggedInUsers));
            if (__typename === 'JiraShareableEntityUnknownProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq0hv.UnknownProject), {
                key: key
            });
        }
        return null;
    }), users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3eoP.UsersGrant), {
        users: users
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $9sww0.default).private)));
};

});
parcelRegister("lGs4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5c8df56a534561$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8590f541f77918db05103a0e59693617>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8d5c8df56a534561$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "access_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraShareableEntityShareGrantConnection",
            "kind": "LinkedField",
            "name": "shareGrants",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraShareableEntityShareGrantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectRoleGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "groupGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraShareableEntityUserGrant"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCustomFilter"
};
$8d5c8df56a534561$var$node.hash = "723acfaab9c38e502d502422ae67f3e2";
var $8d5c8df56a534561$export$2e2bcd8739ae039 = $8d5c8df56a534561$var$node;

});

parcelRegister("5XnMI", function(module, exports) {

$parcel$export(module.exports, "GroupGrant", () => $d3a84620559a0074$export$7ab94d64a59792d5);

var $euaCZ = parcelRequire("euaCZ");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MukO = parcelRequire("1MukO");

var $6HKDE = parcelRequire("6HKDE");
const $d3a84620559a0074$export$7ab94d64a59792d5 = ({ entity: entity })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const groupGrant = (0, $iWLL0.useFragment)((0, $euaCZ.default), entity);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, groupGrant.group && groupGrant.group?.name !== undefined && formatMessage((0, $6HKDE.default).groupName, {
        name: groupGrant.group?.name
    }));
};

});
parcelRegister("euaCZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3221eb9355d74f3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fb505eeac796a265fa1c28cfccde9545>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3221eb9355d74f3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupGrant_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraShareableEntityGroupGrant"
};
$b3221eb9355d74f3$var$node.hash = "5d137f8bd705292955fe74f248e79b45";
var $b3221eb9355d74f3$export$2e2bcd8739ae039 = $b3221eb9355d74f3$var$node;

});

parcelRegister("6HKDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $682ddc0753ee322c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $682ddc0753ee322c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupName: {
        "id": "issue-navigator-custom-filters.common.details-popup.group-grant.group-name",
        "defaultMessage": "Group: {name}"
    }
});

});


parcelRegister("fJbsV", function(module, exports) {

$parcel$export(module.exports, "ProjectGrant", () => $422c2bc49b0bd03c$export$c0fe5a638e35f019);

var $lIG4S = parcelRequire("lIG4S");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $nsZmq = parcelRequire("nsZmq");

var $dnbhd = parcelRequire("dnbhd");

var $dnJL9 = parcelRequire("dnJL9");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1MukO = parcelRequire("1MukO");

var $7fDPB = parcelRequire("7fDPB");
const $422c2bc49b0bd03c$var$linkStart = '{linkStart}';
const $422c2bc49b0bd03c$var$linkEnd = '{linkEnd}';
const $422c2bc49b0bd03c$var$ConditionalLink = (0, $dnJL9.componentWithFG)('nin_serious_accessibility_issues', (0, $nsZmq.default), (0, $dnbhd.default));
const $422c2bc49b0bd03c$export$c0fe5a638e35f019 = ({ entity: entity })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectGrant = (0, $iWLL0.useFragment)((0, $lIG4S.default), entity);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, projectGrant.project?.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: ({ children: children })=>projectGrant.project?.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($422c2bc49b0bd03c$var$ConditionalLink, {
                    href: `/browse/${projectGrant.project?.key}`,
                    onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'projectGrant')
                }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
        },
        message: formatMessage((0, $7fDPB.default).projectNameLink, {
            name: projectGrant.project?.name,
            linkStart: $422c2bc49b0bd03c$var$linkStart,
            linkEnd: $422c2bc49b0bd03c$var$linkEnd
        })
    }));
};

});
parcelRegister("lIG4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5366e79b80c887be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<830b56b1c6fd2336014f37af74b87fba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5366e79b80c887be$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectGrant_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ],
    "type": "JiraShareableEntityProjectGrant"
};
$5366e79b80c887be$var$node.hash = "a6f0045e8c355671600e72844955bb81";
var $5366e79b80c887be$export$2e2bcd8739ae039 = $5366e79b80c887be$var$node;

});

parcelRegister("7fDPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $85188e01abc5704d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $85188e01abc5704d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectNameLink: {
        "id": "issue-navigator-custom-filters.common.details-popup.project-grant.project-name-link",
        "defaultMessage": "Project: {linkStart}{name}{linkEnd} (Everyone)"
    }
});

});


parcelRegister("f6n7J", function(module, exports) {

$parcel$export(module.exports, "ProjectRoleGrant", () => $033c7b2ef02db4e8$export$7da97d7ea4daa99e);

var $esTAR = parcelRequire("esTAR");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $nsZmq = parcelRequire("nsZmq");

var $dnbhd = parcelRequire("dnbhd");

var $dnJL9 = parcelRequire("dnJL9");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $1MukO = parcelRequire("1MukO");

var $6glAt = parcelRequire("6glAt");
const $033c7b2ef02db4e8$var$linkStart = '{linkStart}';
const $033c7b2ef02db4e8$var$linkEnd = '{linkEnd}';
const $033c7b2ef02db4e8$var$ConditionalLink = (0, $dnJL9.componentWithFG)('nin_serious_accessibility_issues', (0, $nsZmq.default), (0, $dnbhd.default));
const $033c7b2ef02db4e8$export$7da97d7ea4daa99e = ({ entity: entity })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectRoleGrant = (0, $iWLL0.useFragment)((0, $esTAR.default), entity);
    const message = formatMessage((0, $6glAt.default).projectRoleNameLink, {
        name: projectRoleGrant.project?.name,
        role: projectRoleGrant.role?.name,
        linkStart: $033c7b2ef02db4e8$var$linkStart,
        linkEnd: $033c7b2ef02db4e8$var$linkEnd
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, projectRoleGrant.project?.name !== undefined && projectRoleGrant.role?.name !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
        componentsMapping: {
            link: ({ children: children })=>projectRoleGrant.project?.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($033c7b2ef02db4e8$var$ConditionalLink, {
                    href: `/browse/${projectRoleGrant.project?.key}`,
                    onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'projectRoleGrant')
                }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
        },
        message: message
    }));
};

});
parcelRegister("esTAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b145fd49321639bb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cfc9b47a86609e2981aad8da17fded50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b145fd49321639bb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectRoleGrant_issueNavigatorCustomFilters",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            },
            {
                "concreteType": "JiraRole",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            }
        ],
        "type": "JiraShareableEntityProjectRoleGrant"
    };
}();
$b145fd49321639bb$var$node.hash = "0353d445a52987cb7c245d2ca5cd2d8c";
var $b145fd49321639bb$export$2e2bcd8739ae039 = $b145fd49321639bb$var$node;

});

parcelRegister("6glAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f15c2f34aa5f8b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8f15c2f34aa5f8b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectRoleNameLink: {
        "id": "issue-navigator-custom-filters.common.details-popup.project-role-grant.project-role-name-link",
        "defaultMessage": "Project: {linkStart}{name}{linkEnd} ({role})"
    }
});

});


parcelRegister("hq0hv", function(module, exports) {

$parcel$export(module.exports, "UnknownProject", () => $2e69df7293ff1226$export$a8bd5ea331aa2c2c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2tBG8 = parcelRequire("2tBG8");

var $jl1we = parcelRequire("jl1we");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MukO = parcelRequire("1MukO");

var $4QDe3 = parcelRequire("4QDe3");
const $2e69df7293ff1226$export$a8bd5ea331aa2c2c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $4QDe3.default).unknownProject), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $4QDe3.default).infoTooltip),
        tag: $2e69df7293ff1226$var$QuestionCircleIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2tBG8))), {
        label: formatMessage((0, $4QDe3.default).infoTooltip),
        size: "small"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e69df7293ff1226$var$QuestionCircleIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19bv1b66 _s7n4nkob _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4QDe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b4235735a3b7b45$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9b4235735a3b7b45$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unknownProject: {
        "id": "issue-navigator-custom-filters.common.details-popup.unknown-project.unknown-project",
        "defaultMessage": "Project: unknown"
    },
    infoTooltip: {
        "id": "issue-navigator-custom-filters.common.details-popup.unknown-project.info-tooltip",
        "defaultMessage": "You do not have access to this project"
    }
});

});


parcelRegister("h3eoP", function(module, exports) {

$parcel$export(module.exports, "UsersGrant", () => $7a8de7d0f8fd9de7$export$eafe47c6bcbc8617);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1MukO = parcelRequire("1MukO");

var $dziwa = parcelRequire("dziwa");
const $7a8de7d0f8fd9de7$export$eafe47c6bcbc8617 = ({ users: users })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $dziwa.default).users), ":", ' ', users.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            key: user
        }, user, index < users.length - 1 ? ', ' : '')));
};

});
parcelRegister("dziwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c7aadd3f5aee0e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $40c7aadd3f5aee0e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    users: {
        "id": "issue-navigator-custom-filters.common.details-popup.users-grant.users",
        "defaultMessage": "Users"
    }
});

});


parcelRegister("9sww0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf23019e440c63c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9cf23019e440c63c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    private: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.private",
        "defaultMessage": "Private"
    },
    visibleTo: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.visible-to",
        "defaultMessage": "Visible to:"
    },
    public: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.public",
        "defaultMessage": "Public"
    },
    loggedInUsers: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.access.logged-in-users",
        "defaultMessage": "Logged in users on this instance"
    }
});

});


parcelRegister("ckTc8", function(module, exports) {

$parcel$export(module.exports, "Edit", () => $301306cec459c2ab$export$6ed0965c9443aaa6);

var $fuydX = parcelRequire("fuydX");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5XnMI = parcelRequire("5XnMI");

var $fJbsV = parcelRequire("fJbsV");

var $f6n7J = parcelRequire("f6n7J");

var $1MukO = parcelRequire("1MukO");

var $hq0hv = parcelRequire("hq0hv");

var $h3eoP = parcelRequire("h3eoP");

var $6AOrh = parcelRequire("6AOrh");
const $301306cec459c2ab$export$6ed0965c9443aaa6 = ({ filter: filter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { editGrants: editGrants } = (0, $iWLL0.useFragment)((0, $fuydX.default), filter);
    const users = (0, $eUqFw.useMemo)(()=>editGrants?.edges && editGrants.edges?.length > 0 ? editGrants?.edges.filter((shareableEntity)=>shareableEntity?.node && shareableEntity.node.__typename === 'JiraShareableEntityUserGrant').map((shareableEntity)=>shareableEntity?.node?.user ? shareableEntity.node.user.name : '') : [], [
        editGrants?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBodyTitle), null, formatMessage((0, $6AOrh.default).editabledBy)), editGrants?.edges && editGrants.edges?.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, // using index as key because these relations don't have individual IDs
    editGrants.edges.map((shareableEntity, key)=>{
        if (shareableEntity?.node) {
            const { __typename: __typename } = shareableEntity?.node;
            if (__typename === 'JiraShareableEntityProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJbsV.ProjectGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityProjectRoleGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6n7J.ProjectRoleGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityGroupGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5XnMI.GroupGrant), {
                key: key,
                entity: shareableEntity.node
            });
            if (__typename === 'JiraShareableEntityUnknownProjectGrant') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hq0hv.UnknownProject), {
                key: key
            });
        }
        return null;
    }), users.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3eoP.UsersGrant), {
        users: users
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.SectionBody), null, formatMessage((0, $6AOrh.default).private)));
};

});
parcelRegister("fuydX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c3ef55d0ee80ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<99f0d9d9838b61861cbb2efaa1de9f54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9c3ef55d0ee80ab$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "edit_issueNavigatorCustomFilters",
    "selections": [
        {
            "concreteType": "JiraShareableEntityEditGrantConnection",
            "kind": "LinkedField",
            "name": "editGrants",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraShareableEntityEditGrantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectRoleGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "groupGrant_issueNavigatorCustomFilters"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraShareableEntityUserGrant"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraCustomFilter"
};
$f9c3ef55d0ee80ab$var$node.hash = "cb8085a4ada55e8e573b553cfab4d229";
var $f9c3ef55d0ee80ab$export$2e2bcd8739ae039 = $f9c3ef55d0ee80ab$var$node;

});

parcelRegister("6AOrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd03b2cd40b2523a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bd03b2cd40b2523a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    private: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.edit.private",
        "defaultMessage": "Private"
    },
    editabledBy: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.edit.editabled-by",
        "defaultMessage": "Editable by:"
    }
});

});


parcelRegister("4sACA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d84a5f5502bd67$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a0d84a5f5502bd67$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    permissions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.permissions",
        "defaultMessage": "Permissions"
    },
    editPermissions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.permissions.edit-permissions",
        "defaultMessage": "Edit Permissions"
    }
});

});


parcelRegister("iutCW", function(module, exports) {

$parcel$export(module.exports, "Subscriptions", () => $5cfa17e2af9740ea$export$d73dcc2e0bdfb5bd);

var $jLFEo = parcelRequire("jLFEo");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iWLL0 = parcelRequire("iWLL0");

var $lUg8E = parcelRequire("lUg8E");

var $eNn5x = parcelRequire("eNn5x");

var $45qbL = parcelRequire("45qbL");
var $1JJay = parcelRequire("1JJay");

var $jl1we = parcelRequire("jl1we");

var $dnbhd = parcelRequire("dnbhd");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3v8lA = parcelRequire("3v8lA");

var $1MukO = parcelRequire("1MukO");

var $GEkEU = parcelRequire("GEkEU");

var $4y0mA = parcelRequire("4y0mA");

var $gUQW9 = parcelRequire("gUQW9");
const $5cfa17e2af9740ea$export$d73dcc2e0bdfb5bd = ({ filter: filter, onOpenNewSubscriptionModal: onOpenNewSubscriptionModal, onSuccess: onSuccess })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const data = (0, $iWLL0.useFragment)((0, $jLFEo.default), filter);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.Section), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3v8lA.SectionHeader), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45qbL.default), {
            space: "space.050",
            alignBlock: "center",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y0mA.AddSubscriptionModalProvider), {
            filter: data,
            onOpenNewSubscriptionModal: onOpenNewSubscriptionModal,
            onSuccess: onSuccess
        }, ({ isLoading: isLoading, open: open, preload: preload })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                appearance: "link",
                spacing: "none",
                onClick: open,
                onMouseOver: preload,
                isDisabled: isLoading,
                testId: "issue-navigator-custom-filters.ui.details-popup.popup-content.subscriptions.add-subscription-button"
            }, formatMessage((0, $gUQW9.default).addSubscription))), data.emailSubscriptions.edges.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
            href: (0, $GEkEU.getManageSubscriptionsLink)(data.filterId),
            onClick: (_, analyticsEvent)=>(0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'manageSubscriptions'),
            "data-testid": "issue-navigator-custom-filters.ui.details-popup.popup-content.subscriptions.manage-subscriptions-link"
        }, formatMessage((0, $gUQW9.default).manageSubscriptions))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45qbL.default), {
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        weight: "semibold"
    }, formatMessage((0, $gUQW9.default).subscriptions)), !data.emailSubscriptions.edges.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gUQW9.default).subscriptionsInfoTooltipIssueTermRefresh : (0, $gUQW9.default).subscriptionsInfoTooltip),
        tag: $5cfa17e2af9740ea$var$InfoIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eNn5x))), {
        label: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gUQW9.default).subscriptionsInfoTooltipIssueTermRefresh : (0, $gUQW9.default).subscriptionsInfoTooltip),
        size: "medium"
    })))), data.emailSubscriptions.edges.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $gUQW9.default).hasTheFollowingSubscriptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5cfa17e2af9740ea$var$SubscriptionList, null, data.emailSubscriptions.edges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: edge.node.id
        }, edge.node.group ? edge.node.group.name : edge.node.user?.name) : null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MukO.PlaceholderText), null, formatMessage((0, $gUQW9.default).subscriptionsPlaceholder))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cfa17e2af9740ea$var$InfoIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkr5cr _4t3i77iu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cfa17e2af9740ea$var$SubscriptionList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jLFEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $21826a34e2e3a06c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bcf3fd047349255d1334d0cedddeea6f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $21826a34e2e3a06c$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "subscriptions_issueNavigatorCustomFilters",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "FragmentSpread",
                "name": "addSubscriptionModal_issueNavigatorCustomFilters_AddSubscriptionModalProvider"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "last",
                            "value": 5
                        }
                    ],
                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                    "kind": "LinkedField",
                    "name": "emailSubscriptions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraFilterEmailSubscriptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEmailSubscription",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v0 /*: any*/ 
                                            },
                                            {
                                                "concreteType": "JiraGroup",
                                                "kind": "LinkedField",
                                                "name": "group",
                                                "plural": false,
                                                "selections": v0 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "emailSubscriptions.edges"
                        }
                    ],
                    "storageKey": "emailSubscriptions(last:5)"
                },
                "action": "THROW",
                "path": "emailSubscriptions"
            }
        ],
        "type": "JiraCustomFilter"
    };
}();
$21826a34e2e3a06c$var$node.hash = "85c47f44d1a205822525c56240e74538";
var $21826a34e2e3a06c$export$2e2bcd8739ae039 = $21826a34e2e3a06c$var$node;

});

parcelRegister("eNn5x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac578d2275764312$var$_react = $ac578d2275764312$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $ac578d2275764312$var$_information = $ac578d2275764312$var$_interopRequireDefault((parcelRequire("jgkb5")));
function $ac578d2275764312$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ac578d2275764312$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $ac578d2275764312$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $ac578d2275764312$var$_information.default
    }));
$ac578d2275764312$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $ac578d2275764312$var$_default = module.exports.default = $ac578d2275764312$var$EditorInfoIcon;

});

parcelRegister("GEkEU", function(module, exports) {

$parcel$export(module.exports, "getManageSubscriptionsLink", () => $6dcb49eb18c759a8$export$426da445adfeedc1);
const $6dcb49eb18c759a8$export$426da445adfeedc1 = (filterId)=>`/secure/ViewSubscriptions.jspa?filterId=${filterId}`;

});

parcelRegister("4y0mA", function(module, exports) {

$parcel$export(module.exports, "AddSubscriptionModalProvider", () => $304d15629b02765d$export$1b56ce395ad0fc78);

var $iTwfO = parcelRequire("iTwfO");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $6Fbwh = parcelRequire("6Fbwh");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $jxATW = parcelRequire("jxATW");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");

var $16kIm = parcelRequire("16kIm");


var $GEkEU = parcelRequire("GEkEU");

var $hLyIA = parcelRequire("hLyIA");

var $4HUA2 = parcelRequire("4HUA2");
const $304d15629b02765d$var$WRM_RESOURCES = [
    'wrc!jira.webresources:croneditor'
];
const $304d15629b02765d$var$preload = ()=>{
    (0, $16kIm.asyncWrmRequire)($304d15629b02765d$var$WRM_RESOURCES);
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $304d15629b02765d$var$getFormDialog = ()=>(0, $16kIm.asyncWrmRequire)($304d15629b02765d$var$WRM_RESOURCES).then(()=>window.JIRA.FormDialog);
const $304d15629b02765d$export$1b56ce395ad0fc78 = ({ filter: filter, children: children, onError: onError, onOpenNewSubscriptionModal: onOpenNewSubscriptionModal, onSuccess: onSuccess })=>{
    const [isLoading, setLoading] = (0, $eUqFw.useState)(false);
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const filterData = (0, $iWLL0.useFragment)((0, $iTwfO.default), filter);
    const onSuccessfulSubmit = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
            actionSubject: 'issueFilterSubscription',
            action: 'created'
        }), 'issueFilterSubscription created', {
            issueFilterNameLength: filterData.name.length,
            issueFilterDescriptionLength: filterData.description?.length,
            issueFilterOwner: filterData.owner?.accountId
        });
        onSuccess && onSuccess();
    }, [
        createAnalyticsEvent,
        filterData,
        onSuccess
    ]);
    const open = (0, $eUqFw.useCallback)(()=>{
        (async ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'addFilterSubscription');
            (0, $hLyIA.viewNewSubscriptionModal).start();
            setLoading(true);
            try {
                const FormDialog = await $304d15629b02765d$var$getFormDialog();
                /**
         * Available options can be found in:
         * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-webapp-resources/src/main/webapp/includes/jira/dialog/FormDialog.js
         * Look at `_getDefaultOptions` function and accesses to `this.options`
         */ const dialog = new FormDialog({
                    ajaxOptions: {
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        url: `https://${window.location.hostname}/secure/EditSubscription!default.jspa?filterId=${filterData.filterId}`,
                        data: {
                            decorator: 'dialog',
                            inline: 'true'
                        }
                    },
                    autoClose: true,
                    onUnSuccessfulSubmit (statusText, errorThrown, smartAjaxResult) {
                        const error = errorThrown || new (0, $7byHA.default)(smartAjaxResult.status, undefined, (0, $jxATW.getTraceIdJq)(smartAjaxResult.xhr));
                        (0, $guiFP.default)({
                            meta: {
                                id: 'AddSubscriptionModalProvider.onUnSuccessfulSubmit',
                                packageName: (0, $3e27b2158b878ad6$export$ad257a98f20ee631),
                                teamName: 'empanada'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        onError && onError(error);
                    },
                    onDialogFinished () {
                        onSuccessfulSubmit();
                        showFlag({
                            type: 'success',
                            title: (0, $4HUA2.default).successFlagTitle,
                            description: [
                                (0, $4HUA2.default).successFlagDescription,
                                {
                                    filterName: filterData.name
                                }
                            ],
                            actions: [
                                {
                                    content: (0, $4HUA2.default).successFlagActionManage,
                                    href: (0, $GEkEU.getManageSubscriptionsLink)(filterData.filterId),
                                    target: '_blank'
                                }
                            ]
                        });
                    }
                });
                dialog.onContentReadyCallbacks?.push(()=>{
                    (0, $hLyIA.viewNewSubscriptionModal).success();
                });
                dialog.show();
                onOpenNewSubscriptionModal && onOpenNewSubscriptionModal();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                showFlag({
                    type: 'error',
                    title: (0, $4HUA2.default).showModalErrorTitle,
                    description: (0, $4HUA2.default).showModalErrorDescription,
                    error: error
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'AddSubscriptionModalProvider',
                        packageName: (0, $3e27b2158b878ad6$export$ad257a98f20ee631),
                        teamName: 'empanada'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                (0, $hLyIA.viewNewSubscriptionModal).failure();
            }
            setLoading(false);
        })();
    }, [
        createAnalyticsEvent,
        filterData,
        showFlag,
        onError,
        onOpenNewSubscriptionModal,
        onSuccessfulSubmit
    ]);
    return children({
        isLoading: isLoading,
        open: open,
        preload: $304d15629b02765d$var$preload
    });
};

});
parcelRegister("iTwfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $88fd0dceb0eb03ba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6cdab0b62ebc5a697477607cd35b545c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $88fd0dceb0eb03ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "addSubscriptionModal_issueNavigatorCustomFilters_AddSubscriptionModalProvider",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "filterId"
            },
            "action": "THROW",
            "path": "filterId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    "action": "THROW",
                    "path": "owner.accountId"
                }
            ]
        }
    ],
    "type": "JiraCustomFilter"
};
$88fd0dceb0eb03ba$var$node.hash = "9d8d65563104a3f742dd7a5adc73ec81";
var $88fd0dceb0eb03ba$export$2e2bcd8739ae039 = $88fd0dceb0eb03ba$var$node;

});

parcelRegister("4HUA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2067d5675f9ba072$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2067d5675f9ba072$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showModalErrorTitle: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.show-modal-error-title",
        "defaultMessage": "Something went wrong"
    },
    showModalErrorDescription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.show-modal-error-description",
        "defaultMessage": "We couldn't create a new subscription. Please refresh the page and try again."
    },
    successFlagTitle: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.success-flag-title",
        "defaultMessage": "Subscription created"
    },
    successFlagDescription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.success-flag-description",
        "defaultMessage": "You\u2019ve created a subscription for \u201C{filterName}\u201D filter."
    },
    successFlagActionManage: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription-modal.success-flag-action-manage",
        "defaultMessage": "Manage subscriptions"
    }
});

});


parcelRegister("gUQW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3752a9e511f57d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e3752a9e511f57d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    subscriptions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions",
        "defaultMessage": "Subscriptions"
    },
    addSubscription: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.add-subscription",
        "defaultMessage": "Add subscription"
    },
    manageSubscriptions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.manage-subscriptions",
        "defaultMessage": "Manage subscriptions"
    },
    subscriptionsPlaceholder: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions-placeholder",
        "defaultMessage": "This filter doesn't have any subscriptions."
    },
    subscriptionsInfoTooltip: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions-info-tooltip",
        "defaultMessage": "Get regular updates from issues in this filter."
    },
    hasTheFollowingSubscriptions: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.has-the-following-subscriptions",
        "defaultMessage": "This filter has the following subscriptions:"
    },
    subscriptionsInfoTooltipIssueTermRefresh: {
        "id": "issue-navigator-custom-filters.details-popup.popup-content.subscriptions.subscriptions-info-tooltip-issue-term-refresh",
        "defaultMessage": "Get regular updates from issues in this filter."
    }
});

});






parcelRegister("5lWFW", function(module, exports) {

$parcel$export(module.exports, "DetailsButtonHeaderWrapper", () => $68a90300266936a7$export$1eb74eb504903ed6);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $68a90300266936a7$export$1eb74eb504903ed6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p4jg8 _18s8otz2 _19pkv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("euIkl", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $6f2c3d94b4640d68$export$8d5dab2ad1e19ea0);
$parcel$export(module.exports, "FavoriteButtonHeaderWrapper", () => $6f2c3d94b4640d68$export$5ca4047aa6ecffac);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eai7U = parcelRequire("eai7U");

var $jrdvV = parcelRequire("jrdvV");
const $6f2c3d94b4640d68$export$8d5dab2ad1e19ea0 = ({ filterId: filterId, isFavoriteInitial: isFavoriteInitial, favoriteItemName: favoriteItemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eai7U.default), {
        key: filterId,
        baseUrl: "",
        itemType: (0, $jrdvV.FILTERS_ITEM_TYPE),
        itemId: filterId,
        isFavoriteInitial: isFavoriteInitial,
        favoriteItemName: favoriteItemName,
        isShownInList: true
    });
const $6f2c3d94b4640d68$export$5ca4047aa6ecffac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _4t3izwfg _18s81nu5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eai7U", function(module, exports) {

$parcel$export(module.exports, "default", () => $851158f210da4df7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dQZ5c = parcelRequire("dQZ5c");


var $gwSUu = parcelRequire("gwSUu");
class $851158f210da4df7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwSUu.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("gwSUu", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $f43e6d70f6db5981$export$8d5dab2ad1e19ea0);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ktkCe = parcelRequire("ktkCe");

var $jrdvV = parcelRequire("jrdvV");

var $1ybV0 = parcelRequire("1ybV0");

var $hXex1 = parcelRequire("hXex1");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f43e6d70f6db5981$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $f43e6d70f6db5981$export$8d5dab2ad1e19ea0 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$f43e6d70f6db5981$var$isProduction && !(0, $jrdvV.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $jrdvV.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $hXex1.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
            'data-testid': 'favorite-button'
        } : {
            'data-test-id': 'favorite-button'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ktkCe.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("ktkCe", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $3e4b24f33924a6f9$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $3e4b24f33924a6f9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $lUg8E = parcelRequire("lUg8E");

var $8ygbv = parcelRequire("8ygbv");

var $jnVUH = parcelRequire("jnVUH");

var $d6awU = parcelRequire("d6awU");

var $14Itk = parcelRequire("14Itk");

var $aFZXp = parcelRequire("aFZXp");

var $6rQDs = parcelRequire("6rQDs");

var $jl1we = parcelRequire("jl1we");

var $8un0w = parcelRequire("8un0w");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $lbjCz = parcelRequire("lbjCz");

var $ivkNG = parcelRequire("ivkNG");
const $3e4b24f33924a6f9$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $3e4b24f33924a6f9$export$f8ad2acf0ec4860f extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $3e4b24f33924a6f9$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbjCz.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$db65185b5889c83, {
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            } : {
                'data-test-id': $3e4b24f33924a6f9$var$SKELETON_TEST_ID
            },
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $3e4b24f33924a6f9$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, isFavorite ? // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ygbv))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($14Itk))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).removeFromStarred)
            }
        }) : // @ts-expect-error - TS2769 - No overload matches this call. | TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jnVUH))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d6awU))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') && {
                label: formatMessage((0, $ivkNG.default).addToStarred)
            }
        }));
        const renderIcon = ()=>{
            let label = '';
            if ((0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts')) {
                if (isFavorite) label = formatMessage((0, $ivkNG.default).removeFromStarred);
                else label = formatMessage((0, $ivkNG.default).addToStarred);
            }
            let StarIconComponent;
            if (isSmall) StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($aFZXp))) : (0, (/*@__PURE__*/$parcel$interopDefault($6rQDs)));
            else StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($8ygbv))) : (0, (/*@__PURE__*/$parcel$interopDefault($jnVUH)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            ...(0, $1ybV0.ff)('favourite-button-label-and-testid_of2ts') ? {
                'data-testid': iconWrapperTestId
            } : {
                'data-test-id': iconWrapperTestId
            },
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $ivkNG.default).removeFromStarred) : formatMessage((0, $ivkNG.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $ivkNG.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $ivkNG.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3e4b24f33924a6f9$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }, (0, $8rQuz.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isAnimating: false
        };
        this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        };
        this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $3e4b24f33924a6f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $8un0w.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $giAhk.injectIntlV2))($3e4b24f33924a6f9$export$f8ad2acf0ec4860f);
const $3e4b24f33924a6f9$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $3e4b24f33924a6f9$var$FavoriteIconWrapperBase = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseNew, $3e4b24f33924a6f9$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e4b24f33924a6f9$var$FavIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3e4b24f33924a6f9$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isFavorite ? "_syaz2kyj" : "_syaz2u25",
            __cmplp.isFavorite ? "_30l31ebw" : "_30l3w9a8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e4b24f33924a6f9$export$db65185b5889c83 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("ivkNG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79b2c2cf8a78bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d79b2c2cf8a78bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});


parcelRegister("hXex1", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $895d7ed98f35f49b$export$fce5eda070ce88d0);

var $lRmyA = parcelRequire("lRmyA");
const $895d7ed98f35f49b$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $895d7ed98f35f49b$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $lRmyA.performGetRequest)($895d7ed98f35f49b$export$959ca2ee969adb8d(baseUrl, request));

});




parcelRegister("fWW8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $63dfc97cd19510eb$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $63dfc97cd19510eb$var$messages = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-issue-navigator.heading",
        "defaultMessage": "Issues"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    }
});
var $63dfc97cd19510eb$export$2e2bcd8739ae039 = $63dfc97cd19510eb$var$messages;

});

parcelRegister("bnHey", function(module, exports) {

$parcel$export(module.exports, "default", () => $2373e9633401d523$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8itcz = parcelRequire("8itcz");

var $6Fbwh = parcelRequire("6Fbwh");

var $5E6sS = parcelRequire("5E6sS");

var $lWUoL = parcelRequire("lWUoL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jNmTx = parcelRequire("jNmTx");

var $knfPo = parcelRequire("knfPo");

var $h6s1i = parcelRequire("h6s1i");


var $6BG4W = parcelRequire("6BG4W");

var $lENSF = parcelRequire("lENSF");

var $eG9vT = parcelRequire("eG9vT");

var $5as0a = parcelRequire("5as0a");

var $cWCvn = parcelRequire("cWCvn");

var $gYJxa = parcelRequire("gYJxa");

var $jx7QD = parcelRequire("jx7QD");

var $kIY50 = parcelRequire("kIY50");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");

var $6yplV = parcelRequire("6yplV");

var $7XCgT = parcelRequire("7XCgT");
const $2373e9633401d523$var$PageActions = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_END);
    }, []);
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const savedFilter = (0, $5as0a.isFilterId)(filterId) ? filterId : undefined; // filter out non-standard PIN named filters
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const fireAdvanceSearchClickAnalytics = (e)=>{
        const leftClick = e.type === 'contextmenu';
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    const jqlString = isModifiedFilter ? jql : undefined;
    const advancedSearchHref = `/issues/?${(0, $8itcz.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const additionalMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        key: (0, $59bd40111a092cf7$export$a7a312131aa962e0),
        onClick: (e)=>fireAdvanceSearchClickAnalytics(e),
        href: advancedSearchHref,
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $7XCgT.default).allIssues));
    const customExportTrigger = (isOpen, triggerButtonProps)=>{
        const { triggerRef: triggerRef, ...props } = triggerButtonProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG9vT.FilterIconButton), {
            customTriggerProps: {
                ...props,
                ref: triggerRef
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWUoL))),
            label: formatMessage((0, $7XCgT.default).exportIssuesButtonIconLabel),
            isSelected: isOpen
        });
    };
    const customExportDisabled = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eG9vT.FilterIconButton), {
        isDisabled: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWUoL))),
        label: formatMessage((0, $7XCgT.default).exportIssuesButtonIconLabel)
    });
    let enableQuickFilters = false;
    if ((0, $6FP8W.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isNaturalLanguageMode] = (0, $jx7QD.useNaturalLanguageMode)();
        enableQuickFilters = !isNaturalLanguageMode && !isQuickFiltersDisabled;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$export$48377ae1c677702b, null, !isAnonymous && (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lENSF.ShareButton), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter
    })), (0, $6FP8W.getWillShowNav4)() && enableQuickFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6BG4W.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knfPo.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter,
        showEcosystemApps: false,
        ...(0, $6FP8W.getWillShowNav4)() && {
            customTriggerButton: customExportTrigger,
            customDisabledButton: customExportDisabled
        }
    })), (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jNmTx.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYJxa.default), {
        filterId: filterId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2373e9633401d523$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h6s1i.default), {
        jql: jql,
        filterId: savedFilter,
        searchResultPageData: searchResultPageData,
        additionalMenuItems: (0, $6FP8W.getWillShowNav4)() && additionalMenuItems
    })));
};
var $2373e9633401d523$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2373e9633401d523$var$PageActions;
const $2373e9633401d523$var$StyledPageAction = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2 _1ul9idpf _1xoqidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2373e9633401d523$export$48377ae1c677702b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8itcz", function(module, exports) {

$parcel$export(module.exports, "decode", () => $60a6a8029ffaae01$export$2f872c0f2117be69, (v) => $60a6a8029ffaae01$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $60a6a8029ffaae01$export$98e6a39c04603d36, (v) => $60a6a8029ffaae01$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $60a6a8029ffaae01$export$c564cdbbe6da493, (v) => $60a6a8029ffaae01$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $60a6a8029ffaae01$export$fac44ee5b035f737, (v) => $60a6a8029ffaae01$export$fac44ee5b035f737 = v);
var $60a6a8029ffaae01$export$2f872c0f2117be69;
var $60a6a8029ffaae01$export$98e6a39c04603d36;
var $60a6a8029ffaae01$export$c564cdbbe6da493;
var $60a6a8029ffaae01$export$fac44ee5b035f737;
'use strict';

$60a6a8029ffaae01$export$2f872c0f2117be69 = $60a6a8029ffaae01$export$98e6a39c04603d36 = (parcelRequire("4WGGY"));

$60a6a8029ffaae01$export$c564cdbbe6da493 = $60a6a8029ffaae01$export$fac44ee5b035f737 = (parcelRequire("9xtCu"));

});
parcelRegister("4WGGY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $399db1fd33a7e3fa$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$399db1fd33a7e3fa$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($399db1fd33a7e3fa$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $399db1fd33a7e3fa$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("9xtCu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6f1e2c05a5f80c6e$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $6f1e2c05a5f80c6e$var$map($6f1e2c05a5f80c6e$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(k)) + eq;
        if ($6f1e2c05a5f80c6e$var$isArray(obj[k])) return $6f1e2c05a5f80c6e$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(name)) + eq + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj));
};
var $6f1e2c05a5f80c6e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $6f1e2c05a5f80c6e$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $6f1e2c05a5f80c6e$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("lWUoL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dee6396e12806214e5fd6f6b74ec1829>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $041fa84fc077291e$var$_react = $041fa84fc077291e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $041fa84fc077291e$var$_upload = $041fa84fc077291e$var$_interopRequireDefault((parcelRequire("1vpI2")));

var $041fa84fc077291e$var$_export = $041fa84fc077291e$var$_interopRequireDefault((parcelRequire("4i6KV")));
function $041fa84fc077291e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for UploadIcon.
 * This component is UploadIcon, with `UNSAFE_fallbackIcon` set to "ExportIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $041fa84fc077291e$var$UploadIcon = (props)=>/*#__PURE__*/ $041fa84fc077291e$var$_react.default.createElement($041fa84fc077291e$var$_upload.default, Object.assign({
        LEGACY_fallbackIcon: $041fa84fc077291e$var$_export.default
    }, props));
$041fa84fc077291e$var$UploadIcon.Name = 'UploadIconMigration';
var $041fa84fc077291e$var$_default = module.exports.default = $041fa84fc077291e$var$UploadIcon;

});
parcelRegister("1vpI2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $118ca10ad20b3a17$var$_react = $118ca10ad20b3a17$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $118ca10ad20b3a17$var$_UNSAFE_baseNew = $118ca10ad20b3a17$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $118ca10ad20b3a17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $118ca10ad20b3a17$var$UploadIcon = (props)=>/*#__PURE__*/ $118ca10ad20b3a17$var$_react.default.createElement($118ca10ad20b3a17$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$118ca10ad20b3a17$var$UploadIcon.displayName = 'UploadIcon';
var $118ca10ad20b3a17$var$_default = module.exports.default = $118ca10ad20b3a17$var$UploadIcon;

});

parcelRegister("4i6KV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31fe156faec30e95$var$_react = $31fe156faec30e95$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $31fe156faec30e95$var$_upload = $31fe156faec30e95$var$_interopRequireDefault((parcelRequire("1vpI2")));
function $31fe156faec30e95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $31fe156faec30e95$var$ExportIcon = (props)=>/*#__PURE__*/ $31fe156faec30e95$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $31fe156faec30e95$var$_upload.default
    }));
$31fe156faec30e95$var$ExportIcon.displayName = 'ExportIcon';
var $31fe156faec30e95$var$_default = module.exports.default = $31fe156faec30e95$var$ExportIcon;

});


parcelRegister("jNmTx", function(module, exports) {

$parcel$export(module.exports, "default", () => $483faf2bcd06b416$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $lUg8E = parcelRequire("lUg8E");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $lB25E = parcelRequire("lB25E");

var $RyjMw = parcelRequire("RyjMw");
const $483faf2bcd06b416$var$AdvancedSearchButton = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const jqlString = isModifiedFilter ? jql : undefined;
    const href = `/issues/?${(0, $53ciZ.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const fireClickAnalytics = (e, leftClick)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        testId: "issue-navigator-action-advanced-search-button.advanced-search-button",
        onContextMenu: (e)=>fireClickAnalytics(e, false),
        onClick: (e)=>fireClickAnalytics(e, true),
        href: href,
        component: (0, $1ybV0.ff)('nin.global-scope_aqec8') ? (0, $lB25E.Link) : undefined
    }, ' ', formatMessage((0, $RyjMw.default).allIssues));
};
var $483faf2bcd06b416$export$2e2bcd8739ae039 = $483faf2bcd06b416$var$AdvancedSearchButton;

});
parcelRegister("RyjMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98656939dcb4113$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $d98656939dcb4113$var$messages = (0, $90IgZ.defineMessages)({
    allIssues: {
        "id": "issue-navigator-action-advanced-search-button.all-issues",
        "defaultMessage": "Go to all issues"
    }
});
var $d98656939dcb4113$export$2e2bcd8739ae039 = $d98656939dcb4113$var$messages;

});


parcelRegister("knfPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f47583b52f51f07c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $f5xzw = parcelRequire("f5xzw");

var $0cdA8 = parcelRequire("0cdA8");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cBaEp = parcelRequire("cBaEp");

var $5n2jn = parcelRequire("5n2jn");

var $gGtKh = parcelRequire("gGtKh");

var $5as8g = parcelRequire("5as8g");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f47583b52f51f07c$var$ExportIssues = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("tp3yA")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/export-issues/src/ui/index.tsx"
});
const $f47583b52f51f07c$var$Fallback = ({ onRetry: onRetry, customTriggerButton: customTriggerButton })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const triggerButton = ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(false, {
            triggerRef: triggerRef,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
            ...props,
            text: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false) ? (0, $5as8g.default).exportButtonText : (0, $5as8g.default).exportIssuesButtonText),
            label: formatMessage((0, $5as8g.default).exportIssuesButtonIconLabel),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>triggerButton({
                triggerRef: triggerRef,
                ...props
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: onRetry,
        pageAction: "exportIssues"
    }));
};
const $f47583b52f51f07c$var$AsyncExportIssues = (props)=>{
    const { customTriggerButton: customTriggerButton, customDisabledButton: customDisabledButton } = props;
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionExportIssues",
        id: "async-export-issues",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f47583b52f51f07c$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error),
                customTriggerButton: customTriggerButton
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-export-issues",
        fallback: customDisabledButton ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
            isDisabled: true,
            text: formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false) ? (0, $5as8g.default).exportButtonText : (0, $5as8g.default).exportIssuesButtonText),
            label: formatMessage((0, $5as8g.default).exportIssuesButtonIconLabel)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f47583b52f51f07c$var$ExportIssues, props)));
};
var $f47583b52f51f07c$export$2e2bcd8739ae039 = $f47583b52f51f07c$var$AsyncExportIssues;

});
parcelRegister("5n2jn", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $7f3e65699e396200$export$fb46dd9777cc6db0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");

var $5IJsn = parcelRequire("5IJsn");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
const $7f3e65699e396200$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled, text: text, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $7f3e65699e396200$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7f3e65699e396200$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))), {
            label: label,
            color: "currentColor"
        })),
        ...customTriggerProps
    }, text)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7f3e65699e396200$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _2hwx196n",
            __cmplp.className
        ])
    });
});
const $7f3e65699e396200$var$buttonWrapperStyles = (0, $8Vv3m.xcss)({
    position: 'relative'
});

});

parcelRegister("5as8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e63f95712ce3819$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $4e63f95712ce3819$var$messages = (0, $90IgZ.defineMessages)({
    // remove on cleanup of jira-issue-term-fade-m1
    exportIssuesButtonText: {
        "id": "issue-navigator-action-export-issues.export-issues-button-text",
        "defaultMessage": "Export issues"
    },
    exportButtonText: {
        "id": "issue-navigator-action-export-issues.export-button-text",
        "defaultMessage": "Export"
    },
    exportIssuesButtonIconLabel: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    }
});
var $4e63f95712ce3819$export$2e2bcd8739ae039 = $4e63f95712ce3819$var$messages;

});

parcelRegister("tp3yA", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iMn9S").then(()=>parcelRequire('5vc4W'));

});


parcelRegister("h6s1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a7fc7b195c224bc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $lUg8E = parcelRequire("lUg8E");

var $f5xzw = parcelRequire("f5xzw");

var $fBmrg = parcelRequire("fBmrg");

var $0cdA8 = parcelRequire("0cdA8");

var $cBaEp = parcelRequire("cBaEp");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4a7fc7b195c224bc$var$MeatballMenu = (0, $dyfd9.lazyAfterPaint)(()=>(parcelRequire("8dSKD")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/meatball-menu/src/ui/index.tsx"
});
const $4a7fc7b195c224bc$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                ...props,
                appearance: "subtle",
                spacing: "default",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBmrg))), {
                    label: "",
                    size: "medium"
                }),
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBaEp.ErrorState), {
        onRetry: onRetry,
        pageAction: "meatballMenu"
    }));
const $4a7fc7b195c224bc$var$AsyncMeatballMenu = ({ jql: jql, filterId: filterId, searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems })=>{
    const [resetCaughtError, setResetCaughtError] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionMeatballMenu",
        id: "async-issue-navigator-actions-meatball-menu",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a7fc7b195c224bc$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-navigator-actions-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
            appearance: "subtle",
            spacing: "default",
            isDisabled: true,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBmrg))), {
                label: "",
                size: "medium"
            })
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4a7fc7b195c224bc$var$MeatballMenu, {
        jql: jql,
        filterId: filterId,
        searchResultPageData: searchResultPageData,
        additionalMenuItems: additionalMenuItems
    })));
};
var $4a7fc7b195c224bc$export$2e2bcd8739ae039 = $4a7fc7b195c224bc$var$AsyncMeatballMenu;

});
parcelRegister("8dSKD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hljUD").then(()=>parcelRequire('6pT9Z'));

});


const $59bd40111a092cf7$export$8a0f2e68464a820f = 'bulk_create_dd_link';
const $59bd40111a092cf7$export$efad93080758a558 = 'bulkedit_curr_pg';
const $59bd40111a092cf7$export$66cb530046350ea5 = 'bulkedit_all';
const $59bd40111a092cf7$export$df7b2838a6fc207e = 'gin-meatball-menu-clear-sorts';
const $59bd40111a092cf7$export$e389676e8d50a810 = 'opt-out-feedback';
const $59bd40111a092cf7$export$c1dcd93cb65a1cc5 = 'connect-app';
const $59bd40111a092cf7$export$3c1bb52064935485 = 'give-feedback';
const $59bd40111a092cf7$export$a7a312131aa962e0 = 'go-to-all-issues';

parcelRegister("6BG4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6031fcc032f3e9f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $6yplV = parcelRequire("6yplV");

var $lB25E = parcelRequire("lB25E");

var $jnl1l = parcelRequire("jnl1l");
const $a6031fcc032f3e9f$var$QuickFiltersDropdown = ({ isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ match: match }] = (0, $lB25E.useRouter)();
    const urlPrefix = match.url.endsWith('/') ? `${match.url}?filter=` : `${match.url}/?filter=`;
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const handleOnOpenChange = (0, $eUqFw.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
        else (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClick = (0, $eUqFw.useCallback)((filter)=>()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filter',
                action: 'selected'
            }), 'issueNavigatorQuickFiltersDropdown', {
                filter: filter
            });
        }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f5xzw.default), {
        trigger: formatMessage((0, $jnl1l.default).quickFilterDropdownTrigger),
        shouldRenderToParent: true,
        defaultOpen: isOpen,
        testId: "issue-navigator-action-quick-filters",
        onOpenChange: handleOnOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e0IEe.default), null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}myopenissues`,
        onClick: handleOnClick('myopenissues')
    }, formatMessage((0, $jnl1l.default).myOpenIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}reportedbyme`,
        onClick: handleOnClick('reportedbyme')
    }, formatMessage((0, $jnl1l.default).reportedByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}allopenissues`,
        onClick: handleOnClick('allopenissues')
    }, formatMessage((0, $jnl1l.default).openIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}doneissues`,
        onClick: handleOnClick('doneissues')
    }, formatMessage((0, $jnl1l.default).doneIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}recentlyviewed`,
        onClick: handleOnClick('recentlyviewed')
    }, formatMessage((0, $jnl1l.default).viewedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}resolvedrecently`,
        onClick: handleOnClick('resolvedrecently')
    }, formatMessage((0, $jnl1l.default).resolvedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5E6sS.default), {
        href: `${urlPrefix}updatedrecently`,
        onClick: handleOnClick('updatedrecently')
    }, formatMessage((0, $jnl1l.default).updatedRecently))));
};
var $a6031fcc032f3e9f$export$2e2bcd8739ae039 = $a6031fcc032f3e9f$var$QuickFiltersDropdown;

});
parcelRegister("jnl1l", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d733ef1a4bd7003$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $5d733ef1a4bd7003$var$messages = (0, $90IgZ.defineMessages)({
    quickFilterDropdownTrigger: {
        "id": "issue-navigator-action-quick-filters.quick-filter-dropdown-trigger",
        "defaultMessage": "Quick filters"
    },
    myOpenIssues: {
        "id": "issue-navigator-action-quick-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "issue-navigator-action-quick-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    openIssues: {
        "id": "issue-navigator-action-quick-filters.open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "issue-navigator-action-quick-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "issue-navigator-action-quick-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "issue-navigator-action-quick-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "issue-navigator-action-quick-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "issue-navigator-action-quick-filters.updated-recently",
        "defaultMessage": "Updated recently"
    }
});
var $5d733ef1a4bd7003$export$2e2bcd8739ae039 = $5d733ef1a4bd7003$var$messages;

});


parcelRegister("lENSF", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $e5291975c0a502e1$export$e980dfbc2840e8bc);

var $eUqFw = parcelRequire("eUqFw");

var $ar7ne = parcelRequire("ar7ne");

var $9aFSa = parcelRequire("9aFSa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5n2jn = parcelRequire("5n2jn");

var $5as0a = parcelRequire("5as0a");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $dWlsy = parcelRequire("dWlsy");

var $30zCP = parcelRequire("30zCP");

var $9vsYV = parcelRequire("9vsYV");

var $2ThFu = parcelRequire("2ThFu");

var $hDLbh = parcelRequire("hDLbh");

var $9tAVu = parcelRequire("9tAVu");
const $e5291975c0a502e1$var$getShareLink = (param, value)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { hostname: hostname, protocol: protocol } = window.location;
    return `${protocol}//${hostname}/issues/?${param}=${encodeURIComponent(value)}`;
};
const $e5291975c0a502e1$var$CustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const onKeyboardShortcutClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'shareSearchCriteriaModalKeyboardShortcut', {
            keyPressed: 's',
            keyboardShortcut: true
        });
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const shortcutsKeyMap = (0, $eUqFw.useMemo)(()=>({
            s: {
                callback: onKeyboardShortcutClick,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $9tAVu.messages).shareKeyboardShortcut))
            }
        }), [
        formatMessage,
        onKeyboardShortcutClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: shortcutsKeyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5n2jn.FilterButton), {
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        label: "",
        text: formatMessage((0, $9tAVu.messages).share),
        customTriggerProps: {
            ...triggerProps,
            'aria-haspopup': false
        }
    }));
};
const $e5291975c0a502e1$var$addContextToEvent = (event)=>{
    const attributes = event.context.map((context)=>context.attributes);
    event.update((payload)=>({
            ...payload,
            attributes: Object.assign(event.payload.attributes || {}, ...attributes)
        }));
};
const $e5291975c0a502e1$export$e980dfbc2840e8bc = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $eUqFw.useState)(false);
    const showFilterShareLinkNew = filterId !== undefined && (0, $5as0a.isCustomFilter)(filterId) && !isModifiedFilter;
    // share custom filters by ID if the JQL is not overridden, otherwise just share the JQL
    const additionalProps = showFilterShareLinkNew ? {
        integrationType: (0, $9vsYV.INTEGRATION_TYPES).FILTER,
        shareContentType: (0, $9vsYV.INTEGRATION_TYPES).FILTER,
        shareLink: $e5291975c0a502e1$var$getShareLink('filter', filterId),
        shareTitle: formatMessage((0, $9tAVu.messages).filter),
        shareFormTitle: formatMessage((0, $9tAVu.messages).dialogTitleFilter)
    } : {
        integrationType: (0, $9vsYV.INTEGRATION_TYPES).SEARCH,
        shareContentType: (0, $9vsYV.INTEGRATION_TYPES).SEARCH,
        shareLink: $e5291975c0a502e1$var$getShareLink('jql', jql),
        shareTitle: formatMessage((0, $9tAVu.messages).search),
        shareFormTitle: formatMessage((0, $9tAVu.messages).dialogTitleSearch)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ar7ne.default), {
        channel: "*",
        onEvent: $e5291975c0a502e1$var$addContextToEvent
    }, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $30zCP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: (0, $hDLbh.getShareSubProductId)(subProduct),
        objectAri: "" // The legacy sharing API does not use ARIs
        ,
        legacyShareClientConfig: (0, $2ThFu.shareSearchClientConfig),
        renderCustomTriggerButton: $e5291975c0a502e1$var$CustomTriggerButton,
        onTriggerButtonClick: ()=>{
            setShouldShowThirdPartyNudge(true);
        },
        ...additionalProps
    }));
};

});
parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonNonLazy", () => $eb292e1f91805d5c$export$2745f5fbff00ebaa);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $lUg8E = parcelRequire("lUg8E");

var $aIRhA = parcelRequire("aIRhA");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $dyfd9 = parcelRequire("dyfd9");

var $8nUKh = parcelRequire("8nUKh");

var $iHQJU = parcelRequire("iHQJU");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aIRhA))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $1b343b038f6c23ec$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $dyfd9.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("iHQJU"))), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $eb292e1f91805d5c$export$2745f5fbff00ebaa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iHQJU.default), props));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("aIRhA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ce75845568c60f5$var$_react = $7ce75845568c60f5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $7ce75845568c60f5$var$_share = $7ce75845568c60f5$var$_interopRequireDefault((parcelRequire("ffimc")));
function $7ce75845568c60f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ce75845568c60f5$var$ShareIcon = (props)=>/*#__PURE__*/ $7ce75845568c60f5$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $7ce75845568c60f5$var$_share.default
    }));
$7ce75845568c60f5$var$ShareIcon.displayName = 'ShareIcon';
var $7ce75845568c60f5$var$_default = module.exports.default = $7ce75845568c60f5$var$ShareIcon;

});
parcelRegister("ffimc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1967f0e34536903$var$_react = $b1967f0e34536903$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b1967f0e34536903$var$_UNSAFE_baseNew = $b1967f0e34536903$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $b1967f0e34536903$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1967f0e34536903$var$ShareIcon = (props)=>/*#__PURE__*/ $b1967f0e34536903$var$_react.default.createElement($b1967f0e34536903$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$b1967f0e34536903$var$ShareIcon.displayName = 'ShareIcon';
var $b1967f0e34536903$var$_default = module.exports.default = $b1967f0e34536903$var$ShareIcon;

});


parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("iHQJU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f34cc533a63143c6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $ce4rN = parcelRequire("ce4rN");

var $5dKU1 = parcelRequire("5dKU1");

var $493jA = parcelRequire("493jA");

var $5KiBf = parcelRequire("5KiBf");

var $8zXW0 = parcelRequire("8zXW0");

var $8MYMy = parcelRequire("8MYMy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f34cc533a63143c6$export$2e2bcd8739ae039 = (props)=>{
    const { integrationType: integrationType, triggerButtonStyle: triggerButtonStyle, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, shareShortcutTriggerCount: shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $gd0Sp.useTenantContext)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $5dKU1.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $493jA.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $ce4rN.useIsHipaaComplianceService)();
    const [isAutoOpen, setIsAutoOpen] = (0, $eUqFw.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $eUqFw.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $eUqFw.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    const getCustomFormTitle = (0, $eUqFw.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $5KiBf.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $eUqFw.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $guiFP.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $guiFP.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (userPermissionError) (0, $guiFP.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (outgoingMailStatus === undefined || outgoingMailStatus?.isEmailEnabled === false || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zXW0.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount
    }), outgoingMailStatus?.isEmailEnabled === true && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MYMy.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $huI7r.createAri)({
            resourceId: activationId,
            cloudId: cloudId,
            resourceType: 'workspace',
            resourceOwner: 'jira'
        }),
        ...otherProps
    }));
};

});
parcelRegister("ce4rN", function(module, exports) {

$parcel$export(module.exports, "useIsHipaaComplianceService", () => $c4937ecf4de18f4f$export$dad138577ca71048);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $c4937ecf4de18f4f$var$getHipaaComplianceStatus = async ()=>(0, $lRmyA.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $c4937ecf4de18f4f$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $eEzyV.useService)($c4937ecf4de18f4f$var$getHipaaComplianceStatus);
    const transformedData = (0, $eUqFw.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});

parcelRegister("5dKU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e868744b66a325$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $07e868744b66a325$var$getEmailSettings = async ()=>(0, $lRmyA.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $07e868744b66a325$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $eEzyV.useService)($07e868744b66a325$var$getEmailSettings);
    const transformedData = (0, $eUqFw.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $07e868744b66a325$export$2e2bcd8739ae039 = $07e868744b66a325$export$5f20fafd52370aae;

});

parcelRegister("493jA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2000a1fa3dad3110$export$2e2bcd8739ae039);

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $2000a1fa3dad3110$var$getUserPermission = async ()=>(0, $lRmyA.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $2000a1fa3dad3110$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $eEzyV.useService)($2000a1fa3dad3110$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $2000a1fa3dad3110$export$2e2bcd8739ae039 = $2000a1fa3dad3110$export$ce7974a7294500be;

});

parcelRegister("5KiBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3f04a0c7828f4b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2c3f04a0c7828f4b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("8zXW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $86834bd052f4d362$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kRXDJ = parcelRequire("kRXDJ");

var $lUg8E = parcelRequire("lUg8E");

var $ffimc = parcelRequire("ffimc");

var $aIRhA = parcelRequire("aIRhA");

var $eruWR = parcelRequire("eruWR");

var $bBdMg = parcelRequire("bBdMg");

var $jl1we = parcelRequire("jl1we");

var $kGQen = parcelRequire("kGQen");

var $c9TLT = parcelRequire("c9TLT");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $8rQuz = parcelRequire("8rQuz");

var $01uPl = parcelRequire("01uPl");

var $4C7gg = parcelRequire("4C7gg");
const $86834bd052f4d362$var$ConditionalTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jl1we.default), {
        content: formatMessage((0, $01uPl.default).shareTriggerButtonText),
        position: "top"
    }, children);
};
const $86834bd052f4d362$var$PreShareView = ({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $eUqFw.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $eUqFw.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
        }
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eruWR.default), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $c9TLT.layers).modal,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86834bd052f4d362$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warningModal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bBdMg.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4C7gg.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $01uPl.default).errorMessage)))),
        isOpen: isOpen,
        placement: "left-start",
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView')
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86834bd052f4d362$var$ConditionalTooltip, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
                testId: "share-button.ui.pre-share-view.button",
                isDisabled: loading,
                label: formatMessage((0, $01uPl.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ffimc))), {
                        spacing: "spacious",
                        label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $01uPl.default).shareTriggerButtonText),
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView')
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
                testId: "share-button.ui.pre-share-view.button" // @ts-expect-error - TS2322 - Type '{ children: string | null; appearance: "subtle"; iconBefore: Element; onClick: () => void; ref: Ref<HTMLElement>; 'aria-controls'?: string | undefined; 'aria-expanded': boolean; 'aria-haspopup': boolean; testId: string; disabled: boolean; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
                ,
                disabled: loading,
                ...triggerProps,
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aIRhA))), {
                    size: "medium",
                    label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $01uPl.default).shareTriggerButtonText),
                    primaryColor: "var(--ds-icon, #44546F)"
                }),
                onClick: ()=>onTriggerClick('PreShareView')
            }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $01uPl.default).shareTriggerButtonText) : null))
    });
};
var $86834bd052f4d362$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $86834bd052f4d362$var$PreShareView;
const $86834bd052f4d362$var$DialogLayout = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("01uPl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0590d2ba434fe8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2f0590d2ba434fe8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("4C7gg", function(module, exports) {

$parcel$export(module.exports, "WarningContent", () => $8106d7aafbb60254$export$b7eb687edfdfe752);

var $eUqFw = parcelRequire("eUqFw");

var $93tHo = parcelRequire("93tHo");

var $dnbhd = parcelRequire("dnbhd");

var $8uD7Y = parcelRequire("8uD7Y");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $avRp9 = parcelRequire("avRp9");
function $8106d7aafbb60254$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93tHo))), {
        size: "medium",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $avRp9.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});
parcelRegister("avRp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6983abd5e3ebe0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ad6983abd5e3ebe0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    }
});

});



parcelRegister("8MYMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe41a183ab13eb9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $g0E5j = parcelRequire("g0E5j");
parcelRequire("eD9ns");
var $3aikN = parcelRequire("3aikN");

var $e91YZ = parcelRequire("e91YZ");

var $2OdyW = parcelRequire("2OdyW");

var $5oIBC = parcelRequire("5oIBC");

var $giAhk = parcelRequire("giAhk");

var $k4wXf = parcelRequire("k4wXf");

var $abtNr = parcelRequire("abtNr");
const $bfe41a183ab13eb9$var$USER_PICKER_LIMIT = 20;
class $bfe41a183ab13eb9$export$e980dfbc2840e8bc extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            shouldAutoDismissFlag: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onTriggerButtonClick: ()=>{}
        };
    }
    constructor(props){
        super(props);
        this.getOriginTracingInstance = ()=>new (0, $g0E5j.default)({
                product: this.props.productId
            });
        this.loadUsers = async (searchText = '')=>{
            const searchTextEncoded = encodeURIComponent(searchText);
            const url = `/rest/api/3/groupuserpicker?maxResults=${$bfe41a183ab13eb9$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
            const groupsAndUsers = await (0, $2OdyW.default)(url);
            return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>{
                const userData = {
                    type: 'user',
                    id: user.accountId,
                    name: user.displayName,
                    avatarUrl: user.avatarUrl
                };
                return userData;
            });
        };
        this.showFlags = (flags)=>{
            const { flagService: flagService, shouldAutoDismissFlag: shouldAutoDismissFlag } = this.props;
            if (flagService.showFlag) flags.forEach((flag)=>{
                flagService.showFlag({
                    type: flag.appearance,
                    title: flag.title.defaultMessage,
                    isAutoDismiss: shouldAutoDismissFlag
                });
            });
        };
        this.cloudId = '';
        this.cloudId = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().cloudId;
        if (props.legacyShareClientConfig !== undefined) this.legacyShareClient = new (0, $abtNr.default)(props.legacyShareClientConfig);
    }
    render() {
        const { objectAri: objectAri, renderCustomTriggerButton: renderCustomTriggerButton, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, subProductId: subProductId, triggerButtonAppearance: triggerButtonAppearance = 'subtle', triggerButtonStyle: triggerButtonStyle, onTriggerButtonClick: onTriggerButtonClick, shareIntegrations: shareIntegrations, integrationMode: integrationMode = 'off', isAutoOpenDialog: isAutoOpenDialog, onDialogClose: onDialogClose, copyTooltipText: copyTooltipText, orgId: orgId, isBrowseUsersEnabled: isBrowseUsersEnabled, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aikN.ShareDialogContainer), {
            shareClient: this.legacyShareClient,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            cloudId: this.cloudId,
            orgId: orgId,
            loadUserOptions: this.legacyShareClient && this.loadUsers,
            // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
            originTracingFactory: this.getOriginTracingInstance,
            productId: subProductId,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareAri: objectAri || (0, $k4wXf.createAri)(subProductId, this.cloudId),
            shareFormHelperMessage: shareFormHelperMessage,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            showFlags: this.showFlags,
            enableSmartUserPicker: !this.legacyShareClient,
            product: "jira",
            onTriggerButtonClick: onTriggerButtonClick,
            shareIntegrations: shareIntegrations,
            integrationMode: integrationMode,
            isAutoOpenDialog: isAutoOpenDialog,
            onDialogClose: onDialogClose,
            copyTooltipText: copyTooltipText,
            isBrowseUsersDisabled: isBrowseUsersEnabled === false,
            shareFieldsFooter: shareFieldsFooter,
            workspaceAri: this.props.workspaceAri
        });
    }
}
var $bfe41a183ab13eb9$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $5oIBC.default)($bfe41a183ab13eb9$export$e980dfbc2840e8bc));

});
parcelRegister("eD9ns", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => (parcelRequire("3aikN")).ShareDialogContainer);

var $3aikN = parcelRequire("3aikN");

var $5ZKXn = parcelRequire("5ZKXn");

var $bVzYo = parcelRequire("bVzYo");

});
parcelRegister("3aikN", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => $11a5325340c50f00$export$78b28896b43ae5d6);

var $eUqFw = parcelRequire("eUqFw");

var $aG7FO = parcelRequire("aG7FO");

var $5iWql = parcelRequire("5iWql");

var $8uD7Y = parcelRequire("8uD7Y");

var $8ynlC = parcelRequire("8ynlC");

var $f3klQ = parcelRequire("f3klQ");

var $5SSre = parcelRequire("5SSre");

var $1INIa = parcelRequire("1INIa");

var $7WN8P = parcelRequire("7WN8P");

var $bLAWR = parcelRequire("bLAWR");

var $encBb = parcelRequire("encBb");

var $1FYo4 = parcelRequire("1FYo4");

var $a8PoO = parcelRequire("a8PoO");

var $5PhnX = parcelRequire("5PhnX");

var $4D4HV = parcelRequire("4D4HV");

var $1Vq8e = parcelRequire("1Vq8e");
const $11a5325340c50f00$var$COPY_LINK_EVENT = (0, $bLAWR.copyLinkButtonClicked)({
    start: 0
});
const $11a5325340c50f00$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $11a5325340c50f00$var$memoizedFormatCopyLink = (0, $5iWql.default)((origin, link)=>origin.addToUrl(link));
function $11a5325340c50f00$var$getCurrentPageUrl() {
    return window.location.href;
}
class $11a5325340c50f00$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props);
        this._isMounted = false;
        this._urlShorteningRequestCounter = 0;
        this._lastUrlShorteningWasTooSlow = false;
        this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $bLAWR.CHANNEL_ID));
        };
        this.fetchConfig = ()=>{
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $1FYo4.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $1FYo4.renderShareDialogExp).success();
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $11a5325340c50f00$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $encBb.isValidFailedExperience)((0, $1FYo4.renderShareDialogExp), errObj);
                }
            });
        };
        this.handleSubmitShare = ({ users: users, comment: comment })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            return this.shareClient.share(content, (0, $1Vq8e.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        };
        this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $11a5325340c50f00$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        };
        this.decorateAnalytics = (payload)=>{
            if (payload.type === $11a5325340c50f00$var$COPY_LINK_EVENT.type && payload.action === $11a5325340c50f00$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $11a5325340c50f00$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        };
        // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $5iWql.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        });
        // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $5iWql.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        });
        this.getUpToDateShortenedCopyLink = (0, $5iWql.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $bLAWR.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $bLAWR.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $bLAWR.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aG7FO))));
        this.getFormShareLink = ()=>{
            // original share link is used here
            return this.getRawLink();
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $8ynlC.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $1INIa.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $5SSre.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $11a5325340c50f00$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $11a5325340c50f00$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($aG7FO)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $11a5325340c50f00$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8PoO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PhnX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4D4HV.ShareDialogWithTrigger), {
            onTriggerButtonClick: onTriggerButtonClick,
            isAutoOpenDialog: isAutoOpenDialog,
            config: config,
            isFetchingConfig: isFetchingConfig,
            copyLink: this.getCopyLink(),
            analyticsDecorator: this.decorateAnalytics,
            dialogPlacement: dialogPlacement,
            loadUserOptions: loadUserOptions,
            onDialogOpen: this.handleDialogOpen,
            onShareSubmit: this.handleSubmitShare,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareContentType: shareContentType,
            shareContentSubType: shareContentSubType,
            shareContentId: shareContentId,
            shareFormTitle: shareFormTitle,
            shareFormHelperMessage: shareFormHelperMessage,
            copyLinkOrigin: this.getCopyLinkOriginTracing(),
            formShareOrigin: this.getFormShareOriginTracing(),
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            showFlags: showFlags,
            enableSmartUserPicker: enableSmartUserPicker,
            loggedInAccountId: loggedInAccountId,
            cloudId: cloudId,
            orgId: orgId,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonIcon: triggerButtonIcon,
            triggerButtonStyle: triggerButtonStyle,
            triggerButtonTooltipPosition: triggerButtonTooltipPosition,
            triggerButtonTooltipText: triggerButtonTooltipText,
            bottomMessage: bottomMessage,
            submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7WN8P.messages).inviteTriggerButtonText),
            product: product,
            productAttributes: productAttributes,
            customFooter: customFooter,
            onUserSelectionChange: onUserSelectionChange,
            shareFieldsFooter: shareFieldsFooter,
            isCopyDisabled: isCopyDisabled,
            isPublicLink: isPublicLink,
            integrationMode: integrationMode,
            shareIntegrations: shareIntegrations,
            shareAri: shareAri,
            tabIndex: tabIndex,
            copyTooltipText: copyTooltipText,
            onDialogClose: onDialogClose,
            isBrowseUsersDisabled: isBrowseUsersDisabled,
            userPickerOptions: userPickerOptions
        })));
    }
}
const $11a5325340c50f00$export$78b28896b43ae5d6 = (0, $f3klQ.default)()($11a5325340c50f00$export$bc8c417f2da43f4);

});
parcelRegister("aG7FO", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("5SSre", function(module, exports) {

$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $12750450112259e7$export$8fed7002650b52ef);
class $12750450112259e7$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("1INIa", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => $e7761b3cf00b0eb2$export$ee05f3e1f0248b62);

var $1Ka8p = parcelRequire("1Ka8p");
const $e7761b3cf00b0eb2$export$a7d7a4246bdd7a12 = 'share';
const $e7761b3cf00b0eb2$export$1a440d9a41e6ce3e = 'share/configuration';
const $e7761b3cf00b0eb2$export$7745139d0aa6183c = '/gateway/api';
class $e7761b3cf00b0eb2$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $e7761b3cf00b0eb2$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $e7761b3cf00b0eb2$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $1Ka8p.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$e7761b3cf00b0eb2$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("7WN8P", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cfb6e18c131ef2c3$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $cfb6e18c131ef2c3$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("bLAWR", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_ID", () => $755f1378a4aaebbb$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $755f1378a4aaebbb$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $755f1378a4aaebbb$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $755f1378a4aaebbb$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $755f1378a4aaebbb$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $755f1378a4aaebbb$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $755f1378a4aaebbb$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $755f1378a4aaebbb$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $755f1378a4aaebbb$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $755f1378a4aaebbb$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $755f1378a4aaebbb$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $755f1378a4aaebbb$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $755f1378a4aaebbb$export$e78d65558f8d859a);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $755f1378a4aaebbb$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $755f1378a4aaebbb$export$e2e6cacbe383cb80);

var $hXhjk = parcelRequire("hXhjk");
const $755f1378a4aaebbb$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $755f1378a4aaebbb$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $755f1378a4aaebbb$var$buildAttributes(attributes)
    });
const $755f1378a4aaebbb$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $755f1378a4aaebbb$var$buildAttributes(attributes)
    });
const $755f1378a4aaebbb$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $755f1378a4aaebbb$export$f7109619a5e9e0d6 = 'shareModal';
const $755f1378a4aaebbb$export$8944b0a832f27e18 = 'integrationShareDialog';
const $755f1378a4aaebbb$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$755f1378a4aaebbb$var$createScreenEvent($755f1378a4aaebbb$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $755f1378a4aaebbb$export$eab30ffadcd0ab75 = ()=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $755f1378a4aaebbb$export$f04d85d45801fef1 = (type = '')=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $755f1378a4aaebbb$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$755f1378a4aaebbb$var$createEvent('operational', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6
    });
const $755f1378a4aaebbb$export$584e8ee8b04ff145 = ()=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $755f1378a4aaebbb$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $755f1378a4aaebbb$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $755f1378a4aaebbb$export$b4731c87331a8174 = (start)=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6,
        duration: $755f1378a4aaebbb$var$duration(start)
    });
const $755f1378a4aaebbb$export$35781a2d50f9fba9 = ()=>$755f1378a4aaebbb$var$createEvent('operational', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6
    });
const $755f1378a4aaebbb$export$e78d65558f8d859a = (start, tooSlow)=>$755f1378a4aaebbb$var$createEvent('operational', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6,
        duration: $755f1378a4aaebbb$var$duration(start),
        tooSlow: tooSlow
    });
const $755f1378a4aaebbb$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $755f1378a4aaebbb$export$f7109619a5e9e0d6,
        duration: $755f1378a4aaebbb$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$755f1378a4aaebbb$var$getOriginTracingAttributes(shareOrigin)
    });
const $755f1378a4aaebbb$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isUser));
    const externalUsers = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isExternalUser));
    const teams = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isTeam));
    const teamUserCounts = $755f1378a4aaebbb$var$extractMemberCountsFromTeams(data, (0, $hXhjk.isTeam));
    const emails = $755f1378a4aaebbb$var$extractIdsByType(data, (0, $hXhjk.isEmail));
    return $755f1378a4aaebbb$var$createEvent('ui', $755f1378a4aaebbb$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$755f1378a4aaebbb$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $755f1378a4aaebbb$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $755f1378a4aaebbb$var$duration = (start)=>Date.now() - start;
const $755f1378a4aaebbb$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $755f1378a4aaebbb$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $755f1378a4aaebbb$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);

});
parcelRegister("hXhjk", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $669a36b46b08f120$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $669a36b46b08f120$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $669a36b46b08f120$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $669a36b46b08f120$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $669a36b46b08f120$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $669a36b46b08f120$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $669a36b46b08f120$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $669a36b46b08f120$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $669a36b46b08f120$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $669a36b46b08f120$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $669a36b46b08f120$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $669a36b46b08f120$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $669a36b46b08f120$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $669a36b46b08f120$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $669a36b46b08f120$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $669a36b46b08f120$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $669a36b46b08f120$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $669a36b46b08f120$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $669a36b46b08f120$export$5419897287f5f1c7);

var $5iWql = parcelRequire("5iWql");


var $5IfN7 = parcelRequire("5IfN7");
const $669a36b46b08f120$export$f6058dbcb5980cb = (option)=>option.type === (0, $fd83a679af43746b$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $669a36b46b08f120$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $fd83a679af43746b$export$8436e53e45ffe15b);
const $669a36b46b08f120$export$f8c4277cb588611f = (option)=>option.type === (0, $fd83a679af43746b$export$26bc40b960693765);
const $669a36b46b08f120$export$d7976824e9f55785 = (option)=>option.type === (0, $fd83a679af43746b$export$d460f747b73abb10);
const $669a36b46b08f120$export$7fbbfbca30081d0 = (option)=>option.type === (0, $fd83a679af43746b$export$6662b3461398ef8c);
const $669a36b46b08f120$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $fd83a679af43746b$export$eafd0979afa5b224);
const $669a36b46b08f120$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $669a36b46b08f120$var$isOptionData = (option)=>option.name !== undefined;
const $669a36b46b08f120$export$3f993c492bd6c728 = (option)=>{
    if ($669a36b46b08f120$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $669a36b46b08f120$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $669a36b46b08f120$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $669a36b46b08f120$export$d2312e68e1f5ad00 = (0, $5iWql.default)((options)=>options.map($669a36b46b08f120$export$3f993c492bd6c728));
const $669a36b46b08f120$export$e6fda14a194bcbcc = (0, $5iWql.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($669a36b46b08f120$export$3f993c492bd6c728);
    return $669a36b46b08f120$export$3f993c492bd6c728(defaultValue);
});
const $669a36b46b08f120$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $669a36b46b08f120$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $669a36b46b08f120$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $669a36b46b08f120$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $669a36b46b08f120$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $669a36b46b08f120$export$b4f8f1f54acec99b = (optionData)=>{
    if ($669a36b46b08f120$export$2e44165f1da65304(optionData) || $669a36b46b08f120$export$f8c4277cb588611f(optionData) || $669a36b46b08f120$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $669a36b46b08f120$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $5IfN7.default);
const $669a36b46b08f120$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $669a36b46b08f120$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $fd83a679af43746b$export$8436e53e45ffe15b = 'user';
const $fd83a679af43746b$export$50042ec1d2e00e63 = 'external_user';
const $fd83a679af43746b$export$26bc40b960693765 = 'team';
const $fd83a679af43746b$export$d460f747b73abb10 = 'group';
const $fd83a679af43746b$export$6662b3461398ef8c = 'email';
const $fd83a679af43746b$export$eafd0979afa5b224 = 'custom';

parcelRegister("5IfN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf75109f1a322fd4$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $lbDTY = parcelRequire("lbDTY");

var $kQSBm = parcelRequire("kQSBm");
var $5bdEm = parcelRequire("5bdEm");
var $dmg8t = parcelRequire("dmg8t");

var $asNSH = parcelRequire("asNSH");

var $2Pede = parcelRequire("2Pede");

var $gYrJM = parcelRequire("gYrJM");

var $8r9C9 = parcelRequire("8r9C9");


var $aJuqz = parcelRequire("aJuqz");

var $a3o6L = parcelRequire("a3o6L");

var $NHgCB = parcelRequire("NHgCB");

var $2FrYX = parcelRequire("2FrYX");
/**
 * Are we rendering on the client or server?
 */ const $bf75109f1a322fd4$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $bf75109f1a322fd4$var$FocusLock = (0, $gYrJM.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
const $bf75109f1a322fd4$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $bf75109f1a322fd4$var$defaultPopperProps = {
    modifiers: $bf75109f1a322fd4$var$modifiers,
    placement: 'bottom-start'
};
const $bf75109f1a322fd4$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $bf75109f1a322fd4$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$bf75109f1a322fd4$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $2FrYX.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$bf75109f1a322fd4$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQSBm.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Pede.IdProvider), {
            postfix: "-popup-select"
        }, ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dmg8t.Reference), null, ({ ref: ref })=>target && target({
                    isOpen: isOpen,
                    onKeyDown: this.handleTargetKeyDown,
                    ref: this.resolveTargetRef(ref),
                    'aria-haspopup': 'true',
                    'aria-expanded': isOpen,
                    'aria-controls': isOpen ? id : undefined
                })), this.renderSelect(id))));
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $8r9C9.mergeStyles)((0, $a3o6L.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $2FrYX.defaultComponents),
            mergedPopperProps: $bf75109f1a322fd4$var$defaultPopperProps
        };
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $gYrJM.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $gYrJM.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $gYrJM.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $bf75109f1a322fd4$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $2FrYX.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $NHgCB.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $NHgCB.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $NHgCB.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bdEm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf75109f1a322fd4$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2FrYX.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: id,
                    testId: testId,
                    ref: !(0, $gYrJM.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bf75109f1a322fd4$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aJuqz.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $8r9C9.mergeStyles)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $bf75109f1a322fd4$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("kQSBm", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $f2e304bb02006a02$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $f2e304bb02006a02$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $f2e304bb02006a02$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $f2e304bb02006a02$export$3dbd3405086fec7b = $eUqFw.createContext();
var $f2e304bb02006a02$export$cbabb21c2529b130 = $eUqFw.createContext();
function $f2e304bb02006a02$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($f2e304bb02006a02$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($f2e304bb02006a02$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("5bdEm", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $3c589169ddd94ce2$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $kQSBm = parcelRequire("kQSBm");

var $2Leve = parcelRequire("2Leve");

var $efr5v = parcelRequire("efr5v");
var $3c589169ddd94ce2$var$NOOP = function NOOP() {
    return void 0;
};
var $3c589169ddd94ce2$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $3c589169ddd94ce2$var$EMPTY_MODIFIERS = [];
function $3c589169ddd94ce2$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $3c589169ddd94ce2$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $kQSBm.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $2Leve.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $efr5v.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $3c589169ddd94ce2$var$NOOP,
            update: update || $3c589169ddd94ce2$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $2Leve.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("2Leve", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $202b3879e180f9e1$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $202b3879e180f9e1$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $202b3879e180f9e1$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $202b3879e180f9e1$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $202b3879e180f9e1$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $202b3879e180f9e1$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $202b3879e180f9e1$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $202b3879e180f9e1$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $202b3879e180f9e1$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $202b3879e180f9e1$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $202b3879e180f9e1$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("efr5v", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $a5f77a7e238a9101$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $ap33P = parcelRequire("ap33P");

var $an8Qp = parcelRequire("an8Qp");

var $2Leve = parcelRequire("2Leve");
var $a5f77a7e238a9101$var$EMPTY_MODIFIERS = [];
var $a5f77a7e238a9101$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $a5f77a7e238a9101$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $2Leve.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $2Leve.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $2Leve.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $2Leve.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $ap33P.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("ap33P", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $792e9cfbd261b473$export$8f7491d57c8f97a9);

var $lYrVW = parcelRequire("lYrVW");

var $anyZr = parcelRequire("anyZr");

var $3QpMQ = parcelRequire("3QpMQ");

var $bbqbM = parcelRequire("bbqbM");

var $lro9d = parcelRequire("lro9d");

var $6qkVe = parcelRequire("6qkVe");

var $8rAdb = parcelRequire("8rAdb");

var $gFjel = parcelRequire("gFjel");

var $hiKPe = parcelRequire("hiKPe");

var $izul8 = parcelRequire("izul8");


var $792e9cfbd261b473$export$d34966752335dd47 = [
    (0, $anyZr.default),
    (0, $3QpMQ.default),
    (0, $bbqbM.default),
    (0, $lro9d.default),
    (0, $6qkVe.default),
    (0, $8rAdb.default),
    (0, $gFjel.default),
    (0, $hiKPe.default),
    (0, $izul8.default)
];
var $792e9cfbd261b473$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $lYrVW.popperGenerator)({
    defaultModifiers: $792e9cfbd261b473$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("lYrVW", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $fff4de9b669adeeb$export$ed5e13716264f202);

var $ag20p = parcelRequire("ag20p");

var $QrBqo = parcelRequire("QrBqo");

var $ePkdB = parcelRequire("ePkdB");

var $dNrcD = parcelRequire("dNrcD");

var $67G0M = parcelRequire("67G0M");

var $fb5CK = parcelRequire("fb5CK");

var $dFfUS = parcelRequire("dFfUS");


var $edBYZ = parcelRequire("edBYZ");
var $fff4de9b669adeeb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $fff4de9b669adeeb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $fff4de9b669adeeb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $fff4de9b669adeeb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $fff4de9b669adeeb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $edBYZ.isElement)(reference) ? (0, $ePkdB.default)(reference) : reference.contextElement ? (0, $ePkdB.default)(reference.contextElement) : [],
                    popper: (0, $ePkdB.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $67G0M.default)((0, $dFfUS.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$fff4de9b669adeeb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $ag20p.default)(reference, (0, $dNrcD.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $QrBqo.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $fb5CK.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$fff4de9b669adeeb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $fff4de9b669adeeb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $fff4de9b669adeeb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("ag20p", function(module, exports) {

$parcel$export(module.exports, "default", () => $777cf448ef0803dd$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");

var $9xSYk = parcelRequire("9xSYk");

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");

var $5l3cx = parcelRequire("5l3cx");

var $80xbK = parcelRequire("80xbK");

var $lB8uB = parcelRequire("lB8uB");

var $lCnHF = parcelRequire("lCnHF");
function $777cf448ef0803dd$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $lCnHF.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $lCnHF.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $777cf448ef0803dd$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $edBYZ.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $edBYZ.isHTMLElement)(offsetParent) && $777cf448ef0803dd$var$isElementScaled(offsetParent);
    var documentElement = (0, $80xbK.default)(offsetParent);
    var rect = (0, $1a1A9.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $k9tfz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lB8uB.default)(documentElement)) scroll = (0, $9xSYk.default)(offsetParent);
        if ((0, $edBYZ.isHTMLElement)(offsetParent)) {
            offsets = (0, $1a1A9.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5l3cx.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("1a1A9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d87f3ca928fe9a2$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");

var $lCnHF = parcelRequire("lCnHF");

var $3xJ5v = parcelRequire("3xJ5v");

var $920uN = parcelRequire("920uN");
function $0d87f3ca928fe9a2$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $edBYZ.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $lCnHF.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $lCnHF.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $edBYZ.isElement)(element) ? (0, $3xJ5v.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $920uN.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("edBYZ", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $a59fbe293893fdf9$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $a59fbe293893fdf9$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $a59fbe293893fdf9$export$af51f0f06c0f328a);

var $3xJ5v = parcelRequire("3xJ5v");
function $a59fbe293893fdf9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3xJ5v.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $a59fbe293893fdf9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3xJ5v.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $a59fbe293893fdf9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $3xJ5v.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("3xJ5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $29476dadb45dea2c$export$2e2bcd8739ae039);
function $29476dadb45dea2c$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("lCnHF", function(module, exports) {

$parcel$export(module.exports, "max", () => $fbcf889019494e36$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $fbcf889019494e36$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $fbcf889019494e36$export$2077e0241d6afd3c);
var $fbcf889019494e36$export$8960430cfd85939f = Math.max;
var $fbcf889019494e36$export$96ec731ed4dcb222 = Math.min;
var $fbcf889019494e36$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("920uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6934af65acd9e478$export$2e2bcd8739ae039);

var $72LZU = parcelRequire("72LZU");
function $6934af65acd9e478$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $72LZU.default)());
}

});
parcelRegister("72LZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $520df39ba6a9a4ac$export$2e2bcd8739ae039);
function $520df39ba6a9a4ac$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9xSYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f31d66ead222a8d$export$2e2bcd8739ae039);

var $ac1Wl = parcelRequire("ac1Wl");

var $3xJ5v = parcelRequire("3xJ5v");

var $edBYZ = parcelRequire("edBYZ");

var $hdS5H = parcelRequire("hdS5H");
function $6f31d66ead222a8d$export$2e2bcd8739ae039(node) {
    if (node === (0, $3xJ5v.default)(node) || !(0, $edBYZ.isHTMLElement)(node)) return (0, $ac1Wl.default)(node);
    else return (0, $hdS5H.default)(node);
}

});
parcelRegister("ac1Wl", function(module, exports) {

$parcel$export(module.exports, "default", () => $76bc879f580a47a7$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
function $76bc879f580a47a7$export$2e2bcd8739ae039(node) {
    var win = (0, $3xJ5v.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("hdS5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89d9be7ec372ac1$export$2e2bcd8739ae039);
function $c89d9be7ec372ac1$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("k9tfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eabb5662a7f5257f$export$2e2bcd8739ae039);
function $eabb5662a7f5257f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("5l3cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e31659f48c6f7d6$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");

var $80xbK = parcelRequire("80xbK");

var $ac1Wl = parcelRequire("ac1Wl");
function $3e31659f48c6f7d6$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1a1A9.default)((0, $80xbK.default)(element)).left + (0, $ac1Wl.default)(element).scrollLeft;
}

});
parcelRegister("80xbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d481159709e436d$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");
function $5d481159709e436d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $edBYZ.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lB8uB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb93a41cc2fd2e28$export$2e2bcd8739ae039);

var $aPsIR = parcelRequire("aPsIR");
function $fb93a41cc2fd2e28$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $aPsIR.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("aPsIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e24f28110b44487$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
function $7e24f28110b44487$export$2e2bcd8739ae039(element) {
    return (0, $3xJ5v.default)(element).getComputedStyle(element);
}

});



parcelRegister("QrBqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $09da44bfd33a27e6$export$2e2bcd8739ae039);

var $1a1A9 = parcelRequire("1a1A9");
function $09da44bfd33a27e6$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1a1A9.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("ePkdB", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb58313ecb6072d$export$2e2bcd8739ae039);

var $fJHhD = parcelRequire("fJHhD");

var $hoKF3 = parcelRequire("hoKF3");

var $3xJ5v = parcelRequire("3xJ5v");

var $lB8uB = parcelRequire("lB8uB");
function $acb58313ecb6072d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fJHhD.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3xJ5v.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lB8uB.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($acb58313ecb6072d$export$2e2bcd8739ae039((0, $hoKF3.default)(target)));
}

});
parcelRegister("fJHhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b74ca229b5aac469$export$2e2bcd8739ae039);

var $hoKF3 = parcelRequire("hoKF3");

var $lB8uB = parcelRequire("lB8uB");

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");
function $b74ca229b5aac469$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $k9tfz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $edBYZ.isHTMLElement)(node) && (0, $lB8uB.default)(node)) return node;
    return $b74ca229b5aac469$export$2e2bcd8739ae039((0, $hoKF3.default)(node));
}

});
parcelRegister("hoKF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caa8df7de2e956b1$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");

var $80xbK = parcelRequire("80xbK");

var $edBYZ = parcelRequire("edBYZ");
function $caa8df7de2e956b1$export$2e2bcd8739ae039(element) {
    if ((0, $k9tfz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $edBYZ.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $80xbK.default)(element) // fallback
    );
}

});



parcelRegister("dNrcD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b4f3d95d479f23$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");

var $k9tfz = parcelRequire("k9tfz");

var $aPsIR = parcelRequire("aPsIR");

var $edBYZ = parcelRequire("edBYZ");

var $kqjk2 = parcelRequire("kqjk2");

var $hoKF3 = parcelRequire("hoKF3");

var $72LZU = parcelRequire("72LZU");
function $a0b4f3d95d479f23$var$getTrueOffsetParent(element) {
    if (!(0, $edBYZ.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $aPsIR.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a0b4f3d95d479f23$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $72LZU.default)());
    var isIE = /Trident/i.test((0, $72LZU.default)());
    if (isIE && (0, $edBYZ.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $aPsIR.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $hoKF3.default)(element);
    if ((0, $edBYZ.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $edBYZ.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $k9tfz.default)(currentNode)) < 0){
        var css = (0, $aPsIR.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a0b4f3d95d479f23$export$2e2bcd8739ae039(element) {
    var window = (0, $3xJ5v.default)(element);
    var offsetParent = $a0b4f3d95d479f23$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $kqjk2.default)(offsetParent) && (0, $aPsIR.default)(offsetParent).position === 'static')offsetParent = $a0b4f3d95d479f23$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $k9tfz.default)(offsetParent) === 'html' || (0, $k9tfz.default)(offsetParent) === 'body' && (0, $aPsIR.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $a0b4f3d95d479f23$var$getContainingBlock(element) || window;
}

});
parcelRegister("kqjk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede5395aec84864a$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");
function $ede5395aec84864a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $k9tfz.default)(element)) >= 0;
}

});


parcelRegister("67G0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4753fc241c56a947$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");
function $4753fc241c56a947$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $4753fc241c56a947$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $4753fc241c56a947$var$order(modifiers); // order based on phase
    return (0, $8CWSq.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("8CWSq", function(module, exports) {

$parcel$export(module.exports, "top", () => $647f8b13194227d9$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $647f8b13194227d9$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $647f8b13194227d9$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $647f8b13194227d9$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $647f8b13194227d9$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $647f8b13194227d9$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $647f8b13194227d9$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $647f8b13194227d9$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $647f8b13194227d9$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $647f8b13194227d9$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $647f8b13194227d9$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $647f8b13194227d9$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $647f8b13194227d9$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $647f8b13194227d9$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $647f8b13194227d9$export$d087d3878fdf71d5);
var $647f8b13194227d9$export$1e95b668f3b82d = 'top';
var $647f8b13194227d9$export$40e543e69a8b3fbb = 'bottom';
var $647f8b13194227d9$export$79ffe56a765070d2 = 'right';
var $647f8b13194227d9$export$eabcd2c8791e7bf4 = 'left';
var $647f8b13194227d9$export$dfb5619354ba860 = 'auto';
var $647f8b13194227d9$export$aec2ce47c367b8c3 = [
    $647f8b13194227d9$export$1e95b668f3b82d,
    $647f8b13194227d9$export$40e543e69a8b3fbb,
    $647f8b13194227d9$export$79ffe56a765070d2,
    $647f8b13194227d9$export$eabcd2c8791e7bf4
];
var $647f8b13194227d9$export$b3571188c770cc5a = 'start';
var $647f8b13194227d9$export$bd5df0f255a350f8 = 'end';
var $647f8b13194227d9$export$390fd549c5303b4d = 'clippingParents';
var $647f8b13194227d9$export$d7b7311ec04a3e8f = 'viewport';
var $647f8b13194227d9$export$ae5ab1c730825774 = 'popper';
var $647f8b13194227d9$export$ca50aac9f3ba507f = 'reference';
var $647f8b13194227d9$export$368f9a87e87fa4e1 = /*#__PURE__*/ $647f8b13194227d9$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $647f8b13194227d9$export$b3571188c770cc5a,
        placement + "-" + $647f8b13194227d9$export$bd5df0f255a350f8
    ]);
}, []);
var $647f8b13194227d9$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($647f8b13194227d9$export$aec2ce47c367b8c3, [
    $647f8b13194227d9$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $647f8b13194227d9$export$b3571188c770cc5a,
        placement + "-" + $647f8b13194227d9$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $647f8b13194227d9$export$421679a7c3d56e = 'beforeRead';
var $647f8b13194227d9$export$aafa59e2e03f2942 = 'read';
var $647f8b13194227d9$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $647f8b13194227d9$export$c65e99957a05207c = 'beforeMain';
var $647f8b13194227d9$export$f22da7240b7add18 = 'main';
var $647f8b13194227d9$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $647f8b13194227d9$export$8d4d2d70e7d46032 = 'beforeWrite';
var $647f8b13194227d9$export$68d8715fc104d294 = 'write';
var $647f8b13194227d9$export$70a6e5159acce2e6 = 'afterWrite';
var $647f8b13194227d9$export$d087d3878fdf71d5 = [
    $647f8b13194227d9$export$421679a7c3d56e,
    $647f8b13194227d9$export$aafa59e2e03f2942,
    $647f8b13194227d9$export$6964f6c886723980,
    $647f8b13194227d9$export$c65e99957a05207c,
    $647f8b13194227d9$export$f22da7240b7add18,
    $647f8b13194227d9$export$bab79516f2d662fe,
    $647f8b13194227d9$export$8d4d2d70e7d46032,
    $647f8b13194227d9$export$68d8715fc104d294,
    $647f8b13194227d9$export$70a6e5159acce2e6
];

});


parcelRegister("fb5CK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cc3ee5e6caa807$export$2e2bcd8739ae039);
function $b0cc3ee5e6caa807$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("dFfUS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f2b735bd29d87f1$export$2e2bcd8739ae039);
function $9f2b735bd29d87f1$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("anyZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e731ac5ccd6edc$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");
var $78e731ac5ccd6edc$var$passive = {
    passive: true
};
function $78e731ac5ccd6edc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3xJ5v.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $78e731ac5ccd6edc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $78e731ac5ccd6edc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $78e731ac5ccd6edc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $78e731ac5ccd6edc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $78e731ac5ccd6edc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $78e731ac5ccd6edc$var$effect,
    data: {}
};

});

parcelRegister("3QpMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cca3b2cec3a358e$export$2e2bcd8739ae039);

var $5HHLS = parcelRequire("5HHLS");
function $2cca3b2cec3a358e$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5HHLS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2cca3b2cec3a358e$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $2cca3b2cec3a358e$var$popperOffsets,
    data: {}
};

});
parcelRegister("5HHLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4272ebf28a8b18f9$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $iR1vh = parcelRequire("iR1vh");

var $fOHu6 = parcelRequire("fOHu6");

var $8CWSq = parcelRequire("8CWSq");
function $4272ebf28a8b18f9$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $aXPSi.default)(placement) : null;
    var variation = placement ? (0, $iR1vh.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8CWSq.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8CWSq.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8CWSq.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8CWSq.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $fOHu6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $8CWSq.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8CWSq.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("aXPSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fb7a75361164827$export$2e2bcd8739ae039);

function $7fb7a75361164827$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("iR1vh", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9e57cb08416451$export$2e2bcd8739ae039);
function $db9e57cb08416451$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("fOHu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b83d41a8913a6625$export$2e2bcd8739ae039);
function $b83d41a8913a6625$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("bbqbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8245095d444bc6ab$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $dNrcD = parcelRequire("dNrcD");

var $3xJ5v = parcelRequire("3xJ5v");

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $aXPSi = parcelRequire("aXPSi");

var $iR1vh = parcelRequire("iR1vh");

var $lCnHF = parcelRequire("lCnHF");
var $8245095d444bc6ab$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8245095d444bc6ab$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $lCnHF.round)(x * dpr) / dpr || 0,
        y: (0, $lCnHF.round)(y * dpr) / dpr || 0
    };
}
function $8245095d444bc6ab$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $8CWSq.left);
    var sideY = (0, $8CWSq.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $dNrcD.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $3xJ5v.default)(popper)) {
            offsetParent = (0, $80xbK.default)(popper);
            if ((0, $aPsIR.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8CWSq.top) || (placement === (0, $8CWSq.left) || placement === (0, $8CWSq.right)) && variation === (0, $8CWSq.end)) {
            sideY = (0, $8CWSq.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8CWSq.left) || (placement === (0, $8CWSq.top) || placement === (0, $8CWSq.bottom)) && variation === (0, $8CWSq.end)) {
            sideX = (0, $8CWSq.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8245095d444bc6ab$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8245095d444bc6ab$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3xJ5v.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $8245095d444bc6ab$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $aXPSi.default)(state.placement),
        variation: (0, $iR1vh.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8245095d444bc6ab$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8245095d444bc6ab$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8245095d444bc6ab$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $8245095d444bc6ab$var$computeStyles,
    data: {}
};

});

parcelRegister("lro9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9bed9cb68105387$export$2e2bcd8739ae039);

var $k9tfz = parcelRequire("k9tfz");

var $edBYZ = parcelRequire("edBYZ");
// and applies them to the HTMLElements such as popper and arrow
function $f9bed9cb68105387$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $edBYZ.isHTMLElement)(element) || !(0, $k9tfz.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $f9bed9cb68105387$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $edBYZ.isHTMLElement)(element) || !(0, $k9tfz.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $f9bed9cb68105387$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $f9bed9cb68105387$var$applyStyles,
    effect: $f9bed9cb68105387$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("6qkVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad56675e809f390$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $8CWSq = parcelRequire("8CWSq");
function $4ad56675e809f390$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $aXPSi.default)(placement);
    var invertDistance = [
        (0, $8CWSq.left),
        (0, $8CWSq.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8CWSq.left),
        (0, $8CWSq.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $4ad56675e809f390$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8CWSq.placements).reduce(function(acc, placement) {
        acc[placement] = $4ad56675e809f390$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4ad56675e809f390$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $4ad56675e809f390$var$offset
};

});

parcelRegister("8rAdb", function(module, exports) {

$parcel$export(module.exports, "default", () => $625cef3e22a64921$export$2e2bcd8739ae039);

var $60Kh8 = parcelRequire("60Kh8");

var $aXPSi = parcelRequire("aXPSi");

var $ib8Lm = parcelRequire("ib8Lm");

var $ecS3L = parcelRequire("ecS3L");

var $gUvF5 = parcelRequire("gUvF5");

var $8CWSq = parcelRequire("8CWSq");

var $iR1vh = parcelRequire("iR1vh");
function $625cef3e22a64921$var$getExpandedFallbackPlacements(placement) {
    if ((0, $aXPSi.default)(placement) === (0, $8CWSq.auto)) return [];
    var oppositePlacement = (0, $60Kh8.default)(placement);
    return [
        (0, $ib8Lm.default)(placement),
        oppositePlacement,
        (0, $ib8Lm.default)(oppositePlacement)
    ];
}
function $625cef3e22a64921$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $aXPSi.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $60Kh8.default)(preferredPlacement)
    ] : $625cef3e22a64921$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $aXPSi.default)(placement) === (0, $8CWSq.auto) ? (0, $gUvF5.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $aXPSi.default)(placement);
        var isStartVariation = (0, $iR1vh.default)(placement) === (0, $8CWSq.start);
        var isVertical = [
            (0, $8CWSq.top),
            (0, $8CWSq.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $ecS3L.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8CWSq.right) : (0, $8CWSq.left) : isStartVariation ? (0, $8CWSq.bottom) : (0, $8CWSq.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $60Kh8.default)(mainVariationSide);
        var altVariationSide = (0, $60Kh8.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $625cef3e22a64921$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $625cef3e22a64921$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("60Kh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4606a37f7c1f292f$export$2e2bcd8739ae039);
var $4606a37f7c1f292f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $4606a37f7c1f292f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $4606a37f7c1f292f$var$hash[matched];
    });
}

});

parcelRegister("ib8Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3c00d3590b14ae0$export$2e2bcd8739ae039);
var $d3c00d3590b14ae0$var$hash = {
    start: 'end',
    end: 'start'
};
function $d3c00d3590b14ae0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d3c00d3590b14ae0$var$hash[matched];
    });
}

});

parcelRegister("ecS3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57c1ec8d520bc76$export$2e2bcd8739ae039);

var $gY30K = parcelRequire("gY30K");

var $80xbK = parcelRequire("80xbK");

var $1a1A9 = parcelRequire("1a1A9");

var $5HHLS = parcelRequire("5HHLS");

var $hRFeC = parcelRequire("hRFeC");

var $8CWSq = parcelRequire("8CWSq");

var $edBYZ = parcelRequire("edBYZ");

var $5HivB = parcelRequire("5HivB");

var $gafWf = parcelRequire("gafWf");
function $a57c1ec8d520bc76$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8CWSq.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8CWSq.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8CWSq.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5HivB.default)(typeof padding !== 'number' ? padding : (0, $gafWf.default)(padding, (0, $8CWSq.basePlacements)));
    var altContext = elementContext === (0, $8CWSq.popper) ? (0, $8CWSq.reference) : (0, $8CWSq.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $gY30K.default)((0, $edBYZ.isElement)(element) ? element : element.contextElement || (0, $80xbK.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1a1A9.default)(state.elements.reference);
    var popperOffsets = (0, $5HHLS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $hRFeC.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8CWSq.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8CWSq.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8CWSq.right),
                (0, $8CWSq.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8CWSq.top),
                (0, $8CWSq.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("gY30K", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a495e161fa24d3$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $3GhRd = parcelRequire("3GhRd");

var $Z1xa3 = parcelRequire("Z1xa3");

var $ePkdB = parcelRequire("ePkdB");

var $dNrcD = parcelRequire("dNrcD");

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $edBYZ = parcelRequire("edBYZ");

var $1a1A9 = parcelRequire("1a1A9");

var $hoKF3 = parcelRequire("hoKF3");

var $4W0o9 = parcelRequire("4W0o9");

var $k9tfz = parcelRequire("k9tfz");

var $hRFeC = parcelRequire("hRFeC");

var $lCnHF = parcelRequire("lCnHF");
function $c5a495e161fa24d3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1a1A9.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $c5a495e161fa24d3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8CWSq.viewport) ? (0, $hRFeC.default)((0, $3GhRd.default)(element, strategy)) : (0, $edBYZ.isElement)(clippingParent) ? $c5a495e161fa24d3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $hRFeC.default)((0, $Z1xa3.default)((0, $80xbK.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $c5a495e161fa24d3$var$getClippingParents(element) {
    var clippingParents = (0, $ePkdB.default)((0, $hoKF3.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $aPsIR.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $edBYZ.isHTMLElement)(element) ? (0, $dNrcD.default)(element) : element;
    if (!(0, $edBYZ.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $edBYZ.isElement)(clippingParent) && (0, $4W0o9.default)(clippingParent, clipperElement) && (0, $k9tfz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $c5a495e161fa24d3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $c5a495e161fa24d3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $c5a495e161fa24d3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $lCnHF.max)(rect.top, accRect.top);
        accRect.right = (0, $lCnHF.min)(rect.right, accRect.right);
        accRect.bottom = (0, $lCnHF.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $lCnHF.max)(rect.left, accRect.left);
        return accRect;
    }, $c5a495e161fa24d3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3GhRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae3256cd0a63b6c$export$2e2bcd8739ae039);

var $3xJ5v = parcelRequire("3xJ5v");

var $80xbK = parcelRequire("80xbK");

var $5l3cx = parcelRequire("5l3cx");

var $920uN = parcelRequire("920uN");
function $2ae3256cd0a63b6c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3xJ5v.default)(element);
    var html = (0, $80xbK.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $920uN.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5l3cx.default)(element),
        y: y
    };
}

});

parcelRegister("Z1xa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b76e33639bec5b0$export$2e2bcd8739ae039);

var $80xbK = parcelRequire("80xbK");

var $aPsIR = parcelRequire("aPsIR");

var $5l3cx = parcelRequire("5l3cx");

var $ac1Wl = parcelRequire("ac1Wl");

var $lCnHF = parcelRequire("lCnHF");
function $0b76e33639bec5b0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $80xbK.default)(element);
    var winScroll = (0, $ac1Wl.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $lCnHF.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $lCnHF.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5l3cx.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $aPsIR.default)(body || html).direction === 'rtl') x += (0, $lCnHF.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4W0o9", function(module, exports) {

$parcel$export(module.exports, "default", () => $397ce160bfc587fd$export$2e2bcd8739ae039);

var $edBYZ = parcelRequire("edBYZ");
function $397ce160bfc587fd$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $edBYZ.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("hRFeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0175f4a07c21ab5$export$2e2bcd8739ae039);
function $d0175f4a07c21ab5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5HivB", function(module, exports) {

$parcel$export(module.exports, "default", () => $425f53560a1fdf3c$export$2e2bcd8739ae039);

var $1ZKmd = parcelRequire("1ZKmd");
function $425f53560a1fdf3c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1ZKmd.default)(), paddingObject);
}

});
parcelRegister("1ZKmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $173f728cc6ee2a3b$export$2e2bcd8739ae039);
function $173f728cc6ee2a3b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("gafWf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc49f189f7bd576d$export$2e2bcd8739ae039);
function $bc49f189f7bd576d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("gUvF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4fa6fa3ea07a9a4$export$2e2bcd8739ae039);

var $iR1vh = parcelRequire("iR1vh");

var $8CWSq = parcelRequire("8CWSq");

var $ecS3L = parcelRequire("ecS3L");

var $aXPSi = parcelRequire("aXPSi");
function $c4fa6fa3ea07a9a4$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8CWSq.placements) : _options$allowedAutoP;
    var variation = (0, $iR1vh.default)(placement);
    var placements = variation ? flipVariations ? (0, $8CWSq.variationPlacements) : (0, $8CWSq.variationPlacements).filter(function(placement) {
        return (0, $iR1vh.default)(placement) === variation;
    }) : (0, $8CWSq.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ecS3L.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $aXPSi.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("gFjel", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21f64720698273b$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $aXPSi = parcelRequire("aXPSi");

var $fOHu6 = parcelRequire("fOHu6");

var $hAEuy = parcelRequire("hAEuy");

var $bnZ7G = parcelRequire("bnZ7G");

var $QrBqo = parcelRequire("QrBqo");

var $dNrcD = parcelRequire("dNrcD");

var $ecS3L = parcelRequire("ecS3L");

var $iR1vh = parcelRequire("iR1vh");

var $1ZKmd = parcelRequire("1ZKmd");

var $lCnHF = parcelRequire("lCnHF");
function $c21f64720698273b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ecS3L.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $aXPSi.default)(state.placement);
    var variation = (0, $iR1vh.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $fOHu6.default)(basePlacement);
    var altAxis = (0, $hAEuy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $8CWSq.top) : (0, $8CWSq.left);
        var altSide = mainAxis === 'y' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8CWSq.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8CWSq.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $QrBqo.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $1ZKmd.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bnZ7G.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $dNrcD.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bnZ7G.within)(tether ? (0, $lCnHF.min)(min, tetherMin) : min, offset, tether ? (0, $lCnHF.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $8CWSq.top) : (0, $8CWSq.left);
        var _altSide = mainAxis === 'x' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8CWSq.top),
            (0, $8CWSq.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bnZ7G.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bnZ7G.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c21f64720698273b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $c21f64720698273b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("hAEuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce5354b6e28e32b$export$2e2bcd8739ae039);
function $cce5354b6e28e32b$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("bnZ7G", function(module, exports) {

$parcel$export(module.exports, "within", () => $84a14174e88d0bc0$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $84a14174e88d0bc0$export$86c8af6d3ef0b4a);

var $lCnHF = parcelRequire("lCnHF");
function $84a14174e88d0bc0$export$f28d906d67a997f3(min, value, max) {
    return (0, $lCnHF.max)(min, (0, $lCnHF.min)(value, max));
}
function $84a14174e88d0bc0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $84a14174e88d0bc0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("hiKPe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c988709f87b64d9b$export$2e2bcd8739ae039);

var $aXPSi = parcelRequire("aXPSi");

var $QrBqo = parcelRequire("QrBqo");

var $4W0o9 = parcelRequire("4W0o9");

var $dNrcD = parcelRequire("dNrcD");

var $fOHu6 = parcelRequire("fOHu6");

var $bnZ7G = parcelRequire("bnZ7G");

var $5HivB = parcelRequire("5HivB");

var $gafWf = parcelRequire("gafWf");

var $8CWSq = parcelRequire("8CWSq");
var $c988709f87b64d9b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5HivB.default)(typeof padding !== 'number' ? padding : (0, $gafWf.default)(padding, (0, $8CWSq.basePlacements)));
};
function $c988709f87b64d9b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $aXPSi.default)(state.placement);
    var axis = (0, $fOHu6.default)(basePlacement);
    var isVertical = [
        (0, $8CWSq.left),
        (0, $8CWSq.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c988709f87b64d9b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $QrBqo.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $8CWSq.top) : (0, $8CWSq.left);
    var maxProp = axis === 'y' ? (0, $8CWSq.bottom) : (0, $8CWSq.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $dNrcD.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bnZ7G.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c988709f87b64d9b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4W0o9.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c988709f87b64d9b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c988709f87b64d9b$var$arrow,
    effect: $c988709f87b64d9b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("izul8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85307bf73b62e8b$export$2e2bcd8739ae039);

var $8CWSq = parcelRequire("8CWSq");

var $ecS3L = parcelRequire("ecS3L");
function $d85307bf73b62e8b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d85307bf73b62e8b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8CWSq.top),
        (0, $8CWSq.right),
        (0, $8CWSq.bottom),
        (0, $8CWSq.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d85307bf73b62e8b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ecS3L.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $ecS3L.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d85307bf73b62e8b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d85307bf73b62e8b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d85307bf73b62e8b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d85307bf73b62e8b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d85307bf73b62e8b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d85307bf73b62e8b$var$hide
};

});




parcelRegister("dmg8t", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $9b99d8a8ad795e92$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $kQSBm = parcelRequire("kQSBm");

var $2Leve = parcelRequire("2Leve");
function $9b99d8a8ad795e92$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $kQSBm.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $2Leve.setRef)(innerRef, node);
        (0, $2Leve.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $2Leve.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $2Leve.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("8r9C9", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $890d25d6ddbbb5af$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $890d25d6ddbbb5af$export$e618dc39ac9ad607);

var $kfs3D = parcelRequire("kfs3D");

var $5eRrO = parcelRequire("5eRrO");

var $ngqpF = parcelRequire("ngqpF");

var $8YZfj = parcelRequire("8YZfj");

var $fG8ma = parcelRequire("fG8ma");

var $6t2wI = parcelRequire("6t2wI");

var $i0VNY = parcelRequire("i0VNY");

var $35wVQ = parcelRequire("35wVQ");

var $akzU3 = parcelRequire("akzU3");

var $7VMaH = parcelRequire("7VMaH");
const $890d25d6ddbbb5af$export$214b055320e0bf32 = {
    clearIndicator: (0, $8YZfj.clearIndicatorCSS),
    container: (0, $kfs3D.containerCSS),
    control: (0, $5eRrO.css),
    dropdownIndicator: (0, $8YZfj.dropdownIndicatorCSS),
    group: (0, $ngqpF.groupCSS),
    groupHeading: (0, $ngqpF.groupHeadingCSS),
    indicatorsContainer: (0, $kfs3D.indicatorsContainerCSS),
    indicatorSeparator: (0, $8YZfj.indicatorSeparatorCSS),
    input: (0, $fG8ma.inputCSS),
    loadingIndicator: (0, $8YZfj.loadingIndicatorCSS),
    loadingMessage: (0, $6t2wI.loadingMessageCSS),
    menu: (0, $6t2wI.menuCSS),
    menuList: (0, $6t2wI.menuListCSS),
    menuPortal: (0, $6t2wI.menuPortalCSS),
    multiValue: (0, $i0VNY.multiValueCSS),
    multiValueLabel: (0, $i0VNY.multiValueLabelCSS),
    multiValueRemove: (0, $i0VNY.multiValueRemoveCSS),
    noOptionsMessage: (0, $6t2wI.noOptionsMessageCSS),
    option: (0, $35wVQ.optionCSS),
    placeholder: (0, $akzU3.placeholderCSS),
    singleValue: (0, $7VMaH.css),
    valueContainer: (0, $kfs3D.valueContainerCSS)
};
function $890d25d6ddbbb5af$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});
parcelRegister("kfs3D", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $9bc2a331068e3f37$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $9bc2a331068e3f37$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $9bc2a331068e3f37$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $9bc2a331068e3f37$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $9bc2a331068e3f37$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $9bc2a331068e3f37$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $9bc2a331068e3f37$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $9bc2a331068e3f37$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $9bc2a331068e3f37$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $9bc2a331068e3f37$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $DomJ2.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $9bc2a331068e3f37$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $9bc2a331068e3f37$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("DomJ2", function(module, exports) {

$parcel$export(module.exports, "noop", () => $a7fa863fc859695d$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $a7fa863fc859695d$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $a7fa863fc859695d$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $a7fa863fc859695d$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $a7fa863fc859695d$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $a7fa863fc859695d$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $a7fa863fc859695d$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $a7fa863fc859695d$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $a7fa863fc859695d$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $a7fa863fc859695d$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $a7fa863fc859695d$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $a7fa863fc859695d$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $a7fa863fc859695d$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $a7fa863fc859695d$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $a7fa863fc859695d$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $a7fa863fc859695d$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $a7fa863fc859695d$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $a7fa863fc859695d$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $a7fa863fc859695d$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $a7fa863fc859695d$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $a7fa863fc859695d$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $a7fa863fc859695d$export$4213b25a1c4e877);
const $a7fa863fc859695d$export$8793edee2d425525 = ()=>{};
const $a7fa863fc859695d$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $a7fa863fc859695d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $a7fa863fc859695d$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$a7fa863fc859695d$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $a7fa863fc859695d$export$33f062f47f21a01 = (value)=>{
    if ($a7fa863fc859695d$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $a7fa863fc859695d$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $a7fa863fc859695d$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $a7fa863fc859695d$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $a7fa863fc859695d$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $a7fa863fc859695d$export$2e0654fad740d2e4(el) {
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $a7fa863fc859695d$export$c4a223a8ba9e4ea5(el) {
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a7fa863fc859695d$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a7fa863fc859695d$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $a7fa863fc859695d$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $a7fa863fc859695d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a7fa863fc859695d$export$858c30343199f3af(element, to, duration = 200, callback = $a7fa863fc859695d$export$8793edee2d425525) {
    const start = $a7fa863fc859695d$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $a7fa863fc859695d$var$easeOutCubic(currentTime, start, change, duration);
        $a7fa863fc859695d$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $a7fa863fc859695d$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a7fa863fc859695d$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a7fa863fc859695d$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $a7fa863fc859695d$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $a7fa863fc859695d$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $a7fa863fc859695d$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $a7fa863fc859695d$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $a7fa863fc859695d$var$passiveOptionAccessed = false;
const $a7fa863fc859695d$var$options = {
    get passive () {
        return $a7fa863fc859695d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $a7fa863fc859695d$var$w = typeof window !== 'undefined' ? window : {};
if ($a7fa863fc859695d$var$w.addEventListener && $a7fa863fc859695d$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $a7fa863fc859695d$var$w.addEventListener('p', $a7fa863fc859695d$export$8793edee2d425525, $a7fa863fc859695d$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $a7fa863fc859695d$var$w.removeEventListener('p', $a7fa863fc859695d$export$8793edee2d425525, false);
}
const $a7fa863fc859695d$export$b0622a6911dbeaf5 = $a7fa863fc859695d$var$passiveOptionAccessed;
function $a7fa863fc859695d$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $a7fa863fc859695d$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $a7fa863fc859695d$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a7fa863fc859695d$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $a7fa863fc859695d$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $a7fa863fc859695d$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("5eRrO", function(module, exports) {

$parcel$export(module.exports, "css", () => $6c9f9c8f28b24213$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $6c9f9c8f28b24213$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $6c9f9c8f28b24213$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $6c9f9c8f28b24213$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        ...(0, $DomJ2.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6c9f9c8f28b24213$export$2e2bcd8739ae039 = $6c9f9c8f28b24213$var$Control;

});

parcelRegister("ngqpF", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $aad1e47212eaaeb7$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $aad1e47212eaaeb7$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $aad1e47212eaaeb7$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $aad1e47212eaaeb7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $aad1e47212eaaeb7$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $aad1e47212eaaeb7$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("div", null, children));
};
const $aad1e47212eaaeb7$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $aad1e47212eaaeb7$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $DomJ2.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$aad1e47212eaaeb7$export$2e2bcd8739ae039 = $aad1e47212eaaeb7$var$Group;

});

parcelRegister("8YZfj", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $17a6994453780832$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $17a6994453780832$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $17a6994453780832$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $17a6994453780832$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $17a6994453780832$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $17a6994453780832$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $17a6994453780832$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $17a6994453780832$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $17a6994453780832$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $17a6994453780832$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
function $17a6994453780832$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $17a6994453780832$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $17a6994453780832$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $17a6994453780832$var$styles,
        ...props
    });
const $17a6994453780832$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $17a6994453780832$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $17a6994453780832$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $17a6994453780832$export$e1687335805e1230 = $17a6994453780832$var$baseCSS;
const $17a6994453780832$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$export$c5cbe1656ba71e6c, null));
};
const $17a6994453780832$export$9c0419fd944c1def = $17a6994453780832$var$baseCSS;
const $17a6994453780832$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$export$3b621d86b1566b2, null));
};
const $17a6994453780832$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $17a6994453780832$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...innerProps,
        ...(0, $DomJ2.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $17a6994453780832$var$loadingDotAnimations = (0, $byn9U.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $17a6994453780832$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $17a6994453780832$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $byn9U.css)({
            animation: `${$17a6994453780832$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $17a6994453780832$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($17a6994453780832$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("fG8ma", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $08ad391264e2f439$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $08ad391264e2f439$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $08ad391264e2f439$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$08ad391264e2f439$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $08ad391264e2f439$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $08ad391264e2f439$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$08ad391264e2f439$var$spacingStyle
    }
};
const $08ad391264e2f439$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$08ad391264e2f439$var$spacingStyle
    });
const $08ad391264e2f439$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $DomJ2.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $08ad391264e2f439$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$08ad391264e2f439$export$2e2bcd8739ae039 = $08ad391264e2f439$var$Input;

});

parcelRegister("6t2wI", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b67347fe66559b87$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b67347fe66559b87$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b67347fe66559b87$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b67347fe66559b87$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b67347fe66559b87$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $b67347fe66559b87$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $b67347fe66559b87$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $b67347fe66559b87$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b67347fe66559b87$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b67347fe66559b87$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b67347fe66559b87$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5O3G9 = parcelRequire("5O3G9");

var $lEfVV = parcelRequire("lEfVV");

var $k286k = parcelRequire("k286k");

var $DomJ2 = parcelRequire("DomJ2");
function $b67347fe66559b87$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $DomJ2.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $DomJ2.normalizedHeight)(scrollParent);
    const scrollTop = (0, $DomJ2.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $DomJ2.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $DomJ2.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $b67347fe66559b87$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $b67347fe66559b87$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b67347fe66559b87$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$b67347fe66559b87$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $b67347fe66559b87$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $b67347fe66559b87$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $eUqFw.useContext)($b67347fe66559b87$var$PortalPlacementContext) || {};
    const ref = (0, $eUqFw.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $eUqFw.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $eUqFw.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $k286k.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b67347fe66559b87$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b67347fe66559b87$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b67347fe66559b87$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b67347fe66559b87$export$2e2bcd8739ae039 = $b67347fe66559b87$var$Menu;
const $b67347fe66559b87$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $b67347fe66559b87$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        //@ts-ignore
        ref: innerRef,
        ...innerProps
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $b67347fe66559b87$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $b67347fe66559b87$export$cf0e22534d8b0074 = $b67347fe66559b87$var$noticeCSS;
const $b67347fe66559b87$export$98ec46397a8cb3cd = $b67347fe66559b87$var$noticeCSS;
const $b67347fe66559b87$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return(//@ts-ignore
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children));
};
const $b67347fe66559b87$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $b67347fe66559b87$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $b67347fe66559b87$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $eUqFw.useRef)(null);
    const cleanupRef = (0, $eUqFw.useRef)(null);
    const [placement, setPortalPlacement] = (0, $eUqFw.useState)($b67347fe66559b87$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $eUqFw.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $eUqFw.useState)(null);
    const updateComputedPosition = (0, $eUqFw.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $DomJ2.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $k286k.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $eUqFw.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $eUqFw.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $DomJ2.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($b67347fe66559b87$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("i0VNY", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $b976d04d171aaa69$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $b976d04d171aaa69$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $b976d04d171aaa69$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $b976d04d171aaa69$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $b976d04d171aaa69$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $b976d04d171aaa69$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $b976d04d171aaa69$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");

var $8YZfj = parcelRequire("8YZfj");
const $b976d04d171aaa69$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $b976d04d171aaa69$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $b976d04d171aaa69$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $b976d04d171aaa69$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $b976d04d171aaa69$export$cf9cf2a30a59265c = $b976d04d171aaa69$export$e1de505c1242dc1a;
const $b976d04d171aaa69$export$544aeea2a5ce08ee = $b976d04d171aaa69$export$e1de505c1242dc1a;
function $b976d04d171aaa69$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)((0, $8YZfj.CrossIcon), {
        size: 14
    }));
}
const $b976d04d171aaa69$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $DomJ2.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b976d04d171aaa69$export$2e2bcd8739ae039 = $b976d04d171aaa69$var$MultiValue;

});

parcelRegister("35wVQ", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $b618ec36fb5deec3$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $b618ec36fb5deec3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $b618ec36fb5deec3$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $b618ec36fb5deec3$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        //@ts-ignore
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b618ec36fb5deec3$export$2e2bcd8739ae039 = $b618ec36fb5deec3$var$Option;

});

parcelRegister("akzU3", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $ee7392090dabd55f$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $ee7392090dabd55f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $ee7392090dabd55f$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $ee7392090dabd55f$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ee7392090dabd55f$export$2e2bcd8739ae039 = $ee7392090dabd55f$var$Placeholder;

});

parcelRegister("7VMaH", function(module, exports) {

$parcel$export(module.exports, "css", () => $bee4e3936873fc73$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $bee4e3936873fc73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $bee4e3936873fc73$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $bee4e3936873fc73$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $DomJ2.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bee4e3936873fc73$export$2e2bcd8739ae039 = $bee4e3936873fc73$var$SingleValue;

});


parcelRegister("aJuqz", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $a5765027d23d0a83$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $a5765027d23d0a83$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $j8gJ1 = parcelRequire("j8gJ1");
var $8LRlt = parcelRequire("8LRlt");
var $f3klQ = parcelRequire("f3klQ");

var $8R79R = parcelRequire("8R79R");

var $1oOGD = parcelRequire("1oOGD");
const $a5765027d23d0a83$var$packageName = "platform-pkg";
const $a5765027d23d0a83$var$packageVersion = "0.0.0-use.local";
const $a5765027d23d0a83$export$d1de3b251ccaa8a3 = (0, $1oOGD.default)((0, $8R79R.default));
const $a5765027d23d0a83$var$createAndFireEventOnAtlaskit = (0, $j8gJ1.default)('atlaskit');
const $a5765027d23d0a83$var$Select = (0, $8LRlt.default)({
    componentName: 'select',
    packageName: $a5765027d23d0a83$var$packageName,
    packageVersion: $a5765027d23d0a83$var$packageVersion
})((0, $f3klQ.default)({
    onChange: $a5765027d23d0a83$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $a5765027d23d0a83$var$packageName,
            packageVersion: $a5765027d23d0a83$var$packageVersion
        }
    })
})($a5765027d23d0a83$export$d1de3b251ccaa8a3));
var $a5765027d23d0a83$export$2e2bcd8739ae039 = $a5765027d23d0a83$var$Select;

});
parcelRegister("8R79R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68207d5ffd699d7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $apnnW = parcelRequire("apnnW");

var $aXltS = parcelRequire("aXltS");
const $c68207d5ffd699d7$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $aXltS.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apnnW.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $c68207d5ffd699d7$export$2e2bcd8739ae039 = $c68207d5ffd699d7$var$StateManagedSelect;

});
parcelRegister("apnnW", function(module, exports) {

$parcel$export(module.exports, "default", () => $812572970dc92908$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k1Zr4 = parcelRequire("k1Zr4");

var $a9GGG = parcelRequire("a9GGG");

var $6EqnL = parcelRequire("6EqnL");

var $l1pLY = parcelRequire("l1pLY");
var $gxsrN = parcelRequire("gxsrN");
var $4GHZi = parcelRequire("4GHZi");

var $1XbPn = parcelRequire("1XbPn");

var $6t2wI = parcelRequire("6t2wI");

var $f6Vzn = parcelRequire("f6Vzn");

var $8r9C9 = parcelRequire("8r9C9");

var $8ogLA = parcelRequire("8ogLA");

var $DomJ2 = parcelRequire("DomJ2");
const $812572970dc92908$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $DomJ2.isTouchCapable)(),
    captureMenuScroll: !(0, $DomJ2.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $f6Vzn.createFilter)(),
    formatGroupLabel: (0, $a9GGG.formatGroupLabel),
    getOptionLabel: (0, $a9GGG.getOptionLabel),
    getOptionValue: (0, $a9GGG.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $a9GGG.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $DomJ2.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $812572970dc92908$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $812572970dc92908$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $812572970dc92908$var$isOptionSelected(props, option, selectValue);
    const label = $812572970dc92908$var$getOptionLabel(props, option);
    const value = $812572970dc92908$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $812572970dc92908$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$812572970dc92908$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$812572970dc92908$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $812572970dc92908$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $812572970dc92908$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $DomJ2.notNullish));
}
function $812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $812572970dc92908$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $812572970dc92908$var$buildFocusableOptions(props, selectValue) {
    return $812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions($812572970dc92908$var$buildCategorizedOptions(props, selectValue));
}
function $812572970dc92908$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$812572970dc92908$var$shouldHideSelectedOptions(props) || !isSelected) && $812572970dc92908$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $812572970dc92908$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $812572970dc92908$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $812572970dc92908$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $812572970dc92908$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $812572970dc92908$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $812572970dc92908$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $812572970dc92908$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $812572970dc92908$var$getOptionValue(props, option);
    return selectValue.some((i)=>$812572970dc92908$var$getOptionValue(props, i) === candidate);
}
function $812572970dc92908$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $812572970dc92908$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $812572970dc92908$var$instanceId = 1;
class $812572970dc92908$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $812572970dc92908$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $k1Zr4.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $DomJ2.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $DomJ2.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $DomJ2.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $DomJ2.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $DomJ2.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $DomJ2.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $DomJ2.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $812572970dc92908$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $812572970dc92908$var$buildFocusableOptionsWithIds($812572970dc92908$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $DomJ2.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $812572970dc92908$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $812572970dc92908$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $8r9C9.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $6EqnL.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$812572970dc92908$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$812572970dc92908$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $DomJ2.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $812572970dc92908$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$812572970dc92908$var$instanceId);
        //@ts-ignore
        this.state.selectValue = (0, $DomJ2.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $812572970dc92908$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        //@ts-ignore
        const selectValue = (0, $DomJ2.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $812572970dc92908$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $812572970dc92908$var$buildFocusableOptionsWithIds($812572970dc92908$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $812572970dc92908$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $812572970dc92908$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $812572970dc92908$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $DomJ2.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $DomJ2.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $DomJ2.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $8ogLA.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $8ogLA.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $8ogLA.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $812572970dc92908$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $812572970dc92908$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $812572970dc92908$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'list',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return(//@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1pLY.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $DomJ2.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ClearIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': this.isAppleDevice ? undefined : isSelected
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) menuUI = this.getCategorizedOptions().map((item)=>{
            if (item.type === 'group') {
                const { data: data, options: options, index: groupIndex } = item;
                const groupId = `${this.getElementId('group')}-${groupIndex}`;
                const headingId = `${groupId}-heading`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, {
                    ...commonProps,
                    key: groupId,
                    data: data,
                    options: options,
                    Heading: GroupHeading,
                    headingProps: {
                        id: headingId,
                        data: item.data
                    },
                    label: this.formatGroupLabel(item.data)
                }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`)));
            } else if (item.type === 'option') return render(item, `${item.index}`);
        });
        else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6t2wI.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GHZi.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        'aria-multiselectable': commonProps.isMulti,
                        id: this.getElementId('listbox')
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxsrN.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XbPn.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("k1Zr4", function(module, exports) {

$parcel$export(module.exports, "isAppleDevice", () => $377df83acaf7b466$export$e1865c3bedcd822b);
function $377df83acaf7b466$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $377df83acaf7b466$export$186c6964ca17d99() {
    return $377df83acaf7b466$var$testPlatform(/^iPhone/i);
}
function $377df83acaf7b466$export$9ac100e40613ea10() {
    return $377df83acaf7b466$var$testPlatform(/^Mac/i);
}
function $377df83acaf7b466$export$7bef049ce92e4224() {
    return $377df83acaf7b466$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $377df83acaf7b466$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $377df83acaf7b466$export$fedb369cb70207f1() {
    return $377df83acaf7b466$export$186c6964ca17d99() || $377df83acaf7b466$export$7bef049ce92e4224();
}
function $377df83acaf7b466$export$e1865c3bedcd822b() {
    return $377df83acaf7b466$export$9ac100e40613ea10() || $377df83acaf7b466$export$fedb369cb70207f1();
}

});

parcelRegister("a9GGG", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $c82f797eede48f28$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $c82f797eede48f28$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $c82f797eede48f28$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $c82f797eede48f28$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $c82f797eede48f28$export$f4da216a6ca54656 = (group)=>group.label;
const $c82f797eede48f28$export$dac6ace3020563ca = (option)=>option.label;
const $c82f797eede48f28$export$40be908210c5a79c = (option)=>option.value;
const $c82f797eede48f28$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("6EqnL", function(module, exports) {

$parcel$export(module.exports, "components", () => $676f8cc7fc9199f1$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $676f8cc7fc9199f1$export$71abc632aa29e6fe);

var $kfs3D = parcelRequire("kfs3D");

var $5eRrO = parcelRequire("5eRrO");

var $ngqpF = parcelRequire("ngqpF");

var $8YZfj = parcelRequire("8YZfj");

var $fG8ma = parcelRequire("fG8ma");

var $6t2wI = parcelRequire("6t2wI");

var $i0VNY = parcelRequire("i0VNY");

var $35wVQ = parcelRequire("35wVQ");

var $akzU3 = parcelRequire("akzU3");

var $7VMaH = parcelRequire("7VMaH");
const $676f8cc7fc9199f1$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $8YZfj.ClearIndicator),
    Control: (0, $5eRrO.default),
    DropdownIndicator: (0, $8YZfj.DropdownIndicator),
    DownChevron: (0, $8YZfj.DownChevron),
    CrossIcon: (0, $8YZfj.CrossIcon),
    Group: (0, $ngqpF.default),
    GroupHeading: (0, $ngqpF.GroupHeading),
    IndicatorsContainer: (0, $kfs3D.IndicatorsContainer),
    IndicatorSeparator: (0, $8YZfj.IndicatorSeparator),
    Input: (0, $fG8ma.default),
    LoadingIndicator: (0, $8YZfj.LoadingIndicator),
    Menu: (0, $6t2wI.default),
    MenuList: (0, $6t2wI.MenuList),
    MenuPortal: (0, $6t2wI.MenuPortal),
    LoadingMessage: (0, $6t2wI.LoadingMessage),
    NoOptionsMessage: (0, $6t2wI.NoOptionsMessage),
    MultiValue: (0, $i0VNY.default),
    MultiValueContainer: (0, $i0VNY.MultiValueContainer),
    MultiValueLabel: (0, $i0VNY.MultiValueLabel),
    MultiValueRemove: (0, $i0VNY.MultiValueRemove),
    Option: (0, $35wVQ.default),
    Placeholder: (0, $akzU3.default),
    SelectContainer: (0, $kfs3D.SelectContainer),
    SingleValue: (0, $7VMaH.default),
    ValueContainer: (0, $kfs3D.ValueContainer)
};
const $676f8cc7fc9199f1$export$71abc632aa29e6fe = (props)=>({
        ...$676f8cc7fc9199f1$export$9b5ac10f59f76296,
        ...props.components
    });

});

parcelRegister("l1pLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $edcfea7cbf7f9aab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $DomJ2 = parcelRequire("DomJ2");
const $edcfea7cbf7f9aab$var$dummyInputStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $edcfea7cbf7f9aab$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $DomJ2.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $edcfea7cbf7f9aab$var$dummyInputStyles
    });
}

});

parcelRegister("gxsrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcd01f5e5b5e85fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $iyKES = parcelRequire("iyKES");
function $fcd01f5e5b5e85fd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fcd01f5e5b5e85fd$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $fcd01f5e5b5e85fd$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $fcd01f5e5b5e85fd$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $iyKES.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fcd01f5e5b5e85fd$export$2e2bcd8739ae039 = $fcd01f5e5b5e85fd$var$RequiredInput;

});

parcelRegister("4GHZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $edb2811a94dc1026$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $iAaF5 = parcelRequire("iAaF5");

var $eGczi = parcelRequire("eGczi");
function $edb2811a94dc1026$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edb2811a94dc1026$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $edb2811a94dc1026$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $edb2811a94dc1026$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $iAaF5.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $eGczi.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onClick: $edb2811a94dc1026$var$blurSelectInput,
        css: $edb2811a94dc1026$var$styles
    }), children(targetRef));
}

});
parcelRegister("iAaF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bb9b4882346d814$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $DomJ2 = parcelRequire("DomJ2");
const $8bb9b4882346d814$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $8bb9b4882346d814$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $eUqFw.useRef)(false);
    const isTop = (0, $eUqFw.useRef)(false);
    const touchStart = (0, $eUqFw.useRef)(0);
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const handleEventDelta = (0, $eUqFw.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $8bb9b4882346d814$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $eUqFw.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $eUqFw.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $eUqFw.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $DomJ2.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("eGczi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece6486884e5b6d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $ece6486884e5b6d9$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $ece6486884e5b6d9$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $ece6486884e5b6d9$var$preventTouchMove(e) {
    e.preventDefault();
}
function $ece6486884e5b6d9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $ece6486884e5b6d9$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $ece6486884e5b6d9$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $ece6486884e5b6d9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $ece6486884e5b6d9$var$activeScrollLocks = 0;
const $ece6486884e5b6d9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $ece6486884e5b6d9$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $eUqFw.useRef)({});
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const addScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$ece6486884e5b6d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $ece6486884e5b6d9$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $ece6486884e5b6d9$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($ece6486884e5b6d9$var$LOCK_STYLES).forEach((key)=>{
                const val = $ece6486884e5b6d9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $ece6486884e5b6d9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $ece6486884e5b6d9$var$preventTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $ece6486884e5b6d9$var$preventInertiaScroll, $ece6486884e5b6d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $ece6486884e5b6d9$var$allowTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $ece6486884e5b6d9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$ece6486884e5b6d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $ece6486884e5b6d9$var$activeScrollLocks = Math.max($ece6486884e5b6d9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $ece6486884e5b6d9$var$activeScrollLocks < 1) $ece6486884e5b6d9$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $ece6486884e5b6d9$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $ece6486884e5b6d9$var$preventTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $ece6486884e5b6d9$var$preventInertiaScroll, $ece6486884e5b6d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $ece6486884e5b6d9$var$allowTouchMove, $ece6486884e5b6d9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("1XbPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0af9987a261c33d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $625wI = parcelRequire("625wI");

var $kULp4 = parcelRequire("kULp4");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $c0af9987a261c33d$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $eUqFw.useMemo)(()=>({
            ...(0, $625wI.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $eUqFw.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const ariaFocused = (0, $eUqFw.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    const ariaResults = (0, $eUqFw.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $eUqFw.useMemo)(()=>{
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-results"
    }, ariaResults), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kULp4.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kULp4.default), {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c0af9987a261c33d$export$2e2bcd8739ae039 = $c0af9987a261c33d$var$LiveRegion;

});
parcelRegister("625wI", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $2e07b4483663f031$export$a7265767c78f9bae);
const $2e07b4483663f031$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `${arr.indexOf(item) + 1} of ${arr.length}` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ''}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}.`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("kULp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $26f0af153c89be40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $26f0af153c89be40$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $26f0af153c89be40$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $26f0af153c89be40$var$A11yText = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $26f0af153c89be40$var$styles,
        ...props
    });
var $26f0af153c89be40$export$2e2bcd8739ae039 = $26f0af153c89be40$var$A11yText;

});


parcelRegister("f6Vzn", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $fdb4680dbf332fef$export$5d81789ff4aeccdf);

var $5iWql = parcelRequire("5iWql");

var $26i9q = parcelRequire("26i9q");
const $fdb4680dbf332fef$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)((0, $26i9q.stripDiacritics));
const $fdb4680dbf332fef$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $fdb4680dbf332fef$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $fdb4680dbf332fef$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $fdb4680dbf332fef$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $fdb4680dbf332fef$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $fdb4680dbf332fef$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $fdb4680dbf332fef$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $26i9q.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("26i9q", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $3944c2da7f0324a1$export$b5bee4b27048330b);
const $3944c2da7f0324a1$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $3944c2da7f0324a1$var$anyDiacritic = new RegExp('[' + $3944c2da7f0324a1$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $3944c2da7f0324a1$var$diacriticToBase = {};
for(let i = 0; i < $3944c2da7f0324a1$var$diacritics.length; i++){
    let diacritic = $3944c2da7f0324a1$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$3944c2da7f0324a1$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $3944c2da7f0324a1$export$b5bee4b27048330b = (str)=>{
    return str.replace($3944c2da7f0324a1$var$anyDiacritic, (match)=>$3944c2da7f0324a1$var$diacriticToBase[match]);
};

});


parcelRegister("8ogLA", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $aa68feeaf48a7bc6$export$164de7ab8df77ef0);
const $aa68feeaf48a7bc6$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $aa68feeaf48a7bc6$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $aa68feeaf48a7bc6$var$baseUnit = 4;
// The minimum height of the control
const $aa68feeaf48a7bc6$var$controlHeight = 38;
// The amount of space between the control and menu */
const $aa68feeaf48a7bc6$var$menuGutter = $aa68feeaf48a7bc6$var$baseUnit * 2;
const $aa68feeaf48a7bc6$export$5458b64234d1333c = {
    baseUnit: $aa68feeaf48a7bc6$var$baseUnit,
    controlHeight: $aa68feeaf48a7bc6$var$controlHeight,
    menuGutter: $aa68feeaf48a7bc6$var$menuGutter
};
const $aa68feeaf48a7bc6$export$164de7ab8df77ef0 = {
    borderRadius: $aa68feeaf48a7bc6$var$borderRadius,
    colors: $aa68feeaf48a7bc6$export$8f45430ccf837300,
    spacing: $aa68feeaf48a7bc6$export$5458b64234d1333c
};

});


parcelRegister("aXltS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4446f2908cc6068e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $4446f2908cc6068e$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("1oOGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $38250713238549ef$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $8r9C9 = parcelRequire("8r9C9");

var $lL8xO = parcelRequire("lL8xO");
var $grOdA = parcelRequire("grOdA");

var $65zLD = parcelRequire("65zLD");

var $5Doo5 = parcelRequire("5Doo5");

var $a3o6L = parcelRequire("a3o6L");

var $NHgCB = parcelRequire("NHgCB");
function $38250713238549ef$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $lL8xO.ClearIndicator,
                DropdownIndicator: $lL8xO.DropdownIndicator,
                LoadingIndicator: $lL8xO.LoadingIndicator,
                MultiValueRemove: $grOdA.MultiValueRemove,
                IndicatorSeparator: $grOdA.IndicatorSeparator,
                Input: $65zLD.Input,
                NoOptionsMessage: $5Doo5.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $NHgCB.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $NHgCB.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $8r9C9.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $a3o6L.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("lL8xO", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $b55fa3a6708e6433$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $b55fa3a6708e6433$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $b55fa3a6708e6433$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5IJsn = parcelRequire("5IJsn");

var $3wscq = parcelRequire("3wscq");

var $45qbL = parcelRequire("45qbL");
var $1jsQJ = parcelRequire("1jsQJ");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");

var $bBdMg = parcelRequire("bBdMg");
const $b55fa3a6708e6433$var$iconContainerStyles = (0, $8Vv3m.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $b55fa3a6708e6433$var$dropdownWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.075'
});
const $b55fa3a6708e6433$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jsQJ.default), {
        xcss: $b55fa3a6708e6433$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3wscq))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $b55fa3a6708e6433$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
        as: "span",
        xcss: $b55fa3a6708e6433$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $b55fa3a6708e6433$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bBdMg.default), {
        size: "small"
    })));
};

});
parcelRegister("3wscq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $290a3c11f7e03bc6$var$_react = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $290a3c11f7e03bc6$var$_crossCircle = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("avwnz")));

var $290a3c11f7e03bc6$var$_selectClear = $290a3c11f7e03bc6$var$_interopRequireDefault((parcelRequire("93YTD")));
function $290a3c11f7e03bc6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $290a3c11f7e03bc6$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $290a3c11f7e03bc6$var$_react.default.createElement($290a3c11f7e03bc6$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $290a3c11f7e03bc6$var$_selectClear.default
    }, props));
$290a3c11f7e03bc6$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $290a3c11f7e03bc6$var$_default = module.exports.default = $290a3c11f7e03bc6$var$CrossCircleIcon;

});
parcelRegister("avwnz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a65ea720a647725$var$_react = $7a65ea720a647725$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7a65ea720a647725$var$_UNSAFE_baseNew = $7a65ea720a647725$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $7a65ea720a647725$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a65ea720a647725$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $7a65ea720a647725$var$_react.default.createElement($7a65ea720a647725$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$7a65ea720a647725$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $7a65ea720a647725$var$_default = module.exports.default = $7a65ea720a647725$var$CrossCircleIcon;

});

parcelRegister("93YTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6993a19f4a8ea624$var$_react = $6993a19f4a8ea624$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $6993a19f4a8ea624$var$_crossCircle = $6993a19f4a8ea624$var$_interopRequireDefault((parcelRequire("7jum4")));
function $6993a19f4a8ea624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6993a19f4a8ea624$var$SelectClearIcon = (props)=>/*#__PURE__*/ $6993a19f4a8ea624$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $6993a19f4a8ea624$var$_crossCircle.default
    }));
$6993a19f4a8ea624$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $6993a19f4a8ea624$var$_default = module.exports.default = $6993a19f4a8ea624$var$SelectClearIcon;

});
parcelRegister("7jum4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5531daa29081c39f$var$_react = $5531daa29081c39f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5531daa29081c39f$var$_UNSAFE_baseNew = $5531daa29081c39f$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $5531daa29081c39f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5531daa29081c39f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5531daa29081c39f$var$_react.default.createElement($5531daa29081c39f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$5531daa29081c39f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $5531daa29081c39f$var$_default = module.exports.default = $5531daa29081c39f$var$CrossCircleIcon;

});




parcelRegister("grOdA", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $ac39515aa513e4da$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $ac39515aa513e4da$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $93YTD = parcelRequire("93YTD");

var $uSXUV = parcelRequire("uSXUV");

var $gYrJM = parcelRequire("gYrJM");

var $45qbL = parcelRequire("45qbL");
var $8Vv3m = parcelRequire("8Vv3m");

var $6EqnL = parcelRequire("6EqnL");

var $lL8xO = parcelRequire("lL8xO");
function $ac39515aa513e4da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac39515aa513e4da$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $ac39515aa513e4da$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $ac39515aa513e4da$var$iconWrapperStyles = (0, $8Vv3m.xcss)({
    padding: 'space.025'
});
const $ac39515aa513e4da$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $gYrJM.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uSXUV))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $gYrJM.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $45qbL.default), {
            xcss: $ac39515aa513e4da$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uSXUV))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93YTD))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $ac39515aa513e4da$var$disabledStyles : $ac39515aa513e4da$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $ac39515aa513e4da$export$bd638c2ba7915668 = null;

});
parcelRegister("uSXUV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05cd7070e053e072$var$_react = $05cd7070e053e072$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $05cd7070e053e072$var$_UNSAFE_baseNew = $05cd7070e053e072$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $05cd7070e053e072$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05cd7070e053e072$var$CrossIcon = (props)=>/*#__PURE__*/ $05cd7070e053e072$var$_react.default.createElement($05cd7070e053e072$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$05cd7070e053e072$var$CrossIcon.displayName = 'CrossIcon';
var $05cd7070e053e072$var$_default = module.exports.default = $05cd7070e053e072$var$CrossIcon;

});


parcelRegister("65zLD", function(module, exports) {

$parcel$export(module.exports, "Input", () => $23b0d2dc6a551f19$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $6EqnL = parcelRequire("6EqnL");
function $23b0d2dc6a551f19$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("5Doo5", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $5ed62d2b15567313$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $1JJay = parcelRequire("1JJay");

var $6EqnL = parcelRequire("6EqnL");
const $5ed62d2b15567313$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6EqnL.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("a3o6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe4a10b382601121$export$2e2bcd8739ae039);

var $gYrJM = parcelRequire("gYrJM");

function $fe4a10b382601121$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $1b343b038f6c23ec$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $1b343b038f6c23ec$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $1b343b038f6c23ec$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $1b343b038f6c23ec$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $1b343b038f6c23ec$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $1b343b038f6c23ec$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $1b343b038f6c23ec$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $1b343b038f6c23ec$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $1b343b038f6c23ec$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $1b343b038f6c23ec$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $1b343b038f6c23ec$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $1b343b038f6c23ec$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $1b343b038f6c23ec$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $1b343b038f6c23ec$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $1b343b038f6c23ec$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $gYrJM.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $1b343b038f6c23ec$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $1b343b038f6c23ec$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $1b343b038f6c23ec$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $1b343b038f6c23ec$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $1b343b038f6c23ec$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $gYrJM.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $1b343b038f6c23ec$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("NHgCB", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $d9c0a053f0c64587$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $d9c0a053f0c64587$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $d9c0a053f0c64587$export$8ee33f304118fce4);
function $d9c0a053f0c64587$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $d9c0a053f0c64587$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $d9c0a053f0c64587$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("2FrYX", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $0361e695debecd6f$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $0361e695debecd6f$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $0361e695debecd6f$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ddMyj = parcelRequire("ddMyj");

var $6EqnL = parcelRequire("6EqnL");


var $6ZA7b = parcelRequire("6ZA7b");

var $hVx5a = parcelRequire("hVx5a");
function $0361e695debecd6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0361e695debecd6f$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $6ZA7b.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $1b343b038f6c23ec$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $1b343b038f6c23ec$export$46987b49aab6d1a8)}`})`
});
const $0361e695debecd6f$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $0361e695debecd6f$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $0361e695debecd6f$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $0361e695debecd6f$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $0361e695debecd6f$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ddMyj))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $0361e695debecd6f$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $0361e695debecd6f$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $0361e695debecd6f$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).Control, {
        ...props,
        innerProps: innerProps
    }));
const $0361e695debecd6f$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hVx5a.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $0361e695debecd6f$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $0361e695debecd6f$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).IndicatorSeparator, props);
const $0361e695debecd6f$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).ClearIndicator, props);
const $0361e695debecd6f$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6EqnL.components).MultiValueRemove, props);
const $0361e695debecd6f$export$71abc632aa29e6fe = {
    Control: $0361e695debecd6f$var$Control,
    DropdownIndicator: $0361e695debecd6f$var$DropdownIndicator,
    Menu: $0361e695debecd6f$var$Menu,
    IndicatorSeparator: $0361e695debecd6f$var$IndicatorSeparator,
    ClearIndicator: $0361e695debecd6f$var$ClearIndicator,
    MultiValueRemove: $0361e695debecd6f$var$MultiValueRemove
};

});
parcelRegister("ddMyj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a0226c6d5821eba$var$_react = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9a0226c6d5821eba$var$_search = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("eebsR")));

var $9a0226c6d5821eba$var$_search2 = $9a0226c6d5821eba$var$_interopRequireDefault((parcelRequire("hU0Tg")));
function $9a0226c6d5821eba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a0226c6d5821eba$var$SearchIcon = (props)=>/*#__PURE__*/ $9a0226c6d5821eba$var$_react.default.createElement($9a0226c6d5821eba$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $9a0226c6d5821eba$var$_search2.default
    }, props));
$9a0226c6d5821eba$var$SearchIcon.Name = 'SearchIconMigration';
var $9a0226c6d5821eba$var$_default = module.exports.default = $9a0226c6d5821eba$var$SearchIcon;

});
parcelRegister("hU0Tg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0885b6f5437ca77$var$_react = $d0885b6f5437ca77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $d0885b6f5437ca77$var$_search = $d0885b6f5437ca77$var$_interopRequireDefault((parcelRequire("eebsR")));
function $d0885b6f5437ca77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0885b6f5437ca77$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $d0885b6f5437ca77$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $d0885b6f5437ca77$var$_search.default
    }));
$d0885b6f5437ca77$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $d0885b6f5437ca77$var$_default = module.exports.default = $d0885b6f5437ca77$var$EditorSearchIcon;

});






parcelRegister("encBb", function(module, exports) {

$parcel$export(module.exports, "isValidFailedExperience", () => $89788eccf1aec1d5$export$883079293b9cad76);
const $89788eccf1aec1d5$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $89788eccf1aec1d5$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($89788eccf1aec1d5$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("1FYo4", function(module, exports) {

$parcel$export(module.exports, "renderShareDialogExp", () => $df39e89f93526324$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $df39e89f93526324$export$31627ee726f40567);

var $81rKJ = parcelRequire("81rKJ");
var $4VUeZ = parcelRequire("4VUeZ");
const $df39e89f93526324$export$99c0383421ae57eb = new (0, $4VUeZ.UFOExperience)('render-share-dialog', {
    type: (0, $81rKJ.ExperienceTypes).Experience,
    performanceType: (0, $81rKJ.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $df39e89f93526324$export$31627ee726f40567 = new (0, $4VUeZ.UFOExperience)('share-submit-action', {
    type: (0, $81rKJ.ExperienceTypes).Experience,
    performanceType: (0, $81rKJ.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});
parcelRegister("81rKJ", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $f2676a4451455673$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $f2676a4451455673$export$cc26007c03242fff);
var $f2676a4451455673$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($f2676a4451455673$export$994164cf3ae1cc9a || ($f2676a4451455673$export$994164cf3ae1cc9a = {}));
var $f2676a4451455673$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($f2676a4451455673$export$cc26007c03242fff || ($f2676a4451455673$export$cc26007c03242fff = {}));

});

parcelRegister("4VUeZ", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $ec1bbe1b2945d366$export$c00d22927c60484a);

var $d63TT = parcelRequire("d63TT");
class $ec1bbe1b2945d366$export$c00d22927c60484a extends (0, $d63TT.UFOAbstractExperience) {
}

});
parcelRegister("d63TT", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $c2bc9aefbdfa5f87$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $11Jfd = parcelRequire("11Jfd");

var $6KjoJ = parcelRequire("6KjoJ");

var $hTPY9 = parcelRequire("hTPY9");

var $ES2vf = parcelRequire("ES2vf");

var $D3U2f = parcelRequire("D3U2f");

var $aQeOK = parcelRequire("aQeOK");

var $YpPYM = parcelRequire("YpPYM");

var $eHUHS = parcelRequire("eHUHS");

var $81rKJ = parcelRequire("81rKJ");
const $c2bc9aefbdfa5f87$var$getPageVisibleState = ()=>{
    return !(0, $aQeOK.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $ES2vf.PageVisibleState).VISIBLE : (0, $ES2vf.PageVisibleState).HIDDEN;
};
const $c2bc9aefbdfa5f87$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $D3U2f.roundPerfNow)();
};
class $c2bc9aefbdfa5f87$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $YpPYM.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $ES2vf.PageVisibleState).MIXED;
            (0, $hTPY9.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $c2bc9aefbdfa5f87$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $81rKJ.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $81rKJ.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $6KjoJ.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $eHUHS.canTransition)(this.state, newState)) {
            (0, $6KjoJ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $YpPYM.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $c2bc9aefbdfa5f87$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $c2bc9aefbdfa5f87$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $11Jfd.getGlobalEventStream)().push((0, $11Jfd.unsubscribeEvent)((0, $ES2vf.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $6KjoJ.ufolog)('this.parent', this.parent);
                (0, $11Jfd.getGlobalEventStream)().push((0, $11Jfd.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $6KjoJ.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $6KjoJ.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $YpPYM.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $c2bc9aefbdfa5f87$var$getPageVisibleState();
            (0, $hTPY9.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $6KjoJ.ufolog)('subscribed', this.id);
                (0, $11Jfd.getGlobalEventStream)().push((0, $11Jfd.subscribeEvent)((0, $ES2vf.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $ES2vf.FMP_MARK) && name !== (0, $ES2vf.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $6KjoJ.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $c2bc9aefbdfa5f87$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $YpPYM.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $ES2vf.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $ES2vf.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $6KjoJ.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $hTPY9.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $YpPYM.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $YpPYM.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $YpPYM.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $6KjoJ.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $fdfbd9402ca234df$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $fdfbd9402ca234df$export$2295b861f318254a = '0.1.5';

parcelRegister("11Jfd", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $e80faf19d0260967$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $e80faf19d0260967$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $e80faf19d0260967$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $e80faf19d0260967$export$7c957416596ca127);

var $6KjoJ = parcelRequire("6KjoJ");

var $ES2vf = parcelRequire("ES2vf");
const $e80faf19d0260967$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $e80faf19d0260967$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $e80faf19d0260967$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $e80faf19d0260967$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $6KjoJ.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $e80faf19d0260967$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $ES2vf.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e80faf19d0260967$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $ES2vf.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $e80faf19d0260967$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $ES2vf.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("6KjoJ", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $3b095d9d5e1b3ac8$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $3b095d9d5e1b3ac8$export$d53d07b6034c4560);
class $3b095d9d5e1b3ac8$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($3b095d9d5e1b3ac8$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($3b095d9d5e1b3ac8$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $3b095d9d5e1b3ac8$export$4ab84f6f04f6566d = new $3b095d9d5e1b3ac8$var$UFOLogger();
const $3b095d9d5e1b3ac8$export$b4958caff08a0960 = (...args)=>{
    $3b095d9d5e1b3ac8$export$4ab84f6f04f6566d.log(...args);
};
const $3b095d9d5e1b3ac8$export$d53d07b6034c4560 = (...args)=>{
    $3b095d9d5e1b3ac8$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("ES2vf", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $b235f3d851d63f60$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $b235f3d851d63f60$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $b235f3d851d63f60$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $b235f3d851d63f60$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $b235f3d851d63f60$export$837e0f79a8056912);
var $b235f3d851d63f60$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($b235f3d851d63f60$export$96253c35c37cf96b || ($b235f3d851d63f60$export$96253c35c37cf96b = {}));
var $b235f3d851d63f60$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($b235f3d851d63f60$export$a12c67b37a306b13 || ($b235f3d851d63f60$export$a12c67b37a306b13 = {}));
var $b235f3d851d63f60$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($b235f3d851d63f60$export$66b33c055cbb625e || ($b235f3d851d63f60$export$66b33c055cbb625e = {}));
var $b235f3d851d63f60$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($b235f3d851d63f60$export$3ce489cbe02dc21b || ($b235f3d851d63f60$export$3ce489cbe02dc21b = {}));
var $b235f3d851d63f60$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($b235f3d851d63f60$export$341b330828bd3906 || ($b235f3d851d63f60$export$341b330828bd3906 = {}));
var $b235f3d851d63f60$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($b235f3d851d63f60$export$b9b20160f581e4f8 || ($b235f3d851d63f60$export$b9b20160f581e4f8 = {}));
const $b235f3d851d63f60$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $b235f3d851d63f60$export$9f2bf58999404c75 = 'fmp';
const $b235f3d851d63f60$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("hTPY9", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $241bc900f7b8581b$export$13e680397ec8f3eb);

var $aQeOK = parcelRequire("aQeOK");
class $241bc900f7b8581b$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $aQeOK.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $241bc900f7b8581b$export$13e680397ec8f3eb = new $241bc900f7b8581b$var$VisibilityChangeObserver();

});
parcelRegister("aQeOK", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $31d49408802005f8$export$15e172712955e18f);
const $31d49408802005f8$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("D3U2f", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $ecea5a474f727a72$export$5f490af6b2b115cf);
const $ecea5a474f727a72$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("YpPYM", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $fbbc02172ff3c387$export$81b70111112841a0);
const $fbbc02172ff3c387$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("eHUHS", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $8eda48793af6a72d$export$178881f329fdb81f);

var $YpPYM = parcelRequire("YpPYM");
const $8eda48793af6a72d$var$UFOStateAvailableTransitions = {
    [(0, $YpPYM.UFOExperienceState).NOT_STARTED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).STARTED.id]: [
        (0, $YpPYM.UFOExperienceState).IN_PROGRESS.id,
        (0, $YpPYM.UFOExperienceState).BLOCKED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $YpPYM.UFOExperienceState).BLOCKED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).BLOCKED.id]: [
        (0, $YpPYM.UFOExperienceState).RECOVERED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).RECOVERED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).SUCCEEDED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $YpPYM.UFOExperienceState).SUCCEEDED.id,
        (0, $YpPYM.UFOExperienceState).FAILED.id,
        (0, $YpPYM.UFOExperienceState).ABORTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).FAILED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ],
    [(0, $YpPYM.UFOExperienceState).ABORTED.id]: [
        (0, $YpPYM.UFOExperienceState).STARTED.id
    ]
};
const $8eda48793af6a72d$export$178881f329fdb81f = (state1, state2)=>{
    return $8eda48793af6a72d$var$UFOStateAvailableTransitions[state1.id] && $8eda48793af6a72d$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("a8PoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae86aa02761d9e62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f3klQ = parcelRequire("f3klQ");

var $bLAWR = parcelRequire("bLAWR");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ae86aa02761d9e62$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $bLAWR.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $bLAWR.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
var $ae86aa02761d9e62$export$2e2bcd8739ae039 = (0, $f3klQ.default)()($ae86aa02761d9e62$var$ErrorBoundary);

});

parcelRegister("5PhnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf18e513c11645fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $cyzWb = parcelRequire("cyzWb");
const $cf18e513c11645fd$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $cyzWb.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US"
    }, children);
};
var $cf18e513c11645fd$export$2e2bcd8739ae039 = (0, $2qhQi.default)($cf18e513c11645fd$var$MessagesIntlProvider);

});
parcelRegister("cyzWb", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $af0143d0207f3984$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ parcelRequire("bLa9I");
var $1pVkx = parcelRequire("1pVkx");
var $hFPML = parcelRequire("hFPML");
var $9rzcX = parcelRequire("9rzcX");
var $gb9Or = parcelRequire("gb9Or");
var $ikz4n = parcelRequire("ikz4n");
var $1ZMpM = parcelRequire("1ZMpM");
var $elgI5 = parcelRequire("elgI5");
var $4uRAx = parcelRequire("4uRAx");
var $gVpdA = parcelRequire("gVpdA");
var $3p42E = parcelRequire("3p42E");
var $aXPtc = parcelRequire("aXPtc");
var $27y1w = parcelRequire("27y1w");
var $iQwQy = parcelRequire("iQwQy");
var $oAl55 = parcelRequire("oAl55");
var $fAuZu = parcelRequire("fAuZu");
var $6lffV = parcelRequire("6lffV");
var $jdnCB = parcelRequire("jdnCB");
var $7tVzL = parcelRequire("7tVzL");
var $iQT9i = parcelRequire("iQT9i");
var $dsr2c = parcelRequire("dsr2c");
var $85g4r = parcelRequire("85g4r");
var $72G9u = parcelRequire("72G9u");
var $dKOkr = parcelRequire("dKOkr");
var $aSS9W = parcelRequire("aSS9W");
const $af0143d0207f3984$var$localesMessagesMap = {
    cs: $1pVkx.default,
    da: $hFPML.default,
    de: $9rzcX.default,
    en: $gb9Or.default,
    en_GB: $ikz4n.default,
    es: $1ZMpM.default,
    et: $elgI5.default,
    fi: $4uRAx.default,
    fr: $gVpdA.default,
    hu: $3p42E.default,
    is: $aXPtc.default,
    it: $27y1w.default,
    ja: $iQwQy.default,
    ko: $oAl55.default,
    nb: $fAuZu.default,
    nl: $6lffV.default,
    pl: $jdnCB.default,
    pt_BR: $7tVzL.default,
    'pt-BR': (0, $7tVzL.default),
    pt_PT: $iQT9i.default,
    'pt-PT': (0, $iQT9i.default),
    ro: $dsr2c.default,
    ru: $85g4r.default,
    sk: $72G9u.default,
    sv: $dKOkr.default,
    zh: $aSS9W.default
};
const $af0143d0207f3984$export$d0a3169680473b6c = (locale)=>{
    let messages = $af0143d0207f3984$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $af0143d0207f3984$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $gb9Or.default);
    return messages;
};

});
parcelRegister("bLa9I", function(module, exports) {

$parcel$export(module.exports, "zh", () => (parcelRequire("aSS9W")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("1pVkx")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("hFPML")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("6lffV")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("elgI5")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("4uRAx")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("gVpdA")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("9rzcX")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("3p42E")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("27y1w")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("iQwQy")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("oAl55")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("fAuZu")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("jdnCB")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("7tVzL")).default);
$parcel$export(module.exports, "pt_PT", () => (parcelRequire("iQT9i")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("85g4r")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("72G9u")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("1ZMpM")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("dKOkr")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("gb9Or")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("ikz4n")).default);
$parcel$export(module.exports, "is", () => (parcelRequire("aXPtc")).default);
$parcel$export(module.exports, "ro", () => (parcelRequire("dsr2c")).default);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aSS9W = parcelRequire("aSS9W");

var $fq038 = parcelRequire("fq038");

var $1pVkx = parcelRequire("1pVkx");

var $hFPML = parcelRequire("hFPML");

var $6lffV = parcelRequire("6lffV");

var $elgI5 = parcelRequire("elgI5");

var $4uRAx = parcelRequire("4uRAx");

var $gVpdA = parcelRequire("gVpdA");

var $9rzcX = parcelRequire("9rzcX");

var $3p42E = parcelRequire("3p42E");

var $27y1w = parcelRequire("27y1w");

var $iQwQy = parcelRequire("iQwQy");

var $oAl55 = parcelRequire("oAl55");

var $fAuZu = parcelRequire("fAuZu");

var $jdnCB = parcelRequire("jdnCB");

var $7tVzL = parcelRequire("7tVzL");

var $iQT9i = parcelRequire("iQT9i");

var $85g4r = parcelRequire("85g4r");

var $72G9u = parcelRequire("72G9u");

var $1ZMpM = parcelRequire("1ZMpM");

var $dKOkr = parcelRequire("dKOkr");

var $l23Gi = parcelRequire("l23Gi");

var $kZEdI = parcelRequire("kZEdI");

var $9Dz0B = parcelRequire("9Dz0B");

var $9RAG0 = parcelRequire("9RAG0");

var $f2xYB = parcelRequire("f2xYB");

var $gb9Or = parcelRequire("gb9Or");

var $ikz4n = parcelRequire("ikz4n");

var $aXPtc = parcelRequire("aXPtc");

var $dsr2c = parcelRequire("dsr2c");

});
parcelRegister("aSS9W", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae914cf82d0247a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $3ae914cf82d0247a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});

parcelRegister("fq038", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $cd9f86d78fb54cc8$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u5DF2\u5C07\u9023\u7D50\u8907\u88FD\u5230\u526A\u8CBC\u7C3F",
    'fabric.elements.share.copylink.button.text': "\u8907\u88FD\u9023\u7D50",
    'fabric.elements.share.copypubliclink.button.text': "\u8907\u88FD\u516C\u958B\u9023\u7D50",
    'fabric.elements.share.failure.icon.label': "\u932F\u8AA4\u5716\u793A",
    'fabric.elements.share.failure.message': "\u7121\u6CD5\u5206\u4EAB",
    'fabric.elements.share.form.comment.label': "\u8A0A\u606F (\u9078\u586B)",
    'fabric.elements.share.form.comment.placeholder': "\u4ED6\u5011\u61C9\u8A72\u77E5\u9053\u54EA\u4E9B\u4E8B\u60C5\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u8005\u5C07\u770B\u5230\u9801\u9762\u7684\u540D\u7A31\u548C\u60A8\u7684\u8A0A\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u8005\u5C07\u770B\u5230\u8B70\u984C\u7684\u540D\u7A31\u548C\u60A8\u7684\u8A0A\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u7121\u6CD5\u5206\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u50B3\u9001\u516C\u958B\u9023\u7D50",
    'fabric.elements.share.form.public.share': "\u5171\u7528\u516C\u958B\u9023\u7D50",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u6B04\u4F4D\u6A19\u6709\u661F\u865F",
    'fabric.elements.share.form.retry': "\u91CD\u8A66",
    'fabric.elements.share.form.send': "\u50B3\u9001",
    'fabric.elements.share.form.share': "\u5206\u4EAB",
    'fabric.elements.share.form.title': "\u5206\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F38\u5165\u66F4\u591A\u9805\u76EE",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u7A31\u3001\u5718\u968A\u3001\u7FA4\u7D44\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u7A31\u3001\u5718\u968A\u6216\u7FA4\u7D44",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u7A31\u6216\u5718\u968A",
    'fabric.elements.share.form.user-picker.label.email-only': "\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u7A31\u3001\u5718\u968A\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u5011\u627E\u4E0D\u5230\u300C{inputValue}\u300D\u7684\u4EFB\u4F55\u7D50\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u5011\u627E\u4E0D\u5230\u300C{inputValue}\u300D\u7684\u4EFB\u4F55\u7D50\u679C\u3002\u8ACB\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u9080\u8ACB\u4F7F\u7528\u8005\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF1A\u746A\u9E97\u4E9E, \u6A58\u968A, \u7B2C\u4E00\u7D44",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF1A\u746A\u9E97\u4E9E, \u6A58\u968A",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF1Amaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF1A\u746A\u9E97\u4E9E, \u6A58\u968A, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8ACB\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4F7F\u7528\u8005\u3001\u7FA4\u7D44\u3001\u5718\u968A\u6216\u96FB\u5B50\u90F5\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u3001\u5718\u968A\u3001\u7FA4\u7D44\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u3001\u5718\u968A\u6216\u7FA4\u7D44",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u6216\u5718\u968A",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u81F3\u5C11\u9078\u53D6\u4E00\u500B\u4EBA\u54E1\u3001\u5718\u968A\u6216\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8ACB\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8ACB\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9801\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u7528\u8B70\u984C",
    'fabric.elements.share.menu.email.label': "\u96FB\u5B50\u90F5\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5206\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u5DF2\u5206\u4EAB\u90E8\u843D\u683C\u8CBC\u6587}board {\u5DF2\u5206\u4EAB\u770B\u677F}calendar {\u5DF2\u5206\u4EAB\u884C\u4E8B\u66C6}draft {\u5DF2\u5206\u4EAB\u8349\u7A3F}filter {\u5DF2\u5206\u4EAB\u7BE9\u9078\u689D\u4EF6}issue {\u5DF2\u5206\u4EAB\u8B70\u984C}summary {\u5DF2\u5206\u4EAB\u6458\u8981}list {\u5DF2\u5206\u4EAB\u5217\u8868}timeline {\u5DF2\u5206\u4EAB\u6642\u9593\u8868}form {\u5DF2\u5206\u4EAB\u8868\u55AE}media {\u5DF2\u5206\u4EAB\u5A92\u9AD4}page {\u5DF2\u5206\u4EAB\u9801\u9762}project {\u5DF2\u5206\u4EAB\u5C08\u6848}pullrequest {\u5DF2\u5206\u4EAB\u63D0\u53D6\u8981\u6C42}question {\u5DF2\u5206\u4EAB\u554F\u984C}report {\u5DF2\u5206\u4EAB\u5831\u544A}repository {\u5DF2\u5206\u4EAB\u5B58\u653E\u5EAB}request {\u5DF2\u5206\u4EAB\u8981\u6C42}roadmap {\u5DF2\u5206\u4EAB\u6642\u9593\u8EF8}site {\u5DF2\u5206\u4EAB\u7DB2\u7AD9}space {\u5DF2\u5206\u4EAB\u7A7A\u9593}other {\u5DF2\u5206\u4EAB\u9023\u7D50}}",
    'fabric.elements.share.to.integration.button': "\u8207 {integrationName} \u5206\u4EAB",
    'fabric.elements.share.trigger.button.icon.label': "\u5206\u4EAB\u5716\u793A",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8ACB",
    'fabric.elements.share.trigger.button.text': "\u5206\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5206\u4EAB"
};

});

parcelRegister("1pVkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e96e2960dbc125a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $9e96e2960dbc125a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});

parcelRegister("hFPML", function(module, exports) {

$parcel$export(module.exports, "default", () => $388256f4dca9bfdf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $388256f4dca9bfdf$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("6lffV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccfc154481b62bad$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $ccfc154481b62bad$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});

parcelRegister("elgI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b639e82a38440eb$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $5b639e82a38440eb$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("4uRAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec4dfd811a08b19$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $2ec4dfd811a08b19$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});

parcelRegister("gVpdA", function(module, exports) {

$parcel$export(module.exports, "default", () => $26417267e1cd8641$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $26417267e1cd8641$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});

parcelRegister("9rzcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5f67031dfc3d73$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $bf5f67031dfc3d73$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});

parcelRegister("3p42E", function(module, exports) {

$parcel$export(module.exports, "default", () => $3370ea033e52bf64$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $3370ea033e52bf64$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});

parcelRegister("27y1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7adc378fc3851339$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $7adc378fc3851339$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});

parcelRegister("iQwQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e460a890bc44e6d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $8e460a890bc44e6d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});

parcelRegister("oAl55", function(module, exports) {

$parcel$export(module.exports, "default", () => $200bc1bcef3bcd91$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $200bc1bcef3bcd91$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});

parcelRegister("fAuZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d54c4eb8241b5a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $00d54c4eb8241b5a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("jdnCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfcaf1289dfd960f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $dfcaf1289dfd960f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});

parcelRegister("7tVzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $14cfbe880c693ab1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $14cfbe880c693ab1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});

parcelRegister("iQT9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e3782e871d3bd4$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $64e3782e871d3bd4$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("85g4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a67580105533c14d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $a67580105533c14d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});

parcelRegister("72G9u", function(module, exports) {

$parcel$export(module.exports, "default", () => $58dea193620a6956$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $58dea193620a6956$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("1ZMpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc68276e914b1179$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $cc68276e914b1179$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});

parcelRegister("dKOkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d9b34466d880a2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $f6d9b34466d880a2$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});

parcelRegister("l23Gi", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $3600545fbf809c3c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E04\u0E25\u0E34\u0E1B\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E49\u0E27",
    'fabric.elements.share.copylink.button.text': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C",
    'fabric.elements.share.copypubliclink.button.text': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'fabric.elements.share.failure.icon.label': "\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14",
    'fabric.elements.share.failure.message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E14\u0E49",
    'fabric.elements.share.form.comment.label': "\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21 (\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38)",
    'fabric.elements.share.form.comment.placeholder': "\u0E21\u0E35\u0E2D\u0E30\u0E44\u0E23\u0E17\u0E35\u0E48\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E04\u0E27\u0E23\u0E23\u0E39\u0E49\u0E44\u0E2B\u0E21",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E1A\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E1A\u0E08\u0E30\u0E40\u0E2B\u0E47\u0E19\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    'fabric.elements.share.form.no-permissions': "\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.form.public.send': "\u0E2A\u0E48\u0E07\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'fabric.elements.share.form.public.share': "\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E2A\u0E32\u0E18\u0E32\u0E23\u0E13\u0E30",
    'fabric.elements.share.form.required-field.summary': "\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E30\u0E1A\u0E38\u0E08\u0E30\u0E21\u0E35\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E14\u0E2D\u0E01\u0E08\u0E31\u0E19",
    'fabric.elements.share.form.retry': "\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'fabric.elements.share.form.send': "\u0E2A\u0E48\u0E07",
    'fabric.elements.share.form.share': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.form.title': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.form.user-picker.add-more': "\u0E1B\u0E49\u0E2D\u0E19\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0E0A\u0E37\u0E48\u0E2D \u0E17\u0E35\u0E21 \u0E01\u0E25\u0E38\u0E48\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0E0A\u0E37\u0E48\u0E2D \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E21",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.label.jira': "\u0E0A\u0E37\u0E48\u0E2D \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E43\u0E14 \u0E46 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A "{inputValue}"',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E43\u0E14 \u0E46 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A "{inputValue}" \u0E40\u0E0A\u0E34\u0E0D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u0E40\u0E0A\u0E48\u0E19 \u0E21\u0E32\u0E40\u0E23\u0E35\u0E22 \u0E17\u0E35\u0E21\u0E2A\u0E49\u0E21 \u0E01\u0E25\u0E38\u0E48\u0E21\u0E2B\u0E19\u0E36\u0E48\u0E07",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u0E40\u0E0A\u0E48\u0E19 \u0E21\u0E32\u0E40\u0E23\u0E35\u0E22 \u0E17\u0E35\u0E21\u0E2A\u0E49\u0E21",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u0E40\u0E0A\u0E48\u0E19 maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u0E40\u0E0A\u0E48\u0E19 \u0E21\u0E32\u0E40\u0E23\u0E35\u0E22 \u0E17\u0E35\u0E21\u0E2A\u0E49\u0E21 maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49 \u0E01\u0E25\u0E38\u0E48\u0E21 \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19 \u0E17\u0E35\u0E21 \u0E01\u0E25\u0E38\u0E48\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19 \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E25\u0E38\u0E48\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E21\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E19 \u0E17\u0E35\u0E21 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
    'fabric.elements.share.in.integration.button': "\u0E41\u0E0A\u0E23\u0E4C\u0E43\u0E19 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u0E40\u0E0A\u0E34\u0E0D\u0E44\u0E1B\u0E22\u0E31\u0E07 Confluence",
    'fabric.elements.share.invite.to.jira': "\u0E40\u0E0A\u0E34\u0E0D\u0E44\u0E1B\u0E22\u0E31\u0E07 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u0E41\u0E0A\u0E23\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'fabric.elements.share.main.tab.text.jira': "\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'fabric.elements.share.menu.email.label': "\u0E2D\u0E35\u0E40\u0E21\u0E25",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0E41\u0E0A\u0E23\u0E4C\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27}board {\u0E41\u0E0A\u0E23\u0E4C\u0E1A\u0E2D\u0E23\u0E4C\u0E14\u0E41\u0E25\u0E49\u0E27}calendar {\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E0F\u0E34\u0E17\u0E34\u0E19\u0E41\u0E25\u0E49\u0E27}draft {\u0E41\u0E0A\u0E23\u0E4C\u0E41\u0E1A\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E41\u0E25\u0E49\u0E27}filter {\u0E41\u0E0A\u0E23\u0E4C\u0E15\u0E31\u0E27\u0E01\u0E23\u0E2D\u0E07\u0E41\u0E25\u0E49\u0E27}issue {\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E41\u0E25\u0E49\u0E27}summary {\u0E41\u0E0A\u0E23\u0E4C\u0E2A\u0E23\u0E38\u0E1B\u0E41\u0E25\u0E49\u0E27}list {\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27}timeline {\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E2A\u0E49\u0E19\u0E40\u0E27\u0E25\u0E32 (\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C) \u0E41\u0E25\u0E49\u0E27}form {\u0E41\u0E0A\u0E23\u0E4C\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E49\u0E27}media {\u0E41\u0E0A\u0E23\u0E4C\u0E2A\u0E37\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27}page {\u0E41\u0E0A\u0E23\u0E4C\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E25\u0E49\u0E27}project {\u0E41\u0E0A\u0E23\u0E4C\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27}pullrequest {\u0E41\u0E0A\u0E23\u0E4C Pull Request \u0E41\u0E25\u0E49\u0E27}question {\u0E41\u0E0A\u0E23\u0E4C\u0E04\u0E33\u0E16\u0E32\u0E21\u0E41\u0E25\u0E49\u0E27}report {\u0E41\u0E0A\u0E23\u0E4C\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E41\u0E25\u0E49\u0E27}repository {\u0E41\u0E0A\u0E23\u0E4C\u0E04\u0E25\u0E31\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27}request {\u0E41\u0E0A\u0E23\u0E4C\u0E04\u0E33\u0E02\u0E2D\u0E41\u0E25\u0E49\u0E27}roadmap {\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E2A\u0E49\u0E19\u0E40\u0E27\u0E25\u0E32 (\u0E44\u0E17\u0E21\u0E4C\u0E44\u0E25\u0E19\u0E4C) \u0E41\u0E25\u0E49\u0E27}site {\u0E41\u0E0A\u0E23\u0E4C\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27}space {\u0E41\u0E0A\u0E23\u0E4C\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27}other {\u0E41\u0E0A\u0E23\u0E4C\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E41\u0E25\u0E49\u0E27}}",
    'fabric.elements.share.to.integration.button': "\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E1B\u0E22\u0E31\u0E07 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0E41\u0E0A\u0E23\u0E4C\u0E44\u0E2D\u0E04\u0E2D\u0E19",
    'fabric.elements.share.trigger.button.invite.text': "\u0E40\u0E0A\u0E34\u0E0D",
    'fabric.elements.share.trigger.button.text': "\u0E41\u0E0A\u0E23\u0E4C",
    'fabric.elements.share.trigger.button.tooltip.text': "\u0E41\u0E0A\u0E23\u0E4C"
};

});

parcelRegister("kZEdI", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $79dc06767d8395f4$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Ba\u011Flant\u0131 panoya kopyaland\u0131",
    'fabric.elements.share.copylink.button.text': "Ba\u011Flant\u0131y\u0131 kopyala",
    'fabric.elements.share.copypubliclink.button.text': "Herkese a\xe7\u0131k ba\u011Flant\u0131y\u0131 kopyalay\u0131n",
    'fabric.elements.share.failure.icon.label': 'Hata simgesi',
    'fabric.elements.share.failure.message': "Payla\u015F\u0131lamad\u0131",
    'fabric.elements.share.form.comment.label': "Mesaj (iste\u011Fe ba\u011Fl\u0131)",
    'fabric.elements.share.form.comment.placeholder': "Bilmeleri gereken bir \u015Fey var m\u0131?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Al\u0131c\u0131lar sayfan\u0131n ad\u0131n\u0131 ve mesaj\u0131n\u0131z\u0131 g\xf6r\xfcr",
    'fabric.elements.share.form.info.message.no.invite.jira': "Al\u0131c\u0131lar konunun ad\u0131n\u0131 ve mesaj\u0131n\u0131z\u0131 g\xf6r\xfcr",
    'fabric.elements.share.form.no-permissions': "Payla\u015Fam\u0131yorsunuz.",
    'fabric.elements.share.form.public.send': "Herkese a\xe7\u0131k ba\u011Flant\u0131y\u0131 g\xf6nderin",
    'fabric.elements.share.form.public.share': "Herkese a\xe7\u0131k ba\u011Flant\u0131y\u0131 payla\u015F",
    'fabric.elements.share.form.required-field.summary': "Gerekli alanlar y\u0131ld\u0131z i\u015Faretiyle belirtilmi\u015Ftir",
    'fabric.elements.share.form.retry': 'Yeniden Dene',
    'fabric.elements.share.form.send': "G\xf6nder",
    'fabric.elements.share.form.share': "Payla\u015F",
    'fabric.elements.share.form.title': "Payla\u015F",
    'fabric.elements.share.form.user-picker.add-more': "Daha fazlas\u0131n\u0131 girin",
    'fabric.elements.share.form.user-picker.label.confluence': "Adlar, tak\u0131mlar, gruplar veya e-postalar",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Adlar, tak\u0131mlar veya gruplar",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Adlar veya tak\u0131mlar",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postalar',
    'fabric.elements.share.form.user-picker.label.jira': "Adlar, tak\u0131mlar veya e-postalar",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" i\xe7in herhangi bir sonu\xe7 bulunamad\u0131.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" i\xe7in herhangi bir sonu\xe7 bulunamad\u0131. Ki\u015Fileri e-posta adresi kullanarak davet edin.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\xf6r. Meryem, Turuncu Tak\u0131m, Birinci Grup",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\xf6r. Meryem, Turuncu Tak\u0131m",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\xf6r. meryem@sirket.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\xf6r. Meryem, Turuncu Tak\u0131m, meryem@sirket.com",
    'fabric.elements.share.form.user-picker.validation.required': "En az bir kullan\u0131c\u0131, grup, tak\u0131m veya e-posta adresi se\xe7in.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "En az bir ki\u015Fi, tak\u0131m, grup veya e-posta se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "En az bir ki\u015Fi, tak\u0131m veya grup se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "En az bir ki\u015Fi veya tak\u0131m se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "En az bir e-posta se\xe7in",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "En az bir ki\u015Fi, tak\u0131m veya e-posta se\xe7in",
    'fabric.elements.share.in.integration.button': "{integrationName} i\xe7inde payla\u015F",
    'fabric.elements.share.invite.to.confluence': "Confluence'a davet et",
    'fabric.elements.share.invite.to.jira': "Jira'ya davet et",
    'fabric.elements.share.main.tab.text.confluence': "Sayfay\u0131 payla\u015F\u0131n",
    'fabric.elements.share.main.tab.text.jira': "Konuyu payla\u015F\u0131n",
    'fabric.elements.share.menu.email.label': 'E-posta',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Payla\u015F",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog g\xf6nderisi payla\u015F\u0131ld\u0131}board {Pano payla\u015F\u0131ld\u0131}calendar {Takvim payla\u015F\u0131ld\u0131}draft {Taslak payla\u015F\u0131ld\u0131}filter {Filtre payla\u015F\u0131ld\u0131}issue {Konu payla\u015F\u0131ld\u0131}summary {\xd6zet payla\u015F\u0131ld\u0131}list {Liste payla\u015F\u0131ld\u0131}timeline {Zaman \xc7izelgesi payla\u015F\u0131ld\u0131}form {Form payla\u015F\u0131ld\u0131}media {Medya payla\u015F\u0131ld\u0131}page {Sayfa payla\u015F\u0131ld\u0131}project {Proje payla\u015F\u0131ld\u0131}pullrequest {\xc7ekme \u0130ste\u011Fi payla\u015F\u0131ld\u0131}question {Soru payla\u015F\u0131ld\u0131}report {Rapor payla\u015F\u0131ld\u0131}repository {Depo payla\u015F\u0131ld\u0131}request {Talep payla\u015F\u0131ld\u0131}roadmap {Zaman \xc7izelgesi payla\u015F\u0131ld\u0131}site {Site payla\u015F\u0131ld\u0131}space {Alan payla\u015F\u0131ld\u0131}other {Ba\u011Flant\u0131 payla\u015F\u0131ld\u0131}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \xfczerinden payla\u015F",
    'fabric.elements.share.trigger.button.icon.label': "Payla\u015Fma simgesi",
    'fabric.elements.share.trigger.button.invite.text': 'Davet Et',
    'fabric.elements.share.trigger.button.text': "Payla\u015F",
    'fabric.elements.share.trigger.button.tooltip.text': "Payla\u015F"
};

});

parcelRegister("9Dz0B", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $0bbb38a3133f9043$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E \u0431\u0443\u0444\u0435\u0440\u0430 \u043E\u0431\u043C\u0456\u043D\u0443",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.failure.icon.label': "\u041F\u0456\u043A\u0442\u043E\u0433\u0440\u0430\u043C\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.form.comment.label': "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456 \u043F\u043E\u0431\u0430\u0447\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0442\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041E\u0442\u0440\u0438\u043C\u0443\u0432\u0430\u0447\u0456 \u043F\u043E\u0431\u0430\u0447\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438 \u0442\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u043C\u043E\u0436\u043B\u0438\u0432\u043E\u0441\u0442\u0456 \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.",
    'fabric.elements.share.form.public.send': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u043C \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0456 \u043F\u043E\u043B\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u0437\u0456\u0440\u043E\u0447\u043A\u043E\u044E",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'fabric.elements.share.form.send': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0431\u0456\u043B\u044C\u0448\u0435 \u0432\u0456\u0434\u043E\u043C\u043E\u0441\u0442\u0435\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0406\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0438, \u0433\u0440\u0443\u043F\u0438 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0406\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0430\u0431\u043E \u0433\u0440\u0443\u043F\u0438",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0406\u043C\u0435\u043D\u0430 \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.label.jira': "\u0406\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0438 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0438 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0456\u0432 \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C \xab{inputValue}\xbb. \u0417\u0430\u043F\u0440\u043E\u0441\u0456\u0442\u044C \u043B\u044E\u0434\u0435\u0439 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u0430\u0434\u0440\u0435\u0441\u0438.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u041C\u0430\u0440\u0456\u044F, Team Orange, \u0433\u0440\u0443\u043F\u0430\xa01",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u041C\u0430\u0440\u0456\u044F, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434: \u041C\u0430\u0440\u0456\u044F, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u0433\u0440\u0443\u043F\u0443 \u0430\u0431\u043E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u043F\u043E\u0448\u0442\u0443.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u0443 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0430\u0431\u043E \u0433\u0440\u0443\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0440\u0438\u043D\u0430\u0439\u043C\u043D\u0456 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438 \u0434\u043E Confluence",
    'fabric.elements.share.invite.to.jira': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438 \u0434\u043E Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u043E\u044E",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F\u043C",
    'fabric.elements.share.menu.email.label': "\u0415\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u043F\u043E\u0448\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0434\u043E\u043F\u0438\u0441\u0443 \u0432 \u0431\u043B\u043E\u0437\u0456}board {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0434\u043E\u0448\u043A\u0438}calendar {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044F}draft {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0447\u0435\u0440\u043D\u0435\u0442\u043A\u0438}filter {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0444\u0456\u043B\u044C\u0442\u0440\u0430}issue {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F}summary {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u0456\u0434\u0441\u0443\u043C\u043A\u0443}list {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u043F\u0438\u0441\u043A\u0443}timeline {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0448\u043A\u0430\u043B\u0438}form {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0444\u043E\u0440\u043C\u0438}media {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043C\u0435\u0434\u0456\u0430\u0444\u0430\u0439\u043B\u0443}page {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438}project {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443}pullrequest {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0443 \u043D\u0430 \u0432\u043D\u0435\u0441\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D}question {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F}report {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0432\u0456\u0442\u0443}repository {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0456\u044E}request {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0437\u0430\u043F\u0438\u0442\u0443}roadmap {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0447\u0430\u0441\u043E\u0432\u043E\u0457 \u0448\u043A\u0430\u043B\u0438}site {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0441\u0430\u0439\u0442\u0443}space {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0440\u043E\u0437\u0434\u0456\u043B\u0443}other {\u041D\u0430\u0434\u0430\u043D\u043E \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F}}",
    'fabric.elements.share.to.integration.button': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u043F\u0456\u043A\u0442\u043E\u0433\u0440\u0430\u043C\u0443",
    'fabric.elements.share.trigger.button.invite.text': "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u0438",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F"
};

});

parcelRegister("9RAG0", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $7036ff543f412ca5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0110\xe3 sao ch\xe9p li\xean k\u1EBFt",
    'fabric.elements.share.copylink.button.text': "Sao ch\xe9p li\xean k\u1EBFt",
    'fabric.elements.share.copypubliclink.button.text': "Sao ch\xe9p li\xean k\u1EBFt c\xf4ng khai",
    'fabric.elements.share.failure.icon.label': "Bi\u1EC3u t\u01B0\u1EE3ng l\u1ED7i",
    'fabric.elements.share.failure.message': "Kh\xf4ng th\u1EC3 chia s\u1EBB",
    'fabric.elements.share.form.comment.label': "Tin nh\u1EAFn (kh\xf4ng b\u1EAFt bu\u1ED9c)",
    'fabric.elements.share.form.comment.placeholder': "B\u1EA1n c\xf3 n\u1ED9i dung g\xec c\u1EA7n l\u01B0u \xfd ng\u01B0\u1EDDi kh\xe1c kh\xf4ng?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Ng\u01B0\u1EDDi nh\u1EADn s\u1EBD th\u1EA5y t\xean trang v\xe0 tin nh\u1EAFn c\u1EE7a b\u1EA1n",
    'fabric.elements.share.form.info.message.no.invite.jira': "Ng\u01B0\u1EDDi nh\u1EADn s\u1EBD th\u1EA5y t\xean s\u1EF1 c\u1ED1 v\xe0 tin nh\u1EAFn c\u1EE7a b\u1EA1n",
    'fabric.elements.share.form.no-permissions': "B\u1EA1n kh\xf4ng c\xf3 kh\u1EA3 n\u0103ng chia s\u1EBB.",
    'fabric.elements.share.form.public.send': "G\u1EEDi li\xean k\u1EBFt c\xf4ng khai",
    'fabric.elements.share.form.public.share': "Chia s\u1EBB li\xean k\u1EBFt c\xf4ng khai",
    'fabric.elements.share.form.required-field.summary': "C\xe1c tr\u01B0\u1EDDng b\u1EAFt bu\u1ED9c \u0111\u01B0\u1EE3c \u0111\xe1nh d\u1EA5u b\u1EB1ng d\u1EA5u sao",
    'fabric.elements.share.form.retry': "Th\u1EED l\u1EA1i",
    'fabric.elements.share.form.send': "G\u1EEDi",
    'fabric.elements.share.form.share': "Chia s\u1EBB",
    'fabric.elements.share.form.title': "Chia s\u1EBB",
    'fabric.elements.share.form.user-picker.add-more': "Nh\u1EADp th\xeam",
    'fabric.elements.share.form.user-picker.label.confluence': "T\xean, \u0111\u1ED9i ng\u0169, nh\xf3m ho\u1EB7c email",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "T\xean, \u0111\u1ED9i ng\u0169 ho\u1EB7c nh\xf3m",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "T\xean ho\u1EB7c \u0111\u1ED9i ng\u0169",
    'fabric.elements.share.form.user-picker.label.email-only': 'Email',
    'fabric.elements.share.form.user-picker.label.jira': "T\xean, \u0111\u1ED9i ng\u0169 ho\u1EB7c email",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\xecm th\u1EA5y b\u1EA5t c\u1EE9 k\u1EBFt qu\u1EA3 n\xe0o cho "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Ch\xfang t\xf4i kh\xf4ng th\u1EC3 t\xecm th\u1EA5y b\u1EA5t c\u1EE9 k\u1EBFt qu\u1EA3 n\xe0o cho "{inputValue}". M\u1EDDi m\u1ECDi ng\u01B0\u1EDDi b\u1EB1ng c\xe1ch s\u1EED d\u1EE5ng \u0111\u1ECBa ch\u1EC9 email.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "v\xed d\u1EE5: Maria, \u0110\u1ED9i ng\u0169 m\xe0u cam, nh\xf3m m\u1ED9t",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "v\xed d\u1EE5: Maria, \u0110\u1ED9i ng\u0169 m\xe0u cam",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "v\xed d\u1EE5: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "v\xed d\u1EE5: Maria, \u0110\u1ED9i ng\u0169 m\xe0u cam, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi d\xf9ng, \u0111\u1ED9i, nh\xf3m ho\u1EB7c email.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi, \u0111\u1ED9i ng\u0169, nh\xf3m ho\u1EB7c email",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi, \u0111\u1ED9i ng\u0169 ho\u1EB7c nh\xf3m",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi ho\u1EB7c \u0111\u1ED9i ng\u0169",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t email",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Ch\u1ECDn \xedt nh\u1EA5t m\u1ED9t ng\u01B0\u1EDDi, \u0111\u1ED9i ng\u0169 ho\u1EB7c email",
    'fabric.elements.share.in.integration.button': "Chia s\u1EBB trong {integrationName}",
    'fabric.elements.share.invite.to.confluence': "M\u1EDDi tham gia Confluence",
    'fabric.elements.share.invite.to.jira': "M\u1EDDi tham gia Jira",
    'fabric.elements.share.main.tab.text.confluence': "Chia s\u1EBB trang",
    'fabric.elements.share.main.tab.text.jira': "Chia s\u1EBB v\u1EA5n \u0111\u1EC1",
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Chia s\u1EBB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0110\xe3 chia s\u1EBB b\xe0i \u0111\u0103ng tr\xean blog}board {\u0110\xe3 chia s\u1EBB b\u1EA3ng th\xf4ng tin}calendar {\u0110\xe3 chia s\u1EBB l\u1ECBch}draft {\u0110\xe3 chia s\u1EBB b\u1EA3n nh\xe1p}filter {\u0110\xe3 chia s\u1EBB b\u1ED9 l\u1ECDc}issue {\u0110\xe3 chia s\u1EBB v\u1EA5n \u0111\u1EC1}summary {\u0110\xe3 chia s\u1EBB b\u1EA3n t\xf3m t\u1EAFt}list {\u0110\xe3 chia s\u1EBB danh s\xe1ch}timeline {\u0110\xe3 chia s\u1EBB l\u1ECBch tr\xecnh}form {\u0110\xe3 chia s\u1EBB bi\u1EC3u m\u1EABu}media {\u0110\xe3 chia s\u1EBB ph\u01B0\u01A1ng ti\u1EC7n}page {\u0110\xe3 chia s\u1EBB trang}project {\u0110\xe3 chia s\u1EBB d\u1EF1 \xe1n}pullrequest {\u0110\xe3 chia s\u1EBB Pull request}question {\u0110\xe3 chia s\u1EBB c\xe2u h\u1ECFi}report {\u0110\xe3 chia s\u1EBB b\xe1o c\xe1o}repository {\u0110\xe3 chia s\u1EBB kho}request {\u0110\xe3 chia s\u1EBB y\xeau c\u1EA7u}roadmap {\u0110\xe3 chia s\u1EBB l\u1ECBch tr\xecnh}site {\u0110\xe3 chia s\u1EBB trang web}space {\u0110\xe3 chia s\u1EBB kh\xf4ng gian}other {\u0110\xe3 chia s\u1EBB li\xean k\u1EBFt}}",
    'fabric.elements.share.to.integration.button': "Chia s\u1EBB v\u1EDBi {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Bi\u1EC3u t\u01B0\u1EE3ng chia s\u1EBB",
    'fabric.elements.share.trigger.button.invite.text': "M\u1EDDi",
    'fabric.elements.share.trigger.button.text': "Chia s\u1EBB",
    'fabric.elements.share.trigger.button.tooltip.text': "Chia s\u1EBB"
};

});

parcelRegister("f2xYB", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6d815bca46daae46$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});

parcelRegister("gb9Or", function(module, exports) {

$parcel$export(module.exports, "default", () => $6572e39f98a14ff9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6572e39f98a14ff9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("ikz4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc923914c26892a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $3bc923914c26892a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("aXPtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $704c2f71df5e4536$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $704c2f71df5e4536$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("dsr2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6af9054e1a1047a$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $e6af9054e1a1047a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});




parcelRegister("4D4HV", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTrigger", () => $b3159d24f4d50cc6$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $f3klQ = parcelRequire("f3klQ");

var $7eL0y = parcelRequire("7eL0y");

var $gYrJM = parcelRequire("gYrJM");

var $eruWR = parcelRequire("eruWR");

var $dMihw = parcelRequire("dMihw");

var $6ZA7b = parcelRequire("6ZA7b");

var $jl1we = parcelRequire("jl1we");

var $7WN8P = parcelRequire("7WN8P");
parcelRequire("bVzYo");

var $bLAWR = parcelRequire("bLAWR");

var $encBb = parcelRequire("encBb");

var $1FYo4 = parcelRequire("1FYo4");

var $hwDUM = parcelRequire("hwDUM");

var $2lw4E = parcelRequire("2lw4E");

var $jIrpW = parcelRequire("jIrpW");

var $1Vq8e = parcelRequire("1Vq8e");
function $b3159d24f4d50cc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b3159d24f4d50cc6$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $b3159d24f4d50cc6$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $b3159d24f4d50cc6$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7eL0y))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $b3159d24f4d50cc6$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $6ZA7b.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $1Vq8e.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b3159d24f4d50cc6$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eruWR.default), {
            content: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hwDUM.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    isMenuItemSelected: isMenuItemSelected,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $7WN8P.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $gYrJM.fg)('platform.enable-appropriate-reading-order-in-share-dialog_fu49') ? true : false
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $dMihw.default), {
            zIndex: (0, $1Vq8e.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ref: this.selectPortalRef
        })));
    }
    constructor(...args){
        super(...args);
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.start = 0;
        this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $b3159d24f4d50cc6$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        };
        this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $b3159d24f4d50cc6$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($b3159d24f4d50cc6$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        };
        this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $bLAWR.CHANNEL_ID));
        };
        this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $bLAWR.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        };
        this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $bLAWR.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        };
        this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $7WN8P.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $7WN8P.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $186a951487e0aa5a$export$9540ac9c843b8743)
                }
            ];
        };
        this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        };
        this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        };
        this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $1FYo4.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $bLAWR.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        };
        this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $bLAWR.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        };
        this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $bLAWR.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        };
        this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $1FYo4.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        };
        this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink } = this.props;
            if (!onShareSubmit) return;
            (0, $1FYo4.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $bLAWR.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                showFlags(this.getFlags());
                (0, $1FYo4.shareSubmitExp).success();
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $encBb.isValidFailedExperience)((0, $1FYo4.shareSubmitExp), err);
            });
        };
        this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        };
        this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        };
        this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $bLAWR.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        };
        this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        };
        this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $b3159d24f4d50cc6$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $2lw4E.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $7WN8P.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $7WN8P.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $byn9U.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $7WN8P.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $jIrpW.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        };
        this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $bLAWR.shareSplitButtonEvent)());
        };
        this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        };
        this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $b3159d24f4d50cc6$export$c7f8df1e37e7f581 = (0, $f3klQ.default)()((0, $2qhQi.default)($b3159d24f4d50cc6$export$bc20a02e9bc30e54));

});
parcelRegister("7eL0y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::238da1d3f1c6691c40bb15e631a6cdbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $544e4dfdb0fef20e$var$_react = $544e4dfdb0fef20e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $544e4dfdb0fef20e$var$_share = $544e4dfdb0fef20e$var$_interopRequireDefault((parcelRequire("ffimc")));

var $544e4dfdb0fef20e$var$_share2 = $544e4dfdb0fef20e$var$_interopRequireDefault((parcelRequire("aIRhA")));
function $544e4dfdb0fef20e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $544e4dfdb0fef20e$var$ShareIcon = (props)=>/*#__PURE__*/ $544e4dfdb0fef20e$var$_react.default.createElement($544e4dfdb0fef20e$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $544e4dfdb0fef20e$var$_share2.default
    }, props));
$544e4dfdb0fef20e$var$ShareIcon.Name = 'ShareIconMigration';
var $544e4dfdb0fef20e$var$_default = module.exports.default = $544e4dfdb0fef20e$var$ShareIcon;

});

parcelRegister("bVzYo", function(module, exports) {

$parcel$export(module.exports, "OBJECT_SHARED", () => $186a951487e0aa5a$export$9540ac9c843b8743);
$parcel$export(module.exports, "TabType", () => (parcelRequire("lHmPr")).TabType);


var $lHmPr = parcelRequire("lHmPr");

});
const $186a951487e0aa5a$export$9540ac9c843b8743 = 'object-shared';
const $186a951487e0aa5a$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("lHmPr", function(module, exports) {

$parcel$export(module.exports, "TabType", () => $4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1);
var $4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1;
(function(TabType) {
    TabType[TabType["default"] = 0] = "default";
    TabType[TabType["Slack"] = 1] = "Slack";
})($4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1 || ($4bb0cc5c8b113cc6$export$ea1f8d830f8d55e1 = {}));

});


parcelRegister("hwDUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4eacd5d0a2b476$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dyfd9 = parcelRequire("dyfd9");
var $lUjxN = parcelRequire("lUjxN");

var $bBdMg = parcelRequire("bBdMg");
parcelRequire("j3Ry8");
var $k3sKh = parcelRequire("k3sKh");
function $de4eacd5d0a2b476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $de4eacd5d0a2b476$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $de4eacd5d0a2b476$var$LazyShareFormLazy = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("bXdNE")), {
    ssr: false,
    moduleId: "../platform/packages/elements/share/src/components/LazyShareForm/LazyShareForm.tsx"
});
const $de4eacd5d0a2b476$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k3sKh.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $de4eacd5d0a2b476$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bBdMg.default), null)));
};
var $de4eacd5d0a2b476$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lUjxN.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $byn9U.jsx)($de4eacd5d0a2b476$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)($de4eacd5d0a2b476$var$LazyShareFormLazy, props));

});
parcelRegister("j3Ry8", function(module, exports) {

$parcel$export(module.exports, "ShareFormWrapper", () => (parcelRequire("k3sKh")).default);

var $k3sKh = parcelRequire("k3sKh");

});
parcelRegister("k3sKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $804d04a566bde0f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7WN8P = parcelRequire("7WN8P");

var $7GR3H = parcelRequire("7GR3H");

var $2LGV3 = parcelRequire("2LGV3");
const $804d04a566bde0f4$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LGV3.InlineDialogContentWrapper), {
        label: formatMessage((0, $7WN8P.messages).formTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2LGV3.InlineDialogFormWrapper), {
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected
    }, shouldShowTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GR3H.ShareHeader), {
        title: shareFormTitle
    }), children), footer);
};
var $804d04a566bde0f4$export$2e2bcd8739ae039 = $804d04a566bde0f4$var$ShareFormWrapper;

});
parcelRegister("7GR3H", function(module, exports) {

$parcel$export(module.exports, "ShareHeader", () => $6d38a2247b02cf20$export$77192fbb468e5af8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
var $4WmDP = parcelRequire("4WmDP");

var $8uD7Y = parcelRequire("8uD7Y");

var $2mu6T = parcelRequire("2mu6T");

var $7WN8P = parcelRequire("7WN8P");
function $6d38a2247b02cf20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d38a2247b02cf20$var$headerWrapperStyles = {
    name: "1eoy87d",
    styles: "display:flex;justify-content:space-between"
};
const $6d38a2247b02cf20$export$fd8f58944443c645 = (theme)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $2mu6T.h500)(theme), "line-height:var(--ds-space-400, 32px);margin-right:var(--ds-space-400, 32px);margin-top:var(--ds-space-400, 32px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;> span{font-size:initial;}");
const $6d38a2247b02cf20$export$77192fbb468e5af8 = ({ title: title })=>{
    const theme = (0, $4WmDP.u)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $6d38a2247b02cf20$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $6d38a2247b02cf20$export$fd8f58944443c645(theme)
    }, title || /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $7WN8P.messages).formTitle)));
};

});

parcelRegister("2LGV3", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $665799c2519cf81a$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $665799c2519cf81a$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $fHTQU = parcelRequire("fHTQU");
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $665799c2519cf81a$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected })=>{
    const formWidth = `${352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $fHTQU.menuWrapperWidth;
    return formWidth;
};
const $665799c2519cf81a$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected })=>{
    const styles = {
        width: $665799c2519cf81a$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected
        })
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $665799c2519cf81a$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $665799c2519cf81a$export$a05835e82fd98f96 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $665799c2519cf81a$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("fHTQU", function(module, exports) {

$parcel$export(module.exports, "ShareMenuItem", () => $78b9d352b764c8db$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $78b9d352b764c8db$export$1cd8104f92c0e299);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $azeZS = parcelRequire("azeZS");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
const $78b9d352b764c8db$var$iconContainerStyles = (0, $8Vv3m.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'border.radius'
});
const $78b9d352b764c8db$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azeZS.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($78b9d352b764c8db$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelId));
const $78b9d352b764c8db$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $78b9d352b764c8db$var$iconContainerStyles
    }, icon);
const $78b9d352b764c8db$export$1cd8104f92c0e299 = '102px';

});




parcelRegister("bXdNE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("8FgQT")
]).then(()=>parcelRequire('2mQZO'));

});


parcelRegister("2lw4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $925589d666542f5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUg8E = parcelRequire("lUg8E");
const $925589d666542f5c$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lUg8E.default), {
        ref: ref,
        "aria-haspopup": "dialog",
        ...props
    }, text);
});
$925589d666542f5c$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $925589d666542f5c$export$2e2bcd8739ae039 = $925589d666542f5c$export$e980dfbc2840e8bc;

});

parcelRegister("jIrpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $499d530102d5184c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $kRXDJ = parcelRequire("kRXDJ");
var $8pjfq = parcelRequire("8pjfq");

var $f5xzw = parcelRequire("f5xzw");
var $5E6sS = parcelRequire("5E6sS");
var $e0IEe = parcelRequire("e0IEe");

var $5IJsn = parcelRequire("5IJsn");


var $7WN8P = parcelRequire("7WN8P");

var $bLAWR = parcelRequire("bLAWR");

var $aApR1 = parcelRequire("aApR1");
// span
const $499d530102d5184c$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $499d530102d5184c$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...(0, $7WN8P.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $499d530102d5184c$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $eUqFw.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $eUqFw.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $bLAWR.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $f5xzw.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $kRXDJ.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5IJsn))),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $e0IEe.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5E6sS.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: $499d530102d5184c$var$dropDownIntegrationButtonWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $aApR1.default), {
            textColor: `var(--ds-text, ${(0, $1b343b038f6c23ec$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $499d530102d5184c$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$499d530102d5184c$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $499d530102d5184c$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8pjfq.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $byn9U.jsx)($499d530102d5184c$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("8pjfq", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $e695a0400f3720db$export$651ad66661acd392);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $gYrJM = parcelRequire("gYrJM");

var $7WqI7 = parcelRequire("7WqI7");

var $koGkE = parcelRequire("koGkE");
function $e695a0400f3720db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e695a0400f3720db$var$heights = {
    default: `${32 / 14}em`,
    compact: `${24 / 14}em`
};
const $e695a0400f3720db$var$baseDividerStyles = {
    name: "qgg6i6",
    styles: "width:var(--ds-border-width, 1px);position:relative;z-index:1"
};
const $e695a0400f3720db$var$defaultDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $e695a0400f3720db$var$heights.default
});
const $e695a0400f3720db$var$compactDividerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: $e695a0400f3720db$var$heights.compact
});
const $e695a0400f3720db$var$dividerDisabledStyles = {
    name: "1e7ljet",
    styles: "background-color:var(--ds-text-disabled, #091E4224);cursor:not-allowed;opacity:0.51"
};
const $e695a0400f3720db$var$dividerDisabledRefreshedStyles = {
    name: "d948c5",
    styles: "background-color:var(--ds-border-disabled, #091E4224);cursor:not-allowed"
};
const $e695a0400f3720db$var$dividerAppearance = {
    default: {
        name: "w0okts",
        styles: "background-color:var(--ds-text, #172B4D);opacity:0.51"
    },
    primary: {
        name: "7nfjo9",
        styles: "background-color:var(--ds-text-inverse, #FFF);opacity:0.64"
    },
    navigation: /*#__PURE__*/ (0, $byn9U.css)({
        height: '16px',
        margin: `${"var(--ds-space-100, 8px)"} -0.5px`,
        backgroundColor: "var(--ds-text-subtle, #0052cc)",
        opacity: 0.62
    })
};
const $e695a0400f3720db$var$dividerRefreshedOffsetStyles = /*#__PURE__*/ (0, $byn9U.css)({
    marginInline: `calc(0px - ${"var(--ds-border-width, 1px)"})`
});
const $e695a0400f3720db$var$dividerHeight = {
    default: $e695a0400f3720db$var$defaultDividerStyles,
    compact: $e695a0400f3720db$var$compactDividerStyles
};
const $e695a0400f3720db$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    return(// I find it funny to provide a div for Divider
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e695a0400f3720db$var$baseDividerStyles,
            $e695a0400f3720db$var$dividerHeight[spacing],
            isDisabled && ((0, $gYrJM.fg)('platform-component-visual-refresh') ? $e695a0400f3720db$var$dividerDisabledRefreshedStyles : $e695a0400f3720db$var$dividerDisabledStyles),
            !isDisabled && $e695a0400f3720db$var$dividerAppearance[appearance],
            (0, $gYrJM.fg)('platform-component-visual-refresh') && $e695a0400f3720db$var$dividerRefreshedOffsetStyles
        ]
    }));
};
const $e695a0400f3720db$var$splitButtonStyles = {
    name: "jzv9d3",
    styles: "display:inline-flex;position:relative;align-items:center;white-space:nowrap"
};
const $e695a0400f3720db$var$primaryButtonStyles = {
    name: "1s736x3",
    styles: "button,a{border-end-end-radius:0;border-start-end-radius:0;}"
};
const $e695a0400f3720db$var$secondaryButtonStyles = {
    name: "1uzrn2e",
    styles: "button,a{border-end-start-radius:0;border-start-start-radius:0;}"
};
const $e695a0400f3720db$var$defaultAppearanceContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius, 3px)",
    outlineColor: "var(--ds-border, #091E4224)",
    outlineOffset: `calc(0px - ${"var(--ds-border-width, 1px)"})`,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width, 1px)"
});
const $e695a0400f3720db$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            appearance === 'default' && !isDisabled && (0, $gYrJM.fg)('platform-component-visual-refresh') && $e695a0400f3720db$var$defaultAppearanceContainerStyles,
            $e695a0400f3720db$var$splitButtonStyles
        ]
    }, children);
};
const $e695a0400f3720db$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $koGkE.getActions)(children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7WqI7.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$primaryButtonStyles
    }, PrimaryAction), /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$secondaryButtonStyles
    }, SecondaryAction)));
};
const $e695a0400f3720db$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7WqI7.SplitButtonContext).Provider, {
        value: {
            appearance: appearance,
            spacing: spacing,
            isDisabled: isDisabled
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$primaryButtonStyles
    }, primaryAction), /*#__PURE__*/ (0, $byn9U.jsx)($e695a0400f3720db$export$2e0a83ec2e27ecbb, {
        appearance: appearance,
        spacing: spacing,
        isDisabled: isDisabled
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e695a0400f3720db$var$secondaryButtonStyles
    }, secondaryAction)));
};

});
parcelRegister("koGkE", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $f0e2c3d717efe06b$export$fe3955935f564b31);

var $eUqFw = parcelRequire("eUqFw");

var $2fFJv = parcelRequire("2fFJv");
const $f0e2c3d717efe06b$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $eUqFw.Children).toArray(children);
    typeof $2fFJv;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("aApR1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d06264937e67b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dU5mb = parcelRequire("dU5mb");

function $e7d06264937e67b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $e7d06264937e67b7$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $e7d06264937e67b7$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $e7d06264937e67b7$var$IntegrationButton = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $dU5mb.default), restProps, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e7d06264937e67b7$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $1b343b038f6c23ec$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e7d06264937e67b7$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $byn9U.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $byn9U.jsx)("span", null, text))));
};
$e7d06264937e67b7$var$IntegrationButton.displayName = 'IntegrationButton';
var $e7d06264937e67b7$export$2e2bcd8739ae039 = $e7d06264937e67b7$var$IntegrationButton;

});


parcelRegister("1Vq8e", function(module, exports) {

$parcel$export(module.exports, "generateSelectZIndex", () => $74bbd83fcdf1c721$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $74bbd83fcdf1c721$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $74bbd83fcdf1c721$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $74bbd83fcdf1c721$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $74bbd83fcdf1c721$export$6900a66855146901);

var $6ZA7b = parcelRequire("6ZA7b");
const $74bbd83fcdf1c721$export$ff1a1e5addedc4cc = 10;
const $74bbd83fcdf1c721$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $6ZA7b.layers).modal() + $74bbd83fcdf1c721$export$ff1a1e5addedc4cc;
    return dialogZIndex + $74bbd83fcdf1c721$export$ff1a1e5addedc4cc;
};
const $74bbd83fcdf1c721$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $74bbd83fcdf1c721$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $74bbd83fcdf1c721$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $74bbd83fcdf1c721$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});



parcelRegister("5ZKXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1dc9c564cbcbab0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9cvwi = parcelRequire("9cvwi");

var $os4bU = parcelRequire("os4bU");

var $gYrJM = parcelRequire("gYrJM");

var $eruWR = parcelRequire("eruWR");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");


var $6ZA7b = parcelRequire("6ZA7b");

var $jl1we = parcelRequire("jl1we");

var $2LGV3 = parcelRequire("2LGV3");

var $fmgJv = parcelRequire("fmgJv");
const $b1dc9c564cbcbab0$var$Z_INDEX = (0, $6ZA7b.layers).modal();
const $b1dc9c564cbcbab0$var$AUTO_DISMISS_SECONDS = 8;
const $b1dc9c564cbcbab0$export$232be6fd960213fd = $b1dc9c564cbcbab0$var$AUTO_DISMISS_SECONDS * 1000;
const $b1dc9c564cbcbab0$export$2cef156ed72138a3 = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    margin: `${"var(--ds-space-negative-100, -8px)"}
    ${"var(--ds-space-negative-200, -16px)"}`
});
const $b1dc9c564cbcbab0$var$boxWrapperStyle = (0, $8Vv3m.xcss)({
    marginRight: 'space.025'
});
const $b1dc9c564cbcbab0$var$messageTextStyle = (0, $8Vv3m.xcss)({
    textIndent: 'space.075'
});
const $b1dc9c564cbcbab0$var$isSafari = typeof window !== 'undefined' && window.navigator.userAgent.indexOf('Safari');
const $b1dc9c564cbcbab0$export$7196851310a3d0bf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(// we need a hidden input to reliably copy to clipboard across all browsers.
(props, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            position: 'absolute',
            left: '-9999px'
        },
        tabIndex: -1,
        "aria-hidden": true,
        ref: ref,
        value: props.text,
        "aria-label": props.label,
        readOnly: true
    }));
class $b1dc9c564cbcbab0$export$534d10f1c5b9c7b3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentWillUnmount() {
        this.clearAutoDismiss();
    }
    render() {
        const { shouldShowCopiedMessage: shouldShowCopiedMessage } = this.state;
        const { copyTooltipText: copyTooltipText, copiedToClipboardText: copiedToClipboardText } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $b1dc9c564cbcbab0$var$isSafari && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            className: "assistive",
            "aria-live": "assertive"
        }, shouldShowCopiedMessage && copiedToClipboardText), /*#__PURE__*/ (0, $byn9U.jsx)($b1dc9c564cbcbab0$export$7196851310a3d0bf, {
            ref: this.inputRef,
            text: this.props.link,
            label: copiedToClipboardText
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eruWR.default), {
            zIndex: $b1dc9c564cbcbab0$var$Z_INDEX,
            autoFocus: false,
            content: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $2LGV3.InlineDialogContentWrapper), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: $b1dc9c564cbcbab0$export$2cef156ed72138a3,
                    "data-testid": "message-container",
                    "aria-hidden": true
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($os4bU))), {
                    spacing: "spacious",
                    label: "",
                    color: `var(--ds-icon-success, ${(0, $1b343b038f6c23ec$export$940e1f69e873f202)})`
                }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
                    xcss: $b1dc9c564cbcbab0$var$messageTextStyle
                }, copiedToClipboardText)))),
            isOpen: shouldShowCopiedMessage,
            onClose: this.handleDismissCopiedMessage,
            placement: "top-start",
            trigger: (triggerProps)=>copyTooltipText ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jl1we.default), {
                    content: copyTooltipText,
                    position: "bottom-start"
                }, this.renderTriggerButton(triggerProps)) : this.renderTriggerButton(triggerProps),
            shouldRenderToParent: (0, $gYrJM.fg)('platform.enable-appropriate-reading-order-in-share-dialog_fu49') ? true : false
        }));
    }
    constructor(...args){
        super(...args);
        this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            shouldShowCopiedMessage: false
        };
        this.clearAutoDismiss = ()=>{
            if (this.autoDismiss) {
                clearTimeout(this.autoDismiss);
                this.autoDismiss = undefined;
            }
        };
        this.handleClick = ()=>{
            this.inputRef.current.select();
            document.execCommand('copy');
            if (this.props.onLinkCopy) this.props.onLinkCopy(this.props.link);
            this.setState({
                shouldShowCopiedMessage: true
            }, ()=>{
                this.clearAutoDismiss();
                this.autoDismiss = setTimeout(()=>{
                    this.setState({
                        shouldShowCopiedMessage: false
                    });
                }, $b1dc9c564cbcbab0$export$232be6fd960213fd);
            });
        };
        this.handleDismissCopiedMessage = ()=>{
            this.clearAutoDismiss();
            this.setState({
                shouldShowCopiedMessage: false
            });
        };
        this.renderTriggerButton = (triggerProps)=>{
            const { isDisabled: isDisabled, copyLinkButtonText: copyLinkButtonText, children: children, iconBefore: iconBefore } = this.props;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fmgJv.default), {
                "aria-label": copyLinkButtonText,
                isDisabled: isDisabled,
                // TODO: (from codemod)"link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
                // https://product-fabric.atlassian.net/browse/DSP-18980
                appearance: "subtle-link",
                iconBefore: iconBefore || /*#__PURE__*/ (0, $byn9U.jsx)((0, $80vF2.default), {
                    xcss: $b1dc9c564cbcbab0$var$boxWrapperStyle
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cvwi))), {
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"} 0 0`,
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "medium"
                })),
                onClick: this.handleClick,
                ref: triggerProps.ref
            }, children || copyLinkButtonText);
        };
    }
}
var $b1dc9c564cbcbab0$export$2e2bcd8739ae039 = $b1dc9c564cbcbab0$export$534d10f1c5b9c7b3;

});
parcelRegister("9cvwi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e721c2947e33cb4d29af61cae3c32db2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b2daf3edd618c28$var$_react = $6b2daf3edd618c28$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6b2daf3edd618c28$var$_link = $6b2daf3edd618c28$var$_interopRequireDefault((parcelRequire("fL9TV")));

var $6b2daf3edd618c28$var$_linkFilled = $6b2daf3edd618c28$var$_interopRequireDefault((parcelRequire("5bscj")));
function $6b2daf3edd618c28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b2daf3edd618c28$var$LinkIcon = (props)=>/*#__PURE__*/ $6b2daf3edd618c28$var$_react.default.createElement($6b2daf3edd618c28$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $6b2daf3edd618c28$var$_linkFilled.default
    }, props));
$6b2daf3edd618c28$var$LinkIcon.Name = 'LinkIconMigration';
var $6b2daf3edd618c28$var$_default = module.exports.default = $6b2daf3edd618c28$var$LinkIcon;

});
parcelRegister("fL9TV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b792ececee7bc53b$var$_react = $b792ececee7bc53b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b792ececee7bc53b$var$_UNSAFE_baseNew = $b792ececee7bc53b$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $b792ececee7bc53b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b792ececee7bc53b$var$LinkIcon = (props)=>/*#__PURE__*/ $b792ececee7bc53b$var$_react.default.createElement($b792ececee7bc53b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$b792ececee7bc53b$var$LinkIcon.displayName = 'LinkIcon';
var $b792ececee7bc53b$var$_default = module.exports.default = $b792ececee7bc53b$var$LinkIcon;

});

parcelRegister("5bscj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c63da4ad3ad0dfc$var$_react = $3c63da4ad3ad0dfc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $3c63da4ad3ad0dfc$var$_link = $3c63da4ad3ad0dfc$var$_interopRequireDefault((parcelRequire("fL9TV")));
function $3c63da4ad3ad0dfc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c63da4ad3ad0dfc$var$LinkFilledIcon = (props)=>/*#__PURE__*/ $3c63da4ad3ad0dfc$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m11.75 16.15.548-.537a.585.585 0 0 0 0-.838.61.61 0 0 0-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 0 1-.119-2.223l1.694-1.663a1.543 1.543 0 0 1 2.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 0 0-3.863 0l-1.694 1.664a2.66 2.66 0 0 0 .208 3.979c1.104.884 2.738.715 3.746-.275"/><path fill="inherit" d="m12.25 7.85-.547.537a.585.585 0 0 0 0 .838.61.61 0 0 0 .853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 0 1-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 0 0 3.863 0l1.695-1.664a2.66 2.66 0 0 0-.209-3.979c-1.104-.884-2.738-.715-3.746.275"/></g></svg>`
    }, props, {
        newIcon: $3c63da4ad3ad0dfc$var$_link.default
    }));
$3c63da4ad3ad0dfc$var$LinkFilledIcon.displayName = 'LinkFilledIcon';
var $3c63da4ad3ad0dfc$var$_default = module.exports.default = $3c63da4ad3ad0dfc$var$LinkFilledIcon;

});


parcelRegister("os4bU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04980372a0b4c9eb$var$_react = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $04980372a0b4c9eb$var$_success = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("dwLyV")));

var $04980372a0b4c9eb$var$_checkCircle = $04980372a0b4c9eb$var$_interopRequireDefault((parcelRequire("gghOv")));
function $04980372a0b4c9eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04980372a0b4c9eb$var$SuccessIcon = (props)=>/*#__PURE__*/ $04980372a0b4c9eb$var$_react.default.createElement($04980372a0b4c9eb$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $04980372a0b4c9eb$var$_checkCircle.default
    }, props));
$04980372a0b4c9eb$var$SuccessIcon.Name = 'SuccessIconMigration';
var $04980372a0b4c9eb$var$_default = module.exports.default = $04980372a0b4c9eb$var$SuccessIcon;

});

parcelRegister("fmgJv", function(module, exports) {

$parcel$export(module.exports, "MAX_PICKER_HEIGHT", () => $d187b87900e44e35$export$c92a3ac7d2eb7b90);
$parcel$export(module.exports, "default", () => $d187b87900e44e35$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dU5mb = parcelRequire("dU5mb");
const $d187b87900e44e35$export$c92a3ac7d2eb7b90 = 102;
const $d187b87900e44e35$var$StyledButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dU5mb.default), {
        ref: ref,
        ...props
    }));
var $d187b87900e44e35$export$2e2bcd8739ae039 = $d187b87900e44e35$var$StyledButton;

});



parcelRegister("k4wXf", function(module, exports) {

$parcel$export(module.exports, "createAri", () => $d6128a3425372110$export$594d18a0ad2e0e57);
const $d6128a3425372110$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $d6128a3425372110$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$d6128a3425372110$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("abtNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $841d9f5232b09f47$export$2e2bcd8739ae039);

var $g0E5j = parcelRequire("g0E5j");
parcelRequire("hUU24");
var $1INIa = parcelRequire("1INIa");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
class $841d9f5232b09f47$export$2e2bcd8739ae039 extends (0, $1INIa.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super();
        this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $g0E5j.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $lRmyA.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $guiFP.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});
parcelRegister("hUU24", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => (parcelRequire("1INIa")).ShareServiceClient);

var $1INIa = parcelRequire("1INIa");

});





parcelRegister("9vsYV", function(module, exports) {

$parcel$export(module.exports, "INTEGRATION_TYPES", () => $d18c1776cefd37b8$export$195813ac8b6ae6f9);
const $d18c1776cefd37b8$export$195813ac8b6ae6f9 = {
    FILTER: 'filter',
    SEARCH: 'search'
};

});

parcelRegister("2ThFu", function(module, exports) {

$parcel$export(module.exports, "shareSearchClientConfig", () => $6ae9a3c91a3ab0ce$export$14295897acb58714);

var $9vsYV = parcelRequire("9vsYV");
const $6ae9a3c91a3ab0ce$export$14295897acb58714 = {
    getShareEndpoint: ({ link: link, type: type })=>type === (0, $9vsYV.INTEGRATION_TYPES).FILTER ? `/rest/share/1.0/filter/${new URL(link).searchParams.get('filter') || ''}` : '/rest/share/1.0/search',
    getSharePayload: ({ link: link, type: type })=>{
        const jql = new URL(link).searchParams.get('jql');
        return type === (0, $9vsYV.INTEGRATION_TYPES).SEARCH && jql !== null ? {
            jql: jql
        } : {};
    }
};

});

parcelRegister("hDLbh", function(module, exports) {

$parcel$export(module.exports, "getShareSubProductId", () => $9f06030df1b2a7dc$export$4a20278dd1d015dd);
const $9f06030df1b2a7dc$var$subProductMap = {
    addon: 'jira-addon',
    core: 'jira-core',
    polaris: 'jira-polaris',
    portfolio: 'jira-portfolio',
    serviceDesk: 'jira-servicedesk',
    software: 'jira-software',
    platform: 'jira-platform',
    unknown: 'jira-unknown'
};
const $9f06030df1b2a7dc$export$4a20278dd1d015dd = (subProduct)=>subProduct && $9f06030df1b2a7dc$var$subProductMap[subProduct] || 'jira-platform';

});

parcelRegister("9tAVu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c4ad6e9e767bee6f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c4ad6e9e767bee6f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    dialogTitleFilter: {
        "id": "issue-navigator-action-share-button.dialog-title-filter",
        "defaultMessage": "Share current filter"
    },
    dialogTitleSearch: {
        "id": "issue-navigator-action-share-button.dialog-title-search",
        "defaultMessage": "Share search criteria"
    },
    filter: {
        "id": "issue-navigator-action-share-button.filter",
        "defaultMessage": "Filter"
    },
    search: {
        "id": "issue-navigator-action-share-button.search",
        "defaultMessage": "Search"
    },
    share: {
        "id": "issue-navigator-action-share-button.share",
        "defaultMessage": "Share"
    },
    shareKeyboardShortcut: {
        "id": "issue-navigator-action-share-button.share-keyboard-shortcut",
        "defaultMessage": "Open share modal"
    }
});

});


parcelRegister("eG9vT", function(module, exports) {

$parcel$export(module.exports, "FilterIconButton", () => $92c7bdd405242632$export$2c752f0ff253a7e6);

var $eUqFw = parcelRequire("eUqFw");

var $kRXDJ = parcelRequire("kRXDJ");

var $80vF2 = parcelRequire("80vF2");
var $8Vv3m = parcelRequire("8Vv3m");
const $92c7bdd405242632$export$2c752f0ff253a7e6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled, icon: icon, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        xcss: $92c7bdd405242632$var$iconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRXDJ.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        icon: icon,
        label: label,
        ...customTriggerProps
    })));
const $92c7bdd405242632$var$iconButtonWrapperStyles = (0, $8Vv3m.xcss)({
    position: 'relative'
});

});

parcelRegister("gYJxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $46042cbfdd614d98$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $hxIJF = parcelRequire("hxIJF");

var $8UT7w = parcelRequire("8UT7w");

var $80vF2 = parcelRequire("80vF2");
var $1JJay = parcelRequire("1JJay");


var $9aFSa = parcelRequire("9aFSa");

var $79xbN = parcelRequire("79xbN");

var $4ksts = parcelRequire("4ksts");

var $5as0a = parcelRequire("5as0a");

var $cHJdq = parcelRequire("cHJdq");

var $dqYzB = parcelRequire("dqYzB");

var $4085S = parcelRequire("4085S");

var $4eIC4 = parcelRequire("4eIC4");

var $6FP8W = parcelRequire("6FP8W");

var $jMP2a = parcelRequire("jMP2a");
var $6Fbwh = parcelRequire("6Fbwh");

var $6vrw7 = parcelRequire("6vrw7");

var $idWR0 = parcelRequire("idWR0");

var $8rQuz = parcelRequire("8rQuz");

var $jccNB = parcelRequire("jccNB");

var $3wKQY = parcelRequire("3wKQY");

var $cWCvn = parcelRequire("cWCvn");

var $3Ic6q = parcelRequire("3Ic6q");

var $4RwIp = parcelRequire("4RwIp");

var $dKsVN = parcelRequire("dKsVN");
const $46042cbfdd614d98$var$KeyboardShortcuts = ({ view: view, onToggle: onToggle, intl: { formatMessage: formatMessage } })=>{
    const isDetailView = view === (0, $jccNB.views).detail;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: {
            t: {
                callback: ()=>{
                    const newView = isDetailView ? (0, $jccNB.views).list : (0, $jccNB.views).detail;
                    onToggle(newView, true);
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage(isDetailView ? (0, $dKsVN.default).listText : (0, $dKsVN.default).detailText))
            }
        }
    });
};
const $46042cbfdd614d98$export$c774a1845e27fedc = ({ view: view, onToggle: onToggle, intl: intl })=>{
    const { formatMessage: formatMessage } = intl;
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.view-switcher.toggle-button.';
    const options = (0, $6FP8W.getWillShowNav4)() ? [
        {
            id: (0, $jccNB.views).list,
            label: (0, $8rQuz.isVisualRefreshEnabled)() ? formatMessage((0, $dKsVN.default).listOptionLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).listOptionLabel)),
            testId: `${testIdPrefix}${(0, $jccNB.views).list}`
        },
        {
            id: (0, $jccNB.views).detail,
            label: (0, $8rQuz.isVisualRefreshEnabled)() ? formatMessage((0, $dKsVN.default).detailOptionLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).detailOptionLabel)),
            testId: `${testIdPrefix}${(0, $jccNB.views).detail}`
        }
    ] : [
        {
            id: (0, $jccNB.views).list,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$var$IconLabel, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                as: "span"
            }, formatMessage((0, $dKsVN.default).listOptionLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                as: "span"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).listOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxIJF))), {
                label: "",
                size: "small"
            })),
            testId: `${testIdPrefix}${(0, $jccNB.views).list}`
        },
        {
            id: (0, $jccNB.views).detail,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$var$IconLabel, null, (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                as: "span"
            }, formatMessage((0, $dKsVN.default).detailOptionLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
                as: "span"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1JJay.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $dKsVN.default).detailOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8UT7w))), {
                label: "",
                size: "small"
            })),
            testId: `${testIdPrefix}${(0, $jccNB.views).detail}`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$var$KeyboardShortcuts, {
        view: view,
        onToggle: onToggle,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idWR0.default), {
        label: formatMessage((0, $dKsVN.default).toggleButtonsLabel),
        options: options,
        selectedOption: view,
        onChange: (newView)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onToggle(newView, false);
        }
    }));
};
$46042cbfdd614d98$export$c774a1845e27fedc.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
const $46042cbfdd614d98$export$3f624639bbe23442 = ({ filterId: filterId })=>{
    (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_VIEW_SWITCHER_START);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $cWCvn.markOnce)((0, $cWCvn.marks).PAGE_ACTIONS_VIEW_SWITCHER_END);
    }, []);
    const selectedIssueKey = (0, $3Ic6q.useSelectedIssueKey)();
    const [{ view: view }, { setView: setView }] = (0, $4RwIp.useSelectedViewState)();
    const intl = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6Fbwh.useAnalyticsEvents)();
    const handleOnToggle = (0, $eUqFw.useCallback)((newView, isKeyboardShortcut)=>{
        // When toggling to detail view we want to update the issue key in the URL to match the currently selected
        // issue. When toggling to list view we want to discard the issue key from the URL.
        const newIssueKey = newView === (0, $jccNB.views).detail ? selectedIssueKey : (0, $6vrw7.toIssueKey)('');
        let resolvedNewView = (0, $3wKQY.convertToIssueNavigatorId)(newView);
        if (newView === (0, $jccNB.views).list && filterId && (0, $5as0a.isCustomFilter)(filterId)) resolvedNewView = (0, $3wKQY.convertFilterIdToIssueNavigatorId)(filterId);
        setView(resolvedNewView, newIssueKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'switchIssueNavigatorView', {
            keyboardShortcut: isKeyboardShortcut,
            switchToView: newView
        });
        return true;
    }, [
        selectedIssueKey,
        filterId,
        setView,
        createAnalyticsEvent
    ]);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cHJdq.NinChangeboardingTourTarget), {
        engagementId: "nin.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($46042cbfdd614d98$export$c774a1845e27fedc, {
        view: (0, $3wKQY.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }));
    const renderSpotlightCard = ({ onEndTour: onEndTour, onSetActiveCard: onSetActiveCard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4085S.default), {
            cardKey: (0, $dqYzB.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER,
            dialogWidth: 272,
            dialogPlacement: "bottom right",
            actions: view === 'detail' ? [
                {
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $dKsVN.default).done)
                }
            ] : [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $dqYzB.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER);
                    },
                    text: intl.formatMessage((0, $dKsVN.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $dKsVN.default).skip)
                }
            ],
            heading: intl.formatMessage((0, $dKsVN.default).tourHeading),
            target: "nin.spotlight.view-switcher",
            targetBgColor: `var(--ds-surface, ${(0, $1b343b038f6c23ec$exports).N0})`,
            targetRadius: 3,
            messageId: "jira-issue-navigator.ui.view-switcher.spotlight",
            messageType: "transactional"
        }, intl.formatMessage((0, $79xbN.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dKsVN.default).tourBodyIssueTermRefresh : (0, $dKsVN.default).tourBody));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4eIC4.default), {
        name: "nin.spotlight.view-switcher",
        renderSpotlightCard: renderSpotlightCard
    }, children);
};
var $46042cbfdd614d98$export$2e2bcd8739ae039 // clean up this styled element with getWillShowNav4
 = $46042cbfdd614d98$export$3f624639bbe23442;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $46042cbfdd614d98$var$IconLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            (0, $8rQuz.isVisualRefreshEnabled)() ? "_zulp1b66" : "_10cu1b66 _2t30idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hxIJF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc58384e4aa23cf1$var$_react = $cc58384e4aa23cf1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $cc58384e4aa23cf1$var$_listBulleted = $cc58384e4aa23cf1$var$_interopRequireDefault((parcelRequire("ag3fn")));
function $cc58384e4aa23cf1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cc58384e4aa23cf1$var$BulletListIcon = (props)=>/*#__PURE__*/ $cc58384e4aa23cf1$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="10" y="15" rx="1"/><rect width="2" height="2" x="6" y="15" rx="1"/><rect width="8" height="2" x="10" y="11" rx="1"/><rect width="2" height="2" x="6" y="11" rx="1"/><rect width="8" height="2" x="10" y="7" rx="1"/><rect width="2" height="2" x="6" y="7" rx="1"/></g></svg>`
    }, props, {
        newIcon: $cc58384e4aa23cf1$var$_listBulleted.default
    }));
$cc58384e4aa23cf1$var$BulletListIcon.displayName = 'BulletListIcon';
var $cc58384e4aa23cf1$var$_default = module.exports.default = $cc58384e4aa23cf1$var$BulletListIcon;

});
parcelRegister("ag3fn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff718278f5b90796d34b75a3e59b4f33>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $777dead0b59f3850$var$_react = $777dead0b59f3850$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $777dead0b59f3850$var$_UNSAFE_baseNew = $777dead0b59f3850$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $777dead0b59f3850$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $777dead0b59f3850$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $777dead0b59f3850$var$_react.default.createElement($777dead0b59f3850$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 2.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M5 2.75h10M5 8h10M5 13.25h10M2.75 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 5.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0-10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
    }, props));
$777dead0b59f3850$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $777dead0b59f3850$var$_default = module.exports.default = $777dead0b59f3850$var$ListBulletedIcon;

});


parcelRegister("8UT7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67de4f6f483a7805$var$_react = $67de4f6f483a7805$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dAv9d = parcelRequire("dAv9d");

var $67de4f6f483a7805$var$_sidebarRight = $67de4f6f483a7805$var$_interopRequireDefault((parcelRequire("96gjB")));
function $67de4f6f483a7805$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $67de4f6f483a7805$var$DetailViewIcon = (props)=>/*#__PURE__*/ $67de4f6f483a7805$var$_react.default.createElement($dAv9d.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props, {
        newIcon: $67de4f6f483a7805$var$_sidebarRight.default
    }));
$67de4f6f483a7805$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $67de4f6f483a7805$var$_default = module.exports.default = $67de4f6f483a7805$var$DetailViewIcon;

});
parcelRegister("96gjB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efcec0491b82465a6dab2a2bedd12deb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a01546fde7e8146$var$_react = $6a01546fde7e8146$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6a01546fde7e8146$var$_UNSAFE_baseNew = $6a01546fde7e8146$var$_interopRequireDefault((parcelRequire("8eXyv")));
function $6a01546fde7e8146$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "SidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a01546fde7e8146$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $6a01546fde7e8146$var$_react.default.createElement($6a01546fde7e8146$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 2.75H14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H7.75m0-10.5v10.5m0-10.5H2C1.31 2.75.75 3.31.75 4v8c0 .69.56 1.25 1.25 1.25h5.75M10 5.75h3m-3 3h3"/>`
    }, props));
$6a01546fde7e8146$var$SidebarRightIcon.displayName = 'SidebarRightIcon';
var $6a01546fde7e8146$var$_default = module.exports.default = $6a01546fde7e8146$var$SidebarRightIcon;

});


parcelRegister("dqYzB", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $313a4b88a1b80018$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $313a4b88a1b80018$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("4085S", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f57c7c3674fcbe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dyfd9 = parcelRequire("dyfd9");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $64f57c7c3674fcbe$var$SpotlightTourCardAsync = (0, $dyfd9.lazyForPaint)(()=>(parcelRequire("jT5fU")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $64f57c7c3674fcbe$var$SpotlightTourCard = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64f57c7c3674fcbe$var$SpotlightTourCardAsync, props)));
var $64f57c7c3674fcbe$export$2e2bcd8739ae039 = $64f57c7c3674fcbe$var$SpotlightTourCard;

});
parcelRegister("jT5fU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bxqVy").then(()=>parcelRequire('lpOp3'));

});


parcelRegister("4eIC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5bbb51b3bc2f363$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $278Vz = parcelRequire("278Vz");
var $cx8Zw = parcelRequire("cx8Zw");
var $9ZQOe = parcelRequire("9ZQOe");

var $kIyph = parcelRequire("kIyph");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $b5bbb51b3bc2f363$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $kIyph.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $278Vz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cx8Zw.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ZQOe.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $b5bbb51b3bc2f363$export$2e2bcd8739ae039 = $b5bbb51b3bc2f363$var$SpotlightTourTarget;

});
parcelRegister("kIyph", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $7b3c8bc552587421$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $7b3c8bc552587421$export$d0297e733168e478);

var $WBLbN = parcelRequire("WBLbN");

const $7b3c8bc552587421$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $7b3c8bc552587421$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $7b3c8bc552587421$var$Store = (0, $WBLbN.createStore)({
    initialState: $7b3c8bc552587421$var$initialState,
    actions: $7b3c8bc552587421$var$actions
});
const $7b3c8bc552587421$export$ac706a6842f43035 = (0, $WBLbN.createHook)($7b3c8bc552587421$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $7b3c8bc552587421$export$d0297e733168e478 = (0, $WBLbN.createActionsHook)($7b3c8bc552587421$var$Store);

});


parcelRegister("idWR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $73632070bf5ddd84$export$2e2bcd8739ae039);

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");

var $5hQTl = parcelRequire("5hQTl");

var $jMs5R = parcelRequire("jMs5R");
var $73632070bf5ddd84$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), (0, $5hQTl.ToggleButtons), (0, $jMs5R.default));

});
parcelRegister("5hQTl", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $27c2dfde36844452$export$34301fadafd0cd9d);

var $eUqFw = parcelRequire("eUqFw");

var $80vF2 = parcelRequire("80vF2");
var $1jsQJ = parcelRequire("1jsQJ");
var $8Vv3m = parcelRequire("8Vv3m");
const $27c2dfde36844452$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact })=>{
    const getButtonWithContext = (0, $eUqFw.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jsQJ.default), {
            key: option.id,
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                $27c2dfde36844452$var$baseStyles,
                !isCompact && $27c2dfde36844452$var$wideStyles,
                isSelected && $27c2dfde36844452$var$selectedStyles
            ],
            onClick: (event)=>!isSelected && onChange(option.id, event),
            isDisabled: option.isDisabled,
            testId: option.testId
        }, option.label), [
        onChange,
        isCompact
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80vF2.default), {
        role: "radiogroup",
        xcss: $27c2dfde36844452$var$containerStyles,
        "aria-label": label,
        as: "fieldset"
    }, options.map((option)=>getButtonWithContext({
            option: option,
            isSelected: option.id === selectedOption
        }))));
};
const $27c2dfde36844452$var$containerStyles = (0, $8Vv3m.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $27c2dfde36844452$var$baseStyles = (0, $8Vv3m.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: '500',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $27c2dfde36844452$var$selectedStyles = (0, $8Vv3m.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $27c2dfde36844452$var$wideStyles = (0, $8Vv3m.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});

});

parcelRegister("jMs5R", function(module, exports) {

$parcel$export(module.exports, "default", () => $64888888ab0ff674$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $c9TLT = parcelRequire("c9TLT");

var $41hTH = parcelRequire("41hTH");

var $jXplI = parcelRequire("jXplI");
let $64888888ab0ff674$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$64888888ab0ff674$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $jXplI.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $jXplI.assertPrecondition)(()=>({
            precondition: (0, $jXplI.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $jXplI.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $jXplI.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $eUqFw.useState)(()=>`toggle-buttons-${$64888888ab0ff674$var$uniqueId++}`);
    const fieldsetRef = (0, $eUqFw.useRef)(null);
    const selectedOptionRef = (0, $eUqFw.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function, jira/jira-ssr/no-unchecked-globals-usage
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($64888888ab0ff674$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $41hTH.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $64888888ab0ff674$var$selectedOptionIndicator = {
    backgroundColor: `${`var(--ds-background-accent-gray-subtler, ${(0, $1b343b038f6c23ec$exports).N0})`} !important`,
    borderRadius: `${(0, $c9TLT.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64888888ab0ff674$var$Fieldset = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $9t7rW.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhk1s4m _2rko1l7b _1yt41b66 _11c8qk37 _k48p1pd9 _vwz41clk _1p1dangw _syazaj1x _1r9t7mnp _ho6m1wmp _soiet94y _1se6t94y _1jdg1n1a _z71v1n1a _1o5t1n1a _irrs1n1a _p8t715vq _b4u715vq _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1jhnstnw _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _1rus1tag _rfx31wa3 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_15e91tag _1ph31wa3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("41hTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $add48a5e476f4f24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");
var $add48a5e476f4f24$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($add48a5e476f4f24$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $add48a5e476f4f24$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11127mnp _1q091wmp _pytkt94y _5hv9t94y _2x4g1n1a _12hv1n1a _x5bd1n1a _1rgf1n1a _1yzy15vq _bgrh15vq _v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _khufstnw _15pj1ule _136ejjoz _1vzltlke _1ioh1l7b _1hhy73ad _1emz73ad _1efl8q0r _7el91vt6 _15pqglyw _vrjh14ae _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jXplI", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $e5a01c78f2e53866$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $e5a01c78f2e53866$export$5565eefbe4b468a0);
const $e5a01c78f2e53866$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $e5a01c78f2e53866$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("dKsVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb49378eb4ca498$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $6bb49378eb4ca498$var$messages = (0, $90IgZ.defineMessages)({
    done: {
        "id": "issue-navigator.view-switcher.done",
        "defaultMessage": "Done"
    },
    next: {
        "id": "issue-navigator.view-switcher.next",
        "defaultMessage": "Next"
    },
    skip: {
        "id": "issue-navigator.view-switcher.skip",
        "defaultMessage": "Skip"
    },
    tourHeading: {
        "id": "issue-navigator.view-switcher.tour-heading",
        "defaultMessage": "View switcher"
    },
    tourBody: {
        "id": "issue-navigator.view-switcher.tour-body",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    },
    detailText: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-text",
        "defaultMessage": "Switch to detail view"
    },
    listText: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-text",
        "defaultMessage": "Switch to list view"
    },
    toggleButtonsLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.toggle-buttons-label",
        "defaultMessage": "Select view"
    },
    detailOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-option-label",
        "defaultMessage": "Detail view"
    },
    listOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-option-label",
        "defaultMessage": "List view"
    },
    tourBodyIssueTermRefresh: {
        "id": "issue-navigator.view-switcher.tour-body-issue-term-refresh",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    }
});
var $6bb49378eb4ca498$export$2e2bcd8739ae039 = $6bb49378eb4ca498$var$messages;

});


parcelRegister("jx7QD", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageMode", () => $4bb3385e03904359$export$617c50bbd595c5ac);

var $WBLbN = parcelRequire("WBLbN");
const $4bb3385e03904359$var$initialState = {
    isNaturalLanguageMode: false
};
const $4bb3385e03904359$export$e324594224ef24da = {
    toggleNaturalLanguageMode: ()=>({ setState: setState, getState: getState })=>{
            setState({
                isNaturalLanguageMode: !getState().isNaturalLanguageMode
            });
        }
};
const $4bb3385e03904359$var$Store = (0, $WBLbN.createStore)({
    initialState: $4bb3385e03904359$var$initialState,
    actions: $4bb3385e03904359$export$e324594224ef24da
});
const $4bb3385e03904359$export$42a852a2b6b56249 = (0, $WBLbN.createContainer)($4bb3385e03904359$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
});
const $4bb3385e03904359$var$getNaturalLanguageMode = (state)=>state.isNaturalLanguageMode;
const $4bb3385e03904359$export$617c50bbd595c5ac = (0, $WBLbN.createHook)($4bb3385e03904359$var$Store, {
    selector: $4bb3385e03904359$var$getNaturalLanguageMode
});

});

parcelRegister("7XCgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $12937ac3e056391a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $12937ac3e056391a$var$messages = (0, $90IgZ.defineMessages)({
    allIssues: {
        "id": "project-issue-navigator.page-actions.all-issues",
        "defaultMessage": "Go to all issues"
    },
    exportIssuesButtonIconLabel: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    }
});
var $12937ac3e056391a$export$2e2bcd8739ae039 = $12937ac3e056391a$var$messages;

});


parcelRegister("iAfyy", function(module, exports) {

$parcel$export(module.exports, "HeaderContentWrapper", () => $fa231709c590a18c$export$6d0d24718f298af7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $fa231709c590a18c$export$6d0d24718f298af7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1y6m _1dyz1kw7 _4t3izwfg _11c81p5s _p12f1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $aD5FN = parcelRequire("aD5FN");

var $2dctp = parcelRequire("2dctp");

var $5cZda = parcelRequire("5cZda");

var $i3LUJ = parcelRequire("i3LUJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $i3LUJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aD5FN.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2dctp.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $5cZda.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("2dctp", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $5eb4cd1368db1a38$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $5eb4cd1368db1a38$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $5eb4cd1368db1a38$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $abWSR = parcelRequire("abWSR");

var $5cZda = parcelRequire("5cZda");

var $F4xHF = parcelRequire("F4xHF");
function $5eb4cd1368db1a38$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $5eb4cd1368db1a38$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $abWSR.default));
    const interactionId = (0, $5cZda.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $F4xHF.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $5eb4cd1368db1a38$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $5eb4cd1368db1a38$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $5cZda.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $F4xHF.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $5eb4cd1368db1a38$export$f02972da195a43bb(marks, timingsConfig);
        (0, $F4xHF.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $iav2y = parcelRequire("iav2y");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $abWSR = parcelRequire("abWSR");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $iav2y.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $abWSR.default);
    }
    render() {
        return null;
    }
}

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $abWSR = parcelRequire("abWSR");

var $i3LUJ = parcelRequire("i3LUJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $i3LUJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $i3LUJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $abWSR.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $5cZda = parcelRequire("5cZda");

var $F4xHF = parcelRequire("F4xHF");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $F4xHF.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $5cZda = parcelRequire("5cZda");

var $F4xHF = parcelRequire("F4xHF");

var $i3LUJ = parcelRequire("i3LUJ");
var $cIeaO = parcelRequire("cIeaO");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $i3LUJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $cIeaO.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $F4xHF.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $5cZda = parcelRequire("5cZda");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $5cZda.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});





//# sourceMappingURL=async-service-desk-project-issue-navigator.e6f4a94e.js.map
